import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Date custom scalar type */
  Date: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** A subtype of an INT type. A percentage must be an unsigned integer or float, in a range of 0 to 100 */
  Percentage: any;
  /** A subtype of an INT type. A price must be an unsigned integer, greater than 50. Represents price in cents */
  Price: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

/** Program access type */
export enum AccessType {
  Exclusive = 'Exclusive',
  Premium = 'Premium',
  PremiumExclusive = 'PremiumExclusive',
}

export type AddClassInput = {
  category: Array<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<MediaInput>;
  description?: InputMaybe<Scalars['String']>;
  difficulty: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  influencerId?: InputMaybe<Scalars['Int']>;
  location: Array<Scalars['String']>;
  name: Scalars['String'];
  price?: InputMaybe<Scalars['Int']>;
  schedule: Scalars['String'];
  type: ClassType;
};

export type AddLandingPageConfigInput = {
  config: Scalars['JSONObject'];
  influencerId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<LandingPageType>;
};

export type AddPurchasePageConfigInput = {
  config: Scalars['JSONObject'];
  programId: Scalars['Int'];
};

export type AddTagToContentInput = {
  contentIds: Array<Scalars['ID']>;
  extendContentType: Scalars['String'];
  tagId?: InputMaybe<Scalars['ID']>;
  tagName?: InputMaybe<Scalars['String']>;
};

export type AdminInfluencerUpdateInput = {
  customURL?: InputMaybe<Scalars['String']>;
  customizations?: InputMaybe<CustomizationsInput>;
  id: Scalars['Int'];
  insights?: InputMaybe<Array<Scalars['String']>>;
  isPaymentEnabled?: InputMaybe<Scalars['Boolean']>;
  isTCAccepted?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<Scalars['Int']>;
  paymentMethod?: InputMaybe<Scalars['Int']>;
  profileDeepLink?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  tier?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

export enum AiProfileField {
  Accomplishments = 'ACCOMPLISHMENTS',
  Bio = 'BIO',
  Tagline = 'TAGLINE',
}

export enum AiStyle {
  Long = 'LONG',
  Medium = 'MEDIUM',
  Short = 'SHORT',
}

export type AiTextOption = {
  __typename?: 'AiTextOption';
  text: Scalars['String'];
  wordCount: Scalars['Int'];
};

export enum AiTone {
  BoldAndMotivating = 'BOLD_AND_MOTIVATING',
  CasualAndFun = 'CASUAL_AND_FUN',
  ExpertAndCredible = 'EXPERT_AND_CREDIBLE',
  WarmAndApproachable = 'WARM_AND_APPROACHABLE',
}

export type Author = {
  __typename?: 'Author';
  badges: Array<Scalars['String']>;
  email: Scalars['String'];
  hasDirectMessagesAccess?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  marketing: Scalars['Boolean'];
  profilePicture: Scalars['String'];
  username: Scalars['String'];
};

export type AuthorIdentifier = {
  memberId: Scalars['Int'];
  memberType: CommunityMemberType;
};

export enum BillingCycleInterval {
  Month = 'Month',
  Year = 'Year',
}

export type BlockedUser = {
  __typename?: 'BlockedUser';
  blockedAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['Int'];
  itemsRemovedCount: Scalars['Int'];
  mediaThumbnail: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['Int']>;
};

export enum BookingClassificationStatus {
  Eligible = 'Eligible',
  Incomplete = 'Incomplete',
  NotEligible = 'NotEligible',
  Pending = 'Pending',
}

export type BookingStepModel = {
  __typename?: 'BookingStepModel';
  amDisplayName?: Maybe<Scalars['String']>;
  amKey?: Maybe<Scalars['String']>;
  meetingUrl?: Maybe<Scalars['String']>;
  prefillEmail?: Maybe<Scalars['String']>;
  prefillFirstName?: Maybe<Scalars['String']>;
  prefillLastName?: Maybe<Scalars['String']>;
  qualified: Scalars['Boolean'];
  status: BookingClassificationStatus;
};

export type Bundle = {
  __typename?: 'Bundle';
  checkoutPage?: Maybe<CheckoutPage>;
  coverImage?: Maybe<Media>;
  createdAt: Scalars['DateTime'];
  deeplinkUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  inAppPurchase: Scalars['String'];
  influencer?: Maybe<Creator>;
  influencerId: Scalars['Int'];
  isFree: Scalars['Boolean'];
  isPlatformBundle: Scalars['Boolean'];
  items?: Maybe<Array<BundleItem>>;
  landingPageUrl?: Maybe<Scalars['String']>;
  migrationProgramId?: Maybe<Scalars['Int']>;
  oneTimeProduct?: Maybe<OneTimeProduct>;
  pricing: BundlePricing;
  pushNotificationMessage?: Maybe<Scalars['String']>;
  pushNotificationSentAt?: Maybe<Scalars['DateTime']>;
  pushNotificationUsageCount: Scalars['Int'];
  status: BundleStatus;
  subscriptionTier?: Maybe<SubscriptionTier>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  upgradeDeeplinkUrl?: Maybe<Scalars['String']>;
  wasPurchased: Scalars['Boolean'];
};

export type BundleFeatureResyncCandidate = {
  __typename?: 'BundleFeatureResyncCandidate';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  influencerId: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
};

export type BundleFeatureResyncCandidates = {
  __typename?: 'BundleFeatureResyncCandidates';
  candidates: Array<BundleFeatureResyncCandidate>;
  total: Scalars['Int'];
};

export type BundleFeatureResyncResult = {
  __typename?: 'BundleFeatureResyncResult';
  processed: Scalars['Int'];
  total: Scalars['Int'];
};

export type BundleItem = {
  __typename?: 'BundleItem';
  bundleId: Scalars['Int'];
  contentId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  details: BundleItemDetails;
  id: Scalars['Int'];
  itemId?: Maybe<Scalars['Int']>;
  itemType: BundleItemType;
};

export type BundleItemDetails = {
  __typename?: 'BundleItemDetails';
  coverUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
};

export type BundleItemInput = {
  contentId?: InputMaybe<Scalars['String']>;
  itemId?: InputMaybe<Scalars['Int']>;
  itemType: BundleItemType;
};

export enum BundleItemType {
  Content = 'CONTENT',
  Feature = 'FEATURE',
  Program = 'PROGRAM',
}

export enum BundlePricing {
  Otp = 'OTP',
  Subscription = 'SUBSCRIPTION',
}

export type BundleResponse = {
  __typename?: 'BundleResponse';
  bundle: Bundle;
  warnings?: Maybe<BundleWarning>;
};

export enum BundleStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
}

export type BundleWarning = {
  __typename?: 'BundleWarning';
  details: Array<BundleWarningDetail>;
  message: Scalars['String'];
};

export type BundleWarningDetail = {
  __typename?: 'BundleWarningDetail';
  contentId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['Int']>;
  itemType: BundleItemType;
  title?: Maybe<Scalars['String']>;
};

export type Challenge = {
  __typename?: 'Challenge';
  completionEnd: Scalars['DateTime'];
  completionRequirements: CompletionRequirements;
  completionStart: Scalars['DateTime'];
  createdAt: Scalars['DateTime'];
  deepLink: Scalars['String'];
  hidePhotos: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  photoInstructions: Scalars['String'];
  programId: Scalars['Int'];
  registrationEnd: Scalars['DateTime'];
  registrationRequirements: RegistrationRequirements;
  registrationStart: Scalars['DateTime'];
  status: Scalars['String'];
  submissions: Array<ChallengeSubmission>;
  templates?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Scalars['DateTime'];
};

export type ChallengeRef = {
  __typename?: 'ChallengeRef';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ChallengeSubmission = {
  __typename?: 'ChallengeSubmission';
  allowRepost: Scalars['Boolean'];
  completionAttributes?: Maybe<CompletionAttributes>;
  completionDate?: Maybe<Scalars['DateTime']>;
  completionMedia?: Maybe<Array<Media>>;
  createdAt: Scalars['DateTime'];
  isShortlisted: Scalars['Boolean'];
  registrationAttributes: RegistrationAttributes;
  registrationDate: Scalars['DateTime'];
  registrationMedia?: Maybe<Array<Media>>;
  submissionId: Scalars['ID'];
  subscriptionInfo?: Maybe<SubscriptionInfo>;
  transformationMedia?: Maybe<Array<Media>>;
  updatedAt: Scalars['DateTime'];
  user: User;
  userStateOnCompletion?: Maybe<UserStateOnCompletion>;
};

export type Channel = {
  __typename?: 'Channel';
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  exerciseCount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  isProtected?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Media>;
  mediaExercise?: Maybe<Media>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Date']>;
};

export type ChecklistModel = {
  __typename?: 'ChecklistModel';
  description?: Maybe<Scalars['String']>;
  estimatedDurationLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  scope: ChecklistScope;
  /** @deprecated Use strategyIds instead */
  scopeStrategyId?: Maybe<Scalars['ID']>;
  /** @deprecated Use strategyIds instead */
  strategyId?: Maybe<Scalars['ID']>;
  strategyIds: Array<Scalars['ID']>;
  tasks: Array<ChecklistTaskModel>;
  title: Scalars['String'];
  unlockCondition?: Maybe<Scalars['String']>;
};

export enum ChecklistScope {
  Any = 'ANY',
  None = 'NONE',
  Strategy = 'STRATEGY',
}

export type ChecklistTaskModel = {
  __typename?: 'ChecklistTaskModel';
  actionModal?: Maybe<Scalars['String']>;
  actionPage?: Maybe<Scalars['String']>;
  actionUrl?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['String']>;
  completedBy?: Maybe<Scalars['String']>;
  completionMode: TaskCompletionMode;
  estimatedTimeLabel?: Maybe<Scalars['String']>;
  eventType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isChecked: Scalars['Boolean'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CheckoutPage = {
  __typename?: 'CheckoutPage';
  type: CheckoutPageType;
  url: Scalars['String'];
};

export enum CheckoutPageType {
  FreeOtpBundle = 'FreeOtpBundle',
  OtpBundle = 'OtpBundle',
  OtpProgram = 'OtpProgram',
  SubscriptionExclusive = 'SubscriptionExclusive',
  SubscriptionLimited = 'SubscriptionLimited',
  SubscriptionPremium = 'SubscriptionPremium',
}

export type Class = {
  __typename?: 'Class';
  category?: Maybe<Array<Scalars['String']>>;
  color?: Maybe<Scalars['String']>;
  cover?: Maybe<Media>;
  createdAt: Scalars['DateTime'];
  deepLink?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  influencer?: Maybe<Creator>;
  influencerId?: Maybe<Scalars['Int']>;
  location?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  price?: Maybe<Scalars['Int']>;
  schedule: Scalars['String'];
  type: ClassType;
  updatedAt: Scalars['DateTime'];
};

export enum ClassType {
  Free = 'Free',
  Paid = 'Paid',
  Subscription = 'Subscription',
}

export type Collection = {
  __typename?: 'Collection';
  accessType: Scalars['String'];
  activeChallenge?: Maybe<Challenge>;
  archivedAt?: Maybe<Scalars['Date']>;
  challenges?: Maybe<Array<Maybe<Challenge>>>;
  color?: Maybe<Scalars['String']>;
  contentStructure?: Maybe<Scalars['String']>;
  daysPerWeek?: Maybe<Scalars['Float']>;
  deeplinkUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  exclusiveProgramMetadata?: Maybe<ExclusiveProgramMetadata>;
  expiresAt?: Maybe<Scalars['Date']>;
  faq?: Maybe<Array<Maybe<FeedFaq>>>;
  goal?: Maybe<Scalars['String']>;
  hiddenSections?: Maybe<ProgramHiddenSections>;
  id: Scalars['Int'];
  inAppPurchase: InAppPurchase;
  index?: Maybe<Scalars['Float']>;
  influencer?: Maybe<Creator>;
  influencerId: Scalars['Int'];
  isLocked?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  mediaCover?: Maybe<Media>;
  mediaIntro?: Maybe<Media>;
  migrationBundleId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  programBusinessModel?: Maybe<ProgramBusinessModel>;
  programStats?: Maybe<ProgramStatsModel>;
  publishedAt?: Maybe<Scalars['Date']>;
  publishingBehaviour: Scalars['String'];
  purchasePageConfig?: Maybe<PurchasePageConfig>;
  readiness?: Maybe<ProgramReadiness>;
  requiredEquipment?: Maybe<Array<Scalars['String']>>;
  sessionDuration?: Maybe<Scalars['String']>;
  swapConfig?: Maybe<ProgramSwapConfig>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  testimonials?: Maybe<Array<Maybe<Testimonial>>>;
  type: Scalars['Float'];
  workoutLimit?: Maybe<Scalars['Float']>;
  workouts?: Maybe<Array<Maybe<WorkoutTiny>>>;
};

export type CollectionWorkoutsArgs = {
  scopes?: InputMaybe<WorkoutScopesInput>;
};

export type CollectionFilters = {
  accessTypes?: InputMaybe<Array<AccessType>>;
  influencerId: Scalars['Int'];
  publishedOnly?: InputMaybe<Scalars['Boolean']>;
  withDeleted?: Scalars['Boolean'];
};

export type CollectionsInput = {
  filters: CollectionFilters;
};

export type ColorScheme = {
  __typename?: 'ColorScheme';
  id?: Maybe<Scalars['Int']>;
  influencerId?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
};

export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  influencerId?: Maybe<Scalars['Int']>;
  reportedCount: Scalars['Int'];
  status: Scalars['Int'];
  textValue: Scalars['String'];
  type: Scalars['Int'];
  user?: Maybe<SimpleUser>;
  userActivity?: Maybe<CommentUserActivity>;
  userActivityId?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
  workout?: Maybe<WorkoutTiny>;
  workoutId?: Maybe<Scalars['Int']>;
};

export type CommentUserActivity = {
  __typename?: 'CommentUserActivity';
  floatValue?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  type: Scalars['Int'];
};

export type CommentValue = {
  __typename?: 'CommentValue';
  author: Author;
  contentId: Scalars['ID'];
  createdAt: Scalars['Date'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  isCreator: Scalars['Boolean'];
  reactions: Array<EmojiSummary>;
  text: Scalars['String'];
  thread?: Maybe<Array<CommentValue>>;
  threadId?: Maybe<Scalars['String']>;
  totalReactionsCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Date']>;
  userId: Scalars['Int'];
};

export type Community = {
  __typename?: 'Community';
  blockedUsersCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  membersCount: Scalars['Int'];
  name: Scalars['String'];
  owner: Author;
  ownerId: Scalars['Int'];
  posts: Array<Post>;
  reportedPostsCount: Scalars['Int'];
  thumbnail?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CommunityPostsArgs = {
  direction?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CommunityFeedFilters>;
  lastId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PostsType>;
};

export type CommunityFeedFilters = {
  authors?: InputMaybe<Array<AuthorIdentifier>>;
  search?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<CommunityPostStatus>>;
};

export enum CommunityMemberType {
  Consumer = 'CONSUMER',
  Creator = 'CREATOR',
}

export enum CommunityPostStatus {
  Draft = 'DRAFT',
  Processing = 'PROCESSING',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
}

export type CompletionAttributes = {
  __typename?: 'CompletionAttributes';
  testimonial?: Maybe<Scalars['String']>;
};

export type CompletionRequirements = {
  __typename?: 'CompletionRequirements';
  photos: Scalars['Boolean'];
  testimonial: Scalars['Boolean'];
};

export type CompletionRequirementsInput = {
  photos: Scalars['Boolean'];
  testimonial: Scalars['Boolean'];
};

export type Content = {
  __typename?: 'Content';
  contentIds?: Maybe<ContentIds>;
  contentItems: Array<ContentItem>;
};

export enum ContentAccessMethod {
  BundlesOnly = 'BundlesOnly',
  Default = 'Default',
  SubscriptionAndBundles = 'SubscriptionAndBundles',
}

export type ContentEvent = {
  __typename?: 'ContentEvent';
  body: Scalars['JSON'];
  contentId?: Maybe<Scalars['ID']>;
  contentType?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  creatorId: Scalars['Int'];
  error?: Maybe<Scalars['String']>;
  eventId: Scalars['ID'];
  eventName: Scalars['String'];
  userId: Scalars['Int'];
};

export type ContentIds = {
  __typename?: 'ContentIds';
  id: Scalars['ID'];
  items?: Maybe<Array<ContentIds>>;
};

export type ContentIdsInput = {
  id: Scalars['ID'];
  items?: InputMaybe<Array<ContentIdsInput>>;
};

export type ContentImageValue = {
  __typename?: 'ContentImageValue';
  accessMethod: ContentAccessMethod;
  bundles: Array<Bundle>;
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ContentItem = {
  __typename?: 'ContentItem';
  type: Scalars['String'];
  value: ContentValue;
};

export type ContentLegacyGuideValue = {
  __typename?: 'ContentLegacyGuideValue';
  accessMethod: ContentAccessMethod;
  bundles: Array<Bundle>;
  contentId: Scalars['Float'];
  count: Scalars['Float'];
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type ContentLinkValue = {
  __typename?: 'ContentLinkValue';
  accessMethod: ContentAccessMethod;
  bundles: Array<Bundle>;
  coverImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ContentPdfValue = {
  __typename?: 'ContentPDFValue';
  accessMethod: ContentAccessMethod;
  bundles: Array<Bundle>;
  coverURL?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  deeplinkURL?: Maybe<Scalars['String']>;
  downloadable: Scalars['Boolean'];
  fileName: Scalars['String'];
  fileSize: Scalars['Float'];
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['Float']>;
  url: Scalars['String'];
};

export type ContentSlidesValue = {
  __typename?: 'ContentSlidesValue';
  accessMethod: ContentAccessMethod;
  bundles: Array<Bundle>;
  coverURL?: Maybe<Scalars['String']>;
  deeplinkURL?: Maybe<Scalars['String']>;
  downloadable: Scalars['Boolean'];
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type ContentTabValue = {
  __typename?: 'ContentTabValue';
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ContentTag = {
  __typename?: 'ContentTag';
  createdAt: Scalars['Date'];
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ContentValue =
  | ContentImageValue
  | ContentLegacyGuideValue
  | ContentLinkValue
  | ContentPdfValue
  | ContentSlidesValue
  | ContentTabValue
  | ContentVideoValue;

export type ContentVideoValue = {
  __typename?: 'ContentVideoValue';
  accessMethod: ContentAccessMethod;
  allowComments: Scalars['Boolean'];
  bundles: Array<Bundle>;
  commentsCount: Scalars['Int'];
  coverURL?: Maybe<Scalars['String']>;
  createdAt: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  downloadable: Scalars['Boolean'];
  durationMs: Scalars['Int'];
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isProcessed: Scalars['Boolean'];
  isPublished: Scalars['Boolean'];
  libraryVideoId: Scalars['ID'];
  likesCount: Scalars['Int'];
  muxAssetId: Scalars['String'];
  muxPlaybackId: Scalars['String'];
  thumbnailCustomURL?: Maybe<Scalars['String']>;
  thumbnailTimestampMs: Scalars['Int'];
  title: Scalars['String'];
  type: Scalars['String'];
  uniqueViewers: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Float']>;
  watchCount: Scalars['Int'];
};

export type ConvertedToProduct = {
  __typename?: 'ConvertedToProduct';
  name?: Maybe<Scalars['String']>;
  productType: Scalars['String'];
};

export type CopyWorkoutToCollectionInput = {
  collectionId: Scalars['Int'];
  workoutId: Scalars['Int'];
};

export type CopyWorkoutsToCollectionInput = {
  collectionId: Scalars['Int'];
  workoutIds: Array<Scalars['Int']>;
};

export type Coupon = {
  __typename?: 'Coupon';
  code: Scalars['String'];
  compatibleWithFreeTrial?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  discountAmount?: Maybe<Scalars['Float']>;
  discountType: CouponDiscountType;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  influencerId: Scalars['Int'];
  isActive: Scalars['Boolean'];
  maxRedemptions?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  paidProductIds?: Maybe<Array<Scalars['Int']>>;
  /** @deprecated Use paidProductIds instead */
  paidProgramIds?: Maybe<Array<Scalars['Float']>>;
  percentOff?: Maybe<Scalars['Float']>;
  productType: CouponProductType;
  providerCouponId?: Maybe<Scalars['String']>;
  redemptions: Scalars['Int'];
  /** Set when a referral campaign uses this coupon, so it can be told apart from one the creator made. */
  referralCampaignId?: Maybe<Scalars['Int']>;
  subscriptionProviderPriceId?: Maybe<Scalars['String']>;
  subscriptionProviderPriceIds?: Maybe<Array<Scalars['String']>>;
};

export type CouponDetails = {
  __typename?: 'CouponDetails';
  coupon: Coupon;
  metrics?: Maybe<CouponRedemptionMetrics>;
  paidOtpBundles?: Maybe<Array<Maybe<Bundle>>>;
  paidPrograms?: Maybe<Array<Maybe<Program>>>;
  redemptionsList?: Maybe<Array<Maybe<CouponRedemption>>>;
  /** @deprecated Use subscriptionTierPrices instead */
  subscriptionTierPrice?: Maybe<SubscriptionTierPrice>;
  subscriptionTierPrices?: Maybe<Array<Maybe<SubscriptionTierPrice>>>;
};

export enum CouponDiscountType {
  FixedAmount = 'FixedAmount',
  Percentage = 'Percentage',
}

export enum CouponProductType {
  Otp = 'OTP',
  OtpBundle = 'OtpBundle',
  Subscription = 'Subscription',
}

export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  receiptId: Scalars['String'];
  redeemedAt: Scalars['Date'];
  userId: Scalars['Int'];
  userStatusAtRedemption: UserStatusAtRedemption;
};

export type CouponRedemptionMetrics = {
  __typename?: 'CouponRedemptionMetrics';
  activeSubscriber: Scalars['Int'];
  new: Scalars['Int'];
  returning: Scalars['Int'];
  totalRedemptions: Scalars['Int'];
  upgrading: Scalars['Int'];
};

export type CreateChallengeInput = {
  completionEnd: Scalars['DateTime'];
  completionRequirements: CompletionRequirementsInput;
  completionStart: Scalars['DateTime'];
  hidePhotos?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  photoInstructions?: InputMaybe<Scalars['String']>;
  programId: Scalars['Int'];
  registrationEnd: Scalars['DateTime'];
  registrationRequirements: RegistrationRequirementsInput;
  registrationStart: Scalars['DateTime'];
  templates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateCollectionInput = {
  accessType?: ProgramAccessType;
  color?: Scalars['String'];
  creatorId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  salesType?: ProgramAccessType;
  type: Scalars['Int'];
};

export type CreateCommentInput = {
  contentId: Scalars['ID'];
  text: Scalars['String'];
  threadId?: InputMaybe<Scalars['String']>;
};

export type CreateCouponInput = {
  code: Scalars['String'];
  compatibleWithFreeTrial?: InputMaybe<Scalars['Boolean']>;
  discountAmount?: InputMaybe<Scalars['Int']>;
  discountType: CouponDiscountType;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  influencerId: Scalars['Int'];
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  paidProductIds?: InputMaybe<Array<Scalars['Int']>>;
  paidProgramIds?: InputMaybe<Array<Scalars['Int']>>;
  percentOff?: InputMaybe<Scalars['Float']>;
  productType: CouponProductType;
  subscriptionProviderPriceId?: InputMaybe<Scalars['String']>;
  subscriptionProviderPriceIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateDiscoveryInput = {
  influencerId: Scalars['Int'];
  influencers?: InputMaybe<Array<InfluencersSectionInput>>;
  latest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nutritions?: InputMaybe<Array<NutritionsSectionInput>>;
  order: Scalars['Int'];
  programs?: InputMaybe<Array<ProgramsSectionInput>>;
  programsCarousel?: InputMaybe<Array<ProgramsCarouselSectionInput>>;
  randomize?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type: DiscoverySectionType;
  websites?: InputMaybe<Array<WebsitesSectionInput>>;
  workouts?: InputMaybe<Array<WorkoutsSectionInput>>;
};

export type CreateImageInput = {
  id?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  parentId: Scalars['String'];
  title: Scalars['String'];
};

export type CreateInfluencerInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  onboardingEnabled: Scalars['Boolean'];
  /** Optional. Provide at least one of profileInstagram, profileTiktok, or profileYoutubeChannel. */
  profileInstagram?: InputMaybe<Scalars['String']>;
  profileTiktok?: InputMaybe<Scalars['String']>;
  profileYoutubeChannel?: InputMaybe<Scalars['String']>;
  tier: Scalars['Int'];
};

export type CreateLegacyGuideInput = {
  contentId: Scalars['Float'];
  count: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  parentId: Scalars['String'];
  title: Scalars['String'];
};

export type CreateLinkInput = {
  coverImage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  parentId: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CreateOtpBundleInput = {
  /** Cover image for the offer. Upload the file first via POST /admin-upload, then pass the returned Media object here. */
  coverImage?: InputMaybe<MediaInput>;
  description?: InputMaybe<Scalars['String']>;
  inAppPurchase?: InputMaybe<InAppPurchase>;
  influencerId: Scalars['Int'];
  isFree?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<BundleItemInput>>;
  playbookFeePercent?: InputMaybe<Scalars['Int']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  skipPriceValidation?: InputMaybe<Scalars['Boolean']>;
  status: BundleStatus;
  title: Scalars['String'];
};

export type CreatePdfInput = {
  coverURL?: InputMaybe<Scalars['String']>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  fileName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  parentId: Scalars['String'];
  title: Scalars['String'];
};

export type CreateReportInput = {
  contentId: Scalars['ID'];
  creatorId: Scalars['Float'];
  reason?: InputMaybe<Scalars['String']>;
};

export type CreateSlidesInput = {
  coverURL: Scalars['String'];
  downloadable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  parentId: Scalars['String'];
  title: Scalars['String'];
};

export type CreateSubscriptionBundleInput = {
  annualPriceCents?: InputMaybe<Scalars['Int']>;
  freeTrial?: InputMaybe<FreeTrialInput>;
  influencerId: Scalars['Int'];
  monthlyPriceCents?: InputMaybe<Scalars['Int']>;
};

export type CreateTabInput = {
  id?: InputMaybe<Scalars['String']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parentId: Scalars['String'];
};

export type CreateTagInput = {
  name: Scalars['String'];
};

export type CreateVideoInput = {
  allowComments: Scalars['Boolean'];
  coverURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isPublished: Scalars['Boolean'];
  libraryVideoId: Scalars['String'];
  parentId: Scalars['String'];
  thumbnailCustomURL?: InputMaybe<Scalars['String']>;
  thumbnailTimestampMs: Scalars['Int'];
  title: Scalars['String'];
};

export type Creator = {
  __typename?: 'Creator';
  accomplishments?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  bankIban?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  bankSwift?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  /** @deprecated Use bundles field instead, since we made a typo originally */
  bundle: Array<Bundle>;
  bundles: Array<Bundle>;
  businessModel: Scalars['String'];
  campaignProfileReady?: Maybe<Scalars['Int']>;
  campaignWorkoutsReady?: Maybe<Scalars['Int']>;
  channel?: Maybe<Array<Maybe<Channel>>>;
  city?: Maybe<Scalars['String']>;
  collectionType?: Maybe<Scalars['String']>;
  communities: Array<Community>;
  communityId?: Maybe<Scalars['Int']>;
  convertedToProducts: Array<ConvertedToProduct>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  customColorSchema?: Maybe<ColorScheme>;
  customDomains?: Maybe<Array<CustomDomain>>;
  customURL?: Maybe<Scalars['String']>;
  customizations?: Maybe<Customizations>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  enableCheckoutFreeTrial: Scalars['Boolean'];
  facebookConversionApiAccessToken?: Maybe<Scalars['String']>;
  facebookPixelId?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Feature>>>;
  feedDescription?: Maybe<Scalars['String']>;
  feedFaq?: Maybe<Array<Maybe<FeedFaq>>>;
  feedMediaCover?: Maybe<Media>;
  feedMediaIntro?: Maybe<Media>;
  feedTitle?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  freeOfferProducts: Array<FreeOfferProduct>;
  ga4Configuration?: Maybe<Ga4Configuration>;
  gender?: Maybe<Scalars['String']>;
  goals?: Maybe<Scalars['String']>;
  hasAccessToOwnExclusiveSubscription?: Maybe<Scalars['Boolean']>;
  hasLoggedInWebApp?: Maybe<Scalars['Boolean']>;
  hasOnlyPlatformBundlePublished: Scalars['Boolean'];
  id: Scalars['Int'];
  index?: Maybe<Scalars['Int']>;
  insights?: Maybe<Array<Maybe<Scalars['String']>>>;
  instagramFollowersCount?: Maybe<Scalars['Int']>;
  isPaymentEnabled?: Maybe<Scalars['Boolean']>;
  isRunOffMode?: Maybe<Scalars['Boolean']>;
  isTCAccepted?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  landingPageConfig?: Maybe<LandingPageConfig>;
  lastName?: Maybe<Scalars['String']>;
  latestWorkout?: Maybe<Array<Maybe<Workout>>>;
  liveStreamKey?: Maybe<Scalars['String']>;
  mediaAvatar?: Maybe<Media>;
  mediaBanner?: Maybe<Media>;
  mediaCover?: Maybe<Media>;
  mediaWelcome?: Maybe<Media>;
  messageCommunity?: Maybe<Scalars['String']>;
  messageProfile?: Maybe<Scalars['String']>;
  mobilePhoneNumber?: Maybe<Scalars['String']>;
  mode?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<Array<NotificationPreference>>;
  offering: Array<Scalars['String']>;
  otpBundleDefaultFee?: Maybe<Scalars['Int']>;
  otpDefaultFee?: Maybe<Scalars['Int']>;
  otpProgramsCount?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<Scalars['Int']>;
  paypal?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  predictedSuccess?: Maybe<Scalars['Int']>;
  processedAt?: Maybe<Scalars['Date']>;
  productType?: Maybe<Scalars['String']>;
  profileDeepLink?: Maybe<Scalars['String']>;
  /** @deprecated Not used by UI anymore */
  profileFacebook?: Maybe<Scalars['String']>;
  profileInstagram?: Maybe<Scalars['String']>;
  /** @deprecated Not used by UI anymore */
  profileSnapchat?: Maybe<Scalars['String']>;
  profileTiktok?: Maybe<Scalars['String']>;
  /** @deprecated Not used by UI anymore */
  profileTwitter?: Maybe<Scalars['String']>;
  profileWebsite?: Maybe<Scalars['String']>;
  profileYoutubeChannel?: Maybe<Scalars['String']>;
  programs: Array<Program>;
  promoteeId?: Maybe<Scalars['Int']>;
  publisheCollectionsCount?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['Date']>;
  publishedPrograms: Array<Program>;
  publishedWorkoutsCount?: Maybe<Scalars['Int']>;
  purchasedOtpProducts: Array<PurchasedOtpProduct>;
  referralCampaign?: Maybe<CreatorReferralCampaign>;
  salesModel?: Maybe<Scalars['String']>;
  signInEmail: Scalars['String'];
  socialAccounts: Array<SocialAccountStatus>;
  source?: Maybe<Scalars['String']>;
  stories?: Maybe<Array<Maybe<Story>>>;
  stripeAccessToken?: Maybe<Scalars['String']>;
  stripeLiveMode?: Maybe<Scalars['Boolean']>;
  stripePublishableKey?: Maybe<Scalars['String']>;
  stripeRefreshToken?: Maybe<Scalars['String']>;
  stripeUserId?: Maybe<Scalars['String']>;
  subscribedProducts: Array<Scalars['String']>;
  subscriptionAnnualPrice?: Maybe<Scalars['Int']>;
  subscriptionMonthlyPrice?: Maybe<Scalars['Int']>;
  summary?: Maybe<CreatorSummary>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tier?: Maybe<Scalars['Int']>;
  tikTokConfiguration?: Maybe<TikTokConfiguration>;
  title?: Maybe<Scalars['String']>;
  trainingRequirements?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Date']>;
  visibility: Scalars['String'];
  workouts: Array<WorkoutTiny>;
};

export type CreatorNotificationPreferencesArgs = {
  version?: InputMaybe<Scalars['Int']>;
};

export type CreatorPublishedProgramsArgs = {
  forActiveBundle?: InputMaybe<Scalars['Boolean']>;
};

export type CreatorWorkoutsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<WorkoutScopesInput>;
};

export type CreatorProfileUpdateInput = {
  accomplishments?: InputMaybe<Scalars['String']>;
  bio?: InputMaybe<Scalars['String']>;
  cascadeToPortalUser?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mediaAvatar?: InputMaybe<MediaInput>;
  mediaBanner?: InputMaybe<MediaInput>;
  mediaCover?: InputMaybe<MediaInput>;
  mediaWelcome?: InputMaybe<MediaInput>;
  messageProfile?: InputMaybe<Scalars['String']>;
  mobilePhoneNumber?: InputMaybe<Scalars['String']>;
  profileInstagram?: InputMaybe<Scalars['String']>;
  profileTiktok?: InputMaybe<Scalars['String']>;
  profileYoutubeChannel?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreatorReferralCampaign = {
  __typename?: 'CreatorReferralCampaign';
  couponCode?: Maybe<Scalars['String']>;
};

export type CreatorSearchFilters = {
  isPPCOnly?: InputMaybe<Scalars['Boolean']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  mode?: InputMaybe<Scalars['Int']>;
  modes?: InputMaybe<Array<Scalars['Int']>>;
  visibility?: InputMaybe<Array<Scalars['String']>>;
};

export type CreatorSearchInput = {
  filters?: InputMaybe<CreatorSearchFilters>;
};

export type CreatorSummary = {
  __typename?: 'CreatorSummary';
  influencerId: Scalars['Int'];
  programCount?: Maybe<Scalars['Int']>;
  programCreatedCount?: Maybe<Scalars['Int']>;
  videoCount?: Maybe<Scalars['Int']>;
  workoutCount?: Maybe<Scalars['Int']>;
  workoutCreatedCount?: Maybe<Scalars['Int']>;
};

export type CustomDomain = {
  __typename?: 'CustomDomain';
  additionalInfo?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTime'];
  creatorId: Scalars['Int'];
  domain: Scalars['String'];
  id: Scalars['Int'];
  status: CustomDomainStatus;
  updatedAt: Scalars['DateTime'];
};

export enum CustomDomainStatus {
  AwaitingDnsConfiguration = 'AwaitingDnsConfiguration',
  DnsVerified = 'DNSVerified',
  Error = 'Error',
  InfraRunning = 'InfraRunning',
  Initialized = 'Initialized',
  InvalidDnsConfiguration = 'InvalidDnsConfiguration',
  SslIssued = 'SSLIssued',
}

export type Customizations = {
  __typename?: 'Customizations';
  autoplayedWorkouts?: Maybe<Scalars['Boolean']>;
  backgroundVideoUpload?: Maybe<Scalars['Boolean']>;
  canDirectMessage?: Maybe<Scalars['Boolean']>;
  canLiveStream?: Maybe<Scalars['Boolean']>;
  canLiveStreamPaidClasses?: Maybe<Scalars['Boolean']>;
  canUsePromotionDetails?: Maybe<Scalars['Boolean']>;
  canUsePromotions?: Maybe<Scalars['Boolean']>;
  exclusivesTitle?: Maybe<Scalars['String']>;
  feedFirst?: Maybe<Scalars['Boolean']>;
  feedLimit?: Maybe<Scalars['Int']>;
  freeInfluencer?: Maybe<Scalars['Boolean']>;
  hideAbout?: Maybe<Scalars['Boolean']>;
  hideDiscovery?: Maybe<Scalars['Boolean']>;
  hideLibrary?: Maybe<Scalars['Boolean']>;
  hideSuggestion?: Maybe<Scalars['Boolean']>;
  insightsTitle?: Maybe<Scalars['String']>;
  isAutomationsEnabled?: Maybe<Scalars['Boolean']>;
  isCommunitiesV2Enabled?: Maybe<Scalars['Boolean']>;
  isCommunityContentEditEnabled?: Maybe<Scalars['Boolean']>;
  isCouponWithFreeTrialEnabled?: Maybe<Scalars['Boolean']>;
  isCreatorApprovedSwapsEnabled?: Maybe<Scalars['Boolean']>;
  isCrmEnabled?: Maybe<Scalars['Boolean']>;
  isExclusiveMigratedToBundle?: Maybe<Scalars['Boolean']>;
  isExerciseSwapsEnabled?: Maybe<Scalars['Boolean']>;
  isNewRunning?: Maybe<Scalars['Boolean']>;
  isNewVideo?: Maybe<Scalars['Boolean']>;
  isOffers35Enabled?: Maybe<Scalars['Boolean']>;
  isOtpMigratedToBundle?: Maybe<Scalars['Boolean']>;
  isPPCOnly?: Maybe<Scalars['Boolean']>;
  isTransactionLedgerEnabled?: Maybe<Scalars['Boolean']>;
  isU2UReferralsEnabled?: Maybe<Scalars['Boolean']>;
  isUltraPremiumForIntercom?: Maybe<Scalars['Boolean']>;
  isUnifiedProgramsEnabled?: Maybe<Scalars['Boolean']>;
  lastLibrary?: Maybe<Scalars['Boolean']>;
  linkInBio?: Maybe<Scalars['String']>;
  mergedLibrary?: Maybe<Scalars['Boolean']>;
  mobileOffersEnabled?: Maybe<Scalars['Boolean']>;
  premiumFeaturesOTPIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  productCatalog: Array<ProductCatalogItem>;
  productCatalogTitle: Scalars['String'];
  promo?: Maybe<Array<Maybe<Scalars['String']>>>;
  selfServeExtras?: Maybe<Scalars['Boolean']>;
  text2Workout?: Maybe<Scalars['Boolean']>;
  visibleForUnknownUsers?: Maybe<Scalars['Boolean']>;
  workoutsTitle?: Maybe<Scalars['String']>;
};

export type CustomizationsInput = {
  autoplayedWorkouts?: InputMaybe<Scalars['Boolean']>;
  backgroundVideoUpload?: InputMaybe<Scalars['Boolean']>;
  canUsePromotionDetails?: InputMaybe<Scalars['Boolean']>;
  canUsePromotions?: InputMaybe<Scalars['Boolean']>;
  exclusivesTitle?: InputMaybe<Scalars['String']>;
  feedFirst?: InputMaybe<Scalars['Boolean']>;
  feedLimit?: InputMaybe<Scalars['Int']>;
  freeInfluencer?: InputMaybe<Scalars['Boolean']>;
  hideAbout?: InputMaybe<Scalars['Boolean']>;
  hideDiscovery?: InputMaybe<Scalars['Boolean']>;
  hideLibrary?: InputMaybe<Scalars['Boolean']>;
  hideSuggestion?: InputMaybe<Scalars['Boolean']>;
  insightsTitle?: InputMaybe<Scalars['String']>;
  isAutomationsEnabled?: InputMaybe<Scalars['Boolean']>;
  isCommunitiesV2Enabled?: InputMaybe<Scalars['Boolean']>;
  isCommunityContentEditEnabled?: InputMaybe<Scalars['Boolean']>;
  isCouponWithFreeTrialEnabled?: InputMaybe<Scalars['Boolean']>;
  isCreatorApprovedSwapsEnabled?: InputMaybe<Scalars['Boolean']>;
  isCrmEnabled?: InputMaybe<Scalars['Boolean']>;
  isExerciseSwapsEnabled?: InputMaybe<Scalars['Boolean']>;
  isNewRunning?: InputMaybe<Scalars['Boolean']>;
  isNewVideo?: InputMaybe<Scalars['Boolean']>;
  isOffers35Enabled?: InputMaybe<Scalars['Boolean']>;
  isOtpMigratedToBundle?: InputMaybe<Scalars['Boolean']>;
  isPPCOnly?: InputMaybe<Scalars['Boolean']>;
  isTransactionLedgerEnabled?: InputMaybe<Scalars['Boolean']>;
  isU2UReferralsEnabled?: InputMaybe<Scalars['Boolean']>;
  isUnifiedProgramsEnabled?: InputMaybe<Scalars['Boolean']>;
  lastLibrary?: InputMaybe<Scalars['Boolean']>;
  linkInBio?: InputMaybe<Scalars['String']>;
  mergedLibrary?: InputMaybe<Scalars['Boolean']>;
  mobileOffersEnabled?: InputMaybe<Scalars['Boolean']>;
  premiumFeaturesOTPIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  productCatalog?: Array<ProductCatalogItemInput>;
  productCatalogTitle?: Scalars['String'];
  promo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selfServeExtras?: InputMaybe<Scalars['Boolean']>;
  text2Workout?: InputMaybe<Scalars['Boolean']>;
  visibleForUnknownUsers?: InputMaybe<Scalars['Boolean']>;
  workoutsTitle?: InputMaybe<Scalars['String']>;
};

export type Discovery = {
  __typename?: 'Discovery';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  items?: Maybe<Array<Maybe<DiscoveryItem>>>;
  latest?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  order: Scalars['Int'];
  randomize?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  type: DiscoverySectionType;
  updatedAt: Scalars['DateTime'];
};

export type DiscoveryItem =
  | InfluencersSection
  | NutritionsSection
  | ProgramsCarouselSection
  | ProgramsSection
  | WebsitesSection
  | WorkoutsSection;

export type DiscoverySectionOrderInput = {
  id: Scalars['Int'];
  order?: InputMaybe<Scalars['Int']>;
};

export enum DiscoverySectionType {
  Influencers = 'Influencers',
  LatestInfluencers = 'LatestInfluencers',
  LatestWorkouts = 'LatestWorkouts',
  Nutritions = 'Nutritions',
  Programs = 'Programs',
  ProgramsCarousel = 'ProgramsCarousel',
  Tags = 'Tags',
  Websites = 'Websites',
  Workouts = 'Workouts',
}

export type DistributionRule = {
  __typename?: 'DistributionRule';
  attributionType: Scalars['String'];
  creatorId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  distributionType: Scalars['String'];
  productType: Scalars['String'];
};

export type Download = {
  __typename?: 'Download';
  high?: Maybe<DownloadLink>;
  low?: Maybe<DownloadLink>;
  medium?: Maybe<DownloadLink>;
};

export type DownloadInput = {
  high?: InputMaybe<DownloadLinkInput>;
  low?: InputMaybe<DownloadLinkInput>;
  medium?: InputMaybe<DownloadLinkInput>;
};

export type DownloadLink = {
  __typename?: 'DownloadLink';
  filesize: Scalars['Float'];
  height: Scalars['Float'];
  link: Scalars['String'];
  width: Scalars['Float'];
};

export type DownloadLinkInput = {
  filesize: Scalars['Float'];
  height: Scalars['Float'];
  link: Scalars['String'];
  width: Scalars['Float'];
};

export type EmojiSummary = {
  __typename?: 'EmojiSummary';
  count: Scalars['Int'];
  customEmoji?: Maybe<Scalars['String']>;
  reaction: EngagementReactionType;
  userReacted: Scalars['Boolean'];
  users?: Maybe<Array<EngagementUser>>;
};

export type EnableCreatorSettingsInput = {
  influencerId: Scalars['Int'];
  isEnabled: Scalars['Boolean'];
};

export type EngagementComment = {
  __typename?: 'EngagementComment';
  author: Author;
  contentId: Scalars['ID'];
  createdAt: Scalars['Date'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  isCreator: Scalars['Boolean'];
  text: Scalars['String'];
  threadId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  userId: Scalars['Int'];
};

export type EngagementReaction = {
  __typename?: 'EngagementReaction';
  contentId: Scalars['ID'];
  createdAt: Scalars['Date'];
  customEmoji?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCreator: Scalars['Boolean'];
  reaction: EngagementReactionType;
  userId: Scalars['Float'];
};

/** The supported reaction types */
export enum EngagementReactionType {
  Care = 'care',
  Custom = 'custom',
  Haha = 'haha',
  Like = 'like',
  Love = 'love',
  Wow = 'wow',
}

export type EngagementReport = {
  __typename?: 'EngagementReport';
  contentId: Scalars['ID'];
  createdAt: Scalars['Date'];
  creatorId: Scalars['Float'];
  id: Scalars['ID'];
  isCreator: Scalars['Boolean'];
  reason?: Maybe<Scalars['String']>;
  status?: Maybe<EngagementReportStatus>;
  userId: Scalars['Int'];
};

/** Status of a content report */
export enum EngagementReportStatus {
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

export type EngagementSummary = {
  __typename?: 'EngagementSummary';
  commentsCount: Scalars['Int'];
  contentId: Scalars['ID'];
  reactions: Array<EmojiSummary>;
  reactionsCount: Scalars['Int'];
  reportsCount: Scalars['Int'];
};

export type EngagementUser = {
  __typename?: 'EngagementUser';
  userAvatarURL: Scalars['String'];
  userId: Scalars['Int'];
  userName: Scalars['String'];
};

export type ExclusiveProgramMetadata = {
  __typename?: 'ExclusiveProgramMetadata';
  checkoutPageUrl?: Maybe<Scalars['String']>;
  deeplinkUrl?: Maybe<Scalars['String']>;
  discountPercent?: Maybe<Scalars['Float']>;
  originalPrice?: Maybe<Scalars['Float']>;
  playbookFee?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  stripeProductUrl?: Maybe<Scalars['String']>;
};

export type Feature = {
  __typename?: 'Feature';
  code: FeatureCode;
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum FeatureCode {
  Community = 'COMMUNITY',
  Dm = 'DM',
  Insight = 'INSIGHT',
  Livestream = 'LIVESTREAM',
  Nutrition = 'NUTRITION',
  Story = 'STORY',
}

export type FeedFaq = {
  __typename?: 'FeedFaq';
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type FreeOfferProduct = {
  __typename?: 'FreeOfferProduct';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  productType: Scalars['String'];
};

export type FreeTrialInput = {
  annual: Scalars['Boolean'];
  monthly: Scalars['Boolean'];
};

export type Ga4Configuration = {
  __typename?: 'GA4Configuration';
  apiSecret?: Maybe<Scalars['String']>;
  measurementId?: Maybe<Scalars['String']>;
};

export enum GqlErrorCode {
  AiFeatureDisabled = 'AI_FEATURE_DISABLED',
  AiQuotaExceeded = 'AI_QUOTA_EXCEEDED',
  AiServiceUnavailable = 'AI_SERVICE_UNAVAILABLE',
  AtLeastOneSocialRequired = 'AT_LEAST_ONE_SOCIAL_REQUIRED',
  CollectionAlreadyArchived = 'COLLECTION_ALREADY_ARCHIVED',
  CollectionAlreadyDraft = 'COLLECTION_ALREADY_DRAFT',
  CollectionAlreadyPublished = 'COLLECTION_ALREADY_PUBLISHED',
  CollectionContentNotReady = 'COLLECTION_CONTENT_NOT_READY',
  CollectionDelete = 'COLLECTION_DELETE',
  CollectionNotArchaivable = 'COLLECTION_NOT_ARCHAIVABLE',
  CollectionNotPurchasable = 'COLLECTION_NOT_PURCHASABLE',
  CommunityPostInvalid = 'COMMUNITY_POST_INVALID',
  CreatorNotLive = 'CREATOR_NOT_LIVE',
  DraftCollectionRequired = 'DRAFT_COLLECTION_REQUIRED',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  LandingPageNotConfigured = 'LANDING_PAGE_NOT_CONFIGURED',
  OtpBundleValidationError = 'OTP_BUNDLE_VALIDATION_ERROR',
  PayoutsNotConfigured = 'PAYOUTS_NOT_CONFIGURED',
  PriceNotSet = 'PRICE_NOT_SET',
  PublishedCollectionRequired = 'PUBLISHED_COLLECTION_REQUIRED',
}

export type GenerateProfileTextInput = {
  field: AiProfileField;
  initialInput?: InputMaybe<Scalars['String']>;
  style: AiStyle;
  thingsToMention?: InputMaybe<Scalars['String']>;
  tone: AiTone;
};

export type GenerateProfileTextResult = {
  __typename?: 'GenerateProfileTextResult';
  options: Array<AiTextOption>;
  remainingGenerations: Scalars['Int'];
};

export type GetLibrary = {
  __typename?: 'GetLibrary';
  folders: Array<LibraryFolder>;
  videos: Array<LibraryVideo>;
};

export type IdObject = {
  __typename?: 'IdObject';
  id: Scalars['ID'];
};

export enum InAppPurchase {
  Allow = 'allow',
  Hide = 'hide',
}

export type InfluencersSection = {
  __typename?: 'InfluencersSection';
  influencerId?: Maybe<Scalars['Int']>;
  type: Scalars['Int'];
};

export type InfluencersSectionInput = {
  influencerId?: InputMaybe<Scalars['Int']>;
};

export type Installation = {
  __typename?: 'Installation';
  apiVersion?: Maybe<Scalars['String']>;
  appBuild?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  confirmationCodeExpiresAt?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  deviceModel?: Maybe<Scalars['String']>;
  deviceToken?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookName?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  installationToken: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  sourceChannel?: Maybe<Scalars['String']>;
  sourceInfluencerId?: Maybe<Scalars['Int']>;
  sourceUrl?: Maybe<Scalars['String']>;
  systemName?: Maybe<Scalars['String']>;
  systemVersion?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
};

export type LandingPageConfig = {
  __typename?: 'LandingPageConfig';
  config?: Maybe<Scalars['JSONObject']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  parent: LandingPageParent;
  parentId?: Maybe<Scalars['Int']>;
  type: LandingPageType;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export type LandingPageParent = Bundle | Creator | Program;

export enum LandingPageType {
  Channel = 'CHANNEL',
  Offer = 'OFFER',
  Program = 'PROGRAM',
}

export type LibraryFolder = {
  __typename?: 'LibraryFolder';
  contentCount?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  creatorId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type LibraryVideo = {
  __typename?: 'LibraryVideo';
  aspectRatio?: Maybe<Scalars['String']>;
  cdn01?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creatorId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  downloadLink?: Maybe<Download>;
  duration?: Maybe<Scalars['Float']>;
  fileSize?: Maybe<Scalars['Float']>;
  folderId?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  muxAssetId?: Maybe<Scalars['String']>;
  muxPlaybackId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  video?: Maybe<Scalars['String']>;
  videoSourceType: Scalars['String'];
  videoThumbnailUrl?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type Media = {
  __typename?: 'Media';
  audio?: Maybe<Scalars['String']>;
  cdn01?: Maybe<Scalars['String']>;
  downloadLink?: Maybe<Download>;
  height?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  videoSourceType?: Maybe<Scalars['String']>;
  videoThumbnailUrl?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type MediaInput = {
  audio?: InputMaybe<Scalars['String']>;
  cdn01?: InputMaybe<Scalars['String']>;
  downloadLink?: InputMaybe<DownloadInput>;
  height?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<Scalars['String']>;
  videoSourceType?: InputMaybe<Scalars['String']>;
  videoThumbnailUrl?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ClearSelectedStrategy: Scalars['Boolean'];
  MarkChecklistAsCompleted: Scalars['Boolean'];
  ResetOnboarding: Scalars['Boolean'];
  SaveOnboardingDismissal: OnboardingDismissalModel;
  SaveOnboardingResponses: Scalars['Boolean'];
  SaveSelectedStrategy: Scalars['Boolean'];
  SaveTaskProgress: Scalars['Boolean'];
  SetActiveChecklist: Scalars['Boolean'];
  addClass: Class;
  addCustomDomain: CustomDomain;
  addFolder: LibraryFolder;
  addLandingPageConfig: LandingPageConfig;
  addPost?: Maybe<Post>;
  addPurchasePageConfig: PurchasePageConfig;
  addReply?: Maybe<Reply>;
  addTagToContent: Scalars['Boolean'];
  addToFolder: Scalars['Boolean'];
  adminUpdateInfluencer: Scalars['Boolean'];
  archiveCollection: Collection;
  banUser: User;
  blockUser?: Maybe<Scalars['Boolean']>;
  bulkCreateDiscoverySection: Scalars['Boolean'];
  bulkDelete: Scalars['Boolean'];
  bulkDeleteDiscoverySection: Scalars['Boolean'];
  bulkDeleteVideos: Scalars['Boolean'];
  bulkUpdateDiscoverySection: Scalars['Boolean'];
  bulkUpdateDiscoverySectionOrder: Scalars['Boolean'];
  confirmDomain: CustomDomain;
  convertToSubscriptionProgram: Collection;
  convertToUnassignedProgram: Collection;
  copyWorkoutToProgram: WorkoutTiny;
  copyWorkoutsToProgram: WorkoutTiny;
  createChallenge: Challenge;
  createComment: IdObject;
  createContent: IdObject;
  createCoupon: Coupon;
  createDraftCollection: Collection;
  createImage: IdObject;
  createInfluencer: Creator;
  createLegacyGuide: IdObject;
  createLink: IdObject;
  createOtpBundle: BundleResponse;
  createPDF: IdObject;
  createReport: IdObject;
  createSlides: IdObject;
  createSubscriptionBundle: Bundle;
  createTab: IdObject;
  createTag: IdObject;
  createVideo: IdObject;
  deactivateCoupon: Coupon;
  deleteClass: Scalars['String'];
  deleteCollection: Collection;
  deleteContent: Scalars['Boolean'];
  deleteEngagement: Scalars['Boolean'];
  deleteFolder: Scalars['Boolean'];
  deleteOtpBundle: Scalars['Boolean'];
  deletePost?: Maybe<Post>;
  deleteReply?: Maybe<Reply>;
  deleteVideo: Scalars['Boolean'];
  disableCommunity: Scalars['Float'];
  editVideo: Video;
  enableCheckoutFreeTrial: Scalars['Boolean'];
  enableCommunity: Scalars['Float'];
  generateProfileText: GenerateProfileTextResult;
  grantFreeExclusiveSubscriptionToCreator: Scalars['Boolean'];
  initializePricing: Pricing;
  keepContent?: Maybe<Scalars['Boolean']>;
  moveCollectionToDrafts: Collection;
  orderCollections?: Maybe<Scalars['Boolean']>;
  publishCollection: Collection;
  publishPost?: Maybe<Post>;
  publishSubscriptionBundle: Bundle;
  removeDomain: Scalars['Boolean'];
  removePermanentBan: User;
  removePricing?: Maybe<Pricing>;
  removeShadowBan: User;
  removeTagFromContent: Scalars['Boolean'];
  renameFolder: LibraryFolder;
  reorderContent: ContentIds;
  resetStripeData: Scalars['Boolean'];
  resyncSubscriptionBundleFeatures: BundleFeatureResyncResult;
  revertDeleteVideo: Scalars['Boolean'];
  sendSubscriptionBundlePushNotification: Scalars['Boolean'];
  setBundleBusinessModel: Scalars['Boolean'];
  setCreatorAsLive: Scalars['Boolean'];
  setCustomUrl: Scalars['Boolean'];
  setDirectMessaging: Scalars['Boolean'];
  setIntercomPriority: Scalars['Boolean'];
  setLivestreaming: Scalars['Boolean'];
  setMyselfAsLive: Scalars['Boolean'];
  setOtpDefaultFee: Scalars['Boolean'];
  setOtpOfferDefaultFee: Scalars['Boolean'];
  setReaction: IdObject;
  setRevenueSplitRules: Scalars['Boolean'];
  setSubmissionShortlistStatus: Scalars['Boolean'];
  setUserAsKnown: User;
  setVisibility: Scalars['Boolean'];
  shadowBanUser: User;
  togglePinPost?: Maybe<Scalars['Boolean']>;
  toggleReaction?: Maybe<Post>;
  unblockUser?: Maybe<Scalars['Boolean']>;
  unpublishCollection: Collection;
  unpublishWorkoutById: Scalars['Boolean'];
  updateBundles: Array<Bundle>;
  updateChallenge: Challenge;
  updateClass: Class;
  updateComment: Scalars['Boolean'];
  updateCommentVisibility: Scalars['Boolean'];
  updateContent: Scalars['Boolean'];
  updateCreatorProfile: Scalars['Boolean'];
  updateDiscount?: Maybe<Pricing>;
  updateImage: Scalars['Boolean'];
  updateLandingPageConfig: LandingPageConfig;
  updateLegacyGuide: Scalars['Boolean'];
  updateLink: Scalars['Boolean'];
  updateNotificationPreference: Array<NotificationPreference>;
  updateOtpBundle: BundleResponse;
  updatePDF: Scalars['Boolean'];
  updatePost?: Maybe<Post>;
  updatePricing: Pricing;
  updatePurchasePageConfig: PurchasePageConfig;
  updateReply?: Maybe<Reply>;
  updateReportsStatus: Scalars['Boolean'];
  updateSlides: Scalars['Boolean'];
  updateTab: Scalars['Boolean'];
  updateVideo: Scalars['Boolean'];
  updateWorkoutName: WorkoutTiny;
  upsertConsumerById: Scalars['Boolean'];
  upsertOrArchiveSubscriptionBundlePrices: Scalars['Boolean'];
};

export type MutationClearSelectedStrategyArgs = {
  creatorId: Scalars['ID'];
};

export type MutationMarkChecklistAsCompletedArgs = {
  checklistId: Scalars['ID'];
  creatorId: Scalars['ID'];
};

export type MutationResetOnboardingArgs = {
  creatorId: Scalars['ID'];
};

export type MutationSaveOnboardingDismissalArgs = {
  creatorId: Scalars['ID'];
  dismissed?: InputMaybe<Scalars['Boolean']>;
  platform: Platform;
};

export type MutationSaveOnboardingResponsesArgs = {
  creatorId: Scalars['ID'];
  platform?: InputMaybe<Platform>;
  responses: Array<OnboardingResponseInput>;
};

export type MutationSaveSelectedStrategyArgs = {
  creatorId: Scalars['ID'];
  strategyId: Scalars['ID'];
};

export type MutationSaveTaskProgressArgs = {
  creatorId: Scalars['ID'];
  input: UpdateTaskProgressInputModel;
};

export type MutationSetActiveChecklistArgs = {
  creatorId: Scalars['ID'];
  input: SetActiveChecklistInputModel;
};

export type MutationAddClassArgs = {
  data: AddClassInput;
};

export type MutationAddCustomDomainArgs = {
  domain: Scalars['String'];
  influencerId: Scalars['Int'];
};

export type MutationAddFolderArgs = {
  creatorId: Scalars['Int'];
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['Int']>;
};

export type MutationAddLandingPageConfigArgs = {
  data: AddLandingPageConfigInput;
};

export type MutationAddPostArgs = {
  communityId: Scalars['Int'];
  media?: InputMaybe<Array<MediaInput>>;
  publishAt?: InputMaybe<Scalars['DateTime']>;
  text: Scalars['String'];
};

export type MutationAddPurchasePageConfigArgs = {
  data: AddPurchasePageConfigInput;
};

export type MutationAddReplyArgs = {
  communityId: Scalars['Int'];
  media?: InputMaybe<Array<MediaInput>>;
  parentReplyId?: InputMaybe<Scalars['String']>;
  postId: Scalars['String'];
  text: Scalars['String'];
};

export type MutationAddTagToContentArgs = {
  creatorId: Scalars['ID'];
  input: AddTagToContentInput;
};

export type MutationAddToFolderArgs = {
  creatorId: Scalars['Int'];
  folderIds?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['Int']>;
  videoIds?: InputMaybe<Array<Scalars['String']>>;
};

export type MutationAdminUpdateInfluencerArgs = {
  data: AdminInfluencerUpdateInput;
};

export type MutationArchiveCollectionArgs = {
  collectionId: Scalars['Int'];
};

export type MutationBanUserArgs = {
  userId: Scalars['Int'];
};

export type MutationBlockUserArgs = {
  communityId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MutationBulkCreateDiscoverySectionArgs = {
  input: Array<CreateDiscoveryInput>;
};

export type MutationBulkDeleteArgs = {
  creatorId: Scalars['Int'];
  folderIds?: InputMaybe<Array<Scalars['Int']>>;
  videoIds?: InputMaybe<Array<Scalars['String']>>;
};

export type MutationBulkDeleteDiscoverySectionArgs = {
  ids: Array<Scalars['Int']>;
};

export type MutationBulkDeleteVideosArgs = {
  creatorId: Scalars['Int'];
  videoIds: Array<Scalars['String']>;
};

export type MutationBulkUpdateDiscoverySectionArgs = {
  input: Array<UpdateDiscoveryInput>;
};

export type MutationBulkUpdateDiscoverySectionOrderArgs = {
  input: UpdateDiscoverySectionOrderInput;
};

export type MutationConfirmDomainArgs = {
  domainId: Scalars['Int'];
  influencerId: Scalars['Int'];
};

export type MutationConvertToSubscriptionProgramArgs = {
  programId: Scalars['Int'];
};

export type MutationConvertToUnassignedProgramArgs = {
  programId: Scalars['Int'];
};

export type MutationCopyWorkoutToProgramArgs = {
  input: CopyWorkoutToCollectionInput;
};

export type MutationCopyWorkoutsToProgramArgs = {
  input: CopyWorkoutsToCollectionInput;
};

export type MutationCreateChallengeArgs = {
  input: CreateChallengeInput;
};

export type MutationCreateCommentArgs = {
  creatorId: Scalars['ID'];
  input: CreateCommentInput;
};

export type MutationCreateContentArgs = {
  creatorId: Scalars['ID'];
  file?: InputMaybe<Scalars['Upload']>;
  input: Scalars['JSON'];
};

export type MutationCreateCouponArgs = {
  input: CreateCouponInput;
};

export type MutationCreateDraftCollectionArgs = {
  data: CreateCollectionInput;
};

export type MutationCreateImageArgs = {
  creatorId: Scalars['ID'];
  file: Scalars['Upload'];
  input: CreateImageInput;
};

export type MutationCreateInfluencerArgs = {
  data: CreateInfluencerInput;
};

export type MutationCreateLegacyGuideArgs = {
  creatorId: Scalars['ID'];
  input: CreateLegacyGuideInput;
};

export type MutationCreateLinkArgs = {
  creatorId: Scalars['ID'];
  input: CreateLinkInput;
};

export type MutationCreateOtpBundleArgs = {
  input: CreateOtpBundleInput;
};

export type MutationCreatePdfArgs = {
  creatorId: Scalars['ID'];
  file: Scalars['Upload'];
  input: CreatePdfInput;
};

export type MutationCreateReportArgs = {
  input: CreateReportInput;
};

export type MutationCreateSlidesArgs = {
  creatorId: Scalars['ID'];
  input: CreateSlidesInput;
};

export type MutationCreateSubscriptionBundleArgs = {
  input: CreateSubscriptionBundleInput;
};

export type MutationCreateTabArgs = {
  creatorId: Scalars['ID'];
  input: CreateTabInput;
};

export type MutationCreateTagArgs = {
  creatorId: Scalars['ID'];
  input: CreateTagInput;
};

export type MutationCreateVideoArgs = {
  creatorId: Scalars['ID'];
  input: CreateVideoInput;
};

export type MutationDeactivateCouponArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteClassArgs = {
  id: Scalars['String'];
  influencerId?: InputMaybe<Scalars['Int']>;
};

export type MutationDeleteCollectionArgs = {
  collectionId: Scalars['Int'];
};

export type MutationDeleteContentArgs = {
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
};

export type MutationDeleteEngagementArgs = {
  creatorId: Scalars['String'];
  engagementId: Scalars['ID'];
};

export type MutationDeleteFolderArgs = {
  id: Scalars['Int'];
};

export type MutationDeleteOtpBundleArgs = {
  bundleId: Scalars['Int'];
};

export type MutationDeletePostArgs = {
  communityId: Scalars['Int'];
  postId: Scalars['String'];
};

export type MutationDeleteReplyArgs = {
  communityId: Scalars['Int'];
  postId: Scalars['String'];
};

export type MutationDeleteVideoArgs = {
  creatorId: Scalars['Int'];
  id: Scalars['String'];
  videoSourceType: Scalars['String'];
};

export type MutationDisableCommunityArgs = {
  creatorId: Scalars['Int'];
};

export type MutationEditVideoArgs = {
  creatorId: Scalars['Int'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  thumbnailTimestamp?: InputMaybe<Scalars['Float']>;
  videoSourceType: Scalars['String'];
};

export type MutationEnableCheckoutFreeTrialArgs = {
  data: EnableCreatorSettingsInput;
};

export type MutationEnableCommunityArgs = {
  creatorEmail: Scalars['String'];
  creatorId: Scalars['Int'];
  creatorName: Scalars['String'];
};

export type MutationGenerateProfileTextArgs = {
  creatorId?: InputMaybe<Scalars['Int']>;
  input: GenerateProfileTextInput;
};

export type MutationGrantFreeExclusiveSubscriptionToCreatorArgs = {
  creatorId: Scalars['Int'];
};

export type MutationInitializePricingArgs = {
  price: Scalars['Int'];
  programId: Scalars['Int'];
};

export type MutationKeepContentArgs = {
  contentId: Scalars['Int'];
};

export type MutationMoveCollectionToDraftsArgs = {
  collectionId: Scalars['Int'];
};

export type MutationOrderCollectionsArgs = {
  ids: Array<Scalars['Int']>;
  influencerId: Scalars['Int'];
  salesType: SalesType;
};

export type MutationPublishCollectionArgs = {
  bundleIds?: InputMaybe<Array<Scalars['Int']>>;
  collectionId: Scalars['Int'];
  customMessage?: InputMaybe<Scalars['String']>;
  onlyPublish?: InputMaybe<Scalars['Boolean']>;
};

export type MutationPublishPostArgs = {
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  publishAt?: InputMaybe<Scalars['DateTime']>;
};

export type MutationPublishSubscriptionBundleArgs = {
  bundleId: Scalars['Int'];
};

export type MutationRemoveDomainArgs = {
  domainId: Scalars['Int'];
  influencerId: Scalars['Int'];
};

export type MutationRemovePermanentBanArgs = {
  userId: Scalars['Int'];
};

export type MutationRemovePricingArgs = {
  programId: Scalars['Int'];
};

export type MutationRemoveShadowBanArgs = {
  userId: Scalars['Int'];
};

export type MutationRemoveTagFromContentArgs = {
  creatorId: Scalars['ID'];
  input: RemoveTagFromContentInput;
};

export type MutationRenameFolderArgs = {
  creatorId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type MutationReorderContentArgs = {
  contentIds: ContentIdsInput;
  creatorId: Scalars['ID'];
};

export type MutationResetStripeDataArgs = {
  influencerId: Scalars['Int'];
};

export type MutationResyncSubscriptionBundleFeaturesArgs = {
  influencerIds?: InputMaybe<Array<Scalars['Int']>>;
};

export type MutationRevertDeleteVideoArgs = {
  creatorId: Scalars['Int'];
  id: Scalars['String'];
  videoSourceType: Scalars['String'];
};

export type MutationSendSubscriptionBundlePushNotificationArgs = {
  bundleId: Scalars['Int'];
  message: Scalars['String'];
};

export type MutationSetBundleBusinessModelArgs = {
  data: SetBundleBusinessModelInput;
};

export type MutationSetCreatorAsLiveArgs = {
  creatorId: Scalars['Int'];
};

export type MutationSetCustomUrlArgs = {
  data: SetCustomUrlInput;
};

export type MutationSetDirectMessagingArgs = {
  data: EnableCreatorSettingsInput;
};

export type MutationSetIntercomPriorityArgs = {
  data: SetIntercomPriorityInput;
};

export type MutationSetLivestreamingArgs = {
  data: EnableCreatorSettingsInput;
};

export type MutationSetOtpDefaultFeeArgs = {
  data: SetOtpDefaultFeeInput;
};

export type MutationSetOtpOfferDefaultFeeArgs = {
  data: SetOtpDefaultFeeInput;
};

export type MutationSetReactionArgs = {
  creatorId: Scalars['ID'];
  input: SetReactionInput;
};

export type MutationSetRevenueSplitRulesArgs = {
  data: SetRevenueSplitRulesInput;
};

export type MutationSetSubmissionShortlistStatusArgs = {
  isShortlisted: Scalars['Boolean'];
  submissionId: Scalars['Int'];
};

export type MutationSetUserAsKnownArgs = {
  userId: Scalars['Int'];
};

export type MutationSetVisibilityArgs = {
  data: SetVisibilityInput;
};

export type MutationShadowBanUserArgs = {
  userId: Scalars['Int'];
};

export type MutationTogglePinPostArgs = {
  communityId: Scalars['Int'];
  pinned: Scalars['Boolean'];
  postId: Scalars['String'];
};

export type MutationToggleReactionArgs = {
  communityId: Scalars['Int'];
  entityId: Scalars['String'];
  parent: ReactionParent;
  type: ReactionType;
};

export type MutationUnblockUserArgs = {
  communityId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type MutationUnpublishCollectionArgs = {
  collectionId: Scalars['Int'];
};

export type MutationUnpublishWorkoutByIdArgs = {
  id: Scalars['Int'];
};

export type MutationUpdateBundlesArgs = {
  input: Array<UpdateBundleInput>;
};

export type MutationUpdateChallengeArgs = {
  input: UpdateChallengeInput;
};

export type MutationUpdateClassArgs = {
  data: UpdateClassInput;
};

export type MutationUpdateCommentArgs = {
  commentId: Scalars['ID'];
  creatorId: Scalars['ID'];
  input: UpdateCommentInput;
};

export type MutationUpdateCommentVisibilityArgs = {
  commentId: Scalars['ID'];
  creatorId: Scalars['ID'];
  isVisible: Scalars['Boolean'];
};

export type MutationUpdateContentArgs = {
  creatorId: Scalars['ID'];
  file?: InputMaybe<Scalars['Upload']>;
  input: Scalars['JSON'];
  itemId: Scalars['ID'];
};

export type MutationUpdateCreatorProfileArgs = {
  data: CreatorProfileUpdateInput;
};

export type MutationUpdateDiscountArgs = {
  discount?: InputMaybe<Scalars['Int']>;
  programId: Scalars['Int'];
};

export type MutationUpdateImageArgs = {
  creatorId: Scalars['ID'];
  input: UpdateImageInput;
  itemId: Scalars['ID'];
};

export type MutationUpdateLandingPageConfigArgs = {
  data: UpdateLandingPageConfigInput;
};

export type MutationUpdateLegacyGuideArgs = {
  creatorId: Scalars['ID'];
  input: UpdateLegacyGuideInput;
  itemId: Scalars['ID'];
};

export type MutationUpdateLinkArgs = {
  creatorId: Scalars['ID'];
  input: UpdateLinkInput;
  itemId: Scalars['ID'];
};

export type MutationUpdateNotificationPreferenceArgs = {
  preference: UpdateNotificationPreference;
  responseVersion?: InputMaybe<Scalars['Int']>;
};

export type MutationUpdateOtpBundleArgs = {
  input: UpdateOtpBundleInput;
};

export type MutationUpdatePdfArgs = {
  creatorId: Scalars['ID'];
  file?: InputMaybe<Scalars['Upload']>;
  input: UpdatePdfInput;
  itemId: Scalars['ID'];
};

export type MutationUpdatePostArgs = {
  communityId: Scalars['Int'];
  media?: InputMaybe<Array<MediaInput>>;
  postId: Scalars['String'];
  text: Scalars['String'];
};

export type MutationUpdatePricingArgs = {
  fee: Scalars['Int'];
  price: Scalars['Int'];
  programId: Scalars['Int'];
};

export type MutationUpdatePurchasePageConfigArgs = {
  data: UpdatePurchasePageConfigInput;
};

export type MutationUpdateReplyArgs = {
  communityId: Scalars['Int'];
  replyId: Scalars['String'];
  text: Scalars['String'];
};

export type MutationUpdateReportsStatusArgs = {
  input: UpdateReportsStatusInput;
};

export type MutationUpdateSlidesArgs = {
  creatorId: Scalars['ID'];
  input: UpdateSlidesInput;
  itemId: Scalars['ID'];
};

export type MutationUpdateTabArgs = {
  creatorId: Scalars['ID'];
  input: UpdateTabInput;
  itemId: Scalars['ID'];
};

export type MutationUpdateVideoArgs = {
  creatorId: Scalars['ID'];
  input: UpdateVideoInput;
  itemId: Scalars['ID'];
};

export type MutationUpdateWorkoutNameArgs = {
  name: Scalars['String'];
  workoutId: Scalars['Int'];
};

export type MutationUpsertConsumerByIdArgs = {
  id: Scalars['Int'];
};

export type MutationUpsertOrArchiveSubscriptionBundlePricesArgs = {
  input: UpsertOrArchiveSubscriptionBundlePricesInput;
};

export enum NotificationCategory {
  Community = 'COMMUNITY',
  DirectMessages = 'DIRECT_MESSAGES',
  MarketingEmails = 'MARKETING_EMAILS',
  OnboardingEmails = 'ONBOARDING_EMAILS',
  WorkoutComments = 'WORKOUT_COMMENTS',
}

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  category: NotificationCategory;
  creatorId: Scalars['Int'];
  grouped: Scalars['Boolean'];
  status: NotificationPreferenceStatus;
};

export enum NotificationPreferenceStatus {
  OptedIn = 'OPTED_IN',
  Subscribed = 'SUBSCRIBED',
  Unsubscribed = 'UNSUBSCRIBED',
}

export type NutritionsSection = {
  __typename?: 'NutritionsSection';
  count?: Maybe<Scalars['Int']>;
  influencerId?: Maybe<Scalars['Int']>;
  nutritionId?: Maybe<Scalars['Int']>;
  type: Scalars['Int'];
};

export type NutritionsSectionInput = {
  count: Scalars['Int'];
  influencerId: Scalars['Int'];
  nutritionId: Scalars['Int'];
};

export type Otp = {
  __typename?: 'OTP';
  createdAt: Scalars['String'];
  deletedAt?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isFree: Scalars['Boolean'];
  productId: Scalars['Int'];
  productName?: Maybe<Scalars['String']>;
  productType: Scalars['String'];
  updatedAt: Scalars['String'];
  userId: Scalars['Int'];
};

export type OnboardingAnswerModel = {
  __typename?: 'OnboardingAnswerModel';
  id: Scalars['ID'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

export type OnboardingDismissalModel = {
  __typename?: 'OnboardingDismissalModel';
  mobileDismissedAt?: Maybe<Scalars['String']>;
  webDismissedAt?: Maybe<Scalars['String']>;
};

export type OnboardingList = {
  __typename?: 'OnboardingList';
  collectionPublishedReady: Scalars['Boolean'];
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  paymentMethodReady: Scalars['Boolean'];
  profileReady: Scalars['Boolean'];
};

export type OnboardingQuestionModel = {
  __typename?: 'OnboardingQuestionModel';
  answers: Array<OnboardingAnswerModel>;
  id: Scalars['ID'];
  isRequired: Scalars['Boolean'];
  platforms: Array<Platform>;
  subtitle?: Maybe<Scalars['String']>;
  targetCategory?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: OnboardingQuestionType;
};

export enum OnboardingQuestionType {
  MultiChoice = 'MULTI_CHOICE',
  OpenText = 'OPEN_TEXT',
  SingleChoice = 'SINGLE_CHOICE',
}

export type OnboardingResponseInput = {
  answerId?: InputMaybe<Scalars['String']>;
  answerIds?: InputMaybe<Array<Scalars['ID']>>;
  questionId: Scalars['String'];
  textValue?: InputMaybe<Scalars['String']>;
};

export type OnboardingResponsePayload = {
  __typename?: 'OnboardingResponsePayload';
  /** @deprecated Use answerIds instead */
  answerId?: Maybe<Scalars['String']>;
  answerIds: Array<Scalars['ID']>;
  questionId: Scalars['String'];
  textValue?: Maybe<Scalars['String']>;
};

export type OneTimeProduct = {
  __typename?: 'OneTimeProduct';
  id: Scalars['Int'];
  playbookFee: Scalars['Int'];
  price: Scalars['Int'];
  providerPriceId: Scalars['String'];
  providerProductId: Scalars['String'];
};

export type PayoutRule = {
  __typename?: 'PayoutRule';
  amount: Scalars['Int'];
  creatorId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  ruleType: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export enum Platform {
  Ios = 'IOS',
  Web = 'WEB',
}

export type Post = {
  __typename?: 'Post';
  author: Author;
  communityId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  /** True once the author edited the content more than 5 minutes after creation. Render "(Edited)" from this and nothing else - updatedAt also moves on pins, reports, and video callbacks. */
  edited: Scalars['Boolean'];
  id: Scalars['String'];
  isSensitiveContent: Scalars['Boolean'];
  media: Array<Media>;
  pinned?: Maybe<Scalars['Boolean']>;
  /** Null for drafts; the (future) publish time for the rest. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  reactions: Array<Reaction>;
  replies: Array<Reply>;
  status?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PostRepliesArgs = {
  direction?: InputMaybe<Scalars['String']>;
  lastId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PostsType>;
};

export enum PostsType {
  All = 'all',
  Pinned = 'pinned',
}

export type Pricing = {
  __typename?: 'Pricing';
  discountPercent?: Maybe<Scalars['Percentage']>;
  discountedPrice?: Maybe<Scalars['Price']>;
  playbookFee?: Maybe<Scalars['Percentage']>;
  price: Scalars['Price'];
  programId: Scalars['ID'];
};

export type ProcessingVideo = {
  __typename?: 'ProcessingVideo';
  aspectRatio?: Maybe<Scalars['String']>;
  cdn01?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creatorId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  fileSize?: Maybe<Scalars['Float']>;
  folderId?: Maybe<Scalars['Int']>;
  height: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  video?: Maybe<Scalars['String']>;
  videoSourceType: Scalars['String'];
  videoThumbnailUrl: Scalars['String'];
  videoUrl: Scalars['String'];
  width: Scalars['Int'];
};

export type ProductCatalogItem = {
  __typename?: 'ProductCatalogItem';
  price: Scalars['Int'];
  productDescription: Scalars['String'];
  productName: Scalars['String'];
  purchaseLink: Scalars['String'];
  tags: Array<Scalars['String']>;
  thumbnailUrl: Scalars['String'];
};

export type ProductCatalogItemInput = {
  price: Scalars['Int'];
  productDescription: Scalars['String'];
  productName: Scalars['String'];
  purchaseLink: Scalars['String'];
  tags?: Array<Scalars['String']>;
  thumbnailUrl: Scalars['String'];
};

export type Program = {
  __typename?: 'Program';
  accessType: Scalars['String'];
  activeChallenge?: Maybe<Challenge>;
  archivedAt?: Maybe<Scalars['Date']>;
  challenges?: Maybe<Array<Maybe<Challenge>>>;
  color?: Maybe<Scalars['String']>;
  contentStructure?: Maybe<Scalars['String']>;
  daysPerWeek?: Maybe<Scalars['Float']>;
  deeplinkUrl?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  exclusiveProgramMetadata?: Maybe<ExclusiveProgramMetadata>;
  expiresAt?: Maybe<Scalars['Date']>;
  faq?: Maybe<Array<Maybe<FeedFaq>>>;
  goal?: Maybe<Scalars['String']>;
  hiddenSections?: Maybe<ProgramHiddenSections>;
  id: Scalars['Int'];
  inAppPurchase: InAppPurchase;
  index?: Maybe<Scalars['Float']>;
  influencer?: Maybe<Creator>;
  influencerId: Scalars['Int'];
  isLocked?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  mediaCover?: Maybe<Media>;
  mediaIntro?: Maybe<Media>;
  migrationBundleId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  programBusinessModel?: Maybe<ProgramBusinessModel>;
  programStats?: Maybe<ProgramStatsModel>;
  publishedAt?: Maybe<Scalars['Date']>;
  publishingBehaviour: Scalars['String'];
  purchasePageConfig?: Maybe<PurchasePageConfig>;
  readiness?: Maybe<ProgramReadiness>;
  requiredEquipment?: Maybe<Array<Scalars['String']>>;
  sessionDuration?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  testimonials?: Maybe<Array<Maybe<Testimonial>>>;
  type: Scalars['Float'];
  workoutLimit?: Maybe<Scalars['Float']>;
  workouts?: Maybe<Array<Maybe<WorkoutTiny>>>;
};

export type ProgramWorkoutsArgs = {
  scopes?: InputMaybe<WorkoutScopesInput>;
};

export enum ProgramAccessType {
  Exclusive = 'Exclusive',
  Premium = 'Premium',
  PremiumExclusive = 'PremiumExclusive',
}

export enum ProgramBusinessModel {
  Purchase = 'Purchase',
  Subscription = 'Subscription',
  Unassigned = 'Unassigned',
}

export type ProgramHiddenSections = {
  __typename?: 'ProgramHiddenSections';
  faq?: Maybe<Scalars['Boolean']>;
  testimonials?: Maybe<Scalars['Boolean']>;
};

export type ProgramReadiness = {
  __typename?: 'ProgramReadiness';
  cover: Scalars['Boolean'];
  goal: Scalars['Boolean'];
  title: Scalars['Boolean'];
  workouts: Scalars['Boolean'];
};

export type ProgramStatsModel = {
  __typename?: 'ProgramStatsModel';
  avgRating?: Maybe<Scalars['Float']>;
  statsBegins: Scalars['Int'];
  statsComments: Scalars['Int'];
  statsCompletions: Scalars['Int'];
  statsFavorites: Scalars['Int'];
  statsRatings: Scalars['Int'];
  statsViews: Scalars['Int'];
};

export type ProgramSwapConfig = {
  __typename?: 'ProgramSwapConfig';
  swapsEnabled: Scalars['Boolean'];
};

export type ProgramsCarouselSection = {
  __typename?: 'ProgramsCarouselSection';
  coverUrl?: Maybe<Scalars['String']>;
  influencerId?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['Int']>;
  type: Scalars['Int'];
};

export type ProgramsCarouselSectionInput = {
  coverUrl?: InputMaybe<Scalars['String']>;
  influencerId?: InputMaybe<Scalars['Int']>;
  programId?: InputMaybe<Scalars['Int']>;
};

export type ProgramsSection = {
  __typename?: 'ProgramsSection';
  coverUrl?: Maybe<Scalars['String']>;
  influencerId?: Maybe<Scalars['Int']>;
  influencerName?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['Int']>;
  programName?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
};

export type ProgramsSectionInput = {
  coverUrl?: InputMaybe<Scalars['String']>;
  influencerId?: InputMaybe<Scalars['Int']>;
  influencerName?: InputMaybe<Scalars['String']>;
  programId?: InputMaybe<Scalars['Int']>;
  programName?: InputMaybe<Scalars['String']>;
};

export type PurchasePageConfig = {
  __typename?: 'PurchasePageConfig';
  config?: Maybe<Scalars['JSONObject']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  programId: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export type PurchasedOtpProduct = {
  __typename?: 'PurchasedOtpProduct';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  productType: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  GetBookingStep: BookingStepModel;
  GetChecklists: Array<ChecklistModel>;
  GetOnboardingDismissal: OnboardingDismissalModel;
  GetOnboardingQuestions: Array<OnboardingQuestionModel>;
  GetOnboardingResponses: Array<OnboardingResponsePayload>;
  GetStrategies: Array<StrategyModel>;
  GetStrategyScoringCategory: Array<StrategyScoringCategoryModel>;
  GetStrategyScoringRules: Array<StrategyScoringRuleModel>;
  allSubscriptionTiers: Array<SubscriptionTier>;
  blockedUsers?: Maybe<Array<BlockedUser>>;
  bundle: Array<Bundle>;
  bundleById: Bundle;
  collection: Collection;
  collections: Array<Collection>;
  community?: Maybe<Community>;
  content: Content;
  contentEvents: Array<ContentEvent>;
  creator?: Maybe<Creator>;
  creatorByCustomURL?: Maybe<Creator>;
  creatorByDomain?: Maybe<Creator>;
  creatorCommunity?: Maybe<Community>;
  creators: Array<Maybe<Creator>>;
  discoveryData: Array<Discovery>;
  discoveryDataByCreatorId: Array<Discovery>;
  exclusivePrograms: Array<Program>;
  feature: Array<Feature>;
  findUserById?: Maybe<User>;
  findUsers?: Maybe<Users>;
  getActiveChallengesByProgramId: Array<Challenge>;
  getChallengeById: Challenge;
  getClass: Class;
  getComments: Array<CommentValue>;
  getCommentsForContent: Array<EngagementComment>;
  getCommentsWithReactions: Array<CommentValue>;
  getContentIdsWithTag: Array<Scalars['ID']>;
  getCouponDetails: CouponDetails;
  getCouponsByInfluencer: Array<Coupon>;
  getCreatorsFolders: Array<LibraryFolder>;
  getCreatorsMedia: Array<Video>;
  getCreatorsProcessingMedia: Array<ProcessingVideo>;
  getEngagementSummary: EngagementSummary;
  getLibrary: GetLibrary;
  getOtpDeepLink?: Maybe<Scalars['String']>;
  getPricing?: Maybe<Pricing>;
  getReactionsForContent: Array<EngagementReaction>;
  getReportsForContent: Array<EngagementReport>;
  getReportsWithContent: Array<ReportWithContent>;
  getTagByName?: Maybe<ContentTag>;
  getTags: Array<ContentTag>;
  getTagsForContentId: Array<ContentTag>;
  getUsersInfoByIds?: Maybe<Array<Author>>;
  getVideoById?: Maybe<Video>;
  getVideosById?: Maybe<Array<Video>>;
  influencerClasses: Array<Class>;
  isCustomUrlAvailable: Scalars['Boolean'];
  landingPageConfig?: Maybe<LandingPageConfig>;
  landingPageConfigByCustomUrl?: Maybe<LandingPageConfig>;
  listSubscriptionBundleFeatureResyncCandidates: BundleFeatureResyncCandidates;
  onboardingListData: OnboardingList;
  parentBundlesByItem: Array<Bundle>;
  post?: Maybe<Post>;
  /** @deprecated Use collection query */
  program: Program;
  publishedWorkouts: Array<Maybe<WorkoutTiny>>;
  purchasePageConfig?: Maybe<PurchasePageConfig>;
  reportedContent?: Maybe<Array<ReportedActivity>>;
  reportedContentCount?: Maybe<Scalars['Int']>;
  searchComments: Array<Comment>;
  stripeDataByEmail?: Maybe<StripeCustomer>;
  stripeDataByUserId?: Maybe<StripeCustomer>;
  subscriptionRevenue: SubscriptionRevenue;
  subscriptionTierByInfluencer: Array<SubscriptionTier>;
  swapCatalogExercises: Array<SwapCatalogExercise>;
  userChallengeParticipation: UserChallengeParticipation;
  userPurchases?: Maybe<Array<Maybe<UserPurchase>>>;
  workout?: Maybe<WorkoutTiny>;
  workouts: Array<WorkoutTiny>;
  workoutsByTags: Array<Maybe<WorkoutTiny>>;
};

export type QueryGetBookingStepArgs = {
  creatorId: Scalars['ID'];
};

export type QueryGetChecklistsArgs = {
  creatorId: Scalars['ID'];
};

export type QueryGetOnboardingDismissalArgs = {
  creatorId: Scalars['ID'];
};

export type QueryGetOnboardingQuestionsArgs = {
  platform: Platform;
};

export type QueryGetOnboardingResponsesArgs = {
  creatorId: Scalars['ID'];
};

export type QueryGetStrategiesArgs = {
  creatorId: Scalars['ID'];
};

export type QueryBlockedUsersArgs = {
  communityId: Scalars['Int'];
};

export type QueryBundleArgs = {
  bundlePricing?: InputMaybe<Array<BundlePricing>>;
  creatorId: Scalars['Int'];
};

export type QueryBundleByIdArgs = {
  bundleId: Scalars['Int'];
};

export type QueryCollectionArgs = {
  collectionId: Scalars['Int'];
};

export type QueryCollectionsArgs = {
  input: CollectionsInput;
};

export type QueryCommunityArgs = {
  id: Scalars['Int'];
};

export type QueryContentArgs = {
  creatorId: Scalars['ID'];
  itemId?: InputMaybe<Scalars['ID']>;
};

export type QueryContentEventsArgs = {
  contentId?: InputMaybe<Scalars['ID']>;
  creatorId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryCreatorArgs = {
  id: Scalars['Int'];
};

export type QueryCreatorByCustomUrlArgs = {
  customURL: Scalars['String'];
};

export type QueryCreatorByDomainArgs = {
  domain: Scalars['String'];
};

export type QueryCreatorCommunityArgs = {
  creatorId: Scalars['Int'];
};

export type QueryCreatorsArgs = {
  input?: InputMaybe<CreatorSearchInput>;
};

export type QueryDiscoveryDataByCreatorIdArgs = {
  creatorId: Scalars['Int'];
};

export type QueryFindUserByIdArgs = {
  id: Scalars['Int'];
};

export type QueryFindUsersArgs = {
  filters: UserSearchFilters;
};

export type QueryGetActiveChallengesByProgramIdArgs = {
  programId: Scalars['Int'];
};

export type QueryGetChallengeByIdArgs = {
  id: Scalars['Int'];
};

export type QueryGetClassArgs = {
  classId: Scalars['String'];
};

export type QueryGetCommentsArgs = {
  contentId: Scalars['String'];
  noThreads?: InputMaybe<Scalars['Boolean']>;
  usersLimit?: Scalars['Int'];
};

export type QueryGetCommentsForContentArgs = {
  contentId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryGetCommentsWithReactionsArgs = {
  contentId: Scalars['ID'];
  creatorId: Scalars['ID'];
  includeUsers?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
};

export type QueryGetContentIdsWithTagArgs = {
  creatorId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  tagId?: InputMaybe<Scalars['ID']>;
  tagInternalName?: InputMaybe<Scalars['String']>;
};

export type QueryGetCouponDetailsArgs = {
  id: Scalars['Int'];
};

export type QueryGetCouponsByInfluencerArgs = {
  influencerId: Scalars['Int'];
};

export type QueryGetCreatorsFoldersArgs = {
  creatorId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
};

export type QueryGetCreatorsMediaArgs = {
  creatorId: Scalars['Int'];
  includeProcessing?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
};

export type QueryGetCreatorsProcessingMediaArgs = {
  creatorId: Scalars['Int'];
};

export type QueryGetEngagementSummaryArgs = {
  contentId: Scalars['ID'];
  creatorId: Scalars['ID'];
  includeUsers?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGetLibraryArgs = {
  creatorId: Scalars['Int'];
  folderId?: InputMaybe<Scalars['Int']>;
};

export type QueryGetOtpDeepLinkArgs = {
  programId: Scalars['Int'];
};

export type QueryGetPricingArgs = {
  programId: Scalars['Int'];
};

export type QueryGetReactionsForContentArgs = {
  contentId: Scalars['ID'];
};

export type QueryGetReportsForContentArgs = {
  contentId: Scalars['ID'];
};

export type QueryGetReportsWithContentArgs = {
  creatorId?: InputMaybe<Scalars['ID']>;
  page?: Scalars['Int'];
  pageSize?: Scalars['Int'];
};

export type QueryGetTagByNameArgs = {
  creatorId: Scalars['ID'];
  name: Scalars['String'];
};

export type QueryGetTagsArgs = {
  creatorId: Scalars['ID'];
};

export type QueryGetTagsForContentIdArgs = {
  contentId: Scalars['ID'];
  creatorId: Scalars['ID'];
};

export type QueryGetUsersInfoByIdsArgs = {
  userIds: Array<Scalars['Int']>;
};

export type QueryGetVideoByIdArgs = {
  creatorId: Scalars['Int'];
  videoId: Scalars['String'];
  videoSourceType: Scalars['String'];
};

export type QueryGetVideosByIdArgs = {
  creatorId: Scalars['Int'];
  videosId: Array<Scalars['String']>;
};

export type QueryInfluencerClassesArgs = {
  influencerId: Scalars['Int'];
};

export type QueryIsCustomUrlAvailableArgs = {
  data: Scalars['String'];
};

export type QueryLandingPageConfigArgs = {
  influencerId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
  resolvable?: InputMaybe<Array<ResolvableField>>;
  type?: InputMaybe<LandingPageType>;
};

export type QueryLandingPageConfigByCustomUrlArgs = {
  customUrl: Scalars['String'];
  parentId?: InputMaybe<Scalars['Int']>;
  resolvable?: InputMaybe<Array<ResolvableField>>;
  type?: InputMaybe<LandingPageType>;
};

export type QueryOnboardingListDataArgs = {
  creatorId: Scalars['Int'];
};

export type QueryParentBundlesByItemArgs = {
  input: BundleItemInput;
};

export type QueryPostArgs = {
  communityId: Scalars['Int'];
  postId: Scalars['String'];
};

export type QueryProgramArgs = {
  live?: InputMaybe<Scalars['Boolean']>;
  programId: Scalars['Int'];
};

export type QueryPublishedWorkoutsArgs = {
  customUrl: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryPurchasePageConfigArgs = {
  programId: Scalars['Int'];
};

export type QueryReportedContentArgs = {
  communityId: Scalars['Int'];
};

export type QueryReportedContentCountArgs = {
  communityId: Scalars['Int'];
};

export type QuerySearchCommentsArgs = {
  creatorId?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['Int']>;
};

export type QueryStripeDataByEmailArgs = {
  email: Scalars['String'];
};

export type QueryStripeDataByUserIdArgs = {
  userId: Scalars['Int'];
};

export type QuerySubscriptionRevenueArgs = {
  influencerId: Scalars['Int'];
};

export type QuerySubscriptionTierByInfluencerArgs = {
  influencerId: Scalars['Int'];
};

export type QuerySwapCatalogExercisesArgs = {
  influencerId?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
};

export type QueryUserChallengeParticipationArgs = {
  creatorId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type QueryUserPurchasesArgs = {
  userId: Scalars['Int'];
};

export type QueryWorkoutArgs = {
  id: Scalars['Int'];
};

export type QueryWorkoutsArgs = {
  input: WorkoutsInput;
};

export type QueryWorkoutsByTagsArgs = {
  tags: Array<Scalars['String']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  count: Scalars['Int'];
  isToggled: Scalars['Boolean'];
  type: ReactionType;
};

export enum ReactionParent {
  Post = 'Post',
  Reply = 'Reply',
}

export enum ReactionType {
  CheckMark = 'CheckMark',
  Clap = 'Clap',
  Comment = 'Comment',
  Cry = 'Cry',
  Disappointed = 'Disappointed',
  ExplodingHead = 'ExplodingHead',
  Eyes = 'Eyes',
  FaceHearts = 'FaceHearts',
  Fire = 'Fire',
  Fist = 'Fist',
  Goat = 'Goat',
  Heart = 'Heart',
  HeartEyes = 'HeartEyes',
  Horns = 'Horns',
  Hug = 'Hug',
  Joy = 'Joy',
  Muscle = 'Muscle',
  OpenMouth = 'OpenMouth',
  Pray = 'Pray',
  RaisedHands = 'RaisedHands',
  Relieved = 'Relieved',
  Rocket = 'Rocket',
  Skull = 'Skull',
  Sparkles = 'Sparkles',
  SweatSmile = 'SweatSmile',
  Tada = 'Tada',
  Tear = 'Tear',
  ThumbsUp = 'ThumbsUp',
  Trophy = 'Trophy',
}

export type ReferralCampaignDetails = {
  __typename?: 'ReferralCampaignDetails';
  celloCampaignId?: Maybe<Scalars['String']>;
  celloReferrerCode: Scalars['String'];
  convertedAt?: Maybe<Scalars['Date']>;
  purchaseId: Scalars['String'];
  referralCampaignId?: Maybe<Scalars['Int']>;
  referrerUserId?: Maybe<Scalars['Int']>;
  rewardCapCents?: Maybe<Scalars['Int']>;
  rewardPercentage?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
};

export type ReferredCampaign = {
  __typename?: 'ReferredCampaign';
  influencerId: Scalars['Int'];
  influencerName?: Maybe<Scalars['String']>;
  referralCampaignId: Scalars['Int'];
};

export type RegistrationAttributes = {
  __typename?: 'RegistrationAttributes';
  goal?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
};

export type RegistrationRequirements = {
  __typename?: 'RegistrationRequirements';
  goal: Scalars['Boolean'];
  instagram: Scalars['Boolean'];
  photos: Scalars['Boolean'];
};

export type RegistrationRequirementsInput = {
  goal: Scalars['Boolean'];
  instagram: Scalars['Boolean'];
  photos: Scalars['Boolean'];
};

export type RemoveTagFromContentInput = {
  contentIds: Array<Scalars['ID']>;
  tagId: Scalars['ID'];
};

export type Reply = {
  __typename?: 'Reply';
  author: Author;
  createdAt: Scalars['DateTime'];
  /** True once the author edited the content more than 5 minutes after creation. Render "(Edited)" from this and nothing else - updatedAt also moves on pins, reports, and video callbacks. */
  edited: Scalars['Boolean'];
  id: Scalars['String'];
  isSensitiveContent: Scalars['Boolean'];
  media?: Maybe<Array<Media>>;
  /** Parent post id (for level-1 replies) or parent reply id (for level-2 replies). Null for legacy rows. */
  parentId?: Maybe<Scalars['String']>;
  reactions: Array<Reaction>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReportWithContent = {
  __typename?: 'ReportWithContent';
  content: CommentValue;
  reports: Array<EngagementReport>;
};

export type ReportedActivity = {
  __typename?: 'ReportedActivity';
  activityId: Scalars['String'];
  activityType: Scalars['String'];
  author: Author;
  createdAt: Scalars['DateTime'];
  id: Scalars['Float'];
  media?: Maybe<Array<Media>>;
  parentId?: Maybe<Scalars['String']>;
  reason: Scalars['Int'];
  reportedBy: Author;
  text: Scalars['String'];
};

export type ResolvableField = {
  fieldName: Scalars['String'];
  resolverType: Scalars['String'];
  sectionType: Scalars['String'];
};

export type RevenueSplitRule = {
  __typename?: 'RevenueSplitRule';
  attributionType: Scalars['String'];
  creatorId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  engagementPercent: Scalars['Int'];
  playbookPercent: Scalars['Int'];
  productType: Scalars['String'];
  referralPercent: Scalars['Int'];
  splitCriteria: Scalars['String'];
};

export enum SalesType {
  Otp = 'otp',
  Subscription = 'subscription',
}

export type SetActiveChecklistInputModel = {
  checklistId: Scalars['ID'];
};

export type SetBundleBusinessModelInput = {
  annualPriceCents?: InputMaybe<Scalars['Int']>;
  freeTrial: FreeTrialInput;
  influencerId: Scalars['Int'];
  monthlyPriceCents?: InputMaybe<Scalars['Int']>;
};

export type SetCustomUrlInput = {
  customUrl?: InputMaybe<Scalars['String']>;
};

export type SetIntercomPriorityInput = {
  disableCreatorIds: Array<Scalars['Int']>;
  enableCreatorIds: Array<Scalars['Int']>;
};

export type SetOtpDefaultFeeInput = {
  fee?: InputMaybe<Scalars['Int']>;
  influencerId: Scalars['Int'];
};

export type SetReactionInput = {
  contentId: Scalars['ID'];
  customEmoji?: InputMaybe<Scalars['String']>;
  reaction: EngagementReactionType;
};

export type SetRevenueSplitRulesInput = {
  influencerId: Scalars['Int'];
  playbook: Scalars['Int'];
  referral: Scalars['Int'];
};

export type SetVisibilityInput = {
  influencerId: Scalars['Int'];
  visibility: Visibility;
};

export type SimpleUser = {
  __typename?: 'SimpleUser';
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  instagram?: Maybe<Scalars['String']>;
  isBanned?: Maybe<Scalars['Boolean']>;
  mediaThumbnail?: Maybe<Media>;
  name: Scalars['String'];
};

export type SocialAccountStatus = {
  __typename?: 'SocialAccountStatus';
  connected: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
};

export type Source = {
  __typename?: 'Source';
  context?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  installationId: Scalars['Int'];
  sourceChannel?: Maybe<Scalars['String']>;
  sourceInfluencerId?: Maybe<Scalars['Int']>;
  sourceUrl?: Maybe<Scalars['String']>;
};

export type Story = {
  __typename?: 'Story';
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  media?: Maybe<Media>;
};

export type StrategyCaseStudyModel = {
  __typename?: 'StrategyCaseStudyModel';
  coverImageHorizontalUrl: Scalars['String'];
  coverImageVerticalUrl: Scalars['String'];
  creatorInstagramName: Scalars['String'];
  creatorName: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  documentUrl: Scalars['String'];
  id: Scalars['ID'];
  strategyId: Scalars['ID'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type StrategyModel = {
  __typename?: 'StrategyModel';
  caseStudies: Array<StrategyCaseStudyModel>;
  coverImageUrl?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  features: Array<Scalars['String']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  isRecommended?: Maybe<Scalars['Boolean']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  launchTimeLabel?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pills: Array<Scalars['String']>;
  priceLabel?: Maybe<Scalars['String']>;
  programLengthLabel?: Maybe<Scalars['String']>;
  superTitle?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
};

export type StrategyScoringCategoryModel = {
  __typename?: 'StrategyScoringCategoryModel';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StrategyScoringRuleModel = {
  __typename?: 'StrategyScoringRuleModel';
  categoryId: Scalars['ID'];
  id: Scalars['ID'];
  maxScore?: Maybe<Scalars['Int']>;
  minScore?: Maybe<Scalars['Int']>;
  strategyId: Scalars['ID'];
};

export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  address?: Maybe<Scalars['JSONObject']>;
  balance?: Maybe<Scalars['Int']>;
  created: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
  default_source?: Maybe<Scalars['String']>;
  delinquent?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  invoice_prefix?: Maybe<Scalars['String']>;
  invoice_settings?: Maybe<Scalars['JSONObject']>;
  livemode: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  next_invoice_sequence?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  referralCampaignDetails?: Maybe<Array<ReferralCampaignDetails>>;
  sources?: Maybe<Array<Maybe<StripeSource>>>;
  subscriptions?: Maybe<Array<Maybe<StripeSubscription>>>;
};

export type StripeSource = {
  __typename?: 'StripeSource';
  address_city?: Maybe<Scalars['String']>;
  address_country?: Maybe<Scalars['String']>;
  address_line1?: Maybe<Scalars['String']>;
  address_line1_check?: Maybe<Scalars['String']>;
  address_line2?: Maybe<Scalars['String']>;
  address_state?: Maybe<Scalars['String']>;
  address_zip?: Maybe<Scalars['String']>;
  address_zip_check?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customer: Scalars['String'];
  cvc_check?: Maybe<Scalars['String']>;
  dynamic_last4?: Maybe<Scalars['String']>;
  exp_month?: Maybe<Scalars['Int']>;
  exp_year?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  funding?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  last4?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  tokenization_method?: Maybe<Scalars['String']>;
};

export enum StripeSubStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
}

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  application?: Maybe<Scalars['String']>;
  application_fee_percent?: Maybe<Scalars['Float']>;
  billing_cycle_anchor?: Maybe<Scalars['Float']>;
  cancel_at?: Maybe<Scalars['Int']>;
  cancel_at_period_end?: Maybe<Scalars['Boolean']>;
  canceled_at?: Maybe<Scalars['Int']>;
  collection_method?: Maybe<Scalars['String']>;
  created: Scalars['Int'];
  current_period_end?: Maybe<Scalars['Int']>;
  current_period_start: Scalars['Int'];
  customer: Scalars['String'];
  days_until_due?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Float']>;
  ended_at?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  items?: Maybe<Scalars['JSONObject']>;
  latest_invoice?: Maybe<Scalars['String']>;
  livemode: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSONObject']>;
  next_pending_invoice_item_invoice?: Maybe<Scalars['String']>;
  pause_collection?: Maybe<Scalars['JSONObject']>;
  payment_settings?: Maybe<Scalars['JSONObject']>;
  pending_invoice_item_interval?: Maybe<Scalars['JSONObject']>;
  pending_setup_intent?: Maybe<Scalars['String']>;
  pending_update?: Maybe<Scalars['JSONObject']>;
  plan?: Maybe<Scalars['JSONObject']>;
  quantity?: Maybe<Scalars['Int']>;
  schedule?: Maybe<Scalars['JSONObject']>;
  start_date: Scalars['Int'];
  status: StripeSubStatus;
  test_clock?: Maybe<Scalars['String']>;
  transfer_data?: Maybe<Scalars['JSONObject']>;
  trial_end?: Maybe<Scalars['Int']>;
  trial_start?: Maybe<Scalars['Int']>;
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  expiresAt: Scalars['DateTime'];
  status: Scalars['String'];
};

export type SubscriptionRevenue = {
  __typename?: 'SubscriptionRevenue';
  distribution: Array<DistributionRule>;
  payout: Array<PayoutRule>;
  revenueSplit: Array<RevenueSplitRule>;
};

export type SubscriptionTier = {
  __typename?: 'SubscriptionTier';
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  name: Scalars['String'];
  prices?: Maybe<Array<Maybe<SubscriptionTierPrice>>>;
  providerProductId?: Maybe<Scalars['String']>;
};

export type SubscriptionTierPrice = {
  __typename?: 'SubscriptionTierPrice';
  billingCycleInterval: BillingCycleInterval;
  billingCycleIntervalUnit: Scalars['Int'];
  createdAt: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Int'];
  downgradePaths?: Maybe<Array<Maybe<SubscriptionTierPricePath>>>;
  id: Scalars['Int'];
  isDefault: Scalars['Boolean'];
  isFreeTrialEnabled: Scalars['Boolean'];
  price: Scalars['Int'];
  providerPriceId?: Maybe<Scalars['String']>;
  subscriptionTier: SubscriptionTier;
  upgradePaths?: Maybe<Array<Maybe<SubscriptionTierPricePath>>>;
};

export type SubscriptionTierPricePath = {
  __typename?: 'SubscriptionTierPricePath';
  createdAt: Scalars['Date'];
  subscriptionTierPriceFrom: SubscriptionTierPrice;
  subscriptionTierPriceIdFrom: Scalars['Int'];
  subscriptionTierPriceIdTo: Scalars['Int'];
  subscriptionTierPriceTo: SubscriptionTierPrice;
};

export type SwapCatalogExercise = {
  __typename?: 'SwapCatalogExercise';
  exercise: WorkoutExerciseSingle;
  name: Scalars['String'];
};

export type Tag = {
  __typename?: 'Tag';
  category?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export enum TaskCompletionMode {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL',
}

export type Testimonial = {
  __typename?: 'Testimonial';
  media?: Maybe<Media>;
  name: Scalars['String'];
  text: Scalars['String'];
};

export type TikTokConfiguration = {
  __typename?: 'TikTokConfiguration';
  apiSecret?: Maybe<Scalars['String']>;
  pixelId?: Maybe<Scalars['String']>;
};

export type UpdateBundleInput = {
  id: Scalars['Int'];
  items: Array<BundleItemInput>;
};

export type UpdateChallengeInput = {
  completionEnd: Scalars['DateTime'];
  completionRequirements: CompletionRequirementsInput;
  completionStart: Scalars['DateTime'];
  hidePhotos?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  photoInstructions?: InputMaybe<Scalars['String']>;
  registrationEnd: Scalars['DateTime'];
  registrationRequirements: RegistrationRequirementsInput;
  registrationStart: Scalars['DateTime'];
  templates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateClassInput = {
  category: Array<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  cover?: InputMaybe<MediaInput>;
  description?: InputMaybe<Scalars['String']>;
  difficulty: Scalars['String'];
  duration?: InputMaybe<Scalars['Int']>;
  id: Scalars['String'];
  influencerId?: InputMaybe<Scalars['Int']>;
  location: Array<Scalars['String']>;
  name: Scalars['String'];
  price?: InputMaybe<Scalars['Int']>;
  schedule: Scalars['String'];
  type: ClassType;
};

export type UpdateCommentInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
};

export type UpdateDiscoveryInput = {
  id: Scalars['Int'];
  influencers?: InputMaybe<Array<InfluencersSectionInput>>;
  latest?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  nutritions?: InputMaybe<Array<NutritionsSectionInput>>;
  programs?: InputMaybe<Array<ProgramsSectionInput>>;
  programsCarousel?: InputMaybe<Array<ProgramsCarouselSectionInput>>;
  randomize?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  websites?: InputMaybe<Array<WebsitesSectionInput>>;
  workouts?: InputMaybe<Array<WorkoutsSectionInput>>;
};

export type UpdateDiscoverySectionOrderInput = {
  sections: Array<DiscoverySectionOrderInput>;
};

export type UpdateImageInput = {
  accessMethod?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type UpdateLandingPageConfigInput = {
  config: Scalars['JSONObject'];
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<LandingPageType>;
};

export type UpdateLegacyGuideInput = {
  accessMethod?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['Float']>;
  count?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateLinkInput = {
  accessMethod?: InputMaybe<Scalars['String']>;
  coverImage?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateNotificationPreference = {
  category: NotificationCategory;
  creatorId: Scalars['Int'];
  grouped: Scalars['Boolean'];
  status: NotificationPreferenceStatus;
};

export type UpdateOtpBundleInput = {
  /** Cover image for the offer. Upload the file first via POST /admin-upload, then pass the returned Media object here. Omit to leave the existing cover image untouched; send null to remove it. */
  coverImage?: InputMaybe<MediaInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  inAppPurchase?: InputMaybe<InAppPurchase>;
  isFree?: InputMaybe<Scalars['Boolean']>;
  items: Array<BundleItemInput>;
  playbookFeePercent?: InputMaybe<Scalars['Int']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  status: BundleStatus;
  title: Scalars['String'];
};

export type UpdatePdfInput = {
  accessMethod?: InputMaybe<ContentAccessMethod>;
  coverURL?: InputMaybe<Scalars['String']>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  fileName?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdatePurchasePageConfigInput = {
  config: Scalars['JSONObject'];
  id: Scalars['Int'];
  programId: Scalars['Int'];
};

export type UpdateReportsStatusInput = {
  reportIds: Array<Scalars['ID']>;
  status: EngagementReportStatus;
};

export type UpdateSlidesInput = {
  accessMethod?: InputMaybe<Scalars['String']>;
  coverURL?: InputMaybe<Scalars['String']>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateTabInput = {
  accessMethod?: InputMaybe<Scalars['String']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateTaskProgressInputModel = {
  completed: Scalars['Boolean'];
  taskId: Scalars['String'];
};

export type UpdateVideoInput = {
  accessMethod?: InputMaybe<ContentAccessMethod>;
  allowComments?: InputMaybe<Scalars['Boolean']>;
  coverURL?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  downloadable?: InputMaybe<Scalars['Boolean']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isProcessed?: InputMaybe<Scalars['Boolean']>;
  isPublished?: InputMaybe<Scalars['Boolean']>;
  libraryVideoId?: InputMaybe<Scalars['String']>;
  thumbnailCustomURL?: InputMaybe<Scalars['String']>;
  thumbnailTimestampMs: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpsertOrArchiveSubscriptionBundlePricesInput = {
  annualPriceCents?: InputMaybe<Scalars['Int']>;
  bundleId: Scalars['Int'];
  freeTrial: FreeTrialInput;
  monthlyPriceCents?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  allowEmails?: Maybe<Scalars['Boolean']>;
  appleUserId?: Maybe<Scalars['String']>;
  campaignTrailFail?: Maybe<Scalars['String']>;
  campaignTrailOngoing?: Maybe<Scalars['String']>;
  campaignTrailStart?: Maybe<Scalars['String']>;
  campaignTrailSuccess?: Maybe<Scalars['String']>;
  campaignWelcome?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  customData?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  facebookEmail?: Maybe<Scalars['String']>;
  facebookName?: Maybe<Scalars['String']>;
  facebookUserId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  instagram?: Maybe<Scalars['String']>;
  installations?: Maybe<Array<Maybe<Installation>>>;
  isActiveReferrer?: Maybe<Scalars['Boolean']>;
  isBadActor?: Maybe<Scalars['Boolean']>;
  isKnown: Scalars['Boolean'];
  isThumbnailOverriden?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  mediaThumbnail?: Maybe<Media>;
  name?: Maybe<Scalars['String']>;
  oneTimePurchases?: Maybe<Array<Otp>>;
  originalTransactionId?: Maybe<Scalars['String']>;
  permanentBanAt?: Maybe<Scalars['String']>;
  referredCampaigns?: Maybe<Array<Maybe<ReferredCampaign>>>;
  shadowBanAt?: Maybe<Scalars['String']>;
  sources?: Maybe<Array<Maybe<Source>>>;
  stripeUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userActivity?: Maybe<Array<Maybe<UserActivity>>>;
  verifiedEmail?: Maybe<Scalars['String']>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  createdAt: Scalars['String'];
  customData?: Maybe<Scalars['String']>;
  floatValue?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  influencerId?: Maybe<Scalars['Int']>;
  performedAt?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['String']>;
  reminderTime?: Maybe<Scalars['String']>;
  storyId?: Maybe<Scalars['Int']>;
  textValue?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
  updatedAt?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  workoutId?: Maybe<Scalars['Int']>;
};

export type UserChallengeParticipation = {
  __typename?: 'UserChallengeParticipation';
  active: Array<ChallengeRef>;
  inactive: Array<ChallengeRef>;
};

export type UserPurchase = {
  __typename?: 'UserPurchase';
  autoRenew?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  discountCode?: Maybe<Scalars['String']>;
  environment?: Maybe<Scalars['Int']>;
  expiresAt?: Maybe<Scalars['String']>;
  feeAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  isFreeTrial?: Maybe<Scalars['Boolean']>;
  limitedInfluencerId?: Maybe<Scalars['Int']>;
  netAmount?: Maybe<Scalars['Float']>;
  originalPurchaseId: Scalars['String'];
  originalReceiptId?: Maybe<Scalars['String']>;
  paymentState?: Maybe<Scalars['Int']>;
  platform?: Maybe<Scalars['Int']>;
  priceAmount?: Maybe<Scalars['Float']>;
  priceCurrency: Scalars['String'];
  productId?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  purchaseToken?: Maybe<Scalars['String']>;
  purchasedAt: Scalars['String'];
  refundedAt?: Maybe<Scalars['String']>;
  sourceInfluencer?: Maybe<Creator>;
  sourceInfluencerId?: Maybe<Scalars['Int']>;
  sourceName?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['Int']>;
};

export type UserSearchFilters = {
  includeDeletedUsers?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type UserStateOnCompletion = {
  __typename?: 'UserStateOnCompletion';
  /** @deprecated Field relies on wrong data source. Use subscriptionInfo field from parent instead. */
  subscriptionStatus?: Maybe<Scalars['String']>;
  /** @deprecated Field relies on wrong data source. Use subscriptionInfo field from parent instead. */
  subscriptionStatusDate?: Maybe<Scalars['String']>;
  workoutsCompleted?: Maybe<Scalars['Int']>;
  workoutsTotal?: Maybe<Scalars['Int']>;
};

export enum UserStatusAtRedemption {
  ActiveSubscriber = 'ActiveSubscriber',
  New = 'New',
  Returning = 'Returning',
  Upgrading = 'Upgrading',
}

export type Users = {
  __typename?: 'Users';
  totalUserCount: Scalars['Int'];
  users: Array<User>;
};

export type Video = {
  __typename?: 'Video';
  aspectRatio?: Maybe<Scalars['String']>;
  cdn01?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  creatorId: Scalars['Int'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  downloadLink?: Maybe<Download>;
  duration?: Maybe<Scalars['Float']>;
  fileSize?: Maybe<Scalars['Float']>;
  folderId?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  muxAssetId?: Maybe<Scalars['String']>;
  muxPlaybackId?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
  video?: Maybe<Scalars['String']>;
  videoSourceType: Scalars['String'];
  videoThumbnailUrl?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export enum Visibility {
  Exclusive = 'Exclusive',
  Limited = 'Limited',
  Premium = 'Premium',
}

export type WebsitesSection = {
  __typename?: 'WebsitesSection';
  coverUrl?: Maybe<Scalars['String']>;
  inApp?: Maybe<Scalars['Boolean']>;
  type: Scalars['Int'];
  websiteUrl?: Maybe<Scalars['String']>;
};

export type WebsitesSectionInput = {
  coverUrl?: InputMaybe<Scalars['String']>;
  inApp?: InputMaybe<Scalars['Boolean']>;
  websiteUrl?: InputMaybe<Scalars['String']>;
};

export type Workout = {
  __typename?: 'Workout';
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  influencerId: Scalars['Int'];
  isProtected?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Media>;
  mediaExercise?: Maybe<Media>;
  name?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['Int']>;
  programIndex?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['Date']>;
  sourceWorkoutId?: Maybe<Scalars['Int']>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type WorkoutExercise =
  | WorkoutExerciseAutoplayed
  | WorkoutExerciseCustom
  | WorkoutExerciseMultiple
  | WorkoutExerciseMux
  | WorkoutExerciseNutrition
  | WorkoutExerciseProduct
  | WorkoutExerciseSingle
  | WorkoutExerciseYouTube;

export type WorkoutExerciseAutoplayed = {
  __typename?: 'WorkoutExerciseAutoplayed';
  description?: Maybe<Scalars['String']>;
  exercises?: Maybe<Array<Maybe<WorkoutExerciseSingle>>>;
  id?: Maybe<Scalars['String']>;
  longRest: Scalars['Int'];
  name: Scalars['String'];
  rounds: Scalars['Int'];
  type: Scalars['Int'];
};

export type WorkoutExerciseCustom = {
  __typename?: 'WorkoutExerciseCustom';
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['Int'];
};

export type WorkoutExerciseDownloadInfo = {
  __typename?: 'WorkoutExerciseDownloadInfo';
  filesize: Scalars['Int'];
  height: Scalars['Int'];
  link: Scalars['String'];
  width: Scalars['Int'];
};

export type WorkoutExerciseDownloadLink = {
  __typename?: 'WorkoutExerciseDownloadLink';
  high?: Maybe<WorkoutExerciseDownloadInfo>;
  low?: Maybe<WorkoutExerciseDownloadInfo>;
  medium?: Maybe<WorkoutExerciseDownloadInfo>;
};

export type WorkoutExerciseMultiple = {
  __typename?: 'WorkoutExerciseMultiple';
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  exercises?: Maybe<Array<Maybe<WorkoutExerciseSingle>>>;
  id?: Maybe<Scalars['String']>;
  measurementMode?: Maybe<Scalars['String']>;
  media?: Maybe<Media>;
  name: Scalars['String'];
  rest?: Maybe<Scalars['Int']>;
  type: Scalars['Int'];
};

export type WorkoutExerciseMux = {
  __typename?: 'WorkoutExerciseMux';
  aspectRatio?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  downloadLink?: Maybe<WorkoutExerciseDownloadLink>;
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<Media>;
  mimeType?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  resolution?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
  video?: Maybe<Scalars['String']>;
  videoId?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  youtubeId?: Maybe<Scalars['String']>;
};

export type WorkoutExerciseNutrition = {
  __typename?: 'WorkoutExerciseNutrition';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['Int'];
};

export type WorkoutExerciseProduct = {
  __typename?: 'WorkoutExerciseProduct';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  link?: Maybe<Scalars['String']>;
  media?: Maybe<Media>;
  name: Scalars['String'];
  type: Scalars['Int'];
};

export type WorkoutExerciseSet = {
  __typename?: 'WorkoutExerciseSet';
  reps?: Maybe<Array<Maybe<Scalars['String']>>>;
  rest?: Maybe<Scalars['Int']>;
  time?: Maybe<Scalars['Int']>;
};

export type WorkoutExerciseSingle = {
  __typename?: 'WorkoutExerciseSingle';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  media?: Maybe<Media>;
  name: Scalars['String'];
  rest?: Maybe<Scalars['Int']>;
  sets?: Maybe<Array<Maybe<WorkoutExerciseSet>>>;
  swapConfig?: Maybe<WorkoutExerciseSwapConfig>;
  type: Scalars['Int'];
  unilateral?: Maybe<Scalars['Boolean']>;
};

export type WorkoutExerciseSwapConfig = {
  __typename?: 'WorkoutExerciseSwapConfig';
  proposals: Array<WorkoutSwapConfigProposal>;
  swapsEnabled: Scalars['Boolean'];
};

export type WorkoutExerciseYouTube = {
  __typename?: 'WorkoutExerciseYouTube';
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Array<Maybe<Scalars['String']>>>;
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['Int'];
  youtubeId?: Maybe<Scalars['String']>;
};

export type WorkoutScopesInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  published?: InputMaybe<Scalars['Boolean']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
};

/** State of workout */
export enum WorkoutState {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Scheduled = 'SCHEDULED',
}

export type WorkoutSwapConfig = {
  __typename?: 'WorkoutSwapConfig';
  exercises: Array<WorkoutSwapConfigSlot>;
  swapsEnabled: Scalars['Boolean'];
  swapsSupported: Scalars['Boolean'];
};

export type WorkoutSwapConfigProposal = {
  __typename?: 'WorkoutSwapConfigProposal';
  exercise: WorkoutExerciseSingle;
};

export type WorkoutSwapConfigSlot = {
  __typename?: 'WorkoutSwapConfigSlot';
  nameKey: Scalars['String'];
  proposals: Array<WorkoutSwapConfigProposal>;
  swapsEnabled: Scalars['Boolean'];
};

export type WorkoutTiny = {
  __typename?: 'WorkoutTiny';
  archivedAt?: Maybe<Scalars['Date']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  description?: Maybe<Scalars['String']>;
  difficulty?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  exercises?: Maybe<Array<Maybe<WorkoutExercise>>>;
  id: Scalars['Int'];
  influencer?: Maybe<Creator>;
  influencerId: Scalars['Int'];
  isClass?: Maybe<Scalars['Boolean']>;
  isProtected?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
  media?: Maybe<Media>;
  mediaCover?: Maybe<Media>;
  mediaExercise?: Maybe<Media>;
  messagePush?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programColor?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['Int']>;
  programIndex?: Maybe<Scalars['Int']>;
  programIsLocked?: Maybe<Scalars['Boolean']>;
  programIsOtp?: Maybe<Scalars['Boolean']>;
  programName?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['Date']>;
  requiredEquipment?: Maybe<Array<Scalars['String']>>;
  statsBegins?: Maybe<Scalars['Float']>;
  statsComments?: Maybe<Scalars['Float']>;
  statsCompletions?: Maybe<Scalars['Float']>;
  statsRatingAverage?: Maybe<Scalars['Float']>;
  statsViews?: Maybe<Scalars['Float']>;
  swapConfig?: Maybe<WorkoutSwapConfig>;
  tags?: Maybe<Array<Tag>>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type WorkoutTinyCommentsArgs = {
  last: Scalars['Int'];
};

export type WorkoutsFilters = {
  influencerId: Scalars['Int'];
  searchTerm?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<WorkoutState>>;
};

export type WorkoutsInput = {
  filters: WorkoutsFilters;
  pagination: WorkoutsPagination;
};

export type WorkoutsPagination = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type WorkoutsSection = {
  __typename?: 'WorkoutsSection';
  coverUrl?: Maybe<Scalars['String']>;
  influencerId?: Maybe<Scalars['Int']>;
  influencerName?: Maybe<Scalars['String']>;
  type: Scalars['Int'];
  workoutId?: Maybe<Scalars['Int']>;
  workoutName?: Maybe<Scalars['String']>;
};

export type WorkoutsSectionInput = {
  coverUrl?: InputMaybe<Scalars['String']>;
  influencerId?: InputMaybe<Scalars['Int']>;
  influencerName?: InputMaybe<Scalars['String']>;
  workoutId?: InputMaybe<Scalars['Int']>;
  workoutName?: InputMaybe<Scalars['String']>;
};

export type LiveClassFragment = {
  __typename?: 'Class';
  id: string;
  color?: string | null;
  name: string;
  description?: string | null;
  duration?: number | null;
  schedule: string;
  deepLink?: string | null;
  type: ClassType;
  difficulty?: string | null;
  location?: Array<string> | null;
  category?: Array<string> | null;
  cover?: {
    __typename?: 'Media';
    source?: string | null;
    cdn01?: string | null;
    image?: string | null;
    video?: string | null;
    audio?: string | null;
    height?: number | null;
    width?: number | null;
    mimeType?: string | null;
  } | null;
};

export type FullMediaFragment = {
  __typename?: 'Media';
  source?: string | null;
  cdn01?: string | null;
  image?: string | null;
  video?: string | null;
  audio?: string | null;
  width?: number | null;
  height?: number | null;
  mimeType?: string | null;
};

export type ProgramListInfoFragment = {
  __typename?: 'Program';
  id: number;
  isVisible?: boolean | null;
  name?: string | null;
  color?: string | null;
  expiresAt?: any | null;
  type: number;
  publishingBehaviour: string;
  workoutLimit?: number | null;
  accessType: string;
  contentStructure?: string | null;
  isLocked?: boolean | null;
  publishedAt?: any | null;
  archivedAt?: any | null;
  migrationBundleId?: number | null;
  mediaCover?: {
    __typename?: 'Media';
    cdn01?: string | null;
    image?: string | null;
  } | null;
  exclusiveProgramMetadata?: {
    __typename?: 'ExclusiveProgramMetadata';
    price?: number | null;
  } | null;
};

export type WorkoutInfoFragment = {
  __typename?: 'WorkoutTiny';
  id: number;
  name?: string | null;
  publishedAt?: any | null;
  updatedAt?: any | null;
  archivedAt?: any | null;
  programId?: number | null;
  programIndex?: number | null;
  programIsLocked?: boolean | null;
  programIsOtp?: boolean | null;
  isProtected?: boolean | null;
  isVisible?: boolean | null;
  statsViews?: number | null;
  statsRatingAverage?: number | null;
  statsCompletions?: number | null;
  statsBegins?: number | null;
  statsComments?: number | null;
  programName?: string | null;
  programColor?: string | null;
  isClass?: boolean | null;
};

export type AddLandingPageConfigMutationVariables = Exact<{
  data: AddLandingPageConfigInput;
}>;

export type AddLandingPageConfigMutation = {
  __typename?: 'Mutation';
  addLandingPageConfig: {
    __typename?: 'LandingPageConfig';
    id: number;
    influencerId: number;
    config?: any | null;
  };
};

export type AddLiveClassMutationVariables = Exact<{
  data: AddClassInput;
}>;

export type AddLiveClassMutation = {
  __typename?: 'Mutation';
  addClass: {
    __typename?: 'Class';
    id: string;
    color?: string | null;
    name: string;
    description?: string | null;
    duration?: number | null;
    schedule: string;
    deepLink?: string | null;
    type: ClassType;
    difficulty?: string | null;
    location?: Array<string> | null;
    category?: Array<string> | null;
    cover?: {
      __typename?: 'Media';
      source?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      height?: number | null;
      width?: number | null;
      mimeType?: string | null;
    } | null;
  };
};

export type AddPurchasePageConfigMutationVariables = Exact<{
  data: AddPurchasePageConfigInput;
}>;

export type AddPurchasePageConfigMutation = {
  __typename?: 'Mutation';
  addPurchasePageConfig: {
    __typename?: 'PurchasePageConfig';
    id: number;
    programId: number;
    config?: any | null;
  };
};

export type ArchiveCollectionMutationVariables = Exact<{
  collectionId: Scalars['Int'];
}>;

export type ArchiveCollectionMutation = {
  __typename?: 'Mutation';
  archiveCollection: { __typename?: 'Collection'; id: number };
};

export type BanUserMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type BanUserMutation = {
  __typename?: 'Mutation';
  banUser: { __typename?: 'User'; id: number; permanentBanAt?: string | null };
};

export type DeleteCollectionMutationVariables = Exact<{
  collectionId: Scalars['Int'];
}>;

export type DeleteCollectionMutation = {
  __typename?: 'Mutation';
  deleteCollection: { __typename?: 'Collection'; id: number };
};

export type InitProgramPricingMutationVariables = Exact<{
  programId: Scalars['Int'];
  price: Scalars['Int'];
}>;

export type InitProgramPricingMutation = {
  __typename?: 'Mutation';
  initializePricing: {
    __typename?: 'Pricing';
    price: any;
    playbookFee?: any | null;
    discountedPrice?: any | null;
    discountPercent?: any | null;
  };
};

export type RemovePermanentBanMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type RemovePermanentBanMutation = {
  __typename?: 'Mutation';
  removePermanentBan: {
    __typename?: 'User';
    id: number;
    permanentBanAt?: string | null;
  };
};

export type RemoveProgramPricingMutationVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type RemoveProgramPricingMutation = {
  __typename?: 'Mutation';
  removePricing?: {
    __typename?: 'Pricing';
    price: any;
    playbookFee?: any | null;
    discountedPrice?: any | null;
    discountPercent?: any | null;
  } | null;
};

export type RemoveShadowbanMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type RemoveShadowbanMutation = {
  __typename?: 'Mutation';
  removeShadowBan: {
    __typename?: 'User';
    id: number;
    shadowBanAt?: string | null;
  };
};

export type ShadowbanUserMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;

export type ShadowbanUserMutation = {
  __typename?: 'Mutation';
  shadowBanUser: {
    __typename?: 'User';
    id: number;
    shadowBanAt?: string | null;
  };
};

export type UpdateProgramDiscountMutationVariables = Exact<{
  programId: Scalars['Int'];
  discount?: InputMaybe<Scalars['Int']>;
}>;

export type UpdateProgramDiscountMutation = {
  __typename?: 'Mutation';
  updateDiscount?: {
    __typename?: 'Pricing';
    price: any;
    playbookFee?: any | null;
    discountedPrice?: any | null;
    discountPercent?: any | null;
  } | null;
};

export type UpdateLandingPageConfigMutationVariables = Exact<{
  data: UpdateLandingPageConfigInput;
}>;

export type UpdateLandingPageConfigMutation = {
  __typename?: 'Mutation';
  updateLandingPageConfig: {
    __typename?: 'LandingPageConfig';
    id: number;
    influencerId: number;
    config?: any | null;
  };
};

export type UpdateLiveClassMutationVariables = Exact<{
  data: UpdateClassInput;
}>;

export type UpdateLiveClassMutation = {
  __typename?: 'Mutation';
  updateClass: {
    __typename?: 'Class';
    id: string;
    color?: string | null;
    name: string;
    description?: string | null;
    duration?: number | null;
    schedule: string;
    deepLink?: string | null;
    type: ClassType;
    difficulty?: string | null;
    location?: Array<string> | null;
    category?: Array<string> | null;
    cover?: {
      __typename?: 'Media';
      source?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      height?: number | null;
      width?: number | null;
      mimeType?: string | null;
    } | null;
  };
};

export type UpdateProgramPricingMutationVariables = Exact<{
  programId: Scalars['Int'];
  price: Scalars['Int'];
  fee: Scalars['Int'];
}>;

export type UpdateProgramPricingMutation = {
  __typename?: 'Mutation';
  updatePricing: {
    __typename?: 'Pricing';
    price: any;
    playbookFee?: any | null;
    discountedPrice?: any | null;
    discountPercent?: any | null;
  };
};

export type UpdatePurchasePageConfigMutationVariables = Exact<{
  data: UpdatePurchasePageConfigInput;
}>;

export type UpdatePurchasePageConfigMutation = {
  __typename?: 'Mutation';
  updatePurchasePageConfig: {
    __typename?: 'PurchasePageConfig';
    id: number;
    programId: number;
    config?: any | null;
  };
};

export type GetAllProgramsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetAllProgramsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    customURL?: string | null;
    mode?: number | null;
    customizations?: {
      __typename?: 'Customizations';
      hideLibrary?: boolean | null;
    } | null;
    programs: Array<{
      __typename?: 'Program';
      id: number;
      isVisible?: boolean | null;
      name?: string | null;
      color?: string | null;
      expiresAt?: any | null;
      type: number;
      publishingBehaviour: string;
      workoutLimit?: number | null;
      accessType: string;
      contentStructure?: string | null;
      isLocked?: boolean | null;
      publishedAt?: any | null;
      archivedAt?: any | null;
      migrationBundleId?: number | null;
      mediaCover?: {
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
      } | null;
      exclusiveProgramMetadata?: {
        __typename?: 'ExclusiveProgramMetadata';
        price?: number | null;
      } | null;
    }>;
  } | null;
};

export type GetAllProgramsWithWorkoutsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetAllProgramsWithWorkoutsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    customURL?: string | null;
    mode?: number | null;
    customizations?: {
      __typename?: 'Customizations';
      hideLibrary?: boolean | null;
    } | null;
    programs: Array<{
      __typename?: 'Program';
      id: number;
      isVisible?: boolean | null;
      name?: string | null;
      color?: string | null;
      expiresAt?: any | null;
      type: number;
      publishingBehaviour: string;
      workoutLimit?: number | null;
      accessType: string;
      contentStructure?: string | null;
      isLocked?: boolean | null;
      publishedAt?: any | null;
      archivedAt?: any | null;
      migrationBundleId?: number | null;
      workouts?: Array<{
        __typename?: 'WorkoutTiny';
        id: number;
        name?: string | null;
        publishedAt?: any | null;
        updatedAt?: any | null;
        archivedAt?: any | null;
        programId?: number | null;
        programIndex?: number | null;
        programIsLocked?: boolean | null;
        programIsOtp?: boolean | null;
        isProtected?: boolean | null;
        isVisible?: boolean | null;
        statsViews?: number | null;
        statsRatingAverage?: number | null;
        statsCompletions?: number | null;
        statsBegins?: number | null;
        statsComments?: number | null;
        programName?: string | null;
        programColor?: string | null;
        isClass?: boolean | null;
      } | null> | null;
      mediaCover?: {
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
      } | null;
      exclusiveProgramMetadata?: {
        __typename?: 'ExclusiveProgramMetadata';
        price?: number | null;
      } | null;
    }>;
  } | null;
};

export type GetArchivedWorkoutsQueryVariables = Exact<{
  id: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;

export type GetArchivedWorkoutsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    mode?: number | null;
    customizations?: {
      __typename?: 'Customizations';
      hideLibrary?: boolean | null;
    } | null;
    archivedWorkouts: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    }>;
  } | null;
};

export type GetCreatorsMediaQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  type?: InputMaybe<Scalars['String']>;
}>;

export type GetCreatorsMediaQuery = {
  __typename?: 'Query';
  getCreatorsMedia: Array<{
    __typename?: 'Video';
    uuid: string;
    creatorId: number;
    title: string;
    type?: string | null;
    video?: string | null;
    image?: string | null;
    cdn01?: string | null;
    videoSourceType: string;
    videoThumbnailUrl?: string | null;
    videoUrl?: string | null;
    duration?: number | null;
    aspectRatio?: string | null;
    status: string;
    width?: number | null;
    height?: number | null;
    mimeType?: string | null;
    createdAt: any;
    deletedAt?: any | null;
    updatedAt: any;
    description?: string | null;
    fileSize?: number | null;
    folderId?: number | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
    } | null;
  }>;
};

export type GetCreatorsProcessingMediaQueryVariables = Exact<{
  creatorId: Scalars['Int'];
}>;

export type GetCreatorsProcessingMediaQuery = {
  __typename?: 'Query';
  getCreatorsProcessingMedia: Array<{
    __typename?: 'ProcessingVideo';
    uuid: string;
    creatorId: number;
    title: string;
    type: string;
    video?: string | null;
    image?: string | null;
    cdn01?: string | null;
    videoSourceType: string;
    videoThumbnailUrl: string;
    videoUrl: string;
    duration: number;
    aspectRatio?: string | null;
    status: string;
    width: number;
    height: number;
    mimeType?: string | null;
    createdAt: any;
    deletedAt?: any | null;
    updatedAt: any;
    description?: string | null;
    fileSize?: number | null;
  }>;
};

export type GetCouponsByInfluencerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetCouponsByInfluencerQuery = {
  __typename?: 'Query';
  getCouponsByInfluencer: Array<{
    __typename?: 'Coupon';
    code: string;
    createdAt: any;
    discountAmount?: number | null;
    expiresAt?: any | null;
    id: string;
    influencerId: number;
    isActive: boolean;
    maxRedemptions?: number | null;
    name: string;
    paidProductIds?: Array<number> | null;
    percentOff?: number | null;
    providerCouponId?: string | null;
    redemptions: number;
    discountType: CouponDiscountType;
    productType: CouponProductType;
    subscriptionProviderPriceIds?: Array<string> | null;
    referralCampaignId?: number | null;
    compatibleWithFreeTrial?: boolean | null;
  }>;
};

export type GetDraftWorkoutsQueryVariables = Exact<{
  id: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;

export type GetDraftWorkoutsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    mode?: number | null;
    customizations?: {
      __typename?: 'Customizations';
      hideLibrary?: boolean | null;
    } | null;
    draftWorkouts: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    }>;
  } | null;
};

export type GetInfluencerQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetInfluencerQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    tier?: number | null;
    bio?: string | null;
    email?: string | null;
    mobilePhoneNumber?: string | null;
    mode?: number | null;
    salesModel?: string | null;
    offering: Array<string>;
    title?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    liveStreamKey?: string | null;
    stripeUserId?: string | null;
    paymentMethod?: number | null;
    profileDeepLink?: string | null;
    facebookPixelId?: string | null;
    facebookConversionApiAccessToken?: string | null;
    profileInstagram?: string | null;
    isVisible?: boolean | null;
    publishedAt?: any | null;
    customURL?: string | null;
    communityId?: number | null;
    visibility: string;
    enableCheckoutFreeTrial: boolean;
    collectionType?: string | null;
    productType?: string | null;
    publisheCollectionsCount?: number | null;
    publishedWorkoutsCount?: number | null;
    createdAt?: any | null;
    otpProgramsCount?: number | null;
    stripeLiveMode?: boolean | null;
    businessModel: string;
    signInEmail: string;
    mediaAvatar?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    latestWorkout?: Array<{
      __typename?: 'Workout';
      publishedAt?: any | null;
    } | null> | null;
    customDomains?: Array<{
      __typename?: 'CustomDomain';
      id: number;
      domain: string;
      status: CustomDomainStatus;
    }> | null;
    customizations?: {
      __typename?: 'Customizations';
      isNewVideo?: boolean | null;
      canUsePromotionDetails?: boolean | null;
      canUsePromotions?: boolean | null;
      premiumFeaturesOTPIds?: Array<number | null> | null;
      isTransactionLedgerEnabled?: boolean | null;
      isUnifiedProgramsEnabled?: boolean | null;
      isCommunitiesV2Enabled?: boolean | null;
      isOtpMigratedToBundle?: boolean | null;
      isOffers35Enabled?: boolean | null;
      isCouponWithFreeTrialEnabled?: boolean | null;
      isCreatorApprovedSwapsEnabled?: boolean | null;
    } | null;
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
      name: string;
    } | null> | null;
    ga4Configuration?: {
      __typename?: 'GA4Configuration';
      measurementId?: string | null;
      apiSecret?: string | null;
    } | null;
    tikTokConfiguration?: {
      __typename?: 'TikTokConfiguration';
      pixelId?: string | null;
      apiSecret?: string | null;
    } | null;
    socialAccounts: Array<{
      __typename?: 'SocialAccountStatus';
      provider: string;
      connected: boolean;
      email?: string | null;
    }>;
  } | null;
};

export type GetInfluencerNamesQueryVariables = Exact<{ [key: string]: never }>;

export type GetInfluencerNamesQuery = {
  __typename?: 'Query';
  creators: Array<{
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
  } | null>;
};

export type GetInfluencersQueryVariables = Exact<{
  mode?: InputMaybe<Scalars['Int']>;
}>;

export type GetInfluencersQuery = {
  __typename?: 'Query';
  creators: Array<{
    __typename?: 'Creator';
    id: number;
    tier?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    isVisible?: boolean | null;
    publishedAt?: any | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    latestWorkout?: Array<{
      __typename?: 'Workout';
      publishedAt?: any | null;
    } | null> | null;
    customizations?: {
      __typename?: 'Customizations';
      isNewVideo?: boolean | null;
    } | null;
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
      name: string;
    } | null> | null;
  } | null>;
};

export type GetProgramByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetProgramByIdQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: number;
    name?: string | null;
    isLocked?: boolean | null;
    accessType: string;
    color?: string | null;
    description?: string | null;
    publishingBehaviour: string;
    workoutLimit?: number | null;
    contentStructure?: string | null;
    publishedAt?: any | null;
    archivedAt?: any | null;
    mediaCover?: {
      __typename?: 'Media';
      image?: string | null;
      video?: string | null;
      cdn01?: string | null;
      width?: number | null;
      height?: number | null;
    } | null;
    mediaIntro?: {
      __typename?: 'Media';
      image?: string | null;
      video?: string | null;
      cdn01?: string | null;
      width?: number | null;
      height?: number | null;
    } | null;
    testimonials?: Array<{
      __typename?: 'Testimonial';
      name: string;
      text: string;
      media?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
    } | null> | null;
    faq?: Array<{
      __typename?: 'FeedFaq';
      answer: string;
      question: string;
    } | null> | null;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    } | null> | null;
  };
  getPricing?: {
    __typename?: 'Pricing';
    price: any;
    playbookFee?: any | null;
    discountedPrice?: any | null;
    discountPercent?: any | null;
  } | null;
};

export type GetProgramArchivedWorkoutsQueryVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type GetProgramArchivedWorkoutsQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: number;
    archivedWorkouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    } | null> | null;
  };
};

export type GetProgramDraftWorkoutsQueryVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type GetProgramDraftWorkoutsQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: number;
    draftWorkouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    } | null> | null;
  };
};

export type GetProgramPublishedWorkoutsQueryVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type GetProgramPublishedWorkoutsQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: number;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    } | null> | null;
  };
};

export type GetProgramPurchasePageByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetProgramPurchasePageByIdQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: number;
    name?: string | null;
    isLocked?: boolean | null;
    accessType: string;
    color?: string | null;
    description?: string | null;
    tags?: Array<string | null> | null;
    difficulty?: string | null;
    duration?: Array<string | null> | null;
    daysPerWeek?: number | null;
    sessionDuration?: string | null;
    location?: string | null;
    publishedAt?: any | null;
    archivedAt?: any | null;
    mediaCover?: {
      __typename?: 'Media';
      image?: string | null;
      video?: string | null;
      cdn01?: string | null;
      width?: number | null;
      height?: number | null;
    } | null;
    mediaIntro?: {
      __typename?: 'Media';
      image?: string | null;
      video?: string | null;
      cdn01?: string | null;
      width?: number | null;
      height?: number | null;
    } | null;
    testimonials?: Array<{
      __typename?: 'Testimonial';
      name: string;
      text: string;
      media?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
    } | null> | null;
    faq?: Array<{
      __typename?: 'FeedFaq';
      answer: string;
      question: string;
    } | null> | null;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      isClass?: boolean | null;
      name?: string | null;
      mediaCover?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
      mediaExercise?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
    } | null> | null;
    influencer?: {
      __typename?: 'Creator';
      id: number;
      firstName?: string | null;
      lastName?: string | null;
      customURL?: string | null;
      bio?: string | null;
      enableCheckoutFreeTrial: boolean;
      messageProfile?: string | null;
      messageCommunity?: string | null;
      mediaAvatar?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
      customColorSchema?: {
        __typename?: 'ColorScheme';
        primaryColor?: string | null;
        secondaryColor?: string | null;
      } | null;
      customDomains?: Array<{
        __typename?: 'CustomDomain';
        id: number;
        domain: string;
        status: CustomDomainStatus;
      }> | null;
    } | null;
  };
};

export type GetProgramScheduledWorkoutsQueryVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type GetProgramScheduledWorkoutsQuery = {
  __typename?: 'Query';
  program: {
    __typename?: 'Program';
    id: number;
    scheduledWorkouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    } | null> | null;
  };
};

export type GetPublishedWorkoutsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetPublishedWorkoutsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    mode?: number | null;
    workouts: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    }>;
  } | null;
};

export type GetScheduledWorkoutsQueryVariables = Exact<{
  id: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;

export type GetScheduledWorkoutsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    mode?: number | null;
    customizations?: {
      __typename?: 'Customizations';
      hideLibrary?: boolean | null;
    } | null;
    scheduledWorkouts: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
      publishedAt?: any | null;
      updatedAt?: any | null;
      archivedAt?: any | null;
      programId?: number | null;
      programIndex?: number | null;
      programIsLocked?: boolean | null;
      programIsOtp?: boolean | null;
      isProtected?: boolean | null;
      isVisible?: boolean | null;
      statsViews?: number | null;
      statsRatingAverage?: number | null;
      statsCompletions?: number | null;
      statsBegins?: number | null;
      statsComments?: number | null;
      programName?: string | null;
      programColor?: string | null;
      isClass?: boolean | null;
    }>;
  } | null;
};

export type GetStreamKeyQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetStreamKeyQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    liveStreamKey?: string | null;
  } | null;
};

export type GetSubTiresQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetSubTiresQuery = {
  __typename?: 'Query';
  subscriptionTierByInfluencer: Array<{
    __typename?: 'SubscriptionTier';
    createdAt: any;
    description?: string | null;
    id: number;
    influencerId: number;
    name: string;
    providerProductId?: string | null;
    prices?: Array<{
      __typename?: 'SubscriptionTierPrice';
      billingCycleInterval: BillingCycleInterval;
      billingCycleIntervalUnit: number;
      createdAt: any;
      description?: string | null;
      displayOrder: number;
      id: number;
      isDefault: boolean;
      price: number;
      providerPriceId?: string | null;
      upgradePaths?: Array<{
        __typename?: 'SubscriptionTierPricePath';
        subscriptionTierPriceIdTo: number;
      } | null> | null;
    } | null> | null;
  }>;
};

export type PurchasePageConfigQueryVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type PurchasePageConfigQuery = {
  __typename?: 'Query';
  purchasePageConfig?: {
    __typename?: 'PurchasePageConfig';
    id: number;
    programId: number;
    config?: any | null;
  } | null;
};

export type SearchCommentsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  creatorId?: InputMaybe<Scalars['Int']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;

export type SearchCommentsQuery = {
  __typename?: 'Query';
  searchComments: Array<{
    __typename?: 'Comment';
    id: number;
    status: number;
    textValue: string;
    createdAt: string;
    reportedCount: number;
    workout?: {
      __typename?: 'WorkoutTiny';
      name?: string | null;
      influencer?: {
        __typename?: 'Creator';
        id: number;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
    } | null;
    user?: {
      __typename?: 'SimpleUser';
      id: number;
      name: string;
      isBanned?: boolean | null;
      email?: string | null;
      mediaThumbnail?: {
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
      } | null;
    } | null;
  }>;
};

export type AddPostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  media?: InputMaybe<Array<MediaInput> | MediaInput>;
  text: Scalars['String'];
}>;

export type AddPostMutation = {
  __typename?: 'Mutation';
  addPost?: {
    __typename?: 'Post';
    communityId?: number | null;
    createdAt: any;
    id: string;
    text: string;
    updatedAt?: any | null;
    author: {
      __typename?: 'Author';
      id: number;
      username: string;
      badges: Array<string>;
      profilePicture: string;
    };
    media: Array<{
      __typename?: 'Media';
      mimeType?: string | null;
      audio?: string | null;
      image?: string | null;
      height?: number | null;
      width?: number | null;
      source?: string | null;
      cdn01?: string | null;
      video?: string | null;
    }>;
  } | null;
};

export type AddReplyMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  text: Scalars['String'];
}>;

export type AddReplyMutation = {
  __typename?: 'Mutation';
  addReply?: {
    __typename?: 'Reply';
    id: string;
    text: string;
    createdAt: any;
    updatedAt?: any | null;
    author: {
      __typename?: 'Author';
      id: number;
      username: string;
      badges: Array<string>;
      profilePicture: string;
    };
  } | null;
};

export type BlockUserMutationVariables = Exact<{
  communityId: Scalars['Int'];
  userId: Scalars['Int'];
}>;

export type BlockUserMutation = {
  __typename?: 'Mutation';
  blockUser?: boolean | null;
};

export type DeletePostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
}>;

export type DeletePostMutation = {
  __typename?: 'Mutation';
  deletePost?: { __typename?: 'Post'; id: string } | null;
};

export type DeleteReplyMutationVariables = Exact<{
  communityId: Scalars['Int'];
  replyId: Scalars['String'];
}>;

export type DeleteReplyMutation = {
  __typename?: 'Mutation';
  deleteReply?: { __typename?: 'Reply'; id: string } | null;
};

export type DisableCommunityMutationVariables = Exact<{
  creatorId: Scalars['Int'];
}>;

export type DisableCommunityMutation = {
  __typename?: 'Mutation';
  disableCommunity: number;
};

export type EnableCommunityMutationVariables = Exact<{
  creatorId: Scalars['Int'];
  creatorEmail: Scalars['String'];
  creatorName: Scalars['String'];
}>;

export type EnableCommunityMutation = {
  __typename?: 'Mutation';
  enableCommunity: number;
};

export type KeepContentMutationVariables = Exact<{
  contentId: Scalars['Int'];
}>;

export type KeepContentMutation = {
  __typename?: 'Mutation';
  keepContent?: boolean | null;
};

export type TogglePinPostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  pinned: Scalars['Boolean'];
}>;

export type TogglePinPostMutation = {
  __typename?: 'Mutation';
  togglePinPost?: boolean | null;
};

export type ToggleReactionMutationVariables = Exact<{
  communityId: Scalars['Int'];
  entityId: Scalars['String'];
  parent: ReactionParent;
  type: ReactionType;
}>;

export type ToggleReactionMutation = {
  __typename?: 'Mutation';
  toggleReaction?: { __typename?: 'Post'; id: string } | null;
};

export type UnblockUserMutationVariables = Exact<{
  communityId: Scalars['Int'];
  userId: Scalars['Int'];
}>;

export type UnblockUserMutation = {
  __typename?: 'Mutation';
  unblockUser?: boolean | null;
};

export type GetBlockedUsersQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetBlockedUsersQuery = {
  __typename?: 'Query';
  blockedUsers?: Array<{
    __typename?: 'BlockedUser';
    id: number;
    email: string;
    name?: string | null;
    mediaThumbnail: string;
  }> | null;
};

export type GetCommunityQueryVariables = Exact<{
  id: Scalars['Int'];
  direction?: InputMaybe<Scalars['String']>;
  lastId?: InputMaybe<Scalars['String']>;
}>;

export type GetCommunityQuery = {
  __typename?: 'Query';
  community?: {
    __typename?: 'Community';
    id: number;
    name: string;
    ownerId: number;
    createdAt: any;
    updatedAt?: any | null;
    owner: {
      __typename?: 'Author';
      id: number;
      username: string;
      badges: Array<string>;
      profilePicture: string;
    };
    posts: Array<{
      __typename?: 'Post';
      id: string;
      text: string;
      createdAt: any;
      updatedAt?: any | null;
      pinned?: boolean | null;
      isSensitiveContent: boolean;
      author: {
        __typename?: 'Author';
        id: number;
        username: string;
        badges: Array<string>;
        profilePicture: string;
        email: string;
        marketing: boolean;
        hasDirectMessagesAccess?: boolean | null;
      };
      media: Array<{
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
        video?: string | null;
        audio?: string | null;
        width?: number | null;
        height?: number | null;
        mimeType?: string | null;
      }>;
      reactions: Array<{
        __typename?: 'Reaction';
        type: ReactionType;
        count: number;
        isToggled: boolean;
      }>;
      replies: Array<{
        __typename?: 'Reply';
        id: string;
        text: string;
        createdAt: any;
        updatedAt?: any | null;
        isSensitiveContent: boolean;
        author: {
          __typename?: 'Author';
          id: number;
          username: string;
          badges: Array<string>;
          profilePicture: string;
          email: string;
          marketing: boolean;
          hasDirectMessagesAccess?: boolean | null;
        };
        reactions: Array<{
          __typename?: 'Reaction';
          type: ReactionType;
          count: number;
          isToggled: boolean;
        }>;
      }>;
    }>;
  } | null;
};

export type GetCommunityPostQueryVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  direction?: InputMaybe<Scalars['String']>;
  lastId?: InputMaybe<Scalars['String']>;
}>;

export type GetCommunityPostQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'Post';
    id: string;
    text: string;
    createdAt: any;
    updatedAt?: any | null;
    edited: boolean;
    pinned?: boolean | null;
    isSensitiveContent: boolean;
    author: {
      __typename?: 'Author';
      id: number;
      username: string;
      badges: Array<string>;
      profilePicture: string;
      email: string;
      marketing: boolean;
      hasDirectMessagesAccess?: boolean | null;
    };
    media: Array<{
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
    }>;
    reactions: Array<{
      __typename?: 'Reaction';
      type: ReactionType;
      count: number;
      isToggled: boolean;
    }>;
    replies: Array<{
      __typename?: 'Reply';
      id: string;
      text: string;
      createdAt: any;
      updatedAt?: any | null;
      edited: boolean;
      isSensitiveContent: boolean;
      author: {
        __typename?: 'Author';
        id: number;
        username: string;
        badges: Array<string>;
        profilePicture: string;
        email: string;
        marketing: boolean;
        hasDirectMessagesAccess?: boolean | null;
      };
      media?: Array<{
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
        video?: string | null;
        audio?: string | null;
        width?: number | null;
        height?: number | null;
        mimeType?: string | null;
        status?: string | null;
        uuid?: string | null;
        videoUrl?: string | null;
        videoThumbnailUrl?: string | null;
        videoSourceType?: string | null;
      }> | null;
      reactions: Array<{
        __typename?: 'Reaction';
        type: ReactionType;
        count: number;
        isToggled: boolean;
      }>;
    }>;
  } | null;
};

export type GetPinnedPostsQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetPinnedPostsQuery = {
  __typename?: 'Query';
  community?: {
    __typename?: 'Community';
    id: number;
    posts: Array<{
      __typename?: 'Post';
      id: string;
      text: string;
      createdAt: any;
      updatedAt?: any | null;
      pinned?: boolean | null;
      isSensitiveContent: boolean;
      author: {
        __typename?: 'Author';
        id: number;
        username: string;
        badges: Array<string>;
        profilePicture: string;
        email: string;
        hasDirectMessagesAccess?: boolean | null;
      };
      media: Array<{
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
        video?: string | null;
        audio?: string | null;
        width?: number | null;
        height?: number | null;
        mimeType?: string | null;
      }>;
      reactions: Array<{
        __typename?: 'Reaction';
        type: ReactionType;
        count: number;
        isToggled: boolean;
      }>;
      replies: Array<{
        __typename?: 'Reply';
        id: string;
        text: string;
        createdAt: any;
        updatedAt?: any | null;
        isSensitiveContent: boolean;
        author: {
          __typename?: 'Author';
          id: number;
          username: string;
          badges: Array<string>;
          profilePicture: string;
          email: string;
          hasDirectMessagesAccess?: boolean | null;
        };
        reactions: Array<{
          __typename?: 'Reaction';
          type: ReactionType;
          count: number;
          isToggled: boolean;
        }>;
      }>;
    }>;
  } | null;
};

export type GetReportedContentQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetReportedContentQuery = {
  __typename?: 'Query';
  reportedContent?: Array<{
    __typename?: 'ReportedActivity';
    id: number;
    parentId?: string | null;
    activityId: string;
    activityType: string;
    createdAt: any;
    reason: number;
    text: string;
    reportedBy: {
      __typename?: 'Author';
      id: number;
      username: string;
      profilePicture: string;
    };
    author: {
      __typename?: 'Author';
      id: number;
      username: string;
      profilePicture: string;
    };
    media?: Array<{
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
    }> | null;
  }> | null;
};

export type GetReportedContentCountQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetReportedContentCountQuery = {
  __typename?: 'Query';
  reportedContentCount?: number | null;
};

export type AddCommunityReplyMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  text: Scalars['String'];
  parentReplyId?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<MediaInput> | MediaInput>;
}>;

export type AddCommunityReplyMutation = {
  __typename?: 'Mutation';
  addReply?: {
    __typename?: 'Reply';
    id: string;
    text: string;
    createdAt: any;
    updatedAt?: any | null;
    parentId?: string | null;
    media?: Array<{
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
      status?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      videoSourceType?: string | null;
    }> | null;
    author: {
      __typename?: 'Author';
      id: number;
      username: string;
      badges: Array<string>;
      profilePicture: string;
    };
  } | null;
};

export type BlockCommunityUserMutationVariables = Exact<{
  communityId: Scalars['Int'];
  userId: Scalars['Int'];
}>;

export type BlockCommunityUserMutation = {
  __typename?: 'Mutation';
  blockUser?: boolean | null;
};

export type CommunitiesV2AddPostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  media?: InputMaybe<Array<MediaInput> | MediaInput>;
  text: Scalars['String'];
  publishAt?: InputMaybe<Scalars['DateTime']>;
}>;

export type CommunitiesV2AddPostMutation = {
  __typename?: 'Mutation';
  addPost?: {
    __typename?: 'Post';
    id: string;
    text: string;
    createdAt: any;
    edited: boolean;
    pinned?: boolean | null;
    status?: string | null;
    publishedAt?: any | null;
    author: {
      __typename?: 'Author';
      email: string;
      marketing: boolean;
      id: number;
      username: string;
      profilePicture: string;
      badges: Array<string>;
      hasDirectMessagesAccess?: boolean | null;
    };
    media: Array<{
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      mimeType?: string | null;
      source?: string | null;
      width?: number | null;
      height?: number | null;
      status?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      videoSourceType?: string | null;
    }>;
    reactions: Array<{
      __typename?: 'Reaction';
      type: ReactionType;
      count: number;
      isToggled: boolean;
    }>;
  } | null;
};

export type CommunityFeedPostFragment = {
  __typename?: 'Post';
  id: string;
  text: string;
  createdAt: any;
  edited: boolean;
  pinned?: boolean | null;
  status?: string | null;
  publishedAt?: any | null;
  author: {
    __typename?: 'Author';
    id: number;
    username: string;
    profilePicture: string;
    badges: Array<string>;
    hasDirectMessagesAccess?: boolean | null;
  };
  media: Array<{
    __typename?: 'Media';
    cdn01?: string | null;
    image?: string | null;
    video?: string | null;
    audio?: string | null;
    mimeType?: string | null;
    source?: string | null;
    width?: number | null;
    height?: number | null;
    status?: string | null;
    uuid?: string | null;
    videoUrl?: string | null;
    videoThumbnailUrl?: string | null;
    videoSourceType?: string | null;
  }>;
  reactions: Array<{
    __typename?: 'Reaction';
    type: ReactionType;
    count: number;
    isToggled: boolean;
  }>;
};

export type CommunityReplyFragment = {
  __typename?: 'Reply';
  id: string;
  text: string;
  createdAt: any;
  edited: boolean;
  parentId?: string | null;
  isSensitiveContent: boolean;
  author: {
    __typename?: 'Author';
    id: number;
    username: string;
    profilePicture: string;
    badges: Array<string>;
    email?: string;
    marketing?: boolean;
    hasDirectMessagesAccess?: boolean | null;
  };
  media?: Array<{
    __typename?: 'Media';
    cdn01?: string | null;
    image?: string | null;
    video?: string | null;
    audio?: string | null;
    width?: number | null;
    height?: number | null;
    mimeType?: string | null;
    status?: string | null;
    uuid?: string | null;
    videoUrl?: string | null;
    videoThumbnailUrl?: string | null;
    videoSourceType?: string | null;
  }> | null;
  reactions: Array<{
    __typename?: 'Reaction';
    type: ReactionType;
    count: number;
    isToggled: boolean;
  }>;
};

export type DeleteCommunityPostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
}>;

export type DeleteCommunityPostMutation = {
  __typename?: 'Mutation';
  deletePost?: { __typename?: 'Post'; id: string } | null;
};

export type DeleteCommunityReplyMutationVariables = Exact<{
  communityId: Scalars['Int'];
  replyId: Scalars['String'];
}>;

export type DeleteCommunityReplyMutation = {
  __typename?: 'Mutation';
  deleteReply?: { __typename?: 'Reply'; id: string } | null;
};

export type GetCommunityBlockedUserIdsQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetCommunityBlockedUserIdsQuery = {
  __typename?: 'Query';
  blockedUsers?: Array<{ __typename?: 'BlockedUser'; id: number }> | null;
};

export type GetCommunityBlockedUsersQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetCommunityBlockedUsersQuery = {
  __typename?: 'Query';
  blockedUsers?: Array<{
    __typename?: 'BlockedUser';
    id: number;
    name?: string | null;
    mediaThumbnail: string;
    blockedAt: any;
    itemsRemovedCount: number;
  }> | null;
};

export type GetCommunityDmStatusQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetCommunityDmStatusQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    features?: Array<{
      __typename?: 'Feature';
      code: FeatureCode;
    } | null> | null;
  } | null;
};

export type GetCommunityPinnedPostsQueryVariables = Exact<{
  id: Scalars['Int'];
  canModerate: Scalars['Boolean'];
}>;

export type GetCommunityPinnedPostsQuery = {
  __typename?: 'Query';
  communityPinnedPosts?: {
    __typename?: 'Community';
    id: number;
    posts: Array<{
      __typename?: 'Post';
      id: string;
      text: string;
      createdAt: any;
      edited: boolean;
      pinned?: boolean | null;
      status?: string | null;
      publishedAt?: any | null;
      author: {
        __typename?: 'Author';
        email?: string;
        marketing?: boolean;
        id: number;
        username: string;
        profilePicture: string;
        badges: Array<string>;
        hasDirectMessagesAccess?: boolean | null;
      };
      media: Array<{
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
        video?: string | null;
        audio?: string | null;
        mimeType?: string | null;
        source?: string | null;
        width?: number | null;
        height?: number | null;
        status?: string | null;
        uuid?: string | null;
        videoUrl?: string | null;
        videoThumbnailUrl?: string | null;
        videoSourceType?: string | null;
      }>;
      reactions: Array<{
        __typename?: 'Reaction';
        type: ReactionType;
        count: number;
        isToggled: boolean;
      }>;
    }>;
  } | null;
};

export type GetCommunityPostRepliesQueryVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  canModerate: Scalars['Boolean'];
  direction?: InputMaybe<Scalars['String']>;
  lastId?: InputMaybe<Scalars['String']>;
}>;

export type GetCommunityPostRepliesQuery = {
  __typename?: 'Query';
  post?: {
    __typename?: 'Post';
    id: string;
    replies: Array<{
      __typename?: 'Reply';
      id: string;
      text: string;
      createdAt: any;
      edited: boolean;
      parentId?: string | null;
      isSensitiveContent: boolean;
      author: {
        __typename?: 'Author';
        id: number;
        username: string;
        profilePicture: string;
        badges: Array<string>;
        email?: string;
        marketing?: boolean;
        hasDirectMessagesAccess?: boolean | null;
      };
      media?: Array<{
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
        video?: string | null;
        audio?: string | null;
        width?: number | null;
        height?: number | null;
        mimeType?: string | null;
        status?: string | null;
        uuid?: string | null;
        videoUrl?: string | null;
        videoThumbnailUrl?: string | null;
        videoSourceType?: string | null;
      }> | null;
      reactions: Array<{
        __typename?: 'Reaction';
        type: ReactionType;
        count: number;
        isToggled: boolean;
      }>;
    }>;
  } | null;
};

export type GetCommunityPostsQueryVariables = Exact<{
  id: Scalars['Int'];
  direction?: InputMaybe<Scalars['String']>;
  lastId?: InputMaybe<Scalars['String']>;
  canModerate: Scalars['Boolean'];
  filters?: InputMaybe<CommunityFeedFilters>;
}>;

export type GetCommunityPostsQuery = {
  __typename?: 'Query';
  communityPosts?: {
    __typename?: 'Community';
    id: number;
    posts: Array<{
      __typename?: 'Post';
      id: string;
      text: string;
      createdAt: any;
      edited: boolean;
      pinned?: boolean | null;
      status?: string | null;
      publishedAt?: any | null;
      author: {
        __typename?: 'Author';
        email?: string;
        marketing?: boolean;
        id: number;
        username: string;
        profilePicture: string;
        badges: Array<string>;
        hasDirectMessagesAccess?: boolean | null;
      };
      media: Array<{
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
        video?: string | null;
        audio?: string | null;
        mimeType?: string | null;
        source?: string | null;
        width?: number | null;
        height?: number | null;
        status?: string | null;
        uuid?: string | null;
        videoUrl?: string | null;
        videoThumbnailUrl?: string | null;
        videoSourceType?: string | null;
      }>;
      reactions: Array<{
        __typename?: 'Reaction';
        type: ReactionType;
        count: number;
        isToggled: boolean;
      }>;
    }>;
  } | null;
};

export type GetCommunityReportedContentQueryVariables = Exact<{
  communityId: Scalars['Int'];
}>;

export type GetCommunityReportedContentQuery = {
  __typename?: 'Query';
  reportedContent?: Array<{
    __typename?: 'ReportedActivity';
    id: number;
    activityId: string;
    activityType: string;
    parentId?: string | null;
    createdAt: any;
    reason: number;
    text: string;
    author: {
      __typename?: 'Author';
      id: number;
      username: string;
      profilePicture: string;
    };
    media?: Array<{
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
    }> | null;
  }> | null;
};

export type GetCreatorCommunitiesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetCreatorCommunitiesQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    name?: string | null;
    mediaAvatar?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    communities: Array<{
      __typename?: 'Community';
      id: number;
      name: string;
      description: string;
      thumbnail?: string | null;
      membersCount: number;
      reportedPostsCount: number;
      blockedUsersCount: number;
    }>;
  } | null;
};

export type KeepCommunityContentMutationVariables = Exact<{
  contentId: Scalars['Int'];
}>;

export type KeepCommunityContentMutation = {
  __typename?: 'Mutation';
  keepContent?: boolean | null;
};

export type PublishCommunityPostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  publishAt?: InputMaybe<Scalars['DateTime']>;
}>;

export type PublishCommunityPostMutation = {
  __typename?: 'Mutation';
  publishPost?: {
    __typename?: 'Post';
    id: string;
    text: string;
    createdAt: any;
    edited: boolean;
    pinned?: boolean | null;
    status?: string | null;
    publishedAt?: any | null;
    author: {
      __typename?: 'Author';
      email: string;
      marketing: boolean;
      id: number;
      username: string;
      profilePicture: string;
      badges: Array<string>;
      hasDirectMessagesAccess?: boolean | null;
    };
    media: Array<{
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      mimeType?: string | null;
      source?: string | null;
      width?: number | null;
      height?: number | null;
      status?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      videoSourceType?: string | null;
    }>;
    reactions: Array<{
      __typename?: 'Reaction';
      type: ReactionType;
      count: number;
      isToggled: boolean;
    }>;
  } | null;
};

export type TogglePinCommunityPostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  pinned: Scalars['Boolean'];
}>;

export type TogglePinCommunityPostMutation = {
  __typename?: 'Mutation';
  togglePinPost?: boolean | null;
};

export type UnblockCommunityUserMutationVariables = Exact<{
  communityId: Scalars['Int'];
  userId: Scalars['Int'];
}>;

export type UnblockCommunityUserMutation = {
  __typename?: 'Mutation';
  unblockUser?: boolean | null;
};

export type UpdateCommunityDraftMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  text: Scalars['String'];
  media?: InputMaybe<Array<MediaInput> | MediaInput>;
}>;

export type UpdateCommunityDraftMutation = {
  __typename?: 'Mutation';
  updatePost?: {
    __typename?: 'Post';
    id: string;
    text: string;
    createdAt: any;
    edited: boolean;
    pinned?: boolean | null;
    status?: string | null;
    publishedAt?: any | null;
    author: {
      __typename?: 'Author';
      email: string;
      marketing: boolean;
      id: number;
      username: string;
      profilePicture: string;
      badges: Array<string>;
      hasDirectMessagesAccess?: boolean | null;
    };
    media: Array<{
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      mimeType?: string | null;
      source?: string | null;
      width?: number | null;
      height?: number | null;
      status?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      videoSourceType?: string | null;
    }>;
    reactions: Array<{
      __typename?: 'Reaction';
      type: ReactionType;
      count: number;
      isToggled: boolean;
    }>;
  } | null;
};

export type UpdateCommunityPostMutationVariables = Exact<{
  communityId: Scalars['Int'];
  postId: Scalars['String'];
  text: Scalars['String'];
}>;

export type UpdateCommunityPostMutation = {
  __typename?: 'Mutation';
  updatePost?: {
    __typename?: 'Post';
    id: string;
    text: string;
    edited: boolean;
  } | null;
};

export type UpdateCommunityReplyMutationVariables = Exact<{
  communityId: Scalars['Int'];
  replyId: Scalars['String'];
  text: Scalars['String'];
}>;

export type UpdateCommunityReplyMutation = {
  __typename?: 'Mutation';
  updateReply?: {
    __typename?: 'Reply';
    id: string;
    text: string;
    edited: boolean;
  } | null;
};

export type UserChallengeParticipationQueryVariables = Exact<{
  userId: Scalars['Int'];
  creatorId: Scalars['Int'];
}>;

export type UserChallengeParticipationQuery = {
  __typename?: 'Query';
  userChallengeParticipation: {
    __typename?: 'UserChallengeParticipation';
    active: Array<{ __typename?: 'ChallengeRef'; id: string; name: string }>;
    inactive: Array<{ __typename?: 'ChallengeRef'; id: string; name: string }>;
  };
};

export type CollectionSwapConfigQueryVariables = Exact<{
  collectionId: Scalars['Int'];
}>;

export type CollectionSwapConfigQuery = {
  __typename?: 'Query';
  collection: {
    __typename?: 'Collection';
    id: number;
    swapConfig?: {
      __typename?: 'ProgramSwapConfig';
      swapsEnabled: boolean;
    } | null;
  };
};

export type SwapCatalogExercisesQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']>;
  influencerId?: InputMaybe<Scalars['Int']>;
}>;

export type SwapCatalogExercisesQuery = {
  __typename?: 'Query';
  swapCatalogExercises: Array<{
    __typename?: 'SwapCatalogExercise';
    name: string;
    exercise: {
      __typename?: 'WorkoutExerciseSingle';
      name: string;
      description?: string | null;
      media?: {
        __typename?: 'Media';
        audio?: string | null;
        cdn01?: string | null;
        image?: string | null;
        video?: string | null;
        width?: number | null;
        height?: number | null;
        source?: string | null;
        mimeType?: string | null;
        videoSourceType?: string | null;
        uuid?: string | null;
        videoUrl?: string | null;
        videoThumbnailUrl?: string | null;
        downloadLink?: {
          __typename?: 'Download';
          low?: {
            __typename?: 'DownloadLink';
            filesize: number;
            height: number;
            width: number;
            link: string;
          } | null;
          high?: {
            __typename?: 'DownloadLink';
            filesize: number;
            height: number;
            width: number;
            link: string;
          } | null;
          medium?: {
            __typename?: 'DownloadLink';
            filesize: number;
            height: number;
            width: number;
            link: string;
          } | null;
        } | null;
      } | null;
    };
  }>;
};

export type LandingPageConfigQueryVariables = Exact<{
  influencerId: Scalars['Int'];
  creatorId: Scalars['ID'];
  forActiveBundle?: InputMaybe<Scalars['Boolean']>;
}>;

export type LandingPageConfigQuery = {
  __typename?: 'Query';
  landingPageConfig?: {
    __typename?: 'LandingPageConfig';
    id: number;
    influencerId: number;
    config?: any | null;
  } | null;
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    customURL?: string | null;
    businessModel: string;
    bio?: string | null;
    messageProfile?: string | null;
    mediaAvatar?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    mediaWelcome?: {
      __typename?: 'Media';
      cdn01?: string | null;
      video?: string | null;
    } | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    customDomains?: Array<{
      __typename?: 'CustomDomain';
      id: number;
      domain: string;
      status: CustomDomainStatus;
    }> | null;
    customColorSchema?: {
      __typename?: 'ColorScheme';
      id?: number | null;
      primaryColor?: string | null;
      secondaryColor?: string | null;
    } | null;
    publishedPrograms: Array<{
      __typename?: 'Program';
      id: number;
      name?: string | null;
      accessType: string;
      mediaCover?: {
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
      } | null;
    }>;
  } | null;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    title: string;
    influencerId: number;
    status: BundleStatus;
    landingPageUrl?: string | null;
    pricing: BundlePricing;
    isPlatformBundle: boolean;
    items?: Array<{
      __typename?: 'BundleItem';
      contentId?: string | null;
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    oneTimeProduct?: { __typename?: 'OneTimeProduct'; price: number } | null;
    checkoutPage?: { __typename?: 'CheckoutPage'; url: string } | null;
    subscriptionTier?: {
      __typename?: 'SubscriptionTier';
      id: number;
      prices?: Array<{
        __typename?: 'SubscriptionTierPrice';
        billingCycleInterval: BillingCycleInterval;
        billingCycleIntervalUnit: number;
        price: number;
      } | null> | null;
    } | null;
    coverImage?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
  }>;
  feature: Array<{
    __typename?: 'Feature';
    id: number;
    name: string;
    code: FeatureCode;
  }>;
  content: {
    __typename?: 'Content';
    contentItems: Array<{
      __typename?: 'ContentItem';
      type: string;
      value:
        | { __typename?: 'ContentImageValue' }
        | { __typename?: 'ContentLegacyGuideValue'; id: string; title: string }
        | { __typename?: 'ContentLinkValue'; id: string; title: string }
        | { __typename?: 'ContentPDFValue'; id: string; title: string }
        | { __typename?: 'ContentSlidesValue'; id: string; title: string }
        | { __typename?: 'ContentTabValue' }
        | { __typename?: 'ContentVideoValue'; id: string; title: string };
    }>;
  };
};

export type GetOtpProductsQueryVariables = Exact<{
  creatorId: Scalars['Int'];
}>;

export type GetOtpProductsQuery = {
  __typename?: 'Query';
  creator?: { __typename?: 'Creator'; customURL?: string | null } | null;
  collections: Array<{
    __typename?: 'Collection';
    id: number;
    name?: string | null;
    type: number;
    accessType: string;
  }>;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    title: string;
    status: BundleStatus;
    description?: string | null;
    landingPageUrl?: string | null;
  }>;
};

export type GrantFreeExclusiveSubscriptionToCreatorMutationVariables = Exact<{
  creatorId: Scalars['Int'];
}>;

export type GrantFreeExclusiveSubscriptionToCreatorMutation = {
  __typename?: 'Mutation';
  grantFreeExclusiveSubscriptionToCreator: boolean;
};

export type AdminResetStripeDataMutationVariables = Exact<{
  influencerId: Scalars['Int'];
}>;

export type AdminResetStripeDataMutation = {
  __typename?: 'Mutation';
  resetStripeData: boolean;
};

export type AdminUpdateInfluencerMutationVariables = Exact<{
  data: AdminInfluencerUpdateInput;
}>;

export type AdminUpdateInfluencerMutation = {
  __typename?: 'Mutation';
  adminUpdateInfluencer: boolean;
};

export type GetAdministrationDataQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetAdministrationDataQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    type?: number | null;
    tier?: number | null;
    isVisible?: boolean | null;
    publishedAt?: any | null;
    mode?: number | null;
    source?: string | null;
    isTCAccepted?: boolean | null;
    salesModel?: string | null;
    isPaymentEnabled?: boolean | null;
    stripeUserId?: string | null;
    paymentMethod?: number | null;
    profileDeepLink?: string | null;
    customURL?: string | null;
    insights?: Array<string | null> | null;
    tags?: Array<string | null> | null;
    collectionType?: string | null;
    productType?: string | null;
    publisheCollectionsCount?: number | null;
    publishedWorkoutsCount?: number | null;
    hasAccessToOwnExclusiveSubscription?: boolean | null;
    customizations?: {
      __typename?: 'Customizations';
      promo?: Array<string | null> | null;
      isNewVideo?: boolean | null;
      isNewRunning?: boolean | null;
      isCrmEnabled?: boolean | null;
      hideDiscovery?: boolean | null;
      hideAbout?: boolean | null;
      hideSuggestion?: boolean | null;
      workoutsTitle?: string | null;
      insightsTitle?: string | null;
      linkInBio?: string | null;
      feedFirst?: boolean | null;
      hideLibrary?: boolean | null;
      lastLibrary?: boolean | null;
      freeInfluencer?: boolean | null;
      feedLimit?: number | null;
      backgroundVideoUpload?: boolean | null;
      canUsePromotionDetails?: boolean | null;
      canUsePromotions?: boolean | null;
      productCatalogTitle: string;
      premiumFeaturesOTPIds?: Array<number | null> | null;
      isPPCOnly?: boolean | null;
      exclusivesTitle?: string | null;
      visibleForUnknownUsers?: boolean | null;
      isTransactionLedgerEnabled?: boolean | null;
      isUnifiedProgramsEnabled?: boolean | null;
      isOtpMigratedToBundle?: boolean | null;
      isCouponWithFreeTrialEnabled?: boolean | null;
      isExerciseSwapsEnabled?: boolean | null;
      isCreatorApprovedSwapsEnabled?: boolean | null;
      isU2UReferralsEnabled?: boolean | null;
      productCatalog: Array<{
        __typename?: 'ProductCatalogItem';
        price: number;
        productDescription: string;
        productName: string;
        purchaseLink: string;
        thumbnailUrl: string;
        tags: Array<string>;
      }>;
    } | null;
  } | null;
  onboardingListData: {
    __typename?: 'OnboardingList';
    profileReady: boolean;
    paymentMethodReady: boolean;
    collectionPublishedReady: boolean;
  };
};

export type GetSellableContentItemsQueryVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type GetSellableContentItemsQuery = {
  __typename?: 'Query';
  content: {
    __typename?: 'Content';
    contentItems: Array<{
      __typename?: 'ContentItem';
      type: string;
      value:
        | { __typename?: 'ContentImageValue' }
        | {
            __typename?: 'ContentLegacyGuideValue';
            id: string;
            title: string;
            isArchived?: boolean | null;
            isPublished: boolean;
          }
        | {
            __typename?: 'ContentLinkValue';
            id: string;
            title: string;
            isArchived?: boolean | null;
            isPublished: boolean;
            url: string;
          }
        | {
            __typename?: 'ContentPDFValue';
            id: string;
            title: string;
            isArchived?: boolean | null;
            isPublished: boolean;
            url: string;
          }
        | {
            __typename?: 'ContentSlidesValue';
            id: string;
            title: string;
            isArchived?: boolean | null;
            isPublished: boolean;
          }
        | { __typename?: 'ContentTabValue' }
        | {
            __typename?: 'ContentVideoValue';
            id: string;
            title: string;
            isArchived?: boolean | null;
            isPublished: boolean;
          };
    }>;
  };
};

export type CreateOtpBundleMutationVariables = Exact<{
  input: CreateOtpBundleInput;
}>;

export type CreateOtpBundleMutation = {
  __typename?: 'Mutation';
  createOtpBundle: {
    __typename?: 'BundleResponse';
    bundle: {
      __typename?: 'Bundle';
      createdAt: any;
      deeplinkUrl?: string | null;
      description?: string | null;
      id: number;
      influencerId: number;
      isPlatformBundle: boolean;
      pricing: BundlePricing;
      status: BundleStatus;
      title: string;
      updatedAt: any;
      oneTimeProduct?: {
        __typename?: 'OneTimeProduct';
        id: number;
        playbookFee: number;
        price: number;
        providerPriceId: string;
        providerProductId: string;
      } | null;
      items?: Array<{
        __typename?: 'BundleItem';
        bundleId: number;
        createdAt: any;
        id: number;
        itemId?: number | null;
        itemType: BundleItemType;
      }> | null;
      coverImage?: {
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
      } | null;
    };
    warnings?: {
      __typename?: 'BundleWarning';
      message: string;
      details: Array<{
        __typename?: 'BundleWarningDetail';
        itemType: BundleItemType;
        itemId?: number | null;
        contentId?: string | null;
        title?: string | null;
        error?: string | null;
      }>;
    } | null;
  };
};

export type DeleteOtpBundleMutationVariables = Exact<{
  bundleId: Scalars['Int'];
}>;

export type DeleteOtpBundleMutation = {
  __typename?: 'Mutation';
  deleteOtpBundle: boolean;
};

export type GetOtpBundlesQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  bundlePricing?: InputMaybe<Array<BundlePricing> | BundlePricing>;
}>;

export type GetOtpBundlesQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    businessModel: string;
  } | null;
  collections: Array<{
    __typename?: 'Collection';
    id: number;
    isVisible?: boolean | null;
    name?: string | null;
    type: number;
    accessType: string;
    publishedAt?: any | null;
    archivedAt?: any | null;
    readiness?: {
      __typename?: 'ProgramReadiness';
      title: boolean;
      cover: boolean;
      workouts: boolean;
      goal: boolean;
    } | null;
  }>;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    title: string;
    influencerId: number;
    status: BundleStatus;
    description?: string | null;
    pricing: BundlePricing;
    wasPurchased: boolean;
    landingPageUrl?: string | null;
    deeplinkUrl?: string | null;
    isFree: boolean;
    inAppPurchase: string;
    migrationProgramId?: number | null;
    items?: Array<{
      __typename?: 'BundleItem';
      contentId?: string | null;
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    oneTimeProduct?: {
      __typename?: 'OneTimeProduct';
      id: number;
      price: number;
      playbookFee: number;
      providerPriceId: string;
      providerProductId: string;
    } | null;
    checkoutPage?: {
      __typename?: 'CheckoutPage';
      url: string;
      type: CheckoutPageType;
    } | null;
    coverImage?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
  }>;
  feature: Array<{
    __typename?: 'Feature';
    id: number;
    name: string;
    code: FeatureCode;
  }>;
  getCouponsByInfluencer: Array<{
    __typename?: 'Coupon';
    code: string;
    id: string;
    isActive: boolean;
    name: string;
    paidProductIds?: Array<number> | null;
  }>;
};

export type UpdateOtpBundleMutationVariables = Exact<{
  input: UpdateOtpBundleInput;
}>;

export type UpdateOtpBundleMutation = {
  __typename?: 'Mutation';
  updateOtpBundle: {
    __typename?: 'BundleResponse';
    bundle: {
      __typename?: 'Bundle';
      createdAt: any;
      deeplinkUrl?: string | null;
      description?: string | null;
      id: number;
      influencerId: number;
      isPlatformBundle: boolean;
      pricing: BundlePricing;
      status: BundleStatus;
      title: string;
      updatedAt: any;
      oneTimeProduct?: {
        __typename?: 'OneTimeProduct';
        id: number;
        playbookFee: number;
        price: number;
        providerPriceId: string;
        providerProductId: string;
      } | null;
      items?: Array<{
        __typename?: 'BundleItem';
        bundleId: number;
        createdAt: any;
        id: number;
        itemId?: number | null;
        itemType: BundleItemType;
      }> | null;
      coverImage?: {
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
      } | null;
    };
    warnings?: {
      __typename?: 'BundleWarning';
      message: string;
      details: Array<{
        __typename?: 'BundleWarningDetail';
        itemType: BundleItemType;
        itemId?: number | null;
        contentId?: string | null;
        title?: string | null;
        error?: string | null;
      }>;
    } | null;
  };
};

export type CreateSubscriptionBundleMutationVariables = Exact<{
  input: CreateSubscriptionBundleInput;
}>;

export type CreateSubscriptionBundleMutation = {
  __typename?: 'Mutation';
  createSubscriptionBundle: {
    __typename?: 'Bundle';
    id: number;
    title: string;
    influencerId: number;
    isPlatformBundle: boolean;
    status: BundleStatus;
    description?: string | null;
    pricing: BundlePricing;
    pushNotificationMessage?: string | null;
    pushNotificationSentAt?: any | null;
    pushNotificationUsageCount: number;
    upgradeDeeplinkUrl?: string | null;
    items?: Array<{
      __typename?: 'BundleItem';
      contentId?: string | null;
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    subscriptionTier?: {
      __typename?: 'SubscriptionTier';
      id: number;
      name: string;
      description?: string | null;
      prices?: Array<{
        __typename?: 'SubscriptionTierPrice';
        billingCycleInterval: BillingCycleInterval;
        billingCycleIntervalUnit: number;
        price: number;
        isFreeTrialEnabled: boolean;
        providerPriceId?: string | null;
      } | null> | null;
    } | null;
  };
};

export type GetSubscriptionBundlesQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  bundlePricing?: InputMaybe<Array<BundlePricing> | BundlePricing>;
}>;

export type GetSubscriptionBundlesQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    name?: string | null;
    customURL?: string | null;
    profileDeepLink?: string | null;
    businessModel: string;
    visibility: string;
    enableCheckoutFreeTrial: boolean;
    programs: Array<{
      __typename?: 'Program';
      id: number;
      isVisible?: boolean | null;
      name?: string | null;
      type: number;
      accessType: string;
      programBusinessModel?: ProgramBusinessModel | null;
      publishedAt?: any | null;
      archivedAt?: any | null;
      readiness?: {
        __typename?: 'ProgramReadiness';
        title: boolean;
        cover: boolean;
        workouts: boolean;
        goal: boolean;
      } | null;
    }>;
    customizations?: {
      __typename?: 'Customizations';
      isExclusiveMigratedToBundle?: boolean | null;
    } | null;
  } | null;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    title: string;
    influencerId: number;
    isPlatformBundle: boolean;
    status: BundleStatus;
    description?: string | null;
    pricing: BundlePricing;
    pushNotificationMessage?: string | null;
    pushNotificationSentAt?: any | null;
    pushNotificationUsageCount: number;
    upgradeDeeplinkUrl?: string | null;
    items?: Array<{
      __typename?: 'BundleItem';
      contentId?: string | null;
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    subscriptionTier?: {
      __typename?: 'SubscriptionTier';
      id: number;
      name: string;
      description?: string | null;
      prices?: Array<{
        __typename?: 'SubscriptionTierPrice';
        billingCycleInterval: BillingCycleInterval;
        billingCycleIntervalUnit: number;
        price: number;
        isFreeTrialEnabled: boolean;
        providerPriceId?: string | null;
      } | null> | null;
    } | null;
  }>;
  feature: Array<{
    __typename?: 'Feature';
    id: number;
    name: string;
    code: FeatureCode;
  }>;
  getCouponsByInfluencer: Array<{
    __typename?: 'Coupon';
    id: string;
    isActive: boolean;
    productType: CouponProductType;
    subscriptionProviderPriceId?: string | null;
    code: string;
    name: string;
  }>;
};

export type PublishSubscriptionBundleMutationVariables = Exact<{
  bundleId: Scalars['Int'];
}>;

export type PublishSubscriptionBundleMutation = {
  __typename?: 'Mutation';
  publishSubscriptionBundle: {
    __typename?: 'Bundle';
    id: number;
    title: string;
    influencerId: number;
    isPlatformBundle: boolean;
    status: BundleStatus;
    description?: string | null;
    pricing: BundlePricing;
    pushNotificationMessage?: string | null;
    pushNotificationSentAt?: any | null;
    pushNotificationUsageCount: number;
    upgradeDeeplinkUrl?: string | null;
    items?: Array<{
      __typename?: 'BundleItem';
      contentId?: string | null;
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    subscriptionTier?: {
      __typename?: 'SubscriptionTier';
      id: number;
      name: string;
      description?: string | null;
      prices?: Array<{
        __typename?: 'SubscriptionTierPrice';
        billingCycleInterval: BillingCycleInterval;
        billingCycleIntervalUnit: number;
        price: number;
        isFreeTrialEnabled: boolean;
        providerPriceId?: string | null;
      } | null> | null;
    } | null;
  };
};

export type SendSubscriptionBundlePushNotificationMutationVariables = Exact<{
  bundleId: Scalars['Int'];
  message: Scalars['String'];
}>;

export type SendSubscriptionBundlePushNotificationMutation = {
  __typename?: 'Mutation';
  sendSubscriptionBundlePushNotification: boolean;
};

export type SetBundleBusinessModelMutationVariables = Exact<{
  data: SetBundleBusinessModelInput;
}>;

export type SetBundleBusinessModelMutation = {
  __typename?: 'Mutation';
  setBundleBusinessModel: boolean;
};

export type UpdateSubscriptionBundlesMutationVariables = Exact<{
  input: Array<UpdateBundleInput> | UpdateBundleInput;
}>;

export type UpdateSubscriptionBundlesMutation = {
  __typename?: 'Mutation';
  updateBundles: Array<{ __typename?: 'Bundle'; id: number }>;
};

export type UpsertOrArchiveSubscriptionBundlePricesMutationVariables = Exact<{
  input: UpsertOrArchiveSubscriptionBundlePricesInput;
}>;

export type UpsertOrArchiveSubscriptionBundlePricesMutation = {
  __typename?: 'Mutation';
  upsertOrArchiveSubscriptionBundlePrices: boolean;
};

export type CollectionBaseFragmentFragment = {
  __typename?: 'Collection';
  id: number;
  influencerId: number;
  isVisible?: boolean | null;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  type: number;
  expiresAt?: any | null;
  publishedAt?: any | null;
  archivedAt?: any | null;
  accessType: string;
};

export type ChallengeBaseFragmentFragment = {
  __typename?: 'Challenge';
  name: string;
  id: string;
  createdAt: any;
  registrationStart: any;
  registrationEnd: any;
  hidePhotos: boolean;
  templates?: Array<string | null> | null;
  updatedAt: any;
  completionStart: any;
  completionEnd: any;
  deepLink: string;
  photoInstructions: string;
  registrationRequirements: {
    __typename?: 'RegistrationRequirements';
    photos: boolean;
    instagram: boolean;
    goal: boolean;
  };
  completionRequirements: {
    __typename?: 'CompletionRequirements';
    photos: boolean;
    testimonial: boolean;
  };
};

export type SubmissionFragmentFragment = {
  __typename?: 'ChallengeSubmission';
  submissionId: string;
  completionDate?: any | null;
  registrationDate: any;
  createdAt: any;
  updatedAt: any;
  isShortlisted: boolean;
  allowRepost: boolean;
  userStateOnCompletion?: {
    __typename?: 'UserStateOnCompletion';
    subscriptionStatus?: string | null;
    workoutsCompleted?: number | null;
    workoutsTotal?: number | null;
    subscriptionStatusDate?: string | null;
  } | null;
  subscriptionInfo?: {
    __typename?: 'SubscriptionInfo';
    expiresAt: any;
    status: string;
  } | null;
  completionAttributes?: {
    __typename?: 'CompletionAttributes';
    testimonial?: string | null;
  } | null;
  registrationAttributes: {
    __typename?: 'RegistrationAttributes';
    goal?: string | null;
    instagram?: string | null;
  };
  user: { __typename?: 'User'; name?: string | null; email?: string | null };
  completionMedia?: Array<{
    __typename?: 'Media';
    audio?: string | null;
    videoThumbnailUrl?: string | null;
    videoUrl?: string | null;
    width?: number | null;
    height?: number | null;
    cdn01?: string | null;
    image?: string | null;
    source?: string | null;
    mimeType?: string | null;
    uuid?: string | null;
    video?: string | null;
    downloadLink?: {
      __typename?: 'Download';
      high?: {
        __typename?: 'DownloadLink';
        link: string;
        filesize: number;
        width: number;
        height: number;
      } | null;
    } | null;
  }> | null;
  registrationMedia?: Array<{
    __typename?: 'Media';
    audio?: string | null;
    videoThumbnailUrl?: string | null;
    videoUrl?: string | null;
    width?: number | null;
    height?: number | null;
    cdn01?: string | null;
    image?: string | null;
    source?: string | null;
    mimeType?: string | null;
    uuid?: string | null;
    video?: string | null;
    downloadLink?: {
      __typename?: 'Download';
      high?: {
        __typename?: 'DownloadLink';
        link: string;
        filesize: number;
        width: number;
        height: number;
      } | null;
    } | null;
  }> | null;
  transformationMedia?: Array<{
    __typename?: 'Media';
    audio?: string | null;
    videoThumbnailUrl?: string | null;
    videoUrl?: string | null;
    width?: number | null;
    height?: number | null;
    cdn01?: string | null;
    image?: string | null;
    source?: string | null;
    mimeType?: string | null;
    uuid?: string | null;
    video?: string | null;
    downloadLink?: {
      __typename?: 'Download';
      high?: {
        __typename?: 'DownloadLink';
        link: string;
        filesize: number;
        width: number;
        height: number;
      } | null;
    } | null;
  }> | null;
};

export type MediaFragmentFragment = {
  __typename?: 'Media';
  audio?: string | null;
  videoThumbnailUrl?: string | null;
  videoUrl?: string | null;
  width?: number | null;
  height?: number | null;
  cdn01?: string | null;
  image?: string | null;
  source?: string | null;
  mimeType?: string | null;
  uuid?: string | null;
  video?: string | null;
  downloadLink?: {
    __typename?: 'Download';
    high?: {
      __typename?: 'DownloadLink';
      link: string;
      filesize: number;
      width: number;
      height: number;
    } | null;
  } | null;
};

export type GetProgramWithLiteChallengesQueryVariables = Exact<{
  collectionId: Scalars['Int'];
}>;

export type GetProgramWithLiteChallengesQuery = {
  __typename?: 'Query';
  collection: {
    __typename?: 'Collection';
    id: number;
    influencerId: number;
    isVisible?: boolean | null;
    name?: string | null;
    description?: string | null;
    color?: string | null;
    type: number;
    expiresAt?: any | null;
    publishedAt?: any | null;
    archivedAt?: any | null;
    accessType: string;
    challenges?: Array<{
      __typename?: 'Challenge';
      name: string;
      id: string;
      createdAt: any;
      registrationStart: any;
      registrationEnd: any;
      hidePhotos: boolean;
      templates?: Array<string | null> | null;
      updatedAt: any;
      completionStart: any;
      completionEnd: any;
      deepLink: string;
      photoInstructions: string;
      submissions: Array<{
        __typename?: 'ChallengeSubmission';
        submissionId: string;
      }>;
      registrationRequirements: {
        __typename?: 'RegistrationRequirements';
        photos: boolean;
        instagram: boolean;
        goal: boolean;
      };
      completionRequirements: {
        __typename?: 'CompletionRequirements';
        photos: boolean;
        testimonial: boolean;
      };
    } | null> | null;
  };
};

export type GetProgramWithChallengesQueryVariables = Exact<{
  collectionId: Scalars['Int'];
}>;

export type GetProgramWithChallengesQuery = {
  __typename?: 'Query';
  collection: {
    __typename?: 'Collection';
    id: number;
    influencerId: number;
    isVisible?: boolean | null;
    name?: string | null;
    description?: string | null;
    color?: string | null;
    type: number;
    expiresAt?: any | null;
    publishedAt?: any | null;
    archivedAt?: any | null;
    accessType: string;
    challenges?: Array<{
      __typename?: 'Challenge';
      name: string;
      id: string;
      createdAt: any;
      registrationStart: any;
      registrationEnd: any;
      hidePhotos: boolean;
      templates?: Array<string | null> | null;
      updatedAt: any;
      completionStart: any;
      completionEnd: any;
      deepLink: string;
      photoInstructions: string;
      submissions: Array<{
        __typename?: 'ChallengeSubmission';
        submissionId: string;
        completionDate?: any | null;
        registrationDate: any;
        createdAt: any;
        updatedAt: any;
        isShortlisted: boolean;
        allowRepost: boolean;
        userStateOnCompletion?: {
          __typename?: 'UserStateOnCompletion';
          subscriptionStatus?: string | null;
          workoutsCompleted?: number | null;
          workoutsTotal?: number | null;
          subscriptionStatusDate?: string | null;
        } | null;
        subscriptionInfo?: {
          __typename?: 'SubscriptionInfo';
          expiresAt: any;
          status: string;
        } | null;
        completionAttributes?: {
          __typename?: 'CompletionAttributes';
          testimonial?: string | null;
        } | null;
        registrationAttributes: {
          __typename?: 'RegistrationAttributes';
          goal?: string | null;
          instagram?: string | null;
        };
        user: {
          __typename?: 'User';
          name?: string | null;
          email?: string | null;
        };
        completionMedia?: Array<{
          __typename?: 'Media';
          audio?: string | null;
          videoThumbnailUrl?: string | null;
          videoUrl?: string | null;
          width?: number | null;
          height?: number | null;
          cdn01?: string | null;
          image?: string | null;
          source?: string | null;
          mimeType?: string | null;
          uuid?: string | null;
          video?: string | null;
          downloadLink?: {
            __typename?: 'Download';
            high?: {
              __typename?: 'DownloadLink';
              link: string;
              filesize: number;
              width: number;
              height: number;
            } | null;
          } | null;
        }> | null;
        registrationMedia?: Array<{
          __typename?: 'Media';
          audio?: string | null;
          videoThumbnailUrl?: string | null;
          videoUrl?: string | null;
          width?: number | null;
          height?: number | null;
          cdn01?: string | null;
          image?: string | null;
          source?: string | null;
          mimeType?: string | null;
          uuid?: string | null;
          video?: string | null;
          downloadLink?: {
            __typename?: 'Download';
            high?: {
              __typename?: 'DownloadLink';
              link: string;
              filesize: number;
              width: number;
              height: number;
            } | null;
          } | null;
        }> | null;
        transformationMedia?: Array<{
          __typename?: 'Media';
          audio?: string | null;
          videoThumbnailUrl?: string | null;
          videoUrl?: string | null;
          width?: number | null;
          height?: number | null;
          cdn01?: string | null;
          image?: string | null;
          source?: string | null;
          mimeType?: string | null;
          uuid?: string | null;
          video?: string | null;
          downloadLink?: {
            __typename?: 'Download';
            high?: {
              __typename?: 'DownloadLink';
              link: string;
              filesize: number;
              width: number;
              height: number;
            } | null;
          } | null;
        }> | null;
      }>;
      registrationRequirements: {
        __typename?: 'RegistrationRequirements';
        photos: boolean;
        instagram: boolean;
        goal: boolean;
      };
      completionRequirements: {
        __typename?: 'CompletionRequirements';
        photos: boolean;
        testimonial: boolean;
      };
    } | null> | null;
  };
};

export type GetProgramChallengesCountQueryVariables = Exact<{
  collectionId: Scalars['Int'];
}>;

export type GetProgramChallengesCountQuery = {
  __typename?: 'Query';
  collection: {
    __typename?: 'Collection';
    challenges?: Array<{ __typename?: 'Challenge'; id: string } | null> | null;
  };
};

export type CreateChallengeMutationVariables = Exact<{
  input: CreateChallengeInput;
}>;

export type CreateChallengeMutation = {
  __typename?: 'Mutation';
  createChallenge: { __typename?: 'Challenge'; id: string };
};

export type UpdateChallengeMutationVariables = Exact<{
  input: UpdateChallengeInput;
}>;

export type UpdateChallengeMutation = {
  __typename?: 'Mutation';
  updateChallenge: { __typename?: 'Challenge'; id: string };
};

export type UpdateSubmissionMutationVariables = Exact<{
  submissionId: Scalars['Int'];
  isShortlisted: Scalars['Boolean'];
}>;

export type UpdateSubmissionMutation = {
  __typename?: 'Mutation';
  setSubmissionShortlistStatus: boolean;
};

export type CollectionMediaFragment = {
  __typename?: 'Media';
  image?: string | null;
  video?: string | null;
  cdn01?: string | null;
  width?: number | null;
  height?: number | null;
};

export type GetCollectionPageDataQueryVariables = Exact<{
  collectionId: Scalars['Int'];
  creatorId: Scalars['Int'];
}>;

export type GetCollectionPageDataQuery = {
  __typename?: 'Query';
  collection: {
    __typename?: 'Collection';
    id: number;
    influencerId: number;
    isVisible?: boolean | null;
    name?: string | null;
    description?: string | null;
    color?: string | null;
    type: number;
    publishingBehaviour: string;
    workoutLimit?: number | null;
    contentStructure?: string | null;
    duration?: Array<string | null> | null;
    tags?: Array<string | null> | null;
    expiresAt?: any | null;
    publishedAt?: any | null;
    archivedAt?: any | null;
    accessType: string;
    inAppPurchase: InAppPurchase;
    isLocked?: boolean | null;
    migrationBundleId?: number | null;
    goal?: string | null;
    daysPerWeek?: number | null;
    sessionDuration?: string | null;
    requiredEquipment?: Array<string> | null;
    difficulty?: string | null;
    location?: string | null;
    index?: number | null;
    deeplinkUrl?: string | null;
    swapConfig?: {
      __typename?: 'ProgramSwapConfig';
      swapsEnabled: boolean;
    } | null;
    mediaCover?: {
      __typename?: 'Media';
      image?: string | null;
      video?: string | null;
      cdn01?: string | null;
      width?: number | null;
      height?: number | null;
    } | null;
    mediaIntro?: {
      __typename?: 'Media';
      image?: string | null;
      video?: string | null;
      cdn01?: string | null;
      width?: number | null;
      height?: number | null;
    } | null;
    faq?: Array<{
      __typename?: 'FeedFaq';
      answer: string;
      question: string;
    } | null> | null;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      isClass?: boolean | null;
      name?: string | null;
      mediaCover?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
      mediaExercise?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
    } | null> | null;
    testimonials?: Array<{
      __typename?: 'Testimonial';
      text: string;
      name: string;
      media?: {
        __typename?: 'Media';
        image?: string | null;
        video?: string | null;
        cdn01?: string | null;
        width?: number | null;
        height?: number | null;
      } | null;
    } | null> | null;
    hiddenSections?: {
      __typename?: 'ProgramHiddenSections';
      faq?: boolean | null;
      testimonials?: boolean | null;
    } | null;
    exclusiveProgramMetadata?: {
      __typename?: 'ExclusiveProgramMetadata';
      deeplinkUrl?: string | null;
      checkoutPageUrl?: string | null;
      price?: number | null;
      playbookFee?: number | null;
      originalPrice?: number | null;
      discountPercent?: number | null;
    } | null;
    readiness?: {
      __typename?: 'ProgramReadiness';
      title: boolean;
      cover: boolean;
      workouts: boolean;
      goal: boolean;
    } | null;
  };
  creator?: {
    __typename?: 'Creator';
    id: number;
    customURL?: string | null;
    mode?: number | null;
    email?: string | null;
    publisheCollectionsCount?: number | null;
    profileDeepLink?: string | null;
    businessModel: string;
  } | null;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    isPlatformBundle: boolean;
    status: BundleStatus;
    pricing: BundlePricing;
    isFree: boolean;
    items?: Array<{
      __typename?: 'BundleItem';
      itemType: BundleItemType;
      itemId?: number | null;
    }> | null;
  }>;
  purchasePageConfig?: {
    __typename?: 'PurchasePageConfig';
    id: number;
    programId: number;
    config?: any | null;
  } | null;
};

export type GetCollectionParentOffersQueryVariables = Exact<{
  input: BundleItemInput;
}>;

export type GetCollectionParentOffersQuery = {
  __typename?: 'Query';
  parentBundlesByItem: Array<{
    __typename?: 'Bundle';
    id: number;
    status: BundleStatus;
    title: string;
    description?: string | null;
  }>;
};

export type GetCollectionParentOffersDetailedQueryVariables = Exact<{
  input: BundleItemInput;
  creatorId: Scalars['Int'];
}>;

export type GetCollectionParentOffersDetailedQuery = {
  __typename?: 'Query';
  parentBundlesByItem: Array<{
    __typename?: 'Bundle';
    id: number;
    status: BundleStatus;
    title: string;
    isFree: boolean;
    oneTimeProduct?: { __typename?: 'OneTimeProduct'; price: number } | null;
    items?: Array<{
      __typename?: 'BundleItem';
      itemType: BundleItemType;
      itemId?: number | null;
    }> | null;
  }>;
  creator?: {
    __typename?: 'Creator';
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
    } | null> | null;
  } | null;
};

export type PublishCollectionMutationVariables = Exact<{
  programId: Scalars['Int'];
  onlyPublish?: InputMaybe<Scalars['Boolean']>;
  bundleIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;

export type PublishCollectionMutation = {
  __typename?: 'Mutation';
  publishCollection: {
    __typename?: 'Collection';
    id: number;
    publishedAt?: any | null;
  };
};

export type GetCollectionWorkoutsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetCollectionWorkoutsQuery = {
  __typename?: 'Query';
  collection: {
    __typename?: 'Collection';
    name?: string | null;
    isLocked?: boolean | null;
    accessType: string;
    migrationBundleId?: number | null;
    influencer?: {
      __typename?: 'Creator';
      mode?: number | null;
      customURL?: string | null;
    } | null;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      isClass?: boolean | null;
      name?: string | null;
    } | null> | null;
  };
};

export type CollectionDetailsFragment = {
  __typename?: 'Collection';
  id: number;
  isVisible?: boolean | null;
  influencerId: number;
  name?: string | null;
  color?: string | null;
  type: number;
  publishingBehaviour: string;
  workoutLimit?: number | null;
  accessType: string;
  contentStructure?: string | null;
  isLocked?: boolean | null;
  archivedAt?: any | null;
  publishedAt?: any | null;
  index?: number | null;
  deeplinkUrl?: string | null;
  migrationBundleId?: number | null;
  mediaCover?: {
    __typename?: 'Media';
    cdn01?: string | null;
    image?: string | null;
  } | null;
  exclusiveProgramMetadata?: {
    __typename?: 'ExclusiveProgramMetadata';
    deeplinkUrl?: string | null;
    checkoutPageUrl?: string | null;
    price?: number | null;
  } | null;
};

export type GetCollectionsQueryVariables = Exact<{
  influencerId: Scalars['Int'];
  accessType?: InputMaybe<Array<AccessType> | AccessType>;
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCollectionsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    customURL?: string | null;
    profileDeepLink?: string | null;
    businessModel: string;
    customizations?: {
      __typename?: 'Customizations';
      isOtpMigratedToBundle?: boolean | null;
    } | null;
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
    } | null> | null;
  } | null;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    isPlatformBundle: boolean;
    isFree: boolean;
    status: BundleStatus;
    pricing: BundlePricing;
    title: string;
    deeplinkUrl?: string | null;
    landingPageUrl?: string | null;
    items?: Array<{
      __typename?: 'BundleItem';
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    checkoutPage?: {
      __typename?: 'CheckoutPage';
      url: string;
      type: CheckoutPageType;
    } | null;
    oneTimeProduct?: { __typename?: 'OneTimeProduct'; price: number } | null;
  }>;
  collections: Array<{
    __typename?: 'Collection';
    id: number;
    isVisible?: boolean | null;
    influencerId: number;
    name?: string | null;
    color?: string | null;
    type: number;
    publishingBehaviour: string;
    workoutLimit?: number | null;
    accessType: string;
    contentStructure?: string | null;
    isLocked?: boolean | null;
    archivedAt?: any | null;
    publishedAt?: any | null;
    index?: number | null;
    deeplinkUrl?: string | null;
    migrationBundleId?: number | null;
    programStats?: {
      __typename?: 'ProgramStatsModel';
      avgRating?: number | null;
      statsBegins: number;
      statsComments: number;
      statsCompletions: number;
    } | null;
    challenges?: Array<{
      __typename?: 'Challenge';
      id: string;
      completionEnd: any;
      deepLink: string;
    } | null> | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    exclusiveProgramMetadata?: {
      __typename?: 'ExclusiveProgramMetadata';
      deeplinkUrl?: string | null;
      checkoutPageUrl?: string | null;
      price?: number | null;
    } | null;
  }>;
};

export type OrderCollectionsMutationVariables = Exact<{
  influencerId: Scalars['Int'];
  salesType: SalesType;
  ids: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type OrderCollectionsMutation = {
  __typename?: 'Mutation';
  orderCollections?: boolean | null;
};

export type PurchaseCollectionFragment = {
  __typename?: 'Collection';
  id: number;
  isVisible?: boolean | null;
  influencerId: number;
  name?: string | null;
  color?: string | null;
  type: number;
  publishingBehaviour: string;
  workoutLimit?: number | null;
  accessType: string;
  contentStructure?: string | null;
  isLocked?: boolean | null;
  mediaCover?: {
    __typename?: 'Media';
    cdn01?: string | null;
    image?: string | null;
  } | null;
};

export type GetPurchaseCollectionsQueryVariables = Exact<{
  influencerId: Scalars['Int'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetPurchaseCollectionsQuery = {
  __typename?: 'Query';
  creator?: { __typename?: 'Creator'; customURL?: string | null } | null;
  collections: Array<{
    __typename?: 'Collection';
    id: number;
    isVisible?: boolean | null;
    influencerId: number;
    name?: string | null;
    color?: string | null;
    type: number;
    publishingBehaviour: string;
    workoutLimit?: number | null;
    accessType: string;
    contentStructure?: string | null;
    isLocked?: boolean | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
  }>;
};

export type SubscriptionCollectionFragment = {
  __typename?: 'Collection';
  id: number;
  isVisible?: boolean | null;
  influencerId: number;
  name?: string | null;
  color?: string | null;
  type: number;
  publishingBehaviour: string;
  workoutLimit?: number | null;
  accessType: string;
  contentStructure?: string | null;
  isLocked?: boolean | null;
  mediaCover?: {
    __typename?: 'Media';
    cdn01?: string | null;
    image?: string | null;
  } | null;
};

export type GetSubscriptionCollectionsQueryVariables = Exact<{
  influencerId: Scalars['Int'];
  withDeleted?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetSubscriptionCollectionsQuery = {
  __typename?: 'Query';
  creator?: { __typename?: 'Creator'; customURL?: string | null } | null;
  collections: Array<{
    __typename?: 'Collection';
    id: number;
    isVisible?: boolean | null;
    influencerId: number;
    name?: string | null;
    color?: string | null;
    type: number;
    publishingBehaviour: string;
    workoutLimit?: number | null;
    accessType: string;
    contentStructure?: string | null;
    isLocked?: boolean | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
  }>;
};

export type SetCustomUrlMutationVariables = Exact<{
  customURL: Scalars['String'];
}>;

export type SetCustomUrlMutation = {
  __typename?: 'Mutation';
  setCustomUrl: boolean;
};

export type GetCommentsQueryVariables = Exact<{
  contentId: Scalars['String'];
  usersLimit?: InputMaybe<Scalars['Int']>;
}>;

export type GetCommentsQuery = {
  __typename?: 'Query';
  getComments: Array<{
    __typename?: 'CommentValue';
    id: string;
    contentId: string;
    threadId?: string | null;
    text: string;
    hidden: boolean;
    createdAt: any;
    updatedAt?: any | null;
    author: {
      __typename?: 'Author';
      id: number;
      username: string;
      profilePicture: string;
    };
    thread?: Array<{
      __typename?: 'CommentValue';
      id: string;
      contentId: string;
      threadId?: string | null;
      text: string;
      hidden: boolean;
      createdAt: any;
      updatedAt?: any | null;
      author: {
        __typename?: 'Author';
        id: number;
        username: string;
        profilePicture: string;
      };
    }> | null;
  }>;
};

export type CreateCommentMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreateCommentInput;
}>;

export type CreateCommentMutation = {
  __typename?: 'Mutation';
  createComment: { __typename?: 'IdObject'; id: string };
};

export type UpdateCommentMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  commentId: Scalars['ID'];
  input: UpdateCommentInput;
}>;

export type UpdateCommentMutation = {
  __typename?: 'Mutation';
  updateComment: boolean;
};

export type UpdateCommentVisibilityMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  commentId: Scalars['ID'];
  isVisible: Scalars['Boolean'];
}>;

export type UpdateCommentVisibilityMutation = {
  __typename?: 'Mutation';
  updateCommentVisibility: boolean;
};

export type DeleteEngagementMutationVariables = Exact<{
  creatorId: Scalars['String'];
  engagementId: Scalars['ID'];
}>;

export type DeleteEngagementMutation = {
  __typename?: 'Mutation';
  deleteEngagement: boolean;
};

export type GetContentQueryVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type GetContentQuery = {
  __typename?: 'Query';
  content: {
    __typename?: 'Content';
    contentIds?: {
      __typename?: 'ContentIds';
      id: string;
      items?: Array<{
        __typename?: 'ContentIds';
        id: string;
        items?: Array<{
          __typename?: 'ContentIds';
          id: string;
          items?: Array<{
            __typename?: 'ContentIds';
            id: string;
            items?: Array<{ __typename?: 'ContentIds'; id: string }> | null;
          }> | null;
        }> | null;
      }> | null;
    } | null;
    contentItems: Array<{
      __typename?: 'ContentItem';
      type: string;
      value:
        | {
            __typename?: 'ContentImageValue';
            id: string;
            title: string;
            url: string;
            isPublished: boolean;
          }
        | {
            __typename?: 'ContentLegacyGuideValue';
            id: string;
            title: string;
            contentId: number;
            count: number;
            isPublished: boolean;
            isArchived?: boolean | null;
            accessMethod: ContentAccessMethod;
            bundles: Array<{
              __typename?: 'Bundle';
              id: number;
              title: string;
              status: BundleStatus;
              wasPurchased: boolean;
            }>;
          }
        | {
            __typename?: 'ContentLinkValue';
            id: string;
            title: string;
            url: string;
            isPublished: boolean;
            isArchived?: boolean | null;
            coverImage?: string | null;
            accessMethod: ContentAccessMethod;
            bundles: Array<{
              __typename?: 'Bundle';
              id: number;
              title: string;
              status: BundleStatus;
              wasPurchased: boolean;
            }>;
          }
        | {
            __typename?: 'ContentPDFValue';
            id: string;
            title: string;
            coverURL?: string | null;
            url: string;
            downloadable: boolean;
            isPublished: boolean;
            isArchived?: boolean | null;
            fileName: string;
            fileSize: number;
            accessMethod: ContentAccessMethod;
            bundles: Array<{
              __typename?: 'Bundle';
              id: number;
              title: string;
              status: BundleStatus;
              wasPurchased: boolean;
            }>;
          }
        | {
            __typename?: 'ContentSlidesValue';
            id: string;
            title: string;
            coverURL?: string | null;
            downloadable: boolean;
            isPublished: boolean;
            isArchived?: boolean | null;
            accessMethod: ContentAccessMethod;
            bundles: Array<{
              __typename?: 'Bundle';
              id: number;
              title: string;
              status: BundleStatus;
              wasPurchased: boolean;
            }>;
          }
        | {
            __typename?: 'ContentTabValue';
            id: string;
            name: string;
            isPublished: boolean;
          }
        | {
            __typename?: 'ContentVideoValue';
            id: string;
            title: string;
            isPublished: boolean;
            isArchived?: boolean | null;
            coverURL?: string | null;
            description?: string | null;
            downloadable: boolean;
            durationMs: number;
            allowComments: boolean;
            thumbnailCustomURL?: string | null;
            thumbnailTimestampMs: number;
            commentsCount: number;
            likesCount: number;
            libraryVideoId: string;
            watchCount: number;
            muxAssetId: string;
            muxPlaybackId: string;
            isProcessed: boolean;
            videoAccessMethod: ContentAccessMethod;
            videoBundles: Array<{
              __typename?: 'Bundle';
              id: number;
              title: string;
              status: BundleStatus;
              wasPurchased: boolean;
            }>;
          };
    }>;
  };
};

export type ReorderContentMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  contentIds: ContentIdsInput;
}>;

export type ReorderContentMutation = {
  __typename?: 'Mutation';
  reorderContent: {
    __typename?: 'ContentIds';
    id: string;
    items?: Array<{
      __typename?: 'ContentIds';
      id: string;
      items?: Array<{ __typename?: 'ContentIds'; id: string }> | null;
    }> | null;
  };
};

export type CreateTabMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreateTabInput;
}>;

export type CreateTabMutation = {
  __typename?: 'Mutation';
  createTab: { __typename?: 'IdObject'; id: string };
};

export type UpdateTabMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  input: UpdateTabInput;
}>;

export type UpdateTabMutation = { __typename?: 'Mutation'; updateTab: boolean };

export type CreateLinkMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreateLinkInput;
}>;

export type CreateLinkMutation = {
  __typename?: 'Mutation';
  createLink: { __typename?: 'IdObject'; id: string };
};

export type UpdateLinkMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  input: UpdateLinkInput;
}>;

export type UpdateLinkMutation = {
  __typename?: 'Mutation';
  updateLink: boolean;
};

export type CreateLegacyGuideMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreateLegacyGuideInput;
}>;

export type CreateLegacyGuideMutation = {
  __typename?: 'Mutation';
  createLegacyGuide: { __typename?: 'IdObject'; id: string };
};

export type UpdateLegacyGuideMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  input: UpdateLegacyGuideInput;
}>;

export type UpdateLegacyGuideMutation = {
  __typename?: 'Mutation';
  updateLegacyGuide: boolean;
};

export type CreateSlidesMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreateSlidesInput;
}>;

export type CreateSlidesMutation = {
  __typename?: 'Mutation';
  createSlides: { __typename?: 'IdObject'; id: string };
};

export type UpdateSlidesMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  input: UpdateSlidesInput;
}>;

export type UpdateSlidesMutation = {
  __typename?: 'Mutation';
  updateSlides: boolean;
};

export type CreateImageMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreateImageInput;
  file: Scalars['Upload'];
}>;

export type CreateImageMutation = {
  __typename?: 'Mutation';
  createImage: { __typename?: 'IdObject'; id: string };
};

export type UpdateImageMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  input: UpdateImageInput;
}>;

export type UpdateImageMutation = {
  __typename?: 'Mutation';
  updateImage: boolean;
};

export type CreatePdfMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreatePdfInput;
  file: Scalars['Upload'];
}>;

export type CreatePdfMutation = {
  __typename?: 'Mutation';
  createPDF: { __typename?: 'IdObject'; id: string };
};

export type UpdatePdfMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  input: UpdatePdfInput;
  file?: InputMaybe<Scalars['Upload']>;
}>;

export type UpdatePdfMutation = { __typename?: 'Mutation'; updatePDF: boolean };

export type CreateVideoMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: CreateVideoInput;
}>;

export type CreateVideoMutation = {
  __typename?: 'Mutation';
  createVideo: { __typename?: 'IdObject'; id: string };
};

export type UpdateVideoMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  input: UpdateVideoInput;
}>;

export type UpdateVideoMutation = {
  __typename?: 'Mutation';
  updateVideo: boolean;
};

export type DeleteContentMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
}>;

export type DeleteContentMutation = {
  __typename?: 'Mutation';
  deleteContent: boolean;
};

export type SellAsSubscriptionMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  type: Scalars['String'];
  accessMethod: ContentAccessMethod;
}>;

export type SellAsSubscriptionMutation = {
  __typename?: 'Mutation';
  updateContent: boolean;
};

export type SellAsAnyPurchaseMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  type: Scalars['String'];
  accessMethod: ContentAccessMethod;
}>;

export type SellAsAnyPurchaseMutation = {
  __typename?: 'Mutation';
  updateContent: boolean;
};

export type ArchiveContentMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  type: Scalars['String'];
}>;

export type ArchiveContentMutation = {
  __typename?: 'Mutation';
  updateContent: boolean;
};

export type UnarchiveContentMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  itemId: Scalars['ID'];
  type: Scalars['String'];
}>;

export type UnarchiveContentMutation = {
  __typename?: 'Mutation';
  updateContent: boolean;
};

export type GetOnboardingGuideDataQueryVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type GetOnboardingGuideDataQuery = {
  __typename?: 'Query';
  GetChecklists: Array<{
    __typename?: 'ChecklistModel';
    id: string;
    title: string;
    description?: string | null;
    estimatedDurationLabel?: string | null;
    scope: ChecklistScope;
    strategyIds: Array<string>;
    isActive: boolean;
    tasks: Array<{
      __typename?: 'ChecklistTaskModel';
      id: string;
      title: string;
      subtitle?: string | null;
      actionUrl?: string | null;
      actionModal?: string | null;
      actionPage?: string | null;
      estimatedTimeLabel?: string | null;
      completionMode: TaskCompletionMode;
      isChecked: boolean;
      completedAt?: string | null;
      completedBy?: string | null;
    }>;
  }>;
  GetStrategies: Array<{
    __typename?: 'StrategyModel';
    id: string;
    name: string;
    isActive: boolean;
    isSelected?: boolean | null;
    launchTimeLabel?: string | null;
  }>;
  GetOnboardingDismissal: {
    __typename?: 'OnboardingDismissalModel';
    webDismissedAt?: string | null;
  };
};

export type DismissOnboardingGuideWebMutationVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type DismissOnboardingGuideWebMutation = {
  __typename?: 'Mutation';
  SaveOnboardingDismissal: {
    __typename?: 'OnboardingDismissalModel';
    webDismissedAt?: string | null;
  };
};

export type SaveOnboardingTaskProgressMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: UpdateTaskProgressInputModel;
}>;

export type SaveOnboardingTaskProgressMutation = {
  __typename?: 'Mutation';
  SaveTaskProgress: boolean;
};

export type SetActiveOnboardingChecklistMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  input: SetActiveChecklistInputModel;
}>;

export type SetActiveOnboardingChecklistMutation = {
  __typename?: 'Mutation';
  SetActiveChecklist: boolean;
};

export type MarkChecklistAsCompletedMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  checklistId: Scalars['ID'];
}>;

export type MarkChecklistAsCompletedMutation = {
  __typename?: 'Mutation';
  MarkChecklistAsCompleted: boolean;
};

export type CreateDraftCollectionMutationVariables = Exact<{
  data: CreateCollectionInput;
}>;

export type CreateDraftCollectionMutation = {
  __typename?: 'Mutation';
  createDraftCollection: { __typename?: 'Collection'; id: number };
};

export type GetHomePageDataQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  creatorIdStr: Scalars['ID'];
}>;

export type GetHomePageDataQuery = {
  __typename?: 'Query';
  onboardingListData: {
    __typename?: 'OnboardingList';
    profileReady: boolean;
    paymentMethodReady: boolean;
    collectionPublishedReady: boolean;
  };
  GetOnboardingDismissal: {
    __typename?: 'OnboardingDismissalModel';
    webDismissedAt?: string | null;
  };
  GetStrategies: Array<{
    __typename?: 'StrategyModel';
    id: string;
    isActive: boolean;
    isSelected?: boolean | null;
  }>;
  creator?: {
    __typename?: 'Creator';
    id: number;
    tier?: number | null;
    email?: string | null;
    mode?: number | null;
    salesModel?: string | null;
    offering: Array<string>;
    title?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    profileInstagram?: string | null;
    profileDeepLink?: string | null;
    isVisible?: boolean | null;
    customURL?: string | null;
    visibility: string;
    createdAt?: any | null;
    businessModel: string;
    mediaAvatar?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    tikTokConfiguration?: {
      __typename?: 'TikTokConfiguration';
      pixelId?: string | null;
      apiSecret?: string | null;
    } | null;
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
      name: string;
    } | null> | null;
    customizations?: {
      __typename?: 'Customizations';
      isExclusiveMigratedToBundle?: boolean | null;
      isOtpMigratedToBundle?: boolean | null;
    } | null;
  } | null;
  collections: Array<{
    __typename?: 'Collection';
    id: number;
    name?: string | null;
    accessType: string;
    publishedAt?: any | null;
    archivedAt?: any | null;
    exclusiveProgramMetadata?: {
      __typename?: 'ExclusiveProgramMetadata';
      deeplinkUrl?: string | null;
      checkoutPageUrl?: string | null;
      price?: number | null;
    } | null;
  }>;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    status: BundleStatus;
    pricing: BundlePricing;
  }>;
  searchComments: Array<{
    __typename?: 'Comment';
    id: number;
    textValue: string;
    status: number;
    type: number;
    createdAt: string;
    user?: {
      __typename?: 'SimpleUser';
      id: number;
      name: string;
      mediaThumbnail?: {
        __typename?: 'Media';
        cdn01?: string | null;
        image?: string | null;
      } | null;
    } | null;
    workout?: {
      __typename?: 'WorkoutTiny';
      id: number;
      name?: string | null;
    } | null;
    userActivity?: {
      __typename?: 'CommentUserActivity';
      id: number;
      type: number;
      floatValue?: number | null;
    } | null;
  }>;
};

export type SetCreatorAsLiveMutationVariables = Exact<{
  creatorId: Scalars['Int'];
}>;

export type SetCreatorAsLiveMutation = {
  __typename?: 'Mutation';
  setCreatorAsLive: boolean;
};

export type AddFolderMutationVariables = Exact<{
  creatorId: Scalars['Int'];
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['Int']>;
}>;

export type AddFolderMutation = {
  __typename?: 'Mutation';
  addFolder: {
    __typename?: 'LibraryFolder';
    id: number;
    parentId?: number | null;
    name: string;
  };
};

export type AddToFolderMutationVariables = Exact<{
  creatorId: Scalars['Int'];
  id?: InputMaybe<Scalars['Int']>;
  folderIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  videoIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type AddToFolderMutation = {
  __typename?: 'Mutation';
  addToFolder: boolean;
};

export type BulkDeleteMutationVariables = Exact<{
  creatorId: Scalars['Int'];
  videoIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  folderIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;

export type BulkDeleteMutation = {
  __typename?: 'Mutation';
  bulkDelete: boolean;
};

export type BulkDeleteVideosMutationVariables = Exact<{
  creatorId: Scalars['Int'];
  videoIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type BulkDeleteVideosMutation = {
  __typename?: 'Mutation';
  bulkDeleteVideos: boolean;
};

export type DeleteFolderMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeleteFolderMutation = {
  __typename?: 'Mutation';
  deleteFolder: boolean;
};

export type DeleteVideoMutationVariables = Exact<{
  creatorId: Scalars['Int'];
  id: Scalars['String'];
  videoSourceType: Scalars['String'];
}>;

export type DeleteVideoMutation = {
  __typename?: 'Mutation';
  deleteVideo: boolean;
};

export type GetCreatorsFoldersQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
}>;

export type GetCreatorsFoldersQuery = {
  __typename?: 'Query';
  getCreatorsFolders: Array<{
    __typename?: 'LibraryFolder';
    id: number;
    name: string;
    parentId?: number | null;
    updatedAt: any;
    creatorId: number;
    createdAt: any;
  }>;
};

export type GetLibraryQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  folderId?: InputMaybe<Scalars['Int']>;
}>;

export type GetLibraryQuery = {
  __typename?: 'Query';
  getLibrary: {
    __typename?: 'GetLibrary';
    folders: Array<{
      __typename?: 'LibraryFolder';
      id: number;
      name: string;
      parentId?: number | null;
      updatedAt: any;
      creatorId: number;
      createdAt: any;
    }>;
    videos: Array<{
      __typename?: 'LibraryVideo';
      uuid: string;
      creatorId: number;
      title: string;
      type?: string | null;
      video?: string | null;
      image?: string | null;
      cdn01?: string | null;
      videoSourceType: string;
      videoThumbnailUrl?: string | null;
      videoUrl?: string | null;
      duration?: number | null;
      aspectRatio?: string | null;
      status: string;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
      createdAt: any;
      deletedAt?: any | null;
      description?: string | null;
      fileSize?: number | null;
      updatedAt: any;
      downloadLink?: {
        __typename?: 'Download';
        low?: {
          __typename?: 'DownloadLink';
          link: string;
          width: number;
          height: number;
          filesize: number;
        } | null;
        medium?: {
          __typename?: 'DownloadLink';
          link: string;
          width: number;
          height: number;
          filesize: number;
        } | null;
        high?: {
          __typename?: 'DownloadLink';
          link: string;
          width: number;
          height: number;
          filesize: number;
        } | null;
      } | null;
    }>;
  };
};

export type GetLibraryContentQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  parentId?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
}>;

export type GetLibraryContentQuery = {
  __typename?: 'Query';
  getCreatorsFolders: Array<{
    __typename?: 'LibraryFolder';
    id: number;
    name: string;
    parentId?: number | null;
    updatedAt: any;
    creatorId: number;
    createdAt: any;
  }>;
  getCreatorsMedia: Array<{
    __typename?: 'Video';
    uuid: string;
    creatorId: number;
    title: string;
    type?: string | null;
    video?: string | null;
    image?: string | null;
    cdn01?: string | null;
    videoSourceType: string;
    videoThumbnailUrl?: string | null;
    videoUrl?: string | null;
    duration?: number | null;
    aspectRatio?: string | null;
    status: string;
    width?: number | null;
    height?: number | null;
    mimeType?: string | null;
    createdAt: any;
    deletedAt?: any | null;
    updatedAt: any;
    description?: string | null;
    fileSize?: number | null;
    folderId?: number | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
    } | null;
  }>;
};

export type GetLibraryTagsQueryVariables = Exact<{
  creatorId: Scalars['ID'];
  tagId?: InputMaybe<Scalars['ID']>;
  tagInternalName?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type GetLibraryTagsQuery = {
  __typename?: 'Query';
  getContentIdsWithTag: Array<string>;
};

export type RenameFolderMutationVariables = Exact<{
  creatorId: Scalars['Int'];
  name: Scalars['String'];
  id: Scalars['Int'];
}>;

export type RenameFolderMutation = {
  __typename?: 'Mutation';
  renameFolder: {
    __typename?: 'LibraryFolder';
    id: number;
    parentId?: number | null;
    name: string;
  };
};

export type GetInfluencerNameQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetInfluencerNameQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
  } | null;
};

export type GetProfileQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetProfileQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    customURL?: string | null;
    mode?: number | null;
    title?: string | null;
    gender?: string | null;
    messageProfile?: string | null;
    keywords?: Array<string | null> | null;
    accomplishments?: string | null;
    profileInstagram?: string | null;
    profileTiktok?: string | null;
    profileYoutubeChannel?: string | null;
    businessModel: string;
    offering: Array<string>;
    mediaAvatar?: {
      __typename?: 'Media';
      source?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
    } | null;
    mediaCover?: {
      __typename?: 'Media';
      source?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
    } | null;
    mediaWelcome?: {
      __typename?: 'Media';
      source?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
    } | null;
    mediaBanner?: {
      __typename?: 'Media';
      source?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      audio?: string | null;
      width?: number | null;
      height?: number | null;
      mimeType?: string | null;
    } | null;
    customColorSchema?: {
      __typename?: 'ColorScheme';
      primaryColor?: string | null;
    } | null;
  } | null;
};

export type IsCustomUrlAvailableQueryVariables = Exact<{
  customUrl: Scalars['String'];
}>;

export type IsCustomUrlAvailableQuery = {
  __typename?: 'Query';
  isCustomUrlAvailable: boolean;
};

export type AddCustomDomainMutationVariables = Exact<{
  domain: Scalars['String'];
  influencerId: Scalars['Int'];
}>;

export type AddCustomDomainMutation = {
  __typename?: 'Mutation';
  addCustomDomain: {
    __typename?: 'CustomDomain';
    id: number;
    status: CustomDomainStatus;
    domain: string;
    additionalInfo?: any | null;
  };
};

export type ConfirmDomainMutationVariables = Exact<{
  domainId: Scalars['Int'];
  influencerId: Scalars['Int'];
}>;

export type ConfirmDomainMutation = {
  __typename?: 'Mutation';
  confirmDomain: {
    __typename?: 'CustomDomain';
    id: number;
    status: CustomDomainStatus;
    domain: string;
    additionalInfo?: any | null;
  };
};

export type CustomDomainsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type CustomDomainsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    firstName?: string | null;
    lastName?: string | null;
    customURL?: string | null;
    customDomains?: Array<{
      __typename?: 'CustomDomain';
      id: number;
      domain: string;
      status: CustomDomainStatus;
      additionalInfo?: any | null;
    }> | null;
  } | null;
};

export type RemoveCustomDomainMutationVariables = Exact<{
  domainId: Scalars['Int'];
  influencerId: Scalars['Int'];
}>;

export type RemoveCustomDomainMutation = {
  __typename?: 'Mutation';
  removeDomain: boolean;
};

export type GetOtpDefaultFeeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetOtpDefaultFeeQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    otpDefaultFee?: number | null;
    otpBundleDefaultFee?: number | null;
  } | null;
};

export type GetSubscriptionRevenueQueryVariables = Exact<{
  influencerId: Scalars['Int'];
}>;

export type GetSubscriptionRevenueQuery = {
  __typename?: 'Query';
  subscriptionRevenue: {
    __typename?: 'SubscriptionRevenue';
    revenueSplit: Array<{
      __typename?: 'RevenueSplitRule';
      creatorId: number;
      productType: string;
      attributionType: string;
      splitCriteria: string;
      referralPercent: number;
      engagementPercent: number;
      playbookPercent: number;
      deletedAt?: any | null;
    }>;
    distribution: Array<{
      __typename?: 'DistributionRule';
      creatorId: number;
      productType: string;
      attributionType: string;
      distributionType: string;
      deletedAt?: any | null;
    }>;
    payout: Array<{
      __typename?: 'PayoutRule';
      creatorId: number;
      ruleType: string;
      amount: number;
      startDate: any;
      endDate?: any | null;
      deletedAt?: any | null;
    }>;
  };
};

export type SetOtpDefaultFeeMutationVariables = Exact<{
  data: SetOtpDefaultFeeInput;
}>;

export type SetOtpDefaultFeeMutation = {
  __typename?: 'Mutation';
  setOtpDefaultFee: boolean;
};

export type SetOtpOfferDefaultFeeMutationVariables = Exact<{
  data: SetOtpDefaultFeeInput;
}>;

export type SetOtpOfferDefaultFeeMutation = {
  __typename?: 'Mutation';
  setOtpOfferDefaultFee: boolean;
};

export type SetRevenueSplitRulesMutationVariables = Exact<{
  data: SetRevenueSplitRulesInput;
}>;

export type SetRevenueSplitRulesMutation = {
  __typename?: 'Mutation';
  setRevenueSplitRules: boolean;
};

export type GetCrmDataQueryVariables = Exact<{
  creatorId: Scalars['Int'];
}>;

export type GetCrmDataQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    visibility: string;
    businessModel: string;
    offering: Array<string>;
    subscribedProducts: Array<string>;
    bundle: Array<{
      __typename?: 'Bundle';
      id: number;
      title: string;
      pricing: BundlePricing;
      status: BundleStatus;
      isFree: boolean;
    }>;
    purchasedOtpProducts: Array<{
      __typename?: 'PurchasedOtpProduct';
      id: number;
      productType: string;
      name?: string | null;
    }>;
    freeOfferProducts: Array<{
      __typename?: 'FreeOfferProduct';
      id: number;
      productType: string;
      name?: string | null;
    }>;
    convertedToProducts: Array<{
      __typename?: 'ConvertedToProduct';
      productType: string;
      name?: string | null;
    }>;
  } | null;
};

export type GetDirectMessageStatusQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetDirectMessageStatusQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    offering: Array<string>;
    businessModel: string;
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
      name: string;
    } | null> | null;
    customizations?: {
      __typename?: 'Customizations';
      premiumFeaturesOTPIds?: Array<number | null> | null;
    } | null;
  } | null;
};

export type GetUserInfoQueryVariables = Exact<{
  userIds: Array<Scalars['Int']> | Scalars['Int'];
}>;

export type GetUserInfoQuery = {
  __typename?: 'Query';
  getUsersInfoByIds?: Array<{
    __typename?: 'Author';
    id: number;
    username: string;
    badges: Array<string>;
    profilePicture: string;
    email: string;
    marketing: boolean;
    hasDirectMessagesAccess?: boolean | null;
  }> | null;
};

export type UpsertConsumerByIdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type UpsertConsumerByIdMutation = {
  __typename?: 'Mutation';
  upsertConsumerById: boolean;
};

export type EditVideoMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  creatorId: Scalars['Int'];
  thumbnailTimestamp?: InputMaybe<Scalars['Float']>;
  videoSourceType: Scalars['String'];
}>;

export type EditVideoMutation = {
  __typename?: 'Mutation';
  editVideo: {
    __typename?: 'Video';
    uuid: string;
    creatorId: number;
    title: string;
    type?: string | null;
    video?: string | null;
    image?: string | null;
    cdn01?: string | null;
    videoSourceType: string;
    videoThumbnailUrl?: string | null;
    videoUrl?: string | null;
    duration?: number | null;
    aspectRatio?: string | null;
    status: string;
    width?: number | null;
    height?: number | null;
    mimeType?: string | null;
    createdAt: any;
    deletedAt?: any | null;
    fileSize?: number | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        link: string;
        width: number;
        height: number;
        filesize: number;
      } | null;
    } | null;
  };
};

export type GetLivestreamStatusQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetLivestreamStatusQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
      name: string;
    } | null> | null;
  } | null;
};

export type CreateInfluencerMutationVariables = Exact<{
  data: CreateInfluencerInput;
}>;

export type CreateInfluencerMutation = {
  __typename?: 'Mutation';
  createInfluencer: { __typename?: 'Creator'; id: number };
};

export type SaveModalityKeywordsMutationVariables = Exact<{
  data: CreatorProfileUpdateInput;
}>;

export type SaveModalityKeywordsMutation = {
  __typename?: 'Mutation';
  updateCreatorProfile: boolean;
};

export type GetOnboardingQuestionsQueryVariables = Exact<{
  platform: Platform;
}>;

export type GetOnboardingQuestionsQuery = {
  __typename?: 'Query';
  GetOnboardingQuestions: Array<{
    __typename?: 'OnboardingQuestionModel';
    id: string;
    title: string;
    subtitle?: string | null;
    type: OnboardingQuestionType;
    targetCategory?: string | null;
    isRequired: boolean;
    platforms: Array<Platform>;
    answers: Array<{
      __typename?: 'OnboardingAnswerModel';
      id: string;
      title: string;
      subtitle?: string | null;
      weight?: number | null;
    }>;
  }>;
};

export type GetOnboardingResponsesQueryVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type GetOnboardingResponsesQuery = {
  __typename?: 'Query';
  GetOnboardingResponses: Array<{
    __typename?: 'OnboardingResponsePayload';
    questionId: string;
    answerIds: Array<string>;
    textValue?: string | null;
  }>;
};

export type GetOnboardingDismissalQueryVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type GetOnboardingDismissalQuery = {
  __typename?: 'Query';
  GetOnboardingDismissal: {
    __typename?: 'OnboardingDismissalModel';
    webDismissedAt?: string | null;
    mobileDismissedAt?: string | null;
  };
};

export type GetStrategiesQueryVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type GetStrategiesQuery = {
  __typename?: 'Query';
  GetStrategies: Array<{
    __typename?: 'StrategyModel';
    id: string;
    name: string;
    tagline?: string | null;
    description?: string | null;
    superTitle?: string | null;
    pills: Array<string>;
    features: Array<string>;
    priceLabel?: string | null;
    programLengthLabel?: string | null;
    launchTimeLabel?: string | null;
    coverImageUrl?: string | null;
    isRecommended?: boolean | null;
    isActive: boolean;
    isSelected?: boolean | null;
    caseStudies: Array<{
      __typename?: 'StrategyCaseStudyModel';
      id: string;
      strategyId: string;
      title: string;
      subtitle?: string | null;
      description?: string | null;
      coverImageHorizontalUrl: string;
      coverImageVerticalUrl: string;
      creatorName: string;
      creatorInstagramName: string;
      documentUrl: string;
    }>;
  }>;
};

export type GetBookingStepQueryVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type GetBookingStepQuery = {
  __typename?: 'Query';
  GetBookingStep: {
    __typename?: 'BookingStepModel';
    status: BookingClassificationStatus;
    qualified: boolean;
    amKey?: string | null;
    amDisplayName?: string | null;
    meetingUrl?: string | null;
    prefillEmail?: string | null;
    prefillFirstName?: string | null;
  };
};

export type GetStrategyScoringCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetStrategyScoringCategoriesQuery = {
  __typename?: 'Query';
  GetStrategyScoringCategory: Array<{
    __typename?: 'StrategyScoringCategoryModel';
    id: string;
    name: string;
  }>;
};

export type GetStrategyScoringRulesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetStrategyScoringRulesQuery = {
  __typename?: 'Query';
  GetStrategyScoringRules: Array<{
    __typename?: 'StrategyScoringRuleModel';
    id: string;
    strategyId: string;
    categoryId: string;
    minScore?: number | null;
    maxScore?: number | null;
  }>;
};

export type SaveOnboardingResponsesMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  responses: Array<OnboardingResponseInput> | OnboardingResponseInput;
}>;

export type SaveOnboardingResponsesMutation = {
  __typename?: 'Mutation';
  SaveOnboardingResponses: boolean;
};

export type SaveSelectedStrategyMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  strategyId: Scalars['ID'];
}>;

export type SaveSelectedStrategyMutation = {
  __typename?: 'Mutation';
  SaveSelectedStrategy: boolean;
};

export type SaveOnboardingDismissalMutationVariables = Exact<{
  creatorId: Scalars['ID'];
  platform: Platform;
}>;

export type SaveOnboardingDismissalMutation = {
  __typename?: 'Mutation';
  SaveOnboardingDismissal: {
    __typename?: 'OnboardingDismissalModel';
    webDismissedAt?: string | null;
    mobileDismissedAt?: string | null;
  };
};

export type ResetOnboardingMutationVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type ResetOnboardingMutation = {
  __typename?: 'Mutation';
  ResetOnboarding: boolean;
};

export type ClearSelectedStrategyMutationVariables = Exact<{
  creatorId: Scalars['ID'];
}>;

export type ClearSelectedStrategyMutation = {
  __typename?: 'Mutation';
  ClearSelectedStrategy: boolean;
};

export type ProgramsListItemFragment = {
  __typename?: 'Collection';
  id: number;
  isVisible?: boolean | null;
  influencerId: number;
  name?: string | null;
  accessType: string;
  contentStructure?: string | null;
  publishingBehaviour: string;
  isLocked?: boolean | null;
  archivedAt?: any | null;
  publishedAt?: any | null;
  index?: number | null;
  deeplinkUrl?: string | null;
  programBusinessModel?: ProgramBusinessModel | null;
  mediaCover?: {
    __typename?: 'Media';
    cdn01?: string | null;
    image?: string | null;
  } | null;
  exclusiveProgramMetadata?: {
    __typename?: 'ExclusiveProgramMetadata';
    deeplinkUrl?: string | null;
    checkoutPageUrl?: string | null;
    price?: number | null;
  } | null;
  programStats?: {
    __typename?: 'ProgramStatsModel';
    avgRating?: number | null;
    statsViews: number;
    statsRatings: number;
    statsBegins: number;
    statsComments: number;
    statsCompletions: number;
    statsFavorites: number;
  } | null;
  workouts?: Array<{
    __typename?: 'WorkoutTiny';
    id: number;
    statsRatingAverage?: number | null;
    statsComments?: number | null;
    statsBegins?: number | null;
    statsCompletions?: number | null;
  } | null> | null;
  challenges?: Array<{
    __typename?: 'Challenge';
    id: string;
    completionEnd: any;
    deepLink: string;
  } | null> | null;
  readiness?: {
    __typename?: 'ProgramReadiness';
    title: boolean;
    cover: boolean;
    workouts: boolean;
    goal: boolean;
  } | null;
};

export type ProgramsGetListQueryVariables = Exact<{
  influencerId: Scalars['Int'];
}>;

export type ProgramsGetListQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    customURL?: string | null;
    profileDeepLink?: string | null;
    businessModel: string;
    features?: Array<{
      __typename?: 'Feature';
      id: number;
      code: FeatureCode;
    } | null> | null;
  } | null;
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    title: string;
    isPlatformBundle: boolean;
    isFree: boolean;
    status: BundleStatus;
    pricing: BundlePricing;
    deeplinkUrl?: string | null;
    landingPageUrl?: string | null;
    checkoutPage?: { __typename?: 'CheckoutPage'; url: string } | null;
    oneTimeProduct?: { __typename?: 'OneTimeProduct'; price: number } | null;
    items?: Array<{
      __typename?: 'BundleItem';
      itemType: BundleItemType;
      itemId?: number | null;
    }> | null;
  }>;
  collections: Array<{
    __typename?: 'Collection';
    id: number;
    isVisible?: boolean | null;
    influencerId: number;
    name?: string | null;
    accessType: string;
    contentStructure?: string | null;
    publishingBehaviour: string;
    isLocked?: boolean | null;
    archivedAt?: any | null;
    publishedAt?: any | null;
    index?: number | null;
    deeplinkUrl?: string | null;
    programBusinessModel?: ProgramBusinessModel | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    exclusiveProgramMetadata?: {
      __typename?: 'ExclusiveProgramMetadata';
      deeplinkUrl?: string | null;
      checkoutPageUrl?: string | null;
      price?: number | null;
    } | null;
    programStats?: {
      __typename?: 'ProgramStatsModel';
      avgRating?: number | null;
      statsViews: number;
      statsRatings: number;
      statsBegins: number;
      statsComments: number;
      statsCompletions: number;
      statsFavorites: number;
    } | null;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      statsRatingAverage?: number | null;
      statsComments?: number | null;
      statsBegins?: number | null;
      statsCompletions?: number | null;
    } | null> | null;
    challenges?: Array<{
      __typename?: 'Challenge';
      id: string;
      completionEnd: any;
      deepLink: string;
    } | null> | null;
    readiness?: {
      __typename?: 'ProgramReadiness';
      title: boolean;
      cover: boolean;
      workouts: boolean;
      goal: boolean;
    } | null;
  }>;
};

export type ProgramsConvertToSubscriptionMutationVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type ProgramsConvertToSubscriptionMutation = {
  __typename?: 'Mutation';
  convertToSubscriptionProgram: {
    __typename?: 'Collection';
    id: number;
    isVisible?: boolean | null;
    influencerId: number;
    name?: string | null;
    accessType: string;
    contentStructure?: string | null;
    publishingBehaviour: string;
    isLocked?: boolean | null;
    archivedAt?: any | null;
    publishedAt?: any | null;
    index?: number | null;
    deeplinkUrl?: string | null;
    programBusinessModel?: ProgramBusinessModel | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    exclusiveProgramMetadata?: {
      __typename?: 'ExclusiveProgramMetadata';
      deeplinkUrl?: string | null;
      checkoutPageUrl?: string | null;
      price?: number | null;
    } | null;
    programStats?: {
      __typename?: 'ProgramStatsModel';
      avgRating?: number | null;
      statsViews: number;
      statsRatings: number;
      statsBegins: number;
      statsComments: number;
      statsCompletions: number;
      statsFavorites: number;
    } | null;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      statsRatingAverage?: number | null;
      statsComments?: number | null;
      statsBegins?: number | null;
      statsCompletions?: number | null;
    } | null> | null;
    challenges?: Array<{
      __typename?: 'Challenge';
      id: string;
      completionEnd: any;
      deepLink: string;
    } | null> | null;
    readiness?: {
      __typename?: 'ProgramReadiness';
      title: boolean;
      cover: boolean;
      workouts: boolean;
      goal: boolean;
    } | null;
  };
};

export type ProgramsConvertToUnassignedMutationVariables = Exact<{
  programId: Scalars['Int'];
}>;

export type ProgramsConvertToUnassignedMutation = {
  __typename?: 'Mutation';
  convertToUnassignedProgram: {
    __typename?: 'Collection';
    id: number;
    isVisible?: boolean | null;
    influencerId: number;
    name?: string | null;
    accessType: string;
    contentStructure?: string | null;
    publishingBehaviour: string;
    isLocked?: boolean | null;
    archivedAt?: any | null;
    publishedAt?: any | null;
    index?: number | null;
    deeplinkUrl?: string | null;
    programBusinessModel?: ProgramBusinessModel | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    exclusiveProgramMetadata?: {
      __typename?: 'ExclusiveProgramMetadata';
      deeplinkUrl?: string | null;
      checkoutPageUrl?: string | null;
      price?: number | null;
    } | null;
    programStats?: {
      __typename?: 'ProgramStatsModel';
      avgRating?: number | null;
      statsViews: number;
      statsRatings: number;
      statsBegins: number;
      statsComments: number;
      statsCompletions: number;
      statsFavorites: number;
    } | null;
    workouts?: Array<{
      __typename?: 'WorkoutTiny';
      id: number;
      statsRatingAverage?: number | null;
      statsComments?: number | null;
      statsBegins?: number | null;
      statsCompletions?: number | null;
    } | null> | null;
    challenges?: Array<{
      __typename?: 'Challenge';
      id: string;
      completionEnd: any;
      deepLink: string;
    } | null> | null;
    readiness?: {
      __typename?: 'ProgramReadiness';
      title: boolean;
      cover: boolean;
      workouts: boolean;
      goal: boolean;
    } | null;
  };
};

export type CreateCouponMutationVariables = Exact<{
  code: Scalars['String'];
  influencerId: Scalars['Int'];
  subscriptionProviderPriceId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  productType: CouponProductType;
  discountType: CouponDiscountType;
  discountAmount?: InputMaybe<Scalars['Int']>;
  percentOff?: InputMaybe<Scalars['Float']>;
  maxRedemptions?: InputMaybe<Scalars['Int']>;
  paidProductIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  compatibleWithFreeTrial?: InputMaybe<Scalars['Boolean']>;
}>;

export type CreateCouponMutation = {
  __typename?: 'Mutation';
  createCoupon: {
    __typename?: 'Coupon';
    code: string;
    createdAt: any;
    discountAmount?: number | null;
    expiresAt?: any | null;
    id: string;
    influencerId: number;
    isActive: boolean;
    maxRedemptions?: number | null;
    name: string;
    percentOff?: number | null;
    providerCouponId?: string | null;
    redemptions: number;
    paidProductIds?: Array<number> | null;
    productType: CouponProductType;
    discountType: CouponDiscountType;
    subscriptionProviderPriceId?: string | null;
    compatibleWithFreeTrial?: boolean | null;
  };
};

export type DeactivateCouponMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type DeactivateCouponMutation = {
  __typename?: 'Mutation';
  deactivateCoupon: {
    __typename?: 'Coupon';
    code: string;
    createdAt: any;
    discountAmount?: number | null;
    expiresAt?: any | null;
    id: string;
    influencerId: number;
    isActive: boolean;
    maxRedemptions?: number | null;
    name: string;
    paidProductIds?: Array<number> | null;
    percentOff?: number | null;
    providerCouponId?: string | null;
    redemptions: number;
  };
};

export type GetBundlesByPricingQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  bundlePricing?: InputMaybe<Array<BundlePricing> | BundlePricing>;
}>;

export type GetBundlesByPricingQuery = {
  __typename?: 'Query';
  bundle: Array<{
    __typename?: 'Bundle';
    id: number;
    title: string;
    influencerId: number;
    status: BundleStatus;
    description?: string | null;
    pricing: BundlePricing;
    wasPurchased: boolean;
    landingPageUrl?: string | null;
    deeplinkUrl?: string | null;
    items?: Array<{
      __typename?: 'BundleItem';
      contentId?: string | null;
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    oneTimeProduct?: {
      __typename?: 'OneTimeProduct';
      id: number;
      price: number;
      playbookFee: number;
      providerPriceId: string;
      providerProductId: string;
    } | null;
    checkoutPage?: {
      __typename?: 'CheckoutPage';
      url: string;
      type: CheckoutPageType;
    } | null;
  }>;
};

export type GetCouponDetailsQueryVariables = Exact<{
  discountId: Scalars['Int'];
}>;

export type GetCouponDetailsQuery = {
  __typename?: 'Query';
  getCouponDetails: {
    __typename?: 'CouponDetails';
    coupon: {
      __typename?: 'Coupon';
      name: string;
      id: string;
      code: string;
      discountAmount?: number | null;
      discountType: CouponDiscountType;
      percentOff?: number | null;
      productType: CouponProductType;
      createdAt: any;
      maxRedemptions?: number | null;
      redemptions: number;
      expiresAt?: any | null;
      paidProductIds?: Array<number> | null;
      influencerId: number;
      isActive: boolean;
      subscriptionProviderPriceIds?: Array<string> | null;
      referralCampaignId?: number | null;
      compatibleWithFreeTrial?: boolean | null;
    };
    metrics?: {
      __typename?: 'CouponRedemptionMetrics';
      activeSubscriber: number;
      new: number;
      returning: number;
      totalRedemptions: number;
      upgrading: number;
    } | null;
    paidPrograms?: Array<{
      __typename?: 'Program';
      id: number;
      name?: string | null;
      exclusiveProgramMetadata?: {
        __typename?: 'ExclusiveProgramMetadata';
        discountPercent?: number | null;
        price?: number | null;
        playbookFee?: number | null;
      } | null;
    } | null> | null;
    paidOtpBundles?: Array<{
      __typename?: 'Bundle';
      createdAt: any;
      description?: string | null;
      id: number;
      influencerId: number;
      isPlatformBundle: boolean;
      pricing: BundlePricing;
      status: BundleStatus;
      title: string;
      updatedAt: any;
      oneTimeProduct?: {
        __typename?: 'OneTimeProduct';
        id: number;
        playbookFee: number;
        price: number;
        providerPriceId: string;
        providerProductId: string;
      } | null;
      checkoutPage?: { __typename?: 'CheckoutPage'; url: string } | null;
    } | null> | null;
    redemptionsList?: Array<{
      __typename?: 'CouponRedemption';
      email: string;
      name?: string | null;
      redeemedAt: any;
      userId: number;
      userStatusAtRedemption: UserStatusAtRedemption;
    } | null> | null;
    subscriptionTierPrices?: Array<{
      __typename?: 'SubscriptionTierPrice';
      id: number;
      price: number;
      providerPriceId?: string | null;
      billingCycleInterval: BillingCycleInterval;
    } | null> | null;
  };
};

export type GetOtpPriceQueryVariables = Exact<{
  collectionId: Scalars['Int'];
}>;

export type GetOtpPriceQuery = {
  __typename?: 'Query';
  collection: {
    __typename?: 'Collection';
    exclusiveProgramMetadata?: {
      __typename?: 'ExclusiveProgramMetadata';
      checkoutPageUrl?: string | null;
      price?: number | null;
      playbookFee?: number | null;
      originalPrice?: number | null;
      discountPercent?: number | null;
    } | null;
  };
};

export type EnableCheckoutFreeTrialMutationVariables = Exact<{
  data: EnableCreatorSettingsInput;
}>;

export type EnableCheckoutFreeTrialMutation = {
  __typename?: 'Mutation';
  enableCheckoutFreeTrial: boolean;
};

export type SetDirectMessagingMutationVariables = Exact<{
  data: EnableCreatorSettingsInput;
}>;

export type SetDirectMessagingMutation = {
  __typename?: 'Mutation';
  setDirectMessaging: boolean;
};

export type SetLivestreamingMutationVariables = Exact<{
  data: EnableCreatorSettingsInput;
}>;

export type SetLivestreamingMutation = {
  __typename?: 'Mutation';
  setLivestreaming: boolean;
};

export type UpdateContactInfoMutationVariables = Exact<{
  data: CreatorProfileUpdateInput;
}>;

export type UpdateContactInfoMutation = {
  __typename?: 'Mutation';
  updateCreatorProfile: boolean;
};

export type GetWorkoutCustomizationsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetWorkoutCustomizationsQuery = {
  __typename?: 'Query';
  creator?: {
    __typename?: 'Creator';
    id: number;
    customizations?: {
      __typename?: 'Customizations';
      isNewRunning?: boolean | null;
    } | null;
  } | null;
};

export type GetLibraryTextsQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  type?: InputMaybe<Scalars['String']>;
}>;

export type GetLibraryTextsQuery = {
  __typename?: 'Query';
  getCreatorsMedia: Array<{
    __typename?: 'Video';
    uuid: string;
    title: string;
    description?: string | null;
  }>;
};

export type GetVideoByIdQueryVariables = Exact<{
  creatorId: Scalars['Int'];
  videoId: Scalars['String'];
  videoSourceType: Scalars['String'];
}>;

export type GetVideoByIdQuery = {
  __typename?: 'Query';
  getVideoById?: {
    __typename?: 'Video';
    uuid: string;
    creatorId: number;
    title: string;
    description?: string | null;
    type?: string | null;
    video?: string | null;
    image?: string | null;
    cdn01?: string | null;
    videoSourceType: string;
    videoThumbnailUrl?: string | null;
    videoUrl?: string | null;
    duration?: number | null;
    aspectRatio?: string | null;
    status: string;
    width?: number | null;
    height?: number | null;
    mimeType?: string | null;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | null;
    fileSize?: number | null;
    folderId?: number | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
    } | null;
  } | null;
};

export type MediaFragment = {
  __typename?: 'Media';
  audio?: string | null;
  cdn01?: string | null;
  image?: string | null;
  video?: string | null;
  width?: number | null;
  height?: number | null;
  source?: string | null;
  mimeType?: string | null;
  videoSourceType?: string | null;
  uuid?: string | null;
  videoUrl?: string | null;
  videoThumbnailUrl?: string | null;
  downloadLink?: {
    __typename?: 'Download';
    low?: {
      __typename?: 'DownloadLink';
      filesize: number;
      height: number;
      width: number;
      link: string;
    } | null;
    high?: {
      __typename?: 'DownloadLink';
      filesize: number;
      height: number;
      width: number;
      link: string;
    } | null;
    medium?: {
      __typename?: 'DownloadLink';
      filesize: number;
      height: number;
      width: number;
      link: string;
    } | null;
  } | null;
};

export type DownloadFragment = {
  __typename?: 'Download';
  low?: {
    __typename?: 'DownloadLink';
    filesize: number;
    height: number;
    width: number;
    link: string;
  } | null;
  high?: {
    __typename?: 'DownloadLink';
    filesize: number;
    height: number;
    width: number;
    link: string;
  } | null;
  medium?: {
    __typename?: 'DownloadLink';
    filesize: number;
    height: number;
    width: number;
    link: string;
  } | null;
};

export type ExerciseAutoplayedFragment = {
  __typename?: 'WorkoutExerciseAutoplayed';
  name: string;
  type: number;
  description?: string | null;
  longRest: number;
  rounds: number;
  id?: string | null;
  exercises?: Array<{
    __typename?: 'WorkoutExerciseSingle';
    name: string;
    type: number;
    id?: string | null;
    description?: string | null;
    rest?: number | null;
    unilateral?: boolean | null;
    sets?: Array<{
      __typename?: 'WorkoutExerciseSet';
      reps?: Array<string | null> | null;
      rest?: number | null;
      time?: number | null;
    } | null> | null;
    media?: {
      __typename?: 'Media';
      audio?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      width?: number | null;
      height?: number | null;
      source?: string | null;
      mimeType?: string | null;
      videoSourceType?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      downloadLink?: {
        __typename?: 'Download';
        low?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        high?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        medium?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
      } | null;
    } | null;
    swapConfig?: {
      __typename?: 'WorkoutExerciseSwapConfig';
      swapsEnabled: boolean;
      proposals: Array<{
        __typename?: 'WorkoutSwapConfigProposal';
        exercise: {
          __typename?: 'WorkoutExerciseSingle';
          name: string;
          description?: string | null;
          sets?: Array<{
            __typename?: 'WorkoutExerciseSet';
            reps?: Array<string | null> | null;
            rest?: number | null;
            time?: number | null;
          } | null> | null;
          media?: {
            __typename?: 'Media';
            audio?: string | null;
            cdn01?: string | null;
            image?: string | null;
            video?: string | null;
            width?: number | null;
            height?: number | null;
            source?: string | null;
            mimeType?: string | null;
            videoSourceType?: string | null;
            uuid?: string | null;
            videoUrl?: string | null;
            videoThumbnailUrl?: string | null;
            downloadLink?: {
              __typename?: 'Download';
              low?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              high?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              medium?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
            } | null;
          } | null;
        };
      }>;
    } | null;
  } | null> | null;
};

export type ExerciseSingleFragment = {
  __typename?: 'WorkoutExerciseSingle';
  name: string;
  type: number;
  id?: string | null;
  description?: string | null;
  rest?: number | null;
  unilateral?: boolean | null;
  sets?: Array<{
    __typename?: 'WorkoutExerciseSet';
    reps?: Array<string | null> | null;
    rest?: number | null;
    time?: number | null;
  } | null> | null;
  media?: {
    __typename?: 'Media';
    audio?: string | null;
    cdn01?: string | null;
    image?: string | null;
    video?: string | null;
    width?: number | null;
    height?: number | null;
    source?: string | null;
    mimeType?: string | null;
    videoSourceType?: string | null;
    uuid?: string | null;
    videoUrl?: string | null;
    videoThumbnailUrl?: string | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
    } | null;
  } | null;
  swapConfig?: {
    __typename?: 'WorkoutExerciseSwapConfig';
    swapsEnabled: boolean;
    proposals: Array<{
      __typename?: 'WorkoutSwapConfigProposal';
      exercise: {
        __typename?: 'WorkoutExerciseSingle';
        name: string;
        description?: string | null;
        sets?: Array<{
          __typename?: 'WorkoutExerciseSet';
          reps?: Array<string | null> | null;
          rest?: number | null;
          time?: number | null;
        } | null> | null;
        media?: {
          __typename?: 'Media';
          audio?: string | null;
          cdn01?: string | null;
          image?: string | null;
          video?: string | null;
          width?: number | null;
          height?: number | null;
          source?: string | null;
          mimeType?: string | null;
          videoSourceType?: string | null;
          uuid?: string | null;
          videoUrl?: string | null;
          videoThumbnailUrl?: string | null;
          downloadLink?: {
            __typename?: 'Download';
            low?: {
              __typename?: 'DownloadLink';
              filesize: number;
              height: number;
              width: number;
              link: string;
            } | null;
            high?: {
              __typename?: 'DownloadLink';
              filesize: number;
              height: number;
              width: number;
              link: string;
            } | null;
            medium?: {
              __typename?: 'DownloadLink';
              filesize: number;
              height: number;
              width: number;
              link: string;
            } | null;
          } | null;
        } | null;
      };
    }>;
  } | null;
};

export type SwapProposalExerciseFragment = {
  __typename?: 'WorkoutExerciseSingle';
  name: string;
  description?: string | null;
  sets?: Array<{
    __typename?: 'WorkoutExerciseSet';
    reps?: Array<string | null> | null;
    rest?: number | null;
    time?: number | null;
  } | null> | null;
  media?: {
    __typename?: 'Media';
    audio?: string | null;
    cdn01?: string | null;
    image?: string | null;
    video?: string | null;
    width?: number | null;
    height?: number | null;
    source?: string | null;
    mimeType?: string | null;
    videoSourceType?: string | null;
    uuid?: string | null;
    videoUrl?: string | null;
    videoThumbnailUrl?: string | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
    } | null;
  } | null;
};

export type ExerciseMultipleFragment = {
  __typename?: 'WorkoutExerciseMultiple';
  name: string;
  type: number;
  description?: string | null;
  duration?: Array<string | null> | null;
  rest?: number | null;
  measurementMode?: string | null;
  media?: {
    __typename?: 'Media';
    audio?: string | null;
    cdn01?: string | null;
    image?: string | null;
    video?: string | null;
    width?: number | null;
    height?: number | null;
    source?: string | null;
    mimeType?: string | null;
    videoSourceType?: string | null;
    uuid?: string | null;
    videoUrl?: string | null;
    videoThumbnailUrl?: string | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
    } | null;
  } | null;
  exercises?: Array<{
    __typename?: 'WorkoutExerciseSingle';
    name: string;
    type: number;
    id?: string | null;
    description?: string | null;
    rest?: number | null;
    unilateral?: boolean | null;
    sets?: Array<{
      __typename?: 'WorkoutExerciseSet';
      reps?: Array<string | null> | null;
      rest?: number | null;
      time?: number | null;
    } | null> | null;
    media?: {
      __typename?: 'Media';
      audio?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      width?: number | null;
      height?: number | null;
      source?: string | null;
      mimeType?: string | null;
      videoSourceType?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      downloadLink?: {
        __typename?: 'Download';
        low?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        high?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        medium?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
      } | null;
    } | null;
    swapConfig?: {
      __typename?: 'WorkoutExerciseSwapConfig';
      swapsEnabled: boolean;
      proposals: Array<{
        __typename?: 'WorkoutSwapConfigProposal';
        exercise: {
          __typename?: 'WorkoutExerciseSingle';
          name: string;
          description?: string | null;
          sets?: Array<{
            __typename?: 'WorkoutExerciseSet';
            reps?: Array<string | null> | null;
            rest?: number | null;
            time?: number | null;
          } | null> | null;
          media?: {
            __typename?: 'Media';
            audio?: string | null;
            cdn01?: string | null;
            image?: string | null;
            video?: string | null;
            width?: number | null;
            height?: number | null;
            source?: string | null;
            mimeType?: string | null;
            videoSourceType?: string | null;
            uuid?: string | null;
            videoUrl?: string | null;
            videoThumbnailUrl?: string | null;
            downloadLink?: {
              __typename?: 'Download';
              low?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              high?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              medium?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
            } | null;
          } | null;
        };
      }>;
    } | null;
  } | null> | null;
};

export type ExerciseCustomFragment = {
  __typename?: 'WorkoutExerciseCustom';
  name: string;
  type: number;
  description?: string | null;
  duration?: Array<string | null> | null;
};

export type ExerciseMuxFragment = {
  __typename?: 'WorkoutExerciseMux';
  name: string;
  type: number;
  description?: string | null;
  duration?: Array<string | null> | null;
  id?: string | null;
  videoId?: string | null;
  video?: string | null;
  thumbnail?: string | null;
  media?: {
    __typename?: 'Media';
    audio?: string | null;
    cdn01?: string | null;
    image?: string | null;
    video?: string | null;
    width?: number | null;
    height?: number | null;
    source?: string | null;
    mimeType?: string | null;
    videoSourceType?: string | null;
    uuid?: string | null;
    videoUrl?: string | null;
    videoThumbnailUrl?: string | null;
    downloadLink?: {
      __typename?: 'Download';
      low?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      high?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
      medium?: {
        __typename?: 'DownloadLink';
        filesize: number;
        height: number;
        width: number;
        link: string;
      } | null;
    } | null;
  } | null;
};

export type ExerciseYoutubeFragment = {
  __typename?: 'WorkoutExerciseYouTube';
  name: string;
  type: number;
  description?: string | null;
  youtubeId?: string | null;
};

export type GetWorkoutByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;

export type GetWorkoutByIdQuery = {
  __typename?: 'Query';
  workout?: {
    __typename?: 'WorkoutTiny';
    id: number;
    name?: string | null;
    description?: string | null;
    duration?: number | null;
    requiredEquipment?: Array<string> | null;
    difficulty?: string | null;
    publishedAt?: any | null;
    timeZone?: string | null;
    updatedAt?: any | null;
    archivedAt?: any | null;
    programId?: number | null;
    programIndex?: number | null;
    isProtected?: boolean | null;
    isVisible?: boolean | null;
    isClass?: boolean | null;
    messagePush?: string | null;
    media?: {
      __typename?: 'Media';
      audio?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      width?: number | null;
      height?: number | null;
      source?: string | null;
      mimeType?: string | null;
      videoSourceType?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      downloadLink?: {
        __typename?: 'Download';
        low?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        high?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        medium?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
      } | null;
    } | null;
    mediaCover?: {
      __typename?: 'Media';
      audio?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      width?: number | null;
      height?: number | null;
      source?: string | null;
      mimeType?: string | null;
      videoSourceType?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      downloadLink?: {
        __typename?: 'Download';
        low?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        high?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        medium?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
      } | null;
    } | null;
    mediaExercise?: {
      __typename?: 'Media';
      audio?: string | null;
      cdn01?: string | null;
      image?: string | null;
      video?: string | null;
      width?: number | null;
      height?: number | null;
      source?: string | null;
      mimeType?: string | null;
      videoSourceType?: string | null;
      uuid?: string | null;
      videoUrl?: string | null;
      videoThumbnailUrl?: string | null;
      downloadLink?: {
        __typename?: 'Download';
        low?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        high?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
        medium?: {
          __typename?: 'DownloadLink';
          filesize: number;
          height: number;
          width: number;
          link: string;
        } | null;
      } | null;
    } | null;
    tags?: Array<{
      __typename?: 'Tag';
      id: number;
      category?: string | null;
      title?: string | null;
    }> | null;
    exercises?: Array<
      | {
          __typename?: 'WorkoutExerciseAutoplayed';
          name: string;
          type: number;
          description?: string | null;
          longRest: number;
          rounds: number;
          id?: string | null;
          exercises?: Array<{
            __typename?: 'WorkoutExerciseSingle';
            name: string;
            type: number;
            id?: string | null;
            description?: string | null;
            rest?: number | null;
            unilateral?: boolean | null;
            sets?: Array<{
              __typename?: 'WorkoutExerciseSet';
              reps?: Array<string | null> | null;
              rest?: number | null;
              time?: number | null;
            } | null> | null;
            media?: {
              __typename?: 'Media';
              audio?: string | null;
              cdn01?: string | null;
              image?: string | null;
              video?: string | null;
              width?: number | null;
              height?: number | null;
              source?: string | null;
              mimeType?: string | null;
              videoSourceType?: string | null;
              uuid?: string | null;
              videoUrl?: string | null;
              videoThumbnailUrl?: string | null;
              downloadLink?: {
                __typename?: 'Download';
                low?: {
                  __typename?: 'DownloadLink';
                  filesize: number;
                  height: number;
                  width: number;
                  link: string;
                } | null;
                high?: {
                  __typename?: 'DownloadLink';
                  filesize: number;
                  height: number;
                  width: number;
                  link: string;
                } | null;
                medium?: {
                  __typename?: 'DownloadLink';
                  filesize: number;
                  height: number;
                  width: number;
                  link: string;
                } | null;
              } | null;
            } | null;
            swapConfig?: {
              __typename?: 'WorkoutExerciseSwapConfig';
              swapsEnabled: boolean;
              proposals: Array<{
                __typename?: 'WorkoutSwapConfigProposal';
                exercise: {
                  __typename?: 'WorkoutExerciseSingle';
                  name: string;
                  description?: string | null;
                  sets?: Array<{
                    __typename?: 'WorkoutExerciseSet';
                    reps?: Array<string | null> | null;
                    rest?: number | null;
                    time?: number | null;
                  } | null> | null;
                  media?: {
                    __typename?: 'Media';
                    audio?: string | null;
                    cdn01?: string | null;
                    image?: string | null;
                    video?: string | null;
                    width?: number | null;
                    height?: number | null;
                    source?: string | null;
                    mimeType?: string | null;
                    videoSourceType?: string | null;
                    uuid?: string | null;
                    videoUrl?: string | null;
                    videoThumbnailUrl?: string | null;
                    downloadLink?: {
                      __typename?: 'Download';
                      low?: {
                        __typename?: 'DownloadLink';
                        filesize: number;
                        height: number;
                        width: number;
                        link: string;
                      } | null;
                      high?: {
                        __typename?: 'DownloadLink';
                        filesize: number;
                        height: number;
                        width: number;
                        link: string;
                      } | null;
                      medium?: {
                        __typename?: 'DownloadLink';
                        filesize: number;
                        height: number;
                        width: number;
                        link: string;
                      } | null;
                    } | null;
                  } | null;
                };
              }>;
            } | null;
          } | null> | null;
        }
      | {
          __typename?: 'WorkoutExerciseCustom';
          name: string;
          type: number;
          description?: string | null;
          duration?: Array<string | null> | null;
        }
      | {
          __typename?: 'WorkoutExerciseMultiple';
          name: string;
          type: number;
          description?: string | null;
          duration?: Array<string | null> | null;
          rest?: number | null;
          measurementMode?: string | null;
          media?: {
            __typename?: 'Media';
            audio?: string | null;
            cdn01?: string | null;
            image?: string | null;
            video?: string | null;
            width?: number | null;
            height?: number | null;
            source?: string | null;
            mimeType?: string | null;
            videoSourceType?: string | null;
            uuid?: string | null;
            videoUrl?: string | null;
            videoThumbnailUrl?: string | null;
            downloadLink?: {
              __typename?: 'Download';
              low?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              high?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              medium?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
            } | null;
          } | null;
          exercises?: Array<{
            __typename?: 'WorkoutExerciseSingle';
            name: string;
            type: number;
            id?: string | null;
            description?: string | null;
            rest?: number | null;
            unilateral?: boolean | null;
            sets?: Array<{
              __typename?: 'WorkoutExerciseSet';
              reps?: Array<string | null> | null;
              rest?: number | null;
              time?: number | null;
            } | null> | null;
            media?: {
              __typename?: 'Media';
              audio?: string | null;
              cdn01?: string | null;
              image?: string | null;
              video?: string | null;
              width?: number | null;
              height?: number | null;
              source?: string | null;
              mimeType?: string | null;
              videoSourceType?: string | null;
              uuid?: string | null;
              videoUrl?: string | null;
              videoThumbnailUrl?: string | null;
              downloadLink?: {
                __typename?: 'Download';
                low?: {
                  __typename?: 'DownloadLink';
                  filesize: number;
                  height: number;
                  width: number;
                  link: string;
                } | null;
                high?: {
                  __typename?: 'DownloadLink';
                  filesize: number;
                  height: number;
                  width: number;
                  link: string;
                } | null;
                medium?: {
                  __typename?: 'DownloadLink';
                  filesize: number;
                  height: number;
                  width: number;
                  link: string;
                } | null;
              } | null;
            } | null;
            swapConfig?: {
              __typename?: 'WorkoutExerciseSwapConfig';
              swapsEnabled: boolean;
              proposals: Array<{
                __typename?: 'WorkoutSwapConfigProposal';
                exercise: {
                  __typename?: 'WorkoutExerciseSingle';
                  name: string;
                  description?: string | null;
                  sets?: Array<{
                    __typename?: 'WorkoutExerciseSet';
                    reps?: Array<string | null> | null;
                    rest?: number | null;
                    time?: number | null;
                  } | null> | null;
                  media?: {
                    __typename?: 'Media';
                    audio?: string | null;
                    cdn01?: string | null;
                    image?: string | null;
                    video?: string | null;
                    width?: number | null;
                    height?: number | null;
                    source?: string | null;
                    mimeType?: string | null;
                    videoSourceType?: string | null;
                    uuid?: string | null;
                    videoUrl?: string | null;
                    videoThumbnailUrl?: string | null;
                    downloadLink?: {
                      __typename?: 'Download';
                      low?: {
                        __typename?: 'DownloadLink';
                        filesize: number;
                        height: number;
                        width: number;
                        link: string;
                      } | null;
                      high?: {
                        __typename?: 'DownloadLink';
                        filesize: number;
                        height: number;
                        width: number;
                        link: string;
                      } | null;
                      medium?: {
                        __typename?: 'DownloadLink';
                        filesize: number;
                        height: number;
                        width: number;
                        link: string;
                      } | null;
                    } | null;
                  } | null;
                };
              }>;
            } | null;
          } | null> | null;
        }
      | {
          __typename?: 'WorkoutExerciseMux';
          name: string;
          type: number;
          description?: string | null;
          duration?: Array<string | null> | null;
          id?: string | null;
          videoId?: string | null;
          video?: string | null;
          thumbnail?: string | null;
          media?: {
            __typename?: 'Media';
            audio?: string | null;
            cdn01?: string | null;
            image?: string | null;
            video?: string | null;
            width?: number | null;
            height?: number | null;
            source?: string | null;
            mimeType?: string | null;
            videoSourceType?: string | null;
            uuid?: string | null;
            videoUrl?: string | null;
            videoThumbnailUrl?: string | null;
            downloadLink?: {
              __typename?: 'Download';
              low?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              high?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              medium?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
            } | null;
          } | null;
        }
      | { __typename?: 'WorkoutExerciseNutrition' }
      | { __typename?: 'WorkoutExerciseProduct' }
      | {
          __typename?: 'WorkoutExerciseSingle';
          name: string;
          type: number;
          id?: string | null;
          description?: string | null;
          rest?: number | null;
          unilateral?: boolean | null;
          sets?: Array<{
            __typename?: 'WorkoutExerciseSet';
            reps?: Array<string | null> | null;
            rest?: number | null;
            time?: number | null;
          } | null> | null;
          media?: {
            __typename?: 'Media';
            audio?: string | null;
            cdn01?: string | null;
            image?: string | null;
            video?: string | null;
            width?: number | null;
            height?: number | null;
            source?: string | null;
            mimeType?: string | null;
            videoSourceType?: string | null;
            uuid?: string | null;
            videoUrl?: string | null;
            videoThumbnailUrl?: string | null;
            downloadLink?: {
              __typename?: 'Download';
              low?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              high?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
              medium?: {
                __typename?: 'DownloadLink';
                filesize: number;
                height: number;
                width: number;
                link: string;
              } | null;
            } | null;
          } | null;
          swapConfig?: {
            __typename?: 'WorkoutExerciseSwapConfig';
            swapsEnabled: boolean;
            proposals: Array<{
              __typename?: 'WorkoutSwapConfigProposal';
              exercise: {
                __typename?: 'WorkoutExerciseSingle';
                name: string;
                description?: string | null;
                sets?: Array<{
                  __typename?: 'WorkoutExerciseSet';
                  reps?: Array<string | null> | null;
                  rest?: number | null;
                  time?: number | null;
                } | null> | null;
                media?: {
                  __typename?: 'Media';
                  audio?: string | null;
                  cdn01?: string | null;
                  image?: string | null;
                  video?: string | null;
                  width?: number | null;
                  height?: number | null;
                  source?: string | null;
                  mimeType?: string | null;
                  videoSourceType?: string | null;
                  uuid?: string | null;
                  videoUrl?: string | null;
                  videoThumbnailUrl?: string | null;
                  downloadLink?: {
                    __typename?: 'Download';
                    low?: {
                      __typename?: 'DownloadLink';
                      filesize: number;
                      height: number;
                      width: number;
                      link: string;
                    } | null;
                    high?: {
                      __typename?: 'DownloadLink';
                      filesize: number;
                      height: number;
                      width: number;
                      link: string;
                    } | null;
                    medium?: {
                      __typename?: 'DownloadLink';
                      filesize: number;
                      height: number;
                      width: number;
                      link: string;
                    } | null;
                  } | null;
                } | null;
              };
            }>;
          } | null;
        }
      | {
          __typename?: 'WorkoutExerciseYouTube';
          name: string;
          type: number;
          description?: string | null;
          youtubeId?: string | null;
        }
      | null
    > | null;
    swapConfig?: {
      __typename?: 'WorkoutSwapConfig';
      swapsEnabled: boolean;
    } | null;
  } | null;
};

export type UnpublishWorkoutByIdMutationVariables = Exact<{
  id: Scalars['Int'];
}>;

export type UnpublishWorkoutByIdMutation = {
  __typename?: 'Mutation';
  unpublishWorkoutById: boolean;
};

export type AddOfferLandingPageConfigMutationVariables = Exact<{
  data: AddLandingPageConfigInput;
}>;

export type AddOfferLandingPageConfigMutation = {
  __typename?: 'Mutation';
  addLandingPageConfig: {
    __typename?: 'LandingPageConfig';
    id: number;
    parentId?: number | null;
    type: LandingPageType;
    influencerId: number;
    config?: any | null;
  };
};

export type OfferLandingPageConfigQueryVariables = Exact<{
  influencerId: Scalars['Int'];
  parentId: Scalars['Int'];
}>;

export type OfferLandingPageConfigQuery = {
  __typename?: 'Query';
  landingPageConfig?: {
    __typename?: 'LandingPageConfig';
    id: number;
    parentId?: number | null;
    type: LandingPageType;
    influencerId: number;
    config?: any | null;
  } | null;
};

export type UpdateOfferLandingPageConfigMutationVariables = Exact<{
  data: UpdateLandingPageConfigInput;
}>;

export type UpdateOfferLandingPageConfigMutation = {
  __typename?: 'Mutation';
  updateLandingPageConfig: {
    __typename?: 'LandingPageConfig';
    id: number;
    parentId?: number | null;
    type: LandingPageType;
    influencerId: number;
    config?: any | null;
  };
};

export type GetOfferQueryVariables = Exact<{
  creatorIdID: Scalars['ID'];
  creatorIdInt: Scalars['Int'];
  bundleId: Scalars['Int'];
}>;

export type GetOfferQuery = {
  __typename?: 'Query';
  content: {
    __typename?: 'Content';
    contentItems: Array<{
      __typename?: 'ContentItem';
      type: string;
      value:
        | { __typename?: 'ContentImageValue'; id: string; title: string }
        | { __typename?: 'ContentLegacyGuideValue'; id: string; title: string }
        | { __typename?: 'ContentLinkValue'; id: string; title: string }
        | { __typename?: 'ContentPDFValue'; id: string; title: string }
        | { __typename?: 'ContentSlidesValue'; id: string; title: string }
        | { __typename?: 'ContentTabValue'; id: string; name: string }
        | { __typename?: 'ContentVideoValue'; id: string; title: string };
    }>;
  };
  bundleById: {
    __typename?: 'Bundle';
    id: number;
    title: string;
    description?: string | null;
    influencerId: number;
    status: BundleStatus;
    items?: Array<{
      __typename?: 'BundleItem';
      contentId?: string | null;
      itemId?: number | null;
      itemType: BundleItemType;
    }> | null;
    oneTimeProduct?: { __typename?: 'OneTimeProduct'; price: number } | null;
    checkoutPage?: { __typename?: 'CheckoutPage'; url: string } | null;
  };
  feature: Array<{
    __typename?: 'Feature';
    id: number;
    name: string;
    code: FeatureCode;
  }>;
  creator?: {
    __typename?: 'Creator';
    mediaAvatar?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
    programs: Array<{
      __typename?: 'Program';
      id: number;
      isVisible?: boolean | null;
      name?: string | null;
      workouts?: Array<{
        __typename?: 'WorkoutTiny';
        id: number;
        name?: string | null;
        programId?: number | null;
        programName?: string | null;
        mediaCover?: {
          __typename?: 'Media';
          videoThumbnailUrl?: string | null;
          cdn01?: string | null;
          image?: string | null;
        } | null;
        mediaExercise?: {
          __typename?: 'Media';
          image?: string | null;
          cdn01?: string | null;
          videoThumbnailUrl?: string | null;
        } | null;
      } | null> | null;
    }>;
  } | null;
};

export type GetInfluencersListQueryVariables = Exact<{ [key: string]: never }>;

export type GetInfluencersListQuery = {
  __typename?: 'Query';
  creators: Array<{
    __typename?: 'Creator';
    id: number;
    tier?: number | null;
    mode?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    isVisible?: boolean | null;
    publishedAt?: any | null;
    visibility: string;
    createdAt?: any | null;
    instagramFollowersCount?: number | null;
    profileTiktok?: string | null;
    profileYoutubeChannel?: string | null;
    profileInstagram?: string | null;
    customURL?: string | null;
    businessModel: string;
    email?: string | null;
    mediaCover?: {
      __typename?: 'Media';
      cdn01?: string | null;
      image?: string | null;
    } | null;
  } | null>;
};

export const LiveClassFragmentDoc = gql`
  fragment liveClass on Class {
    id
    cover {
      source
      cdn01
      image
      video
      audio
      height
      width
      mimeType
    }
    color
    name
    description
    duration
    schedule
    deepLink
    type
    difficulty
    location
    category
  }
`;
export const FullMediaFragmentDoc = gql`
  fragment fullMedia on Media {
    source
    cdn01
    image
    video
    audio
    width
    height
    mimeType
  }
`;
export const ProgramListInfoFragmentDoc = gql`
  fragment programListInfo on Program {
    id
    isVisible
    name
    color
    expiresAt
    type
    publishingBehaviour
    workoutLimit
    accessType
    contentStructure
    isLocked
    mediaCover {
      cdn01
      image
    }
    publishedAt
    archivedAt
    migrationBundleId
    exclusiveProgramMetadata {
      price
    }
  }
`;
export const WorkoutInfoFragmentDoc = gql`
  fragment workoutInfo on WorkoutTiny {
    id
    name
    publishedAt
    updatedAt
    archivedAt
    programId
    programIndex
    programIsLocked
    programIsOtp
    isProtected
    isVisible
    statsViews
    statsRatingAverage
    statsCompletions
    statsBegins
    statsComments
    programName
    programColor
    isClass
  }
`;
export const CommunityFeedPostFragmentDoc = gql`
  fragment CommunityFeedPost on Post {
    id
    text
    createdAt
    edited
    pinned
    status
    publishedAt
    author {
      id
      username
      profilePicture
      badges
      hasDirectMessagesAccess
    }
    media {
      cdn01
      image
      video
      audio
      mimeType
      source
      width
      height
      status
      uuid
      videoUrl
      videoThumbnailUrl
      videoSourceType
    }
    reactions {
      type
      count
      isToggled
    }
  }
`;
export const CommunityReplyFragmentDoc = gql`
  fragment CommunityReply on Reply {
    id
    text
    createdAt
    edited
    parentId
    author {
      id
      username
      profilePicture
      badges
      email @include(if: $canModerate)
      marketing @include(if: $canModerate)
      hasDirectMessagesAccess
    }
    media {
      cdn01
      image
      video
      audio
      width
      height
      mimeType
      status
      uuid
      videoUrl
      videoThumbnailUrl
      videoSourceType
    }
    reactions {
      type
      count
      isToggled
    }
    isSensitiveContent
  }
`;
export const CollectionBaseFragmentFragmentDoc = gql`
  fragment CollectionBaseFragment on Collection {
    id
    influencerId
    isVisible
    name
    description
    color
    type
    expiresAt
    publishedAt
    archivedAt
    accessType
  }
`;
export const ChallengeBaseFragmentFragmentDoc = gql`
  fragment ChallengeBaseFragment on Challenge {
    name
    id
    createdAt
    registrationStart
    registrationEnd
    registrationRequirements {
      photos
      instagram
      goal
    }
    hidePhotos
    completionRequirements {
      photos
      testimonial
    }
    templates
    updatedAt
    completionStart
    completionEnd
    completionRequirements {
      photos
      testimonial
    }
    deepLink
    photoInstructions
  }
`;
export const MediaFragmentFragmentDoc = gql`
  fragment MediaFragment on Media {
    audio
    videoThumbnailUrl
    videoUrl
    width
    height
    cdn01
    image
    downloadLink {
      high {
        link
        filesize
        width
        height
      }
    }
    source
    mimeType
    uuid
    video
  }
`;
export const SubmissionFragmentFragmentDoc = gql`
  fragment SubmissionFragment on ChallengeSubmission {
    submissionId
    completionDate
    registrationDate
    createdAt
    updatedAt
    isShortlisted
    allowRepost
    userStateOnCompletion {
      subscriptionStatus
      workoutsCompleted
      workoutsTotal
      subscriptionStatusDate
    }
    subscriptionInfo {
      expiresAt
      status
    }
    completionAttributes {
      testimonial
    }
    registrationAttributes {
      goal
      instagram
    }
    user {
      name
      email
    }
    completionMedia {
      ...MediaFragment
    }
    registrationMedia {
      ...MediaFragment
    }
    transformationMedia {
      ...MediaFragment
    }
  }
  ${MediaFragmentFragmentDoc}
`;
export const CollectionMediaFragmentDoc = gql`
  fragment collectionMedia on Media {
    image
    video
    cdn01
    width
    height
  }
`;
export const CollectionDetailsFragmentDoc = gql`
  fragment collectionDetails on Collection {
    id
    isVisible
    influencerId
    name
    color
    type
    publishingBehaviour
    workoutLimit
    accessType
    contentStructure
    isLocked
    mediaCover {
      cdn01
      image
    }
    archivedAt
    publishedAt
    index
    deeplinkUrl
    migrationBundleId
    exclusiveProgramMetadata {
      deeplinkUrl
      checkoutPageUrl
      price
    }
  }
`;
export const PurchaseCollectionFragmentDoc = gql`
  fragment PurchaseCollection on Collection {
    id
    isVisible
    influencerId
    name
    color
    type
    publishingBehaviour
    workoutLimit
    accessType
    contentStructure
    isLocked
    mediaCover {
      cdn01
      image
    }
  }
`;
export const SubscriptionCollectionFragmentDoc = gql`
  fragment SubscriptionCollection on Collection {
    id
    isVisible
    influencerId
    name
    color
    type
    publishingBehaviour
    workoutLimit
    accessType
    contentStructure
    isLocked
    mediaCover {
      cdn01
      image
    }
  }
`;
export const ProgramsListItemFragmentDoc = gql`
  fragment programsListItem on Collection {
    id
    isVisible
    influencerId
    name
    accessType
    contentStructure
    publishingBehaviour
    isLocked
    archivedAt
    publishedAt
    index
    deeplinkUrl
    programBusinessModel
    mediaCover {
      cdn01
      image
    }
    exclusiveProgramMetadata {
      deeplinkUrl
      checkoutPageUrl
      price
    }
    programStats {
      avgRating
      statsViews
      statsRatings
      statsBegins
      statsComments
      statsCompletions
      statsFavorites
    }
    workouts {
      id
      statsRatingAverage
      statsComments
      statsBegins
      statsCompletions
    }
    challenges {
      id
      completionEnd
      deepLink
    }
    readiness {
      title
      cover
      workouts
      goal
    }
  }
`;
export const DownloadFragmentDoc = gql`
  fragment download on Download {
    low {
      filesize
      height
      width
      link
    }
    high {
      filesize
      height
      width
      link
    }
    medium {
      filesize
      height
      width
      link
    }
  }
`;
export const MediaFragmentDoc = gql`
  fragment media on Media {
    audio
    cdn01
    image
    video
    width
    height
    source
    mimeType
    videoSourceType
    uuid
    videoUrl
    downloadLink {
      ...download
    }
    videoThumbnailUrl
  }
  ${DownloadFragmentDoc}
`;
export const SwapProposalExerciseFragmentDoc = gql`
  fragment swapProposalExercise on WorkoutExerciseSingle {
    name
    description
    sets {
      reps
      rest
      time
    }
    media {
      ...media
    }
  }
  ${MediaFragmentDoc}
`;
export const ExerciseSingleFragmentDoc = gql`
  fragment exerciseSingle on WorkoutExerciseSingle {
    name
    type
    id
    description
    rest
    unilateral
    sets {
      reps
      rest
      time
    }
    media {
      ...media
    }
    swapConfig {
      swapsEnabled
      proposals {
        exercise {
          ...swapProposalExercise
        }
      }
    }
  }
  ${MediaFragmentDoc}
  ${SwapProposalExerciseFragmentDoc}
`;
export const ExerciseAutoplayedFragmentDoc = gql`
  fragment exerciseAutoplayed on WorkoutExerciseAutoplayed {
    name
    type
    description
    longRest
    rounds
    id
    exercises {
      ...exerciseSingle
    }
  }
  ${ExerciseSingleFragmentDoc}
`;
export const ExerciseMultipleFragmentDoc = gql`
  fragment exerciseMultiple on WorkoutExerciseMultiple {
    name
    type
    description
    duration
    rest
    measurementMode
    media {
      ...media
    }
    exercises {
      ...exerciseSingle
    }
  }
  ${MediaFragmentDoc}
  ${ExerciseSingleFragmentDoc}
`;
export const ExerciseCustomFragmentDoc = gql`
  fragment exerciseCustom on WorkoutExerciseCustom {
    name
    type
    description
    duration
  }
`;
export const ExerciseMuxFragmentDoc = gql`
  fragment exerciseMux on WorkoutExerciseMux {
    name
    type
    description
    duration
    id
    videoId
    video
    thumbnail
    media {
      ...media
    }
  }
  ${MediaFragmentDoc}
`;
export const ExerciseYoutubeFragmentDoc = gql`
  fragment exerciseYoutube on WorkoutExerciseYouTube {
    name
    type
    description
    youtubeId
  }
`;
export const AddLandingPageConfigDocument = gql`
  mutation AddLandingPageConfig($data: AddLandingPageConfigInput!) {
    addLandingPageConfig(data: $data) {
      id
      influencerId
      config
    }
  }
`;
export type AddLandingPageConfigMutationFn = Apollo.MutationFunction<
  AddLandingPageConfigMutation,
  AddLandingPageConfigMutationVariables
>;

/**
 * __useAddLandingPageConfigMutation__
 *
 * To run a mutation, you first call `useAddLandingPageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLandingPageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLandingPageConfigMutation, { data, loading, error }] = useAddLandingPageConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddLandingPageConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddLandingPageConfigMutation,
    AddLandingPageConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddLandingPageConfigMutation,
    AddLandingPageConfigMutationVariables
  >(AddLandingPageConfigDocument, options);
}
export type AddLandingPageConfigMutationHookResult = ReturnType<
  typeof useAddLandingPageConfigMutation
>;
export type AddLandingPageConfigMutationResult =
  Apollo.MutationResult<AddLandingPageConfigMutation>;
export type AddLandingPageConfigMutationOptions = Apollo.BaseMutationOptions<
  AddLandingPageConfigMutation,
  AddLandingPageConfigMutationVariables
>;
export const AddLiveClassDocument = gql`
  mutation AddLiveClass($data: AddClassInput!) {
    addClass(data: $data) {
      ...liveClass
    }
  }
  ${LiveClassFragmentDoc}
`;
export type AddLiveClassMutationFn = Apollo.MutationFunction<
  AddLiveClassMutation,
  AddLiveClassMutationVariables
>;

/**
 * __useAddLiveClassMutation__
 *
 * To run a mutation, you first call `useAddLiveClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddLiveClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addLiveClassMutation, { data, loading, error }] = useAddLiveClassMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddLiveClassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddLiveClassMutation,
    AddLiveClassMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddLiveClassMutation,
    AddLiveClassMutationVariables
  >(AddLiveClassDocument, options);
}
export type AddLiveClassMutationHookResult = ReturnType<
  typeof useAddLiveClassMutation
>;
export type AddLiveClassMutationResult =
  Apollo.MutationResult<AddLiveClassMutation>;
export type AddLiveClassMutationOptions = Apollo.BaseMutationOptions<
  AddLiveClassMutation,
  AddLiveClassMutationVariables
>;
export const AddPurchasePageConfigDocument = gql`
  mutation AddPurchasePageConfig($data: AddPurchasePageConfigInput!) {
    addPurchasePageConfig(data: $data) {
      id
      programId
      config
    }
  }
`;
export type AddPurchasePageConfigMutationFn = Apollo.MutationFunction<
  AddPurchasePageConfigMutation,
  AddPurchasePageConfigMutationVariables
>;

/**
 * __useAddPurchasePageConfigMutation__
 *
 * To run a mutation, you first call `useAddPurchasePageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPurchasePageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPurchasePageConfigMutation, { data, loading, error }] = useAddPurchasePageConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddPurchasePageConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPurchasePageConfigMutation,
    AddPurchasePageConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddPurchasePageConfigMutation,
    AddPurchasePageConfigMutationVariables
  >(AddPurchasePageConfigDocument, options);
}
export type AddPurchasePageConfigMutationHookResult = ReturnType<
  typeof useAddPurchasePageConfigMutation
>;
export type AddPurchasePageConfigMutationResult =
  Apollo.MutationResult<AddPurchasePageConfigMutation>;
export type AddPurchasePageConfigMutationOptions = Apollo.BaseMutationOptions<
  AddPurchasePageConfigMutation,
  AddPurchasePageConfigMutationVariables
>;
export const ArchiveCollectionDocument = gql`
  mutation ArchiveCollection($collectionId: Int!) {
    archiveCollection(collectionId: $collectionId) {
      id
    }
  }
`;
export type ArchiveCollectionMutationFn = Apollo.MutationFunction<
  ArchiveCollectionMutation,
  ArchiveCollectionMutationVariables
>;

/**
 * __useArchiveCollectionMutation__
 *
 * To run a mutation, you first call `useArchiveCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCollectionMutation, { data, loading, error }] = useArchiveCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useArchiveCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveCollectionMutation,
    ArchiveCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveCollectionMutation,
    ArchiveCollectionMutationVariables
  >(ArchiveCollectionDocument, options);
}
export type ArchiveCollectionMutationHookResult = ReturnType<
  typeof useArchiveCollectionMutation
>;
export type ArchiveCollectionMutationResult =
  Apollo.MutationResult<ArchiveCollectionMutation>;
export type ArchiveCollectionMutationOptions = Apollo.BaseMutationOptions<
  ArchiveCollectionMutation,
  ArchiveCollectionMutationVariables
>;
export const BanUserDocument = gql`
  mutation BanUser($userId: Int!) {
    banUser(userId: $userId) {
      id
      permanentBanAt
    }
  }
`;
export type BanUserMutationFn = Apollo.MutationFunction<
  BanUserMutation,
  BanUserMutationVariables
>;

/**
 * __useBanUserMutation__
 *
 * To run a mutation, you first call `useBanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [banUserMutation, { data, loading, error }] = useBanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBanUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BanUserMutation,
    BanUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BanUserMutation, BanUserMutationVariables>(
    BanUserDocument,
    options,
  );
}
export type BanUserMutationHookResult = ReturnType<typeof useBanUserMutation>;
export type BanUserMutationResult = Apollo.MutationResult<BanUserMutation>;
export type BanUserMutationOptions = Apollo.BaseMutationOptions<
  BanUserMutation,
  BanUserMutationVariables
>;
export const DeleteCollectionDocument = gql`
  mutation DeleteCollection($collectionId: Int!) {
    deleteCollection(collectionId: $collectionId) {
      id
    }
  }
`;
export type DeleteCollectionMutationFn = Apollo.MutationFunction<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>;

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useDeleteCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCollectionMutation,
    DeleteCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCollectionMutation,
    DeleteCollectionMutationVariables
  >(DeleteCollectionDocument, options);
}
export type DeleteCollectionMutationHookResult = ReturnType<
  typeof useDeleteCollectionMutation
>;
export type DeleteCollectionMutationResult =
  Apollo.MutationResult<DeleteCollectionMutation>;
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<
  DeleteCollectionMutation,
  DeleteCollectionMutationVariables
>;
export const InitProgramPricingDocument = gql`
  mutation InitProgramPricing($programId: Int!, $price: Int!) {
    initializePricing(programId: $programId, price: $price) {
      price
      playbookFee
      discountedPrice
      discountPercent
    }
  }
`;
export type InitProgramPricingMutationFn = Apollo.MutationFunction<
  InitProgramPricingMutation,
  InitProgramPricingMutationVariables
>;

/**
 * __useInitProgramPricingMutation__
 *
 * To run a mutation, you first call `useInitProgramPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitProgramPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initProgramPricingMutation, { data, loading, error }] = useInitProgramPricingMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useInitProgramPricingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    InitProgramPricingMutation,
    InitProgramPricingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    InitProgramPricingMutation,
    InitProgramPricingMutationVariables
  >(InitProgramPricingDocument, options);
}
export type InitProgramPricingMutationHookResult = ReturnType<
  typeof useInitProgramPricingMutation
>;
export type InitProgramPricingMutationResult =
  Apollo.MutationResult<InitProgramPricingMutation>;
export type InitProgramPricingMutationOptions = Apollo.BaseMutationOptions<
  InitProgramPricingMutation,
  InitProgramPricingMutationVariables
>;
export const RemovePermanentBanDocument = gql`
  mutation RemovePermanentBan($userId: Int!) {
    removePermanentBan(userId: $userId) {
      id
      permanentBanAt
    }
  }
`;
export type RemovePermanentBanMutationFn = Apollo.MutationFunction<
  RemovePermanentBanMutation,
  RemovePermanentBanMutationVariables
>;

/**
 * __useRemovePermanentBanMutation__
 *
 * To run a mutation, you first call `useRemovePermanentBanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePermanentBanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePermanentBanMutation, { data, loading, error }] = useRemovePermanentBanMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemovePermanentBanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemovePermanentBanMutation,
    RemovePermanentBanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemovePermanentBanMutation,
    RemovePermanentBanMutationVariables
  >(RemovePermanentBanDocument, options);
}
export type RemovePermanentBanMutationHookResult = ReturnType<
  typeof useRemovePermanentBanMutation
>;
export type RemovePermanentBanMutationResult =
  Apollo.MutationResult<RemovePermanentBanMutation>;
export type RemovePermanentBanMutationOptions = Apollo.BaseMutationOptions<
  RemovePermanentBanMutation,
  RemovePermanentBanMutationVariables
>;
export const RemoveProgramPricingDocument = gql`
  mutation RemoveProgramPricing($programId: Int!) {
    removePricing(programId: $programId) {
      price
      playbookFee
      discountedPrice
      discountPercent
    }
  }
`;
export type RemoveProgramPricingMutationFn = Apollo.MutationFunction<
  RemoveProgramPricingMutation,
  RemoveProgramPricingMutationVariables
>;

/**
 * __useRemoveProgramPricingMutation__
 *
 * To run a mutation, you first call `useRemoveProgramPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProgramPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProgramPricingMutation, { data, loading, error }] = useRemoveProgramPricingMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useRemoveProgramPricingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveProgramPricingMutation,
    RemoveProgramPricingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveProgramPricingMutation,
    RemoveProgramPricingMutationVariables
  >(RemoveProgramPricingDocument, options);
}
export type RemoveProgramPricingMutationHookResult = ReturnType<
  typeof useRemoveProgramPricingMutation
>;
export type RemoveProgramPricingMutationResult =
  Apollo.MutationResult<RemoveProgramPricingMutation>;
export type RemoveProgramPricingMutationOptions = Apollo.BaseMutationOptions<
  RemoveProgramPricingMutation,
  RemoveProgramPricingMutationVariables
>;
export const RemoveShadowbanDocument = gql`
  mutation RemoveShadowban($userId: Int!) {
    removeShadowBan(userId: $userId) {
      id
      shadowBanAt
    }
  }
`;
export type RemoveShadowbanMutationFn = Apollo.MutationFunction<
  RemoveShadowbanMutation,
  RemoveShadowbanMutationVariables
>;

/**
 * __useRemoveShadowbanMutation__
 *
 * To run a mutation, you first call `useRemoveShadowbanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShadowbanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShadowbanMutation, { data, loading, error }] = useRemoveShadowbanMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveShadowbanMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveShadowbanMutation,
    RemoveShadowbanMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveShadowbanMutation,
    RemoveShadowbanMutationVariables
  >(RemoveShadowbanDocument, options);
}
export type RemoveShadowbanMutationHookResult = ReturnType<
  typeof useRemoveShadowbanMutation
>;
export type RemoveShadowbanMutationResult =
  Apollo.MutationResult<RemoveShadowbanMutation>;
export type RemoveShadowbanMutationOptions = Apollo.BaseMutationOptions<
  RemoveShadowbanMutation,
  RemoveShadowbanMutationVariables
>;
export const ShadowbanUserDocument = gql`
  mutation ShadowbanUser($userId: Int!) {
    shadowBanUser(userId: $userId) {
      id
      shadowBanAt
    }
  }
`;
export type ShadowbanUserMutationFn = Apollo.MutationFunction<
  ShadowbanUserMutation,
  ShadowbanUserMutationVariables
>;

/**
 * __useShadowbanUserMutation__
 *
 * To run a mutation, you first call `useShadowbanUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShadowbanUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shadowbanUserMutation, { data, loading, error }] = useShadowbanUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useShadowbanUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ShadowbanUserMutation,
    ShadowbanUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ShadowbanUserMutation,
    ShadowbanUserMutationVariables
  >(ShadowbanUserDocument, options);
}
export type ShadowbanUserMutationHookResult = ReturnType<
  typeof useShadowbanUserMutation
>;
export type ShadowbanUserMutationResult =
  Apollo.MutationResult<ShadowbanUserMutation>;
export type ShadowbanUserMutationOptions = Apollo.BaseMutationOptions<
  ShadowbanUserMutation,
  ShadowbanUserMutationVariables
>;
export const UpdateProgramDiscountDocument = gql`
  mutation UpdateProgramDiscount($programId: Int!, $discount: Int) {
    updateDiscount(programId: $programId, discount: $discount) {
      price
      playbookFee
      discountedPrice
      discountPercent
    }
  }
`;
export type UpdateProgramDiscountMutationFn = Apollo.MutationFunction<
  UpdateProgramDiscountMutation,
  UpdateProgramDiscountMutationVariables
>;

/**
 * __useUpdateProgramDiscountMutation__
 *
 * To run a mutation, you first call `useUpdateProgramDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramDiscountMutation, { data, loading, error }] = useUpdateProgramDiscountMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      discount: // value for 'discount'
 *   },
 * });
 */
export function useUpdateProgramDiscountMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProgramDiscountMutation,
    UpdateProgramDiscountMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProgramDiscountMutation,
    UpdateProgramDiscountMutationVariables
  >(UpdateProgramDiscountDocument, options);
}
export type UpdateProgramDiscountMutationHookResult = ReturnType<
  typeof useUpdateProgramDiscountMutation
>;
export type UpdateProgramDiscountMutationResult =
  Apollo.MutationResult<UpdateProgramDiscountMutation>;
export type UpdateProgramDiscountMutationOptions = Apollo.BaseMutationOptions<
  UpdateProgramDiscountMutation,
  UpdateProgramDiscountMutationVariables
>;
export const UpdateLandingPageConfigDocument = gql`
  mutation UpdateLandingPageConfig($data: UpdateLandingPageConfigInput!) {
    updateLandingPageConfig(data: $data) {
      id
      influencerId
      config
    }
  }
`;
export type UpdateLandingPageConfigMutationFn = Apollo.MutationFunction<
  UpdateLandingPageConfigMutation,
  UpdateLandingPageConfigMutationVariables
>;

/**
 * __useUpdateLandingPageConfigMutation__
 *
 * To run a mutation, you first call `useUpdateLandingPageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandingPageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandingPageConfigMutation, { data, loading, error }] = useUpdateLandingPageConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLandingPageConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLandingPageConfigMutation,
    UpdateLandingPageConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLandingPageConfigMutation,
    UpdateLandingPageConfigMutationVariables
  >(UpdateLandingPageConfigDocument, options);
}
export type UpdateLandingPageConfigMutationHookResult = ReturnType<
  typeof useUpdateLandingPageConfigMutation
>;
export type UpdateLandingPageConfigMutationResult =
  Apollo.MutationResult<UpdateLandingPageConfigMutation>;
export type UpdateLandingPageConfigMutationOptions = Apollo.BaseMutationOptions<
  UpdateLandingPageConfigMutation,
  UpdateLandingPageConfigMutationVariables
>;
export const UpdateLiveClassDocument = gql`
  mutation UpdateLiveClass($data: UpdateClassInput!) {
    updateClass(data: $data) {
      ...liveClass
    }
  }
  ${LiveClassFragmentDoc}
`;
export type UpdateLiveClassMutationFn = Apollo.MutationFunction<
  UpdateLiveClassMutation,
  UpdateLiveClassMutationVariables
>;

/**
 * __useUpdateLiveClassMutation__
 *
 * To run a mutation, you first call `useUpdateLiveClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLiveClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLiveClassMutation, { data, loading, error }] = useUpdateLiveClassMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateLiveClassMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLiveClassMutation,
    UpdateLiveClassMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLiveClassMutation,
    UpdateLiveClassMutationVariables
  >(UpdateLiveClassDocument, options);
}
export type UpdateLiveClassMutationHookResult = ReturnType<
  typeof useUpdateLiveClassMutation
>;
export type UpdateLiveClassMutationResult =
  Apollo.MutationResult<UpdateLiveClassMutation>;
export type UpdateLiveClassMutationOptions = Apollo.BaseMutationOptions<
  UpdateLiveClassMutation,
  UpdateLiveClassMutationVariables
>;
export const UpdateProgramPricingDocument = gql`
  mutation UpdateProgramPricing($programId: Int!, $price: Int!, $fee: Int!) {
    updatePricing(programId: $programId, price: $price, fee: $fee) {
      price
      playbookFee
      discountedPrice
      discountPercent
    }
  }
`;
export type UpdateProgramPricingMutationFn = Apollo.MutationFunction<
  UpdateProgramPricingMutation,
  UpdateProgramPricingMutationVariables
>;

/**
 * __useUpdateProgramPricingMutation__
 *
 * To run a mutation, you first call `useUpdateProgramPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProgramPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProgramPricingMutation, { data, loading, error }] = useUpdateProgramPricingMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      price: // value for 'price'
 *      fee: // value for 'fee'
 *   },
 * });
 */
export function useUpdateProgramPricingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateProgramPricingMutation,
    UpdateProgramPricingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateProgramPricingMutation,
    UpdateProgramPricingMutationVariables
  >(UpdateProgramPricingDocument, options);
}
export type UpdateProgramPricingMutationHookResult = ReturnType<
  typeof useUpdateProgramPricingMutation
>;
export type UpdateProgramPricingMutationResult =
  Apollo.MutationResult<UpdateProgramPricingMutation>;
export type UpdateProgramPricingMutationOptions = Apollo.BaseMutationOptions<
  UpdateProgramPricingMutation,
  UpdateProgramPricingMutationVariables
>;
export const UpdatePurchasePageConfigDocument = gql`
  mutation UpdatePurchasePageConfig($data: UpdatePurchasePageConfigInput!) {
    updatePurchasePageConfig(data: $data) {
      id
      programId
      config
    }
  }
`;
export type UpdatePurchasePageConfigMutationFn = Apollo.MutationFunction<
  UpdatePurchasePageConfigMutation,
  UpdatePurchasePageConfigMutationVariables
>;

/**
 * __useUpdatePurchasePageConfigMutation__
 *
 * To run a mutation, you first call `useUpdatePurchasePageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchasePageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchasePageConfigMutation, { data, loading, error }] = useUpdatePurchasePageConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePurchasePageConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePurchasePageConfigMutation,
    UpdatePurchasePageConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdatePurchasePageConfigMutation,
    UpdatePurchasePageConfigMutationVariables
  >(UpdatePurchasePageConfigDocument, options);
}
export type UpdatePurchasePageConfigMutationHookResult = ReturnType<
  typeof useUpdatePurchasePageConfigMutation
>;
export type UpdatePurchasePageConfigMutationResult =
  Apollo.MutationResult<UpdatePurchasePageConfigMutation>;
export type UpdatePurchasePageConfigMutationOptions =
  Apollo.BaseMutationOptions<
    UpdatePurchasePageConfigMutation,
    UpdatePurchasePageConfigMutationVariables
  >;
export const GetAllProgramsDocument = gql`
  query GetAllPrograms($id: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
      customURL
      customizations {
        hideLibrary
      }
      mode
      programs {
        ...programListInfo
      }
    }
  }
  ${ProgramListInfoFragmentDoc}
`;

/**
 * __useGetAllProgramsQuery__
 *
 * To run a query within a React component, call `useGetAllProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProgramsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllProgramsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllProgramsQuery,
    GetAllProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllProgramsQuery, GetAllProgramsQueryVariables>(
    GetAllProgramsDocument,
    options,
  );
}
export function useGetAllProgramsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllProgramsQuery,
    GetAllProgramsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllProgramsQuery, GetAllProgramsQueryVariables>(
    GetAllProgramsDocument,
    options,
  );
}
export type GetAllProgramsQueryHookResult = ReturnType<
  typeof useGetAllProgramsQuery
>;
export type GetAllProgramsLazyQueryHookResult = ReturnType<
  typeof useGetAllProgramsLazyQuery
>;
export type GetAllProgramsQueryResult = Apollo.QueryResult<
  GetAllProgramsQuery,
  GetAllProgramsQueryVariables
>;
export const GetAllProgramsWithWorkoutsDocument = gql`
  query GetAllProgramsWithWorkouts($id: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
      customURL
      customizations {
        hideLibrary
      }
      mode
      programs {
        ...programListInfo
        workouts {
          ...workoutInfo
        }
      }
    }
  }
  ${ProgramListInfoFragmentDoc}
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetAllProgramsWithWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetAllProgramsWithWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProgramsWithWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProgramsWithWorkoutsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAllProgramsWithWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAllProgramsWithWorkoutsQuery,
    GetAllProgramsWithWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAllProgramsWithWorkoutsQuery,
    GetAllProgramsWithWorkoutsQueryVariables
  >(GetAllProgramsWithWorkoutsDocument, options);
}
export function useGetAllProgramsWithWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAllProgramsWithWorkoutsQuery,
    GetAllProgramsWithWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAllProgramsWithWorkoutsQuery,
    GetAllProgramsWithWorkoutsQueryVariables
  >(GetAllProgramsWithWorkoutsDocument, options);
}
export type GetAllProgramsWithWorkoutsQueryHookResult = ReturnType<
  typeof useGetAllProgramsWithWorkoutsQuery
>;
export type GetAllProgramsWithWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetAllProgramsWithWorkoutsLazyQuery
>;
export type GetAllProgramsWithWorkoutsQueryResult = Apollo.QueryResult<
  GetAllProgramsWithWorkoutsQuery,
  GetAllProgramsWithWorkoutsQueryVariables
>;
export const GetArchivedWorkoutsDocument = gql`
  query GetArchivedWorkouts($id: Int!, $limit: Int!, $offset: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
      customizations {
        hideLibrary
      }
      mode
      archivedWorkouts: workouts(
        scopes: { archived: true }
        limit: $limit
        offset: $offset
      ) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetArchivedWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetArchivedWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArchivedWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArchivedWorkoutsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetArchivedWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetArchivedWorkoutsQuery,
    GetArchivedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetArchivedWorkoutsQuery,
    GetArchivedWorkoutsQueryVariables
  >(GetArchivedWorkoutsDocument, options);
}
export function useGetArchivedWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetArchivedWorkoutsQuery,
    GetArchivedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetArchivedWorkoutsQuery,
    GetArchivedWorkoutsQueryVariables
  >(GetArchivedWorkoutsDocument, options);
}
export type GetArchivedWorkoutsQueryHookResult = ReturnType<
  typeof useGetArchivedWorkoutsQuery
>;
export type GetArchivedWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetArchivedWorkoutsLazyQuery
>;
export type GetArchivedWorkoutsQueryResult = Apollo.QueryResult<
  GetArchivedWorkoutsQuery,
  GetArchivedWorkoutsQueryVariables
>;
export const GetCreatorsMediaDocument = gql`
  query getCreatorsMedia($creatorId: Int!, $type: String) {
    getCreatorsMedia(creatorId: $creatorId, type: $type) {
      uuid
      creatorId
      title
      type
      video
      image
      cdn01
      videoSourceType
      videoThumbnailUrl
      videoUrl
      duration
      aspectRatio
      status
      width
      height
      mimeType
      createdAt
      deletedAt
      updatedAt
      description
      downloadLink {
        low {
          link
          width
          height
          filesize
        }
        medium {
          link
          width
          height
          filesize
        }
        high {
          link
          width
          height
          filesize
        }
      }
      fileSize
      folderId
    }
  }
`;

/**
 * __useGetCreatorsMediaQuery__
 *
 * To run a query within a React component, call `useGetCreatorsMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorsMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorsMediaQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetCreatorsMediaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreatorsMediaQuery,
    GetCreatorsMediaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCreatorsMediaQuery, GetCreatorsMediaQueryVariables>(
    GetCreatorsMediaDocument,
    options,
  );
}
export function useGetCreatorsMediaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreatorsMediaQuery,
    GetCreatorsMediaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCreatorsMediaQuery,
    GetCreatorsMediaQueryVariables
  >(GetCreatorsMediaDocument, options);
}
export type GetCreatorsMediaQueryHookResult = ReturnType<
  typeof useGetCreatorsMediaQuery
>;
export type GetCreatorsMediaLazyQueryHookResult = ReturnType<
  typeof useGetCreatorsMediaLazyQuery
>;
export type GetCreatorsMediaQueryResult = Apollo.QueryResult<
  GetCreatorsMediaQuery,
  GetCreatorsMediaQueryVariables
>;
export const GetCreatorsProcessingMediaDocument = gql`
  query getCreatorsProcessingMedia($creatorId: Int!) {
    getCreatorsProcessingMedia(creatorId: $creatorId) {
      uuid
      creatorId
      title
      type
      video
      image
      cdn01
      videoSourceType
      videoThumbnailUrl
      videoUrl
      duration
      aspectRatio
      status
      width
      height
      mimeType
      createdAt
      deletedAt
      updatedAt
      description
      fileSize
    }
  }
`;

/**
 * __useGetCreatorsProcessingMediaQuery__
 *
 * To run a query within a React component, call `useGetCreatorsProcessingMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorsProcessingMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorsProcessingMediaQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetCreatorsProcessingMediaQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreatorsProcessingMediaQuery,
    GetCreatorsProcessingMediaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCreatorsProcessingMediaQuery,
    GetCreatorsProcessingMediaQueryVariables
  >(GetCreatorsProcessingMediaDocument, options);
}
export function useGetCreatorsProcessingMediaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreatorsProcessingMediaQuery,
    GetCreatorsProcessingMediaQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCreatorsProcessingMediaQuery,
    GetCreatorsProcessingMediaQueryVariables
  >(GetCreatorsProcessingMediaDocument, options);
}
export type GetCreatorsProcessingMediaQueryHookResult = ReturnType<
  typeof useGetCreatorsProcessingMediaQuery
>;
export type GetCreatorsProcessingMediaLazyQueryHookResult = ReturnType<
  typeof useGetCreatorsProcessingMediaLazyQuery
>;
export type GetCreatorsProcessingMediaQueryResult = Apollo.QueryResult<
  GetCreatorsProcessingMediaQuery,
  GetCreatorsProcessingMediaQueryVariables
>;
export const GetCouponsByInfluencerDocument = gql`
  query GetCouponsByInfluencer($id: Int!) {
    getCouponsByInfluencer(influencerId: $id) {
      code
      createdAt
      discountAmount
      expiresAt
      id
      influencerId
      isActive
      maxRedemptions
      name
      paidProductIds
      percentOff
      providerCouponId
      redemptions
      discountType
      productType
      subscriptionProviderPriceIds
      referralCampaignId
      compatibleWithFreeTrial
    }
  }
`;

/**
 * __useGetCouponsByInfluencerQuery__
 *
 * To run a query within a React component, call `useGetCouponsByInfluencerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponsByInfluencerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponsByInfluencerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCouponsByInfluencerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCouponsByInfluencerQuery,
    GetCouponsByInfluencerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCouponsByInfluencerQuery,
    GetCouponsByInfluencerQueryVariables
  >(GetCouponsByInfluencerDocument, options);
}
export function useGetCouponsByInfluencerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCouponsByInfluencerQuery,
    GetCouponsByInfluencerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCouponsByInfluencerQuery,
    GetCouponsByInfluencerQueryVariables
  >(GetCouponsByInfluencerDocument, options);
}
export type GetCouponsByInfluencerQueryHookResult = ReturnType<
  typeof useGetCouponsByInfluencerQuery
>;
export type GetCouponsByInfluencerLazyQueryHookResult = ReturnType<
  typeof useGetCouponsByInfluencerLazyQuery
>;
export type GetCouponsByInfluencerQueryResult = Apollo.QueryResult<
  GetCouponsByInfluencerQuery,
  GetCouponsByInfluencerQueryVariables
>;
export const GetDraftWorkoutsDocument = gql`
  query GetDraftWorkouts($id: Int!, $limit: Int!, $offset: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
      customizations {
        hideLibrary
      }
      mode
      draftWorkouts: workouts(
        scopes: { draft: true }
        limit: $limit
        offset: $offset
      ) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetDraftWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetDraftWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDraftWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDraftWorkoutsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetDraftWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDraftWorkoutsQuery,
    GetDraftWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDraftWorkoutsQuery, GetDraftWorkoutsQueryVariables>(
    GetDraftWorkoutsDocument,
    options,
  );
}
export function useGetDraftWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDraftWorkoutsQuery,
    GetDraftWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDraftWorkoutsQuery,
    GetDraftWorkoutsQueryVariables
  >(GetDraftWorkoutsDocument, options);
}
export type GetDraftWorkoutsQueryHookResult = ReturnType<
  typeof useGetDraftWorkoutsQuery
>;
export type GetDraftWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetDraftWorkoutsLazyQuery
>;
export type GetDraftWorkoutsQueryResult = Apollo.QueryResult<
  GetDraftWorkoutsQuery,
  GetDraftWorkoutsQueryVariables
>;
export const GetInfluencerDocument = gql`
  query GetInfluencer($id: Int!) {
    creator(id: $id) {
      id
      tier
      bio
      email
      mobilePhoneNumber
      mode
      salesModel
      offering
      mediaAvatar {
        cdn01
        image
      }
      mediaCover {
        cdn01
        image
      }
      title
      firstName
      lastName
      liveStreamKey
      latestWorkout {
        publishedAt
      }
      stripeUserId
      paymentMethod
      profileDeepLink
      facebookPixelId
      facebookConversionApiAccessToken
      profileInstagram
      isVisible
      publishedAt
      customURL
      customDomains {
        id
        domain
        status
      }
      customizations {
        isNewVideo
        canUsePromotionDetails
        canUsePromotions
        premiumFeaturesOTPIds
        isTransactionLedgerEnabled
        isUnifiedProgramsEnabled
        isCommunitiesV2Enabled
        isOtpMigratedToBundle
        isOffers35Enabled
        isCouponWithFreeTrialEnabled
        isCreatorApprovedSwapsEnabled
      }
      features {
        id
        code
        name
      }
      communityId
      ga4Configuration {
        measurementId
        apiSecret
      }
      visibility
      tikTokConfiguration {
        pixelId
        apiSecret
      }
      enableCheckoutFreeTrial
      collectionType
      productType
      publisheCollectionsCount
      publishedWorkoutsCount
      createdAt
      otpProgramsCount
      stripeLiveMode
      businessModel
      socialAccounts {
        provider
        connected
        email
      }
      signInEmail
    }
  }
`;

/**
 * __useGetInfluencerQuery__
 *
 * To run a query within a React component, call `useGetInfluencerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfluencerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfluencerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInfluencerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInfluencerQuery,
    GetInfluencerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInfluencerQuery, GetInfluencerQueryVariables>(
    GetInfluencerDocument,
    options,
  );
}
export function useGetInfluencerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInfluencerQuery,
    GetInfluencerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInfluencerQuery, GetInfluencerQueryVariables>(
    GetInfluencerDocument,
    options,
  );
}
export type GetInfluencerQueryHookResult = ReturnType<
  typeof useGetInfluencerQuery
>;
export type GetInfluencerLazyQueryHookResult = ReturnType<
  typeof useGetInfluencerLazyQuery
>;
export type GetInfluencerQueryResult = Apollo.QueryResult<
  GetInfluencerQuery,
  GetInfluencerQueryVariables
>;
export const GetInfluencerNamesDocument = gql`
  query GetInfluencerNames {
    creators {
      id
      firstName
      lastName
    }
  }
`;

/**
 * __useGetInfluencerNamesQuery__
 *
 * To run a query within a React component, call `useGetInfluencerNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfluencerNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfluencerNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInfluencerNamesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInfluencerNamesQuery,
    GetInfluencerNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInfluencerNamesQuery,
    GetInfluencerNamesQueryVariables
  >(GetInfluencerNamesDocument, options);
}
export function useGetInfluencerNamesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInfluencerNamesQuery,
    GetInfluencerNamesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInfluencerNamesQuery,
    GetInfluencerNamesQueryVariables
  >(GetInfluencerNamesDocument, options);
}
export type GetInfluencerNamesQueryHookResult = ReturnType<
  typeof useGetInfluencerNamesQuery
>;
export type GetInfluencerNamesLazyQueryHookResult = ReturnType<
  typeof useGetInfluencerNamesLazyQuery
>;
export type GetInfluencerNamesQueryResult = Apollo.QueryResult<
  GetInfluencerNamesQuery,
  GetInfluencerNamesQueryVariables
>;
export const GetInfluencersDocument = gql`
  query GetInfluencers($mode: Int) {
    creators(input: { filters: { mode: $mode } }) {
      id
      tier
      mediaCover {
        cdn01
        image
      }
      firstName
      lastName
      latestWorkout {
        publishedAt
      }
      isVisible
      publishedAt
      customizations {
        isNewVideo
      }
      features {
        id
        code
        name
      }
    }
  }
`;

/**
 * __useGetInfluencersQuery__
 *
 * To run a query within a React component, call `useGetInfluencersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfluencersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfluencersQuery({
 *   variables: {
 *      mode: // value for 'mode'
 *   },
 * });
 */
export function useGetInfluencersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInfluencersQuery,
    GetInfluencersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInfluencersQuery, GetInfluencersQueryVariables>(
    GetInfluencersDocument,
    options,
  );
}
export function useGetInfluencersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInfluencersQuery,
    GetInfluencersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInfluencersQuery, GetInfluencersQueryVariables>(
    GetInfluencersDocument,
    options,
  );
}
export type GetInfluencersQueryHookResult = ReturnType<
  typeof useGetInfluencersQuery
>;
export type GetInfluencersLazyQueryHookResult = ReturnType<
  typeof useGetInfluencersLazyQuery
>;
export type GetInfluencersQueryResult = Apollo.QueryResult<
  GetInfluencersQuery,
  GetInfluencersQueryVariables
>;
export const GetProgramByIdDocument = gql`
  query GetProgramById($id: Int!) {
    program(programId: $id) {
      id
      name
      isLocked
      accessType
      color
      description
      publishingBehaviour
      workoutLimit
      accessType
      contentStructure
      mediaCover {
        image
        video
        cdn01
        width
        height
      }
      mediaIntro {
        image
        video
        cdn01
        width
        height
      }
      testimonials {
        media {
          image
          video
          cdn01
          width
          height
        }
        name
        text
      }
      faq {
        answer
        question
      }
      workouts {
        ...workoutInfo
      }
      publishedAt
      archivedAt
    }
    getPricing(programId: $id) {
      price
      playbookFee
      discountedPrice
      discountPercent
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetProgramByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgramByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramByIdQuery,
    GetProgramByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(
    GetProgramByIdDocument,
    options,
  );
}
export function useGetProgramByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramByIdQuery,
    GetProgramByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProgramByIdQuery, GetProgramByIdQueryVariables>(
    GetProgramByIdDocument,
    options,
  );
}
export type GetProgramByIdQueryHookResult = ReturnType<
  typeof useGetProgramByIdQuery
>;
export type GetProgramByIdLazyQueryHookResult = ReturnType<
  typeof useGetProgramByIdLazyQuery
>;
export type GetProgramByIdQueryResult = Apollo.QueryResult<
  GetProgramByIdQuery,
  GetProgramByIdQueryVariables
>;
export const GetProgramArchivedWorkoutsDocument = gql`
  query GetProgramArchivedWorkouts($programId: Int!) {
    program(programId: $programId) {
      id
      archivedWorkouts: workouts(scopes: { archived: true }) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetProgramArchivedWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetProgramArchivedWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramArchivedWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramArchivedWorkoutsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetProgramArchivedWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramArchivedWorkoutsQuery,
    GetProgramArchivedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramArchivedWorkoutsQuery,
    GetProgramArchivedWorkoutsQueryVariables
  >(GetProgramArchivedWorkoutsDocument, options);
}
export function useGetProgramArchivedWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramArchivedWorkoutsQuery,
    GetProgramArchivedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramArchivedWorkoutsQuery,
    GetProgramArchivedWorkoutsQueryVariables
  >(GetProgramArchivedWorkoutsDocument, options);
}
export type GetProgramArchivedWorkoutsQueryHookResult = ReturnType<
  typeof useGetProgramArchivedWorkoutsQuery
>;
export type GetProgramArchivedWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetProgramArchivedWorkoutsLazyQuery
>;
export type GetProgramArchivedWorkoutsQueryResult = Apollo.QueryResult<
  GetProgramArchivedWorkoutsQuery,
  GetProgramArchivedWorkoutsQueryVariables
>;
export const GetProgramDraftWorkoutsDocument = gql`
  query GetProgramDraftWorkouts($programId: Int!) {
    program(programId: $programId) {
      id
      draftWorkouts: workouts(scopes: { draft: true }) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetProgramDraftWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetProgramDraftWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramDraftWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramDraftWorkoutsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetProgramDraftWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramDraftWorkoutsQuery,
    GetProgramDraftWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramDraftWorkoutsQuery,
    GetProgramDraftWorkoutsQueryVariables
  >(GetProgramDraftWorkoutsDocument, options);
}
export function useGetProgramDraftWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramDraftWorkoutsQuery,
    GetProgramDraftWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramDraftWorkoutsQuery,
    GetProgramDraftWorkoutsQueryVariables
  >(GetProgramDraftWorkoutsDocument, options);
}
export type GetProgramDraftWorkoutsQueryHookResult = ReturnType<
  typeof useGetProgramDraftWorkoutsQuery
>;
export type GetProgramDraftWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetProgramDraftWorkoutsLazyQuery
>;
export type GetProgramDraftWorkoutsQueryResult = Apollo.QueryResult<
  GetProgramDraftWorkoutsQuery,
  GetProgramDraftWorkoutsQueryVariables
>;
export const GetProgramPublishedWorkoutsDocument = gql`
  query GetProgramPublishedWorkouts($programId: Int!) {
    program(programId: $programId) {
      id
      workouts(scopes: { published: true }) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetProgramPublishedWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetProgramPublishedWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramPublishedWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramPublishedWorkoutsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetProgramPublishedWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramPublishedWorkoutsQuery,
    GetProgramPublishedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramPublishedWorkoutsQuery,
    GetProgramPublishedWorkoutsQueryVariables
  >(GetProgramPublishedWorkoutsDocument, options);
}
export function useGetProgramPublishedWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramPublishedWorkoutsQuery,
    GetProgramPublishedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramPublishedWorkoutsQuery,
    GetProgramPublishedWorkoutsQueryVariables
  >(GetProgramPublishedWorkoutsDocument, options);
}
export type GetProgramPublishedWorkoutsQueryHookResult = ReturnType<
  typeof useGetProgramPublishedWorkoutsQuery
>;
export type GetProgramPublishedWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetProgramPublishedWorkoutsLazyQuery
>;
export type GetProgramPublishedWorkoutsQueryResult = Apollo.QueryResult<
  GetProgramPublishedWorkoutsQuery,
  GetProgramPublishedWorkoutsQueryVariables
>;
export const GetProgramPurchasePageByIdDocument = gql`
  query GetProgramPurchasePageById($id: Int!) {
    program(programId: $id) {
      id
      name
      isLocked
      accessType
      color
      description
      tags
      difficulty
      duration
      daysPerWeek
      sessionDuration
      location
      publishedAt
      archivedAt
      mediaCover {
        image
        video
        cdn01
        width
        height
      }
      mediaIntro {
        image
        video
        cdn01
        width
        height
      }
      testimonials {
        media {
          image
          video
          cdn01
          width
          height
        }
        name
        text
      }
      faq {
        answer
        question
      }
      workouts {
        id
        isClass
        name
        mediaCover {
          image
          video
          cdn01
          width
          height
        }
        mediaExercise {
          image
          video
          cdn01
          width
          height
        }
      }
      influencer {
        id
        firstName
        lastName
        customURL
        bio
        mediaAvatar {
          image
          video
          cdn01
          width
          height
        }
        enableCheckoutFreeTrial
        messageProfile
        messageCommunity
        customColorSchema {
          primaryColor
          secondaryColor
        }
        customDomains {
          id
          domain
          status
        }
      }
    }
  }
`;

/**
 * __useGetProgramPurchasePageByIdQuery__
 *
 * To run a query within a React component, call `useGetProgramPurchasePageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramPurchasePageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramPurchasePageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProgramPurchasePageByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramPurchasePageByIdQuery,
    GetProgramPurchasePageByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramPurchasePageByIdQuery,
    GetProgramPurchasePageByIdQueryVariables
  >(GetProgramPurchasePageByIdDocument, options);
}
export function useGetProgramPurchasePageByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramPurchasePageByIdQuery,
    GetProgramPurchasePageByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramPurchasePageByIdQuery,
    GetProgramPurchasePageByIdQueryVariables
  >(GetProgramPurchasePageByIdDocument, options);
}
export type GetProgramPurchasePageByIdQueryHookResult = ReturnType<
  typeof useGetProgramPurchasePageByIdQuery
>;
export type GetProgramPurchasePageByIdLazyQueryHookResult = ReturnType<
  typeof useGetProgramPurchasePageByIdLazyQuery
>;
export type GetProgramPurchasePageByIdQueryResult = Apollo.QueryResult<
  GetProgramPurchasePageByIdQuery,
  GetProgramPurchasePageByIdQueryVariables
>;
export const GetProgramScheduledWorkoutsDocument = gql`
  query GetProgramScheduledWorkouts($programId: Int!) {
    program(programId: $programId) {
      id
      scheduledWorkouts: workouts(scopes: { scheduled: true }) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetProgramScheduledWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetProgramScheduledWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramScheduledWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramScheduledWorkoutsQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useGetProgramScheduledWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramScheduledWorkoutsQuery,
    GetProgramScheduledWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramScheduledWorkoutsQuery,
    GetProgramScheduledWorkoutsQueryVariables
  >(GetProgramScheduledWorkoutsDocument, options);
}
export function useGetProgramScheduledWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramScheduledWorkoutsQuery,
    GetProgramScheduledWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramScheduledWorkoutsQuery,
    GetProgramScheduledWorkoutsQueryVariables
  >(GetProgramScheduledWorkoutsDocument, options);
}
export type GetProgramScheduledWorkoutsQueryHookResult = ReturnType<
  typeof useGetProgramScheduledWorkoutsQuery
>;
export type GetProgramScheduledWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetProgramScheduledWorkoutsLazyQuery
>;
export type GetProgramScheduledWorkoutsQueryResult = Apollo.QueryResult<
  GetProgramScheduledWorkoutsQuery,
  GetProgramScheduledWorkoutsQueryVariables
>;
export const GetPublishedWorkoutsDocument = gql`
  query GetPublishedWorkouts($id: Int!) {
    creator(id: $id) {
      mode
      workouts: workouts(scopes: { published: true }) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetPublishedWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetPublishedWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublishedWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublishedWorkoutsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPublishedWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPublishedWorkoutsQuery,
    GetPublishedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPublishedWorkoutsQuery,
    GetPublishedWorkoutsQueryVariables
  >(GetPublishedWorkoutsDocument, options);
}
export function useGetPublishedWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPublishedWorkoutsQuery,
    GetPublishedWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPublishedWorkoutsQuery,
    GetPublishedWorkoutsQueryVariables
  >(GetPublishedWorkoutsDocument, options);
}
export type GetPublishedWorkoutsQueryHookResult = ReturnType<
  typeof useGetPublishedWorkoutsQuery
>;
export type GetPublishedWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetPublishedWorkoutsLazyQuery
>;
export type GetPublishedWorkoutsQueryResult = Apollo.QueryResult<
  GetPublishedWorkoutsQuery,
  GetPublishedWorkoutsQueryVariables
>;
export const GetScheduledWorkoutsDocument = gql`
  query GetScheduledWorkouts($id: Int!, $limit: Int!, $offset: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
      customizations {
        hideLibrary
      }
      mode
      scheduledWorkouts: workouts(
        scopes: { scheduled: true }
        limit: $limit
        offset: $offset
      ) {
        ...workoutInfo
      }
    }
  }
  ${WorkoutInfoFragmentDoc}
`;

/**
 * __useGetScheduledWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetScheduledWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScheduledWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScheduledWorkoutsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetScheduledWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetScheduledWorkoutsQuery,
    GetScheduledWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetScheduledWorkoutsQuery,
    GetScheduledWorkoutsQueryVariables
  >(GetScheduledWorkoutsDocument, options);
}
export function useGetScheduledWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetScheduledWorkoutsQuery,
    GetScheduledWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetScheduledWorkoutsQuery,
    GetScheduledWorkoutsQueryVariables
  >(GetScheduledWorkoutsDocument, options);
}
export type GetScheduledWorkoutsQueryHookResult = ReturnType<
  typeof useGetScheduledWorkoutsQuery
>;
export type GetScheduledWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetScheduledWorkoutsLazyQuery
>;
export type GetScheduledWorkoutsQueryResult = Apollo.QueryResult<
  GetScheduledWorkoutsQuery,
  GetScheduledWorkoutsQueryVariables
>;
export const GetStreamKeyDocument = gql`
  query GetStreamKey($id: Int!) {
    creator(id: $id) {
      id
      liveStreamKey
    }
  }
`;

/**
 * __useGetStreamKeyQuery__
 *
 * To run a query within a React component, call `useGetStreamKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamKeyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStreamKeyQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStreamKeyQuery,
    GetStreamKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStreamKeyQuery, GetStreamKeyQueryVariables>(
    GetStreamKeyDocument,
    options,
  );
}
export function useGetStreamKeyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStreamKeyQuery,
    GetStreamKeyQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStreamKeyQuery, GetStreamKeyQueryVariables>(
    GetStreamKeyDocument,
    options,
  );
}
export type GetStreamKeyQueryHookResult = ReturnType<
  typeof useGetStreamKeyQuery
>;
export type GetStreamKeyLazyQueryHookResult = ReturnType<
  typeof useGetStreamKeyLazyQuery
>;
export type GetStreamKeyQueryResult = Apollo.QueryResult<
  GetStreamKeyQuery,
  GetStreamKeyQueryVariables
>;
export const GetSubTiresDocument = gql`
  query GetSubTires($id: Int!) {
    subscriptionTierByInfluencer(influencerId: $id) {
      createdAt
      description
      id
      influencerId
      name
      providerProductId
      prices {
        billingCycleInterval
        billingCycleIntervalUnit
        createdAt
        description
        displayOrder
        id
        isDefault
        price
        providerPriceId
        upgradePaths {
          subscriptionTierPriceIdTo
        }
      }
    }
  }
`;

/**
 * __useGetSubTiresQuery__
 *
 * To run a query within a React component, call `useGetSubTiresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubTiresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubTiresQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubTiresQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubTiresQuery,
    GetSubTiresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSubTiresQuery, GetSubTiresQueryVariables>(
    GetSubTiresDocument,
    options,
  );
}
export function useGetSubTiresLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubTiresQuery,
    GetSubTiresQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSubTiresQuery, GetSubTiresQueryVariables>(
    GetSubTiresDocument,
    options,
  );
}
export type GetSubTiresQueryHookResult = ReturnType<typeof useGetSubTiresQuery>;
export type GetSubTiresLazyQueryHookResult = ReturnType<
  typeof useGetSubTiresLazyQuery
>;
export type GetSubTiresQueryResult = Apollo.QueryResult<
  GetSubTiresQuery,
  GetSubTiresQueryVariables
>;
export const PurchasePageConfigDocument = gql`
  query PurchasePageConfig($programId: Int!) {
    purchasePageConfig(programId: $programId) {
      id
      programId
      config
    }
  }
`;

/**
 * __usePurchasePageConfigQuery__
 *
 * To run a query within a React component, call `usePurchasePageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePurchasePageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePurchasePageConfigQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function usePurchasePageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    PurchasePageConfigQuery,
    PurchasePageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PurchasePageConfigQuery,
    PurchasePageConfigQueryVariables
  >(PurchasePageConfigDocument, options);
}
export function usePurchasePageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PurchasePageConfigQuery,
    PurchasePageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PurchasePageConfigQuery,
    PurchasePageConfigQueryVariables
  >(PurchasePageConfigDocument, options);
}
export type PurchasePageConfigQueryHookResult = ReturnType<
  typeof usePurchasePageConfigQuery
>;
export type PurchasePageConfigLazyQueryHookResult = ReturnType<
  typeof usePurchasePageConfigLazyQuery
>;
export type PurchasePageConfigQueryResult = Apollo.QueryResult<
  PurchasePageConfigQuery,
  PurchasePageConfigQueryVariables
>;
export const SearchCommentsDocument = gql`
  query SearchComments(
    $status: Int
    $searchTerm: String
    $creatorId: Int
    $limit: Int!
    $offset: Int!
  ) {
    searchComments(
      searchTerm: $searchTerm
      status: $status
      creatorId: $creatorId
      limit: $limit
      offset: $offset
    ) {
      id
      status
      textValue
      createdAt
      reportedCount
      workout {
        name
        influencer {
          id
          firstName
          lastName
        }
      }
      user {
        id
        name
        isBanned
        mediaThumbnail {
          cdn01
          image
        }
        email
      }
    }
  }
`;

/**
 * __useSearchCommentsQuery__
 *
 * To run a query within a React component, call `useSearchCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCommentsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      searchTerm: // value for 'searchTerm'
 *      creatorId: // value for 'creatorId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchCommentsQuery,
    SearchCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SearchCommentsQuery, SearchCommentsQueryVariables>(
    SearchCommentsDocument,
    options,
  );
}
export function useSearchCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchCommentsQuery,
    SearchCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SearchCommentsQuery, SearchCommentsQueryVariables>(
    SearchCommentsDocument,
    options,
  );
}
export type SearchCommentsQueryHookResult = ReturnType<
  typeof useSearchCommentsQuery
>;
export type SearchCommentsLazyQueryHookResult = ReturnType<
  typeof useSearchCommentsLazyQuery
>;
export type SearchCommentsQueryResult = Apollo.QueryResult<
  SearchCommentsQuery,
  SearchCommentsQueryVariables
>;
export const AddPostDocument = gql`
  mutation AddPost($communityId: Int!, $media: [MediaInput!], $text: String!) {
    addPost(communityId: $communityId, media: $media, text: $text) {
      author {
        id
        username
        badges
        profilePicture
      }
      communityId
      createdAt
      id
      text
      updatedAt
      media {
        mimeType
        audio
        image
        height
        width
        source
        cdn01
        video
      }
    }
  }
`;
export type AddPostMutationFn = Apollo.MutationFunction<
  AddPostMutation,
  AddPostMutationVariables
>;

/**
 * __useAddPostMutation__
 *
 * To run a mutation, you first call `useAddPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPostMutation, { data, loading, error }] = useAddPostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      media: // value for 'media'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPostMutation,
    AddPostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddPostMutation, AddPostMutationVariables>(
    AddPostDocument,
    options,
  );
}
export type AddPostMutationHookResult = ReturnType<typeof useAddPostMutation>;
export type AddPostMutationResult = Apollo.MutationResult<AddPostMutation>;
export type AddPostMutationOptions = Apollo.BaseMutationOptions<
  AddPostMutation,
  AddPostMutationVariables
>;
export const AddReplyDocument = gql`
  mutation AddReply($communityId: Int!, $postId: String!, $text: String!) {
    addReply(communityId: $communityId, postId: $postId, text: $text) {
      author {
        id
        username
        badges
        profilePicture
      }
      id
      text
      createdAt
      updatedAt
    }
  }
`;
export type AddReplyMutationFn = Apollo.MutationFunction<
  AddReplyMutation,
  AddReplyMutationVariables
>;

/**
 * __useAddReplyMutation__
 *
 * To run a mutation, you first call `useAddReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addReplyMutation, { data, loading, error }] = useAddReplyMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAddReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddReplyMutation,
    AddReplyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddReplyMutation, AddReplyMutationVariables>(
    AddReplyDocument,
    options,
  );
}
export type AddReplyMutationHookResult = ReturnType<typeof useAddReplyMutation>;
export type AddReplyMutationResult = Apollo.MutationResult<AddReplyMutation>;
export type AddReplyMutationOptions = Apollo.BaseMutationOptions<
  AddReplyMutation,
  AddReplyMutationVariables
>;
export const BlockUserDocument = gql`
  mutation BlockUser($communityId: Int!, $userId: Int!) {
    blockUser(communityId: $communityId, userId: $userId)
  }
`;
export type BlockUserMutationFn = Apollo.MutationFunction<
  BlockUserMutation,
  BlockUserMutationVariables
>;

/**
 * __useBlockUserMutation__
 *
 * To run a mutation, you first call `useBlockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockUserMutation, { data, loading, error }] = useBlockUserMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BlockUserMutation,
    BlockUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BlockUserMutation, BlockUserMutationVariables>(
    BlockUserDocument,
    options,
  );
}
export type BlockUserMutationHookResult = ReturnType<
  typeof useBlockUserMutation
>;
export type BlockUserMutationResult = Apollo.MutationResult<BlockUserMutation>;
export type BlockUserMutationOptions = Apollo.BaseMutationOptions<
  BlockUserMutation,
  BlockUserMutationVariables
>;
export const DeletePostDocument = gql`
  mutation DeletePost($communityId: Int!, $postId: String!) {
    deletePost(communityId: $communityId, postId: $postId) {
      id
    }
  }
`;
export type DeletePostMutationFn = Apollo.MutationFunction<
  DeletePostMutation,
  DeletePostMutationVariables
>;

/**
 * __useDeletePostMutation__
 *
 * To run a mutation, you first call `useDeletePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePostMutation, { data, loading, error }] = useDeletePostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeletePostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePostMutation,
    DeletePostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePostMutation, DeletePostMutationVariables>(
    DeletePostDocument,
    options,
  );
}
export type DeletePostMutationHookResult = ReturnType<
  typeof useDeletePostMutation
>;
export type DeletePostMutationResult =
  Apollo.MutationResult<DeletePostMutation>;
export type DeletePostMutationOptions = Apollo.BaseMutationOptions<
  DeletePostMutation,
  DeletePostMutationVariables
>;
export const DeleteReplyDocument = gql`
  mutation DeleteReply($communityId: Int!, $replyId: String!) {
    deleteReply(communityId: $communityId, postId: $replyId) {
      id
    }
  }
`;
export type DeleteReplyMutationFn = Apollo.MutationFunction<
  DeleteReplyMutation,
  DeleteReplyMutationVariables
>;

/**
 * __useDeleteReplyMutation__
 *
 * To run a mutation, you first call `useDeleteReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReplyMutation, { data, loading, error }] = useDeleteReplyMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useDeleteReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteReplyMutation,
    DeleteReplyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteReplyMutation, DeleteReplyMutationVariables>(
    DeleteReplyDocument,
    options,
  );
}
export type DeleteReplyMutationHookResult = ReturnType<
  typeof useDeleteReplyMutation
>;
export type DeleteReplyMutationResult =
  Apollo.MutationResult<DeleteReplyMutation>;
export type DeleteReplyMutationOptions = Apollo.BaseMutationOptions<
  DeleteReplyMutation,
  DeleteReplyMutationVariables
>;
export const DisableCommunityDocument = gql`
  mutation DisableCommunity($creatorId: Int!) {
    disableCommunity(creatorId: $creatorId)
  }
`;
export type DisableCommunityMutationFn = Apollo.MutationFunction<
  DisableCommunityMutation,
  DisableCommunityMutationVariables
>;

/**
 * __useDisableCommunityMutation__
 *
 * To run a mutation, you first call `useDisableCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableCommunityMutation, { data, loading, error }] = useDisableCommunityMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useDisableCommunityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DisableCommunityMutation,
    DisableCommunityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DisableCommunityMutation,
    DisableCommunityMutationVariables
  >(DisableCommunityDocument, options);
}
export type DisableCommunityMutationHookResult = ReturnType<
  typeof useDisableCommunityMutation
>;
export type DisableCommunityMutationResult =
  Apollo.MutationResult<DisableCommunityMutation>;
export type DisableCommunityMutationOptions = Apollo.BaseMutationOptions<
  DisableCommunityMutation,
  DisableCommunityMutationVariables
>;
export const EnableCommunityDocument = gql`
  mutation EnableCommunity(
    $creatorId: Int!
    $creatorEmail: String!
    $creatorName: String!
  ) {
    enableCommunity(
      creatorId: $creatorId
      creatorEmail: $creatorEmail
      creatorName: $creatorName
    )
  }
`;
export type EnableCommunityMutationFn = Apollo.MutationFunction<
  EnableCommunityMutation,
  EnableCommunityMutationVariables
>;

/**
 * __useEnableCommunityMutation__
 *
 * To run a mutation, you first call `useEnableCommunityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCommunityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCommunityMutation, { data, loading, error }] = useEnableCommunityMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      creatorEmail: // value for 'creatorEmail'
 *      creatorName: // value for 'creatorName'
 *   },
 * });
 */
export function useEnableCommunityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableCommunityMutation,
    EnableCommunityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnableCommunityMutation,
    EnableCommunityMutationVariables
  >(EnableCommunityDocument, options);
}
export type EnableCommunityMutationHookResult = ReturnType<
  typeof useEnableCommunityMutation
>;
export type EnableCommunityMutationResult =
  Apollo.MutationResult<EnableCommunityMutation>;
export type EnableCommunityMutationOptions = Apollo.BaseMutationOptions<
  EnableCommunityMutation,
  EnableCommunityMutationVariables
>;
export const KeepContentDocument = gql`
  mutation KeepContent($contentId: Int!) {
    keepContent(contentId: $contentId)
  }
`;
export type KeepContentMutationFn = Apollo.MutationFunction<
  KeepContentMutation,
  KeepContentMutationVariables
>;

/**
 * __useKeepContentMutation__
 *
 * To run a mutation, you first call `useKeepContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeepContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keepContentMutation, { data, loading, error }] = useKeepContentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useKeepContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    KeepContentMutation,
    KeepContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<KeepContentMutation, KeepContentMutationVariables>(
    KeepContentDocument,
    options,
  );
}
export type KeepContentMutationHookResult = ReturnType<
  typeof useKeepContentMutation
>;
export type KeepContentMutationResult =
  Apollo.MutationResult<KeepContentMutation>;
export type KeepContentMutationOptions = Apollo.BaseMutationOptions<
  KeepContentMutation,
  KeepContentMutationVariables
>;
export const TogglePinPostDocument = gql`
  mutation TogglePinPost(
    $communityId: Int!
    $postId: String!
    $pinned: Boolean!
  ) {
    togglePinPost(communityId: $communityId, postId: $postId, pinned: $pinned)
  }
`;
export type TogglePinPostMutationFn = Apollo.MutationFunction<
  TogglePinPostMutation,
  TogglePinPostMutationVariables
>;

/**
 * __useTogglePinPostMutation__
 *
 * To run a mutation, you first call `useTogglePinPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinPostMutation, { data, loading, error }] = useTogglePinPostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function useTogglePinPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TogglePinPostMutation,
    TogglePinPostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TogglePinPostMutation,
    TogglePinPostMutationVariables
  >(TogglePinPostDocument, options);
}
export type TogglePinPostMutationHookResult = ReturnType<
  typeof useTogglePinPostMutation
>;
export type TogglePinPostMutationResult =
  Apollo.MutationResult<TogglePinPostMutation>;
export type TogglePinPostMutationOptions = Apollo.BaseMutationOptions<
  TogglePinPostMutation,
  TogglePinPostMutationVariables
>;
export const ToggleReactionDocument = gql`
  mutation ToggleReaction(
    $communityId: Int!
    $entityId: String!
    $parent: ReactionParent!
    $type: ReactionType!
  ) {
    toggleReaction(
      communityId: $communityId
      entityId: $entityId
      parent: $parent
      type: $type
    ) {
      id
    }
  }
`;
export type ToggleReactionMutationFn = Apollo.MutationFunction<
  ToggleReactionMutation,
  ToggleReactionMutationVariables
>;

/**
 * __useToggleReactionMutation__
 *
 * To run a mutation, you first call `useToggleReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleReactionMutation, { data, loading, error }] = useToggleReactionMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      entityId: // value for 'entityId'
 *      parent: // value for 'parent'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useToggleReactionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleReactionMutation,
    ToggleReactionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleReactionMutation,
    ToggleReactionMutationVariables
  >(ToggleReactionDocument, options);
}
export type ToggleReactionMutationHookResult = ReturnType<
  typeof useToggleReactionMutation
>;
export type ToggleReactionMutationResult =
  Apollo.MutationResult<ToggleReactionMutation>;
export type ToggleReactionMutationOptions = Apollo.BaseMutationOptions<
  ToggleReactionMutation,
  ToggleReactionMutationVariables
>;
export const UnblockUserDocument = gql`
  mutation UnblockUser($communityId: Int!, $userId: Int!) {
    unblockUser(communityId: $communityId, userId: $userId)
  }
`;
export type UnblockUserMutationFn = Apollo.MutationFunction<
  UnblockUserMutation,
  UnblockUserMutationVariables
>;

/**
 * __useUnblockUserMutation__
 *
 * To run a mutation, you first call `useUnblockUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockUserMutation, { data, loading, error }] = useUnblockUserMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnblockUserMutation,
    UnblockUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnblockUserMutation, UnblockUserMutationVariables>(
    UnblockUserDocument,
    options,
  );
}
export type UnblockUserMutationHookResult = ReturnType<
  typeof useUnblockUserMutation
>;
export type UnblockUserMutationResult =
  Apollo.MutationResult<UnblockUserMutation>;
export type UnblockUserMutationOptions = Apollo.BaseMutationOptions<
  UnblockUserMutation,
  UnblockUserMutationVariables
>;
export const GetBlockedUsersDocument = gql`
  query GetBlockedUsers($communityId: Int!) {
    blockedUsers(communityId: $communityId) {
      id
      email
      name
      mediaThumbnail
    }
  }
`;

/**
 * __useGetBlockedUsersQuery__
 *
 * To run a query within a React component, call `useGetBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlockedUsersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetBlockedUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBlockedUsersQuery,
    GetBlockedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBlockedUsersQuery, GetBlockedUsersQueryVariables>(
    GetBlockedUsersDocument,
    options,
  );
}
export function useGetBlockedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBlockedUsersQuery,
    GetBlockedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBlockedUsersQuery,
    GetBlockedUsersQueryVariables
  >(GetBlockedUsersDocument, options);
}
export type GetBlockedUsersQueryHookResult = ReturnType<
  typeof useGetBlockedUsersQuery
>;
export type GetBlockedUsersLazyQueryHookResult = ReturnType<
  typeof useGetBlockedUsersLazyQuery
>;
export type GetBlockedUsersQueryResult = Apollo.QueryResult<
  GetBlockedUsersQuery,
  GetBlockedUsersQueryVariables
>;
export const GetCommunityDocument = gql`
  query GetCommunity($id: Int!, $direction: String, $lastId: String) {
    community(id: $id) {
      id
      name
      ownerId
      owner {
        id
        username
        badges
        profilePicture
      }
      createdAt
      updatedAt
      posts(direction: $direction, lastId: $lastId) {
        id
        text
        createdAt
        updatedAt
        pinned
        author {
          id
          username
          badges
          profilePicture
          email
          marketing
          hasDirectMessagesAccess
        }
        media {
          cdn01
          image
          video
          audio
          width
          height
          mimeType
        }
        reactions {
          type
          count
          isToggled
        }
        replies {
          id
          text
          createdAt
          updatedAt
          author {
            id
            username
            badges
            profilePicture
            email
            marketing
            hasDirectMessagesAccess
          }
          reactions {
            type
            count
            isToggled
          }
          isSensitiveContent
        }
        isSensitiveContent
      }
    }
  }
`;

/**
 * __useGetCommunityQuery__
 *
 * To run a query within a React component, call `useGetCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      direction: // value for 'direction'
 *      lastId: // value for 'lastId'
 *   },
 * });
 */
export function useGetCommunityQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityQuery,
    GetCommunityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCommunityQuery, GetCommunityQueryVariables>(
    GetCommunityDocument,
    options,
  );
}
export function useGetCommunityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityQuery,
    GetCommunityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCommunityQuery, GetCommunityQueryVariables>(
    GetCommunityDocument,
    options,
  );
}
export type GetCommunityQueryHookResult = ReturnType<
  typeof useGetCommunityQuery
>;
export type GetCommunityLazyQueryHookResult = ReturnType<
  typeof useGetCommunityLazyQuery
>;
export type GetCommunityQueryResult = Apollo.QueryResult<
  GetCommunityQuery,
  GetCommunityQueryVariables
>;
export const GetCommunityPostDocument = gql`
  query GetCommunityPost(
    $communityId: Int!
    $postId: String!
    $direction: String
    $lastId: String
  ) {
    post(communityId: $communityId, postId: $postId) {
      id
      text
      createdAt
      updatedAt
      edited
      pinned
      author {
        id
        username
        badges
        profilePicture
        email
        marketing
        hasDirectMessagesAccess
      }
      media {
        cdn01
        image
        video
        audio
        width
        height
        mimeType
      }
      reactions {
        type
        count
        isToggled
      }
      replies(direction: $direction, lastId: $lastId) {
        id
        text
        createdAt
        updatedAt
        edited
        author {
          id
          username
          badges
          profilePicture
          email
          marketing
          hasDirectMessagesAccess
        }
        media {
          cdn01
          image
          video
          audio
          width
          height
          mimeType
          status
          uuid
          videoUrl
          videoThumbnailUrl
          videoSourceType
        }
        reactions {
          type
          count
          isToggled
        }
        isSensitiveContent
      }
      isSensitiveContent
    }
  }
`;

/**
 * __useGetCommunityPostQuery__
 *
 * To run a query within a React component, call `useGetCommunityPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPostQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      direction: // value for 'direction'
 *      lastId: // value for 'lastId'
 *   },
 * });
 */
export function useGetCommunityPostQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityPostQuery,
    GetCommunityPostQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCommunityPostQuery, GetCommunityPostQueryVariables>(
    GetCommunityPostDocument,
    options,
  );
}
export function useGetCommunityPostLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityPostQuery,
    GetCommunityPostQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityPostQuery,
    GetCommunityPostQueryVariables
  >(GetCommunityPostDocument, options);
}
export type GetCommunityPostQueryHookResult = ReturnType<
  typeof useGetCommunityPostQuery
>;
export type GetCommunityPostLazyQueryHookResult = ReturnType<
  typeof useGetCommunityPostLazyQuery
>;
export type GetCommunityPostQueryResult = Apollo.QueryResult<
  GetCommunityPostQuery,
  GetCommunityPostQueryVariables
>;
export const GetPinnedPostsDocument = gql`
  query GetPinnedPosts($communityId: Int!) {
    community(id: $communityId) {
      id
      posts(type: pinned) {
        id
        text
        createdAt
        updatedAt
        pinned
        author {
          id
          username
          badges
          profilePicture
          email
          hasDirectMessagesAccess
        }
        media {
          cdn01
          image
          video
          audio
          width
          height
          mimeType
        }
        reactions {
          type
          count
          isToggled
        }
        replies {
          id
          text
          createdAt
          updatedAt
          author {
            id
            username
            badges
            profilePicture
            email
            hasDirectMessagesAccess
          }
          reactions {
            type
            count
            isToggled
          }
          isSensitiveContent
        }
        isSensitiveContent
      }
    }
  }
`;

/**
 * __useGetPinnedPostsQuery__
 *
 * To run a query within a React component, call `useGetPinnedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPinnedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPinnedPostsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetPinnedPostsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPinnedPostsQuery,
    GetPinnedPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPinnedPostsQuery, GetPinnedPostsQueryVariables>(
    GetPinnedPostsDocument,
    options,
  );
}
export function useGetPinnedPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPinnedPostsQuery,
    GetPinnedPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPinnedPostsQuery, GetPinnedPostsQueryVariables>(
    GetPinnedPostsDocument,
    options,
  );
}
export type GetPinnedPostsQueryHookResult = ReturnType<
  typeof useGetPinnedPostsQuery
>;
export type GetPinnedPostsLazyQueryHookResult = ReturnType<
  typeof useGetPinnedPostsLazyQuery
>;
export type GetPinnedPostsQueryResult = Apollo.QueryResult<
  GetPinnedPostsQuery,
  GetPinnedPostsQueryVariables
>;
export const GetReportedContentDocument = gql`
  query GetReportedContent($communityId: Int!) {
    reportedContent(communityId: $communityId) {
      id
      parentId
      activityId
      activityType
      createdAt
      reason
      reportedBy {
        id
        username
        profilePicture
      }
      text
      author {
        id
        username
        profilePicture
      }
      media {
        cdn01
        image
        video
        audio
        width
        height
        mimeType
      }
    }
  }
`;

/**
 * __useGetReportedContentQuery__
 *
 * To run a query within a React component, call `useGetReportedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportedContentQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetReportedContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportedContentQuery,
    GetReportedContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportedContentQuery,
    GetReportedContentQueryVariables
  >(GetReportedContentDocument, options);
}
export function useGetReportedContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportedContentQuery,
    GetReportedContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportedContentQuery,
    GetReportedContentQueryVariables
  >(GetReportedContentDocument, options);
}
export type GetReportedContentQueryHookResult = ReturnType<
  typeof useGetReportedContentQuery
>;
export type GetReportedContentLazyQueryHookResult = ReturnType<
  typeof useGetReportedContentLazyQuery
>;
export type GetReportedContentQueryResult = Apollo.QueryResult<
  GetReportedContentQuery,
  GetReportedContentQueryVariables
>;
export const GetReportedContentCountDocument = gql`
  query GetReportedContentCount($communityId: Int!) {
    reportedContentCount(communityId: $communityId)
  }
`;

/**
 * __useGetReportedContentCountQuery__
 *
 * To run a query within a React component, call `useGetReportedContentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportedContentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportedContentCountQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetReportedContentCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetReportedContentCountQuery,
    GetReportedContentCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetReportedContentCountQuery,
    GetReportedContentCountQueryVariables
  >(GetReportedContentCountDocument, options);
}
export function useGetReportedContentCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReportedContentCountQuery,
    GetReportedContentCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetReportedContentCountQuery,
    GetReportedContentCountQueryVariables
  >(GetReportedContentCountDocument, options);
}
export type GetReportedContentCountQueryHookResult = ReturnType<
  typeof useGetReportedContentCountQuery
>;
export type GetReportedContentCountLazyQueryHookResult = ReturnType<
  typeof useGetReportedContentCountLazyQuery
>;
export type GetReportedContentCountQueryResult = Apollo.QueryResult<
  GetReportedContentCountQuery,
  GetReportedContentCountQueryVariables
>;
export const AddCommunityReplyDocument = gql`
  mutation AddCommunityReply(
    $communityId: Int!
    $postId: String!
    $text: String!
    $parentReplyId: String
    $media: [MediaInput!]
  ) {
    addReply(
      communityId: $communityId
      postId: $postId
      text: $text
      parentReplyId: $parentReplyId
      media: $media
    ) {
      id
      text
      createdAt
      updatedAt
      parentId
      media {
        cdn01
        image
        video
        audio
        width
        height
        mimeType
        status
        uuid
        videoUrl
        videoThumbnailUrl
        videoSourceType
      }
      author {
        id
        username
        badges
        profilePicture
      }
    }
  }
`;
export type AddCommunityReplyMutationFn = Apollo.MutationFunction<
  AddCommunityReplyMutation,
  AddCommunityReplyMutationVariables
>;

/**
 * __useAddCommunityReplyMutation__
 *
 * To run a mutation, you first call `useAddCommunityReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommunityReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommunityReplyMutation, { data, loading, error }] = useAddCommunityReplyMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      text: // value for 'text'
 *      parentReplyId: // value for 'parentReplyId'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useAddCommunityReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCommunityReplyMutation,
    AddCommunityReplyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCommunityReplyMutation,
    AddCommunityReplyMutationVariables
  >(AddCommunityReplyDocument, options);
}
export type AddCommunityReplyMutationHookResult = ReturnType<
  typeof useAddCommunityReplyMutation
>;
export type AddCommunityReplyMutationResult =
  Apollo.MutationResult<AddCommunityReplyMutation>;
export type AddCommunityReplyMutationOptions = Apollo.BaseMutationOptions<
  AddCommunityReplyMutation,
  AddCommunityReplyMutationVariables
>;
export const BlockCommunityUserDocument = gql`
  mutation BlockCommunityUser($communityId: Int!, $userId: Int!) {
    blockUser(communityId: $communityId, userId: $userId)
  }
`;
export type BlockCommunityUserMutationFn = Apollo.MutationFunction<
  BlockCommunityUserMutation,
  BlockCommunityUserMutationVariables
>;

/**
 * __useBlockCommunityUserMutation__
 *
 * To run a mutation, you first call `useBlockCommunityUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBlockCommunityUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [blockCommunityUserMutation, { data, loading, error }] = useBlockCommunityUserMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBlockCommunityUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BlockCommunityUserMutation,
    BlockCommunityUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BlockCommunityUserMutation,
    BlockCommunityUserMutationVariables
  >(BlockCommunityUserDocument, options);
}
export type BlockCommunityUserMutationHookResult = ReturnType<
  typeof useBlockCommunityUserMutation
>;
export type BlockCommunityUserMutationResult =
  Apollo.MutationResult<BlockCommunityUserMutation>;
export type BlockCommunityUserMutationOptions = Apollo.BaseMutationOptions<
  BlockCommunityUserMutation,
  BlockCommunityUserMutationVariables
>;
export const CommunitiesV2AddPostDocument = gql`
  mutation CommunitiesV2AddPost(
    $communityId: Int!
    $media: [MediaInput!]
    $text: String!
    $publishAt: DateTime
  ) {
    addPost(
      communityId: $communityId
      media: $media
      text: $text
      publishAt: $publishAt
    ) {
      ...CommunityFeedPost
      author {
        email
        marketing
      }
    }
  }
  ${CommunityFeedPostFragmentDoc}
`;
export type CommunitiesV2AddPostMutationFn = Apollo.MutationFunction<
  CommunitiesV2AddPostMutation,
  CommunitiesV2AddPostMutationVariables
>;

/**
 * __useCommunitiesV2AddPostMutation__
 *
 * To run a mutation, you first call `useCommunitiesV2AddPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesV2AddPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [communitiesV2AddPostMutation, { data, loading, error }] = useCommunitiesV2AddPostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      media: // value for 'media'
 *      text: // value for 'text'
 *      publishAt: // value for 'publishAt'
 *   },
 * });
 */
export function useCommunitiesV2AddPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CommunitiesV2AddPostMutation,
    CommunitiesV2AddPostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CommunitiesV2AddPostMutation,
    CommunitiesV2AddPostMutationVariables
  >(CommunitiesV2AddPostDocument, options);
}
export type CommunitiesV2AddPostMutationHookResult = ReturnType<
  typeof useCommunitiesV2AddPostMutation
>;
export type CommunitiesV2AddPostMutationResult =
  Apollo.MutationResult<CommunitiesV2AddPostMutation>;
export type CommunitiesV2AddPostMutationOptions = Apollo.BaseMutationOptions<
  CommunitiesV2AddPostMutation,
  CommunitiesV2AddPostMutationVariables
>;
export const DeleteCommunityPostDocument = gql`
  mutation DeleteCommunityPost($communityId: Int!, $postId: String!) {
    deletePost(communityId: $communityId, postId: $postId) {
      id
    }
  }
`;
export type DeleteCommunityPostMutationFn = Apollo.MutationFunction<
  DeleteCommunityPostMutation,
  DeleteCommunityPostMutationVariables
>;

/**
 * __useDeleteCommunityPostMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityPostMutation, { data, loading, error }] = useDeleteCommunityPostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function useDeleteCommunityPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCommunityPostMutation,
    DeleteCommunityPostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCommunityPostMutation,
    DeleteCommunityPostMutationVariables
  >(DeleteCommunityPostDocument, options);
}
export type DeleteCommunityPostMutationHookResult = ReturnType<
  typeof useDeleteCommunityPostMutation
>;
export type DeleteCommunityPostMutationResult =
  Apollo.MutationResult<DeleteCommunityPostMutation>;
export type DeleteCommunityPostMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommunityPostMutation,
  DeleteCommunityPostMutationVariables
>;
export const DeleteCommunityReplyDocument = gql`
  mutation DeleteCommunityReply($communityId: Int!, $replyId: String!) {
    deleteReply(communityId: $communityId, postId: $replyId) {
      id
    }
  }
`;
export type DeleteCommunityReplyMutationFn = Apollo.MutationFunction<
  DeleteCommunityReplyMutation,
  DeleteCommunityReplyMutationVariables
>;

/**
 * __useDeleteCommunityReplyMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityReplyMutation, { data, loading, error }] = useDeleteCommunityReplyMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      replyId: // value for 'replyId'
 *   },
 * });
 */
export function useDeleteCommunityReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteCommunityReplyMutation,
    DeleteCommunityReplyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteCommunityReplyMutation,
    DeleteCommunityReplyMutationVariables
  >(DeleteCommunityReplyDocument, options);
}
export type DeleteCommunityReplyMutationHookResult = ReturnType<
  typeof useDeleteCommunityReplyMutation
>;
export type DeleteCommunityReplyMutationResult =
  Apollo.MutationResult<DeleteCommunityReplyMutation>;
export type DeleteCommunityReplyMutationOptions = Apollo.BaseMutationOptions<
  DeleteCommunityReplyMutation,
  DeleteCommunityReplyMutationVariables
>;
export const GetCommunityBlockedUserIdsDocument = gql`
  query GetCommunityBlockedUserIds($communityId: Int!) {
    blockedUsers(communityId: $communityId) {
      id
    }
  }
`;

/**
 * __useGetCommunityBlockedUserIdsQuery__
 *
 * To run a query within a React component, call `useGetCommunityBlockedUserIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityBlockedUserIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityBlockedUserIdsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityBlockedUserIdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityBlockedUserIdsQuery,
    GetCommunityBlockedUserIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommunityBlockedUserIdsQuery,
    GetCommunityBlockedUserIdsQueryVariables
  >(GetCommunityBlockedUserIdsDocument, options);
}
export function useGetCommunityBlockedUserIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityBlockedUserIdsQuery,
    GetCommunityBlockedUserIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityBlockedUserIdsQuery,
    GetCommunityBlockedUserIdsQueryVariables
  >(GetCommunityBlockedUserIdsDocument, options);
}
export type GetCommunityBlockedUserIdsQueryHookResult = ReturnType<
  typeof useGetCommunityBlockedUserIdsQuery
>;
export type GetCommunityBlockedUserIdsLazyQueryHookResult = ReturnType<
  typeof useGetCommunityBlockedUserIdsLazyQuery
>;
export type GetCommunityBlockedUserIdsQueryResult = Apollo.QueryResult<
  GetCommunityBlockedUserIdsQuery,
  GetCommunityBlockedUserIdsQueryVariables
>;
export const GetCommunityBlockedUsersDocument = gql`
  query GetCommunityBlockedUsers($communityId: Int!) {
    blockedUsers(communityId: $communityId) {
      id
      name
      mediaThumbnail
      blockedAt
      itemsRemovedCount
    }
  }
`;

/**
 * __useGetCommunityBlockedUsersQuery__
 *
 * To run a query within a React component, call `useGetCommunityBlockedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityBlockedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityBlockedUsersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityBlockedUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityBlockedUsersQuery,
    GetCommunityBlockedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommunityBlockedUsersQuery,
    GetCommunityBlockedUsersQueryVariables
  >(GetCommunityBlockedUsersDocument, options);
}
export function useGetCommunityBlockedUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityBlockedUsersQuery,
    GetCommunityBlockedUsersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityBlockedUsersQuery,
    GetCommunityBlockedUsersQueryVariables
  >(GetCommunityBlockedUsersDocument, options);
}
export type GetCommunityBlockedUsersQueryHookResult = ReturnType<
  typeof useGetCommunityBlockedUsersQuery
>;
export type GetCommunityBlockedUsersLazyQueryHookResult = ReturnType<
  typeof useGetCommunityBlockedUsersLazyQuery
>;
export type GetCommunityBlockedUsersQueryResult = Apollo.QueryResult<
  GetCommunityBlockedUsersQuery,
  GetCommunityBlockedUsersQueryVariables
>;
export const GetCommunityDmStatusDocument = gql`
  query GetCommunityDmStatus($id: Int!) {
    creator(id: $id) {
      features {
        code
      }
    }
  }
`;

/**
 * __useGetCommunityDmStatusQuery__
 *
 * To run a query within a React component, call `useGetCommunityDmStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityDmStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityDmStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCommunityDmStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityDmStatusQuery,
    GetCommunityDmStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommunityDmStatusQuery,
    GetCommunityDmStatusQueryVariables
  >(GetCommunityDmStatusDocument, options);
}
export function useGetCommunityDmStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityDmStatusQuery,
    GetCommunityDmStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityDmStatusQuery,
    GetCommunityDmStatusQueryVariables
  >(GetCommunityDmStatusDocument, options);
}
export type GetCommunityDmStatusQueryHookResult = ReturnType<
  typeof useGetCommunityDmStatusQuery
>;
export type GetCommunityDmStatusLazyQueryHookResult = ReturnType<
  typeof useGetCommunityDmStatusLazyQuery
>;
export type GetCommunityDmStatusQueryResult = Apollo.QueryResult<
  GetCommunityDmStatusQuery,
  GetCommunityDmStatusQueryVariables
>;
export const GetCommunityPinnedPostsDocument = gql`
  query GetCommunityPinnedPosts($id: Int!, $canModerate: Boolean!) {
    communityPinnedPosts: community(id: $id) {
      id
      posts(type: pinned) {
        ...CommunityFeedPost
        author {
          email @include(if: $canModerate)
          marketing @include(if: $canModerate)
        }
      }
    }
  }
  ${CommunityFeedPostFragmentDoc}
`;

/**
 * __useGetCommunityPinnedPostsQuery__
 *
 * To run a query within a React component, call `useGetCommunityPinnedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPinnedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPinnedPostsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      canModerate: // value for 'canModerate'
 *   },
 * });
 */
export function useGetCommunityPinnedPostsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityPinnedPostsQuery,
    GetCommunityPinnedPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommunityPinnedPostsQuery,
    GetCommunityPinnedPostsQueryVariables
  >(GetCommunityPinnedPostsDocument, options);
}
export function useGetCommunityPinnedPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityPinnedPostsQuery,
    GetCommunityPinnedPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityPinnedPostsQuery,
    GetCommunityPinnedPostsQueryVariables
  >(GetCommunityPinnedPostsDocument, options);
}
export type GetCommunityPinnedPostsQueryHookResult = ReturnType<
  typeof useGetCommunityPinnedPostsQuery
>;
export type GetCommunityPinnedPostsLazyQueryHookResult = ReturnType<
  typeof useGetCommunityPinnedPostsLazyQuery
>;
export type GetCommunityPinnedPostsQueryResult = Apollo.QueryResult<
  GetCommunityPinnedPostsQuery,
  GetCommunityPinnedPostsQueryVariables
>;
export const GetCommunityPostRepliesDocument = gql`
  query GetCommunityPostReplies(
    $communityId: Int!
    $postId: String!
    $canModerate: Boolean!
    $direction: String
    $lastId: String
  ) {
    post(communityId: $communityId, postId: $postId) {
      id
      replies(direction: $direction, lastId: $lastId) {
        ...CommunityReply
      }
    }
  }
  ${CommunityReplyFragmentDoc}
`;

/**
 * __useGetCommunityPostRepliesQuery__
 *
 * To run a query within a React component, call `useGetCommunityPostRepliesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPostRepliesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPostRepliesQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      canModerate: // value for 'canModerate'
 *      direction: // value for 'direction'
 *      lastId: // value for 'lastId'
 *   },
 * });
 */
export function useGetCommunityPostRepliesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityPostRepliesQuery,
    GetCommunityPostRepliesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommunityPostRepliesQuery,
    GetCommunityPostRepliesQueryVariables
  >(GetCommunityPostRepliesDocument, options);
}
export function useGetCommunityPostRepliesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityPostRepliesQuery,
    GetCommunityPostRepliesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityPostRepliesQuery,
    GetCommunityPostRepliesQueryVariables
  >(GetCommunityPostRepliesDocument, options);
}
export type GetCommunityPostRepliesQueryHookResult = ReturnType<
  typeof useGetCommunityPostRepliesQuery
>;
export type GetCommunityPostRepliesLazyQueryHookResult = ReturnType<
  typeof useGetCommunityPostRepliesLazyQuery
>;
export type GetCommunityPostRepliesQueryResult = Apollo.QueryResult<
  GetCommunityPostRepliesQuery,
  GetCommunityPostRepliesQueryVariables
>;
export const GetCommunityPostsDocument = gql`
  query GetCommunityPosts(
    $id: Int!
    $direction: String
    $lastId: String
    $canModerate: Boolean!
    $filters: CommunityFeedFilters
  ) {
    communityPosts: community(id: $id) {
      id
      posts(direction: $direction, lastId: $lastId, filters: $filters) {
        ...CommunityFeedPost
        author {
          email @include(if: $canModerate)
          marketing @include(if: $canModerate)
        }
      }
    }
  }
  ${CommunityFeedPostFragmentDoc}
`;

/**
 * __useGetCommunityPostsQuery__
 *
 * To run a query within a React component, call `useGetCommunityPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityPostsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      direction: // value for 'direction'
 *      lastId: // value for 'lastId'
 *      canModerate: // value for 'canModerate'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCommunityPostsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityPostsQuery,
    GetCommunityPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommunityPostsQuery,
    GetCommunityPostsQueryVariables
  >(GetCommunityPostsDocument, options);
}
export function useGetCommunityPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityPostsQuery,
    GetCommunityPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityPostsQuery,
    GetCommunityPostsQueryVariables
  >(GetCommunityPostsDocument, options);
}
export type GetCommunityPostsQueryHookResult = ReturnType<
  typeof useGetCommunityPostsQuery
>;
export type GetCommunityPostsLazyQueryHookResult = ReturnType<
  typeof useGetCommunityPostsLazyQuery
>;
export type GetCommunityPostsQueryResult = Apollo.QueryResult<
  GetCommunityPostsQuery,
  GetCommunityPostsQueryVariables
>;
export const GetCommunityReportedContentDocument = gql`
  query GetCommunityReportedContent($communityId: Int!) {
    reportedContent(communityId: $communityId) {
      id
      activityId
      activityType
      parentId
      createdAt
      reason
      text
      author {
        id
        username
        profilePicture
      }
      media {
        cdn01
        image
        video
        audio
        width
        height
        mimeType
      }
    }
  }
`;

/**
 * __useGetCommunityReportedContentQuery__
 *
 * To run a query within a React component, call `useGetCommunityReportedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommunityReportedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommunityReportedContentQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGetCommunityReportedContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommunityReportedContentQuery,
    GetCommunityReportedContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCommunityReportedContentQuery,
    GetCommunityReportedContentQueryVariables
  >(GetCommunityReportedContentDocument, options);
}
export function useGetCommunityReportedContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommunityReportedContentQuery,
    GetCommunityReportedContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCommunityReportedContentQuery,
    GetCommunityReportedContentQueryVariables
  >(GetCommunityReportedContentDocument, options);
}
export type GetCommunityReportedContentQueryHookResult = ReturnType<
  typeof useGetCommunityReportedContentQuery
>;
export type GetCommunityReportedContentLazyQueryHookResult = ReturnType<
  typeof useGetCommunityReportedContentLazyQuery
>;
export type GetCommunityReportedContentQueryResult = Apollo.QueryResult<
  GetCommunityReportedContentQuery,
  GetCommunityReportedContentQueryVariables
>;
export const GetCreatorCommunitiesDocument = gql`
  query GetCreatorCommunities($id: Int!) {
    creator(id: $id) {
      id
      name
      mediaAvatar {
        cdn01
        image
      }
      communities {
        id
        name
        description
        thumbnail
        membersCount
        reportedPostsCount
        blockedUsersCount
      }
    }
  }
`;

/**
 * __useGetCreatorCommunitiesQuery__
 *
 * To run a query within a React component, call `useGetCreatorCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorCommunitiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCreatorCommunitiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreatorCommunitiesQuery,
    GetCreatorCommunitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCreatorCommunitiesQuery,
    GetCreatorCommunitiesQueryVariables
  >(GetCreatorCommunitiesDocument, options);
}
export function useGetCreatorCommunitiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreatorCommunitiesQuery,
    GetCreatorCommunitiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCreatorCommunitiesQuery,
    GetCreatorCommunitiesQueryVariables
  >(GetCreatorCommunitiesDocument, options);
}
export type GetCreatorCommunitiesQueryHookResult = ReturnType<
  typeof useGetCreatorCommunitiesQuery
>;
export type GetCreatorCommunitiesLazyQueryHookResult = ReturnType<
  typeof useGetCreatorCommunitiesLazyQuery
>;
export type GetCreatorCommunitiesQueryResult = Apollo.QueryResult<
  GetCreatorCommunitiesQuery,
  GetCreatorCommunitiesQueryVariables
>;
export const KeepCommunityContentDocument = gql`
  mutation KeepCommunityContent($contentId: Int!) {
    keepContent(contentId: $contentId)
  }
`;
export type KeepCommunityContentMutationFn = Apollo.MutationFunction<
  KeepCommunityContentMutation,
  KeepCommunityContentMutationVariables
>;

/**
 * __useKeepCommunityContentMutation__
 *
 * To run a mutation, you first call `useKeepCommunityContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeepCommunityContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keepCommunityContentMutation, { data, loading, error }] = useKeepCommunityContentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useKeepCommunityContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    KeepCommunityContentMutation,
    KeepCommunityContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    KeepCommunityContentMutation,
    KeepCommunityContentMutationVariables
  >(KeepCommunityContentDocument, options);
}
export type KeepCommunityContentMutationHookResult = ReturnType<
  typeof useKeepCommunityContentMutation
>;
export type KeepCommunityContentMutationResult =
  Apollo.MutationResult<KeepCommunityContentMutation>;
export type KeepCommunityContentMutationOptions = Apollo.BaseMutationOptions<
  KeepCommunityContentMutation,
  KeepCommunityContentMutationVariables
>;
export const PublishCommunityPostDocument = gql`
  mutation PublishCommunityPost(
    $communityId: Int!
    $postId: String!
    $publishAt: DateTime
  ) {
    publishPost(
      communityId: $communityId
      postId: $postId
      publishAt: $publishAt
    ) {
      ...CommunityFeedPost
      author {
        email
        marketing
      }
    }
  }
  ${CommunityFeedPostFragmentDoc}
`;
export type PublishCommunityPostMutationFn = Apollo.MutationFunction<
  PublishCommunityPostMutation,
  PublishCommunityPostMutationVariables
>;

/**
 * __usePublishCommunityPostMutation__
 *
 * To run a mutation, you first call `usePublishCommunityPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCommunityPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCommunityPostMutation, { data, loading, error }] = usePublishCommunityPostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      publishAt: // value for 'publishAt'
 *   },
 * });
 */
export function usePublishCommunityPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishCommunityPostMutation,
    PublishCommunityPostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishCommunityPostMutation,
    PublishCommunityPostMutationVariables
  >(PublishCommunityPostDocument, options);
}
export type PublishCommunityPostMutationHookResult = ReturnType<
  typeof usePublishCommunityPostMutation
>;
export type PublishCommunityPostMutationResult =
  Apollo.MutationResult<PublishCommunityPostMutation>;
export type PublishCommunityPostMutationOptions = Apollo.BaseMutationOptions<
  PublishCommunityPostMutation,
  PublishCommunityPostMutationVariables
>;
export const TogglePinCommunityPostDocument = gql`
  mutation TogglePinCommunityPost(
    $communityId: Int!
    $postId: String!
    $pinned: Boolean!
  ) {
    togglePinPost(communityId: $communityId, postId: $postId, pinned: $pinned)
  }
`;
export type TogglePinCommunityPostMutationFn = Apollo.MutationFunction<
  TogglePinCommunityPostMutation,
  TogglePinCommunityPostMutationVariables
>;

/**
 * __useTogglePinCommunityPostMutation__
 *
 * To run a mutation, you first call `useTogglePinCommunityPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTogglePinCommunityPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [togglePinCommunityPostMutation, { data, loading, error }] = useTogglePinCommunityPostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function useTogglePinCommunityPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    TogglePinCommunityPostMutation,
    TogglePinCommunityPostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    TogglePinCommunityPostMutation,
    TogglePinCommunityPostMutationVariables
  >(TogglePinCommunityPostDocument, options);
}
export type TogglePinCommunityPostMutationHookResult = ReturnType<
  typeof useTogglePinCommunityPostMutation
>;
export type TogglePinCommunityPostMutationResult =
  Apollo.MutationResult<TogglePinCommunityPostMutation>;
export type TogglePinCommunityPostMutationOptions = Apollo.BaseMutationOptions<
  TogglePinCommunityPostMutation,
  TogglePinCommunityPostMutationVariables
>;
export const UnblockCommunityUserDocument = gql`
  mutation UnblockCommunityUser($communityId: Int!, $userId: Int!) {
    unblockUser(communityId: $communityId, userId: $userId)
  }
`;
export type UnblockCommunityUserMutationFn = Apollo.MutationFunction<
  UnblockCommunityUserMutation,
  UnblockCommunityUserMutationVariables
>;

/**
 * __useUnblockCommunityUserMutation__
 *
 * To run a mutation, you first call `useUnblockCommunityUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnblockCommunityUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unblockCommunityUserMutation, { data, loading, error }] = useUnblockCommunityUserMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnblockCommunityUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnblockCommunityUserMutation,
    UnblockCommunityUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnblockCommunityUserMutation,
    UnblockCommunityUserMutationVariables
  >(UnblockCommunityUserDocument, options);
}
export type UnblockCommunityUserMutationHookResult = ReturnType<
  typeof useUnblockCommunityUserMutation
>;
export type UnblockCommunityUserMutationResult =
  Apollo.MutationResult<UnblockCommunityUserMutation>;
export type UnblockCommunityUserMutationOptions = Apollo.BaseMutationOptions<
  UnblockCommunityUserMutation,
  UnblockCommunityUserMutationVariables
>;
export const UpdateCommunityDraftDocument = gql`
  mutation UpdateCommunityDraft(
    $communityId: Int!
    $postId: String!
    $text: String!
    $media: [MediaInput!]
  ) {
    updatePost(
      communityId: $communityId
      postId: $postId
      text: $text
      media: $media
    ) {
      ...CommunityFeedPost
      author {
        email
        marketing
      }
    }
  }
  ${CommunityFeedPostFragmentDoc}
`;
export type UpdateCommunityDraftMutationFn = Apollo.MutationFunction<
  UpdateCommunityDraftMutation,
  UpdateCommunityDraftMutationVariables
>;

/**
 * __useUpdateCommunityDraftMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityDraftMutation, { data, loading, error }] = useUpdateCommunityDraftMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      text: // value for 'text'
 *      media: // value for 'media'
 *   },
 * });
 */
export function useUpdateCommunityDraftMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCommunityDraftMutation,
    UpdateCommunityDraftMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCommunityDraftMutation,
    UpdateCommunityDraftMutationVariables
  >(UpdateCommunityDraftDocument, options);
}
export type UpdateCommunityDraftMutationHookResult = ReturnType<
  typeof useUpdateCommunityDraftMutation
>;
export type UpdateCommunityDraftMutationResult =
  Apollo.MutationResult<UpdateCommunityDraftMutation>;
export type UpdateCommunityDraftMutationOptions = Apollo.BaseMutationOptions<
  UpdateCommunityDraftMutation,
  UpdateCommunityDraftMutationVariables
>;
export const UpdateCommunityPostDocument = gql`
  mutation UpdateCommunityPost(
    $communityId: Int!
    $postId: String!
    $text: String!
  ) {
    updatePost(communityId: $communityId, postId: $postId, text: $text) {
      id
      text
      edited
    }
  }
`;
export type UpdateCommunityPostMutationFn = Apollo.MutationFunction<
  UpdateCommunityPostMutation,
  UpdateCommunityPostMutationVariables
>;

/**
 * __useUpdateCommunityPostMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityPostMutation, { data, loading, error }] = useUpdateCommunityPostMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      postId: // value for 'postId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCommunityPostMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCommunityPostMutation,
    UpdateCommunityPostMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCommunityPostMutation,
    UpdateCommunityPostMutationVariables
  >(UpdateCommunityPostDocument, options);
}
export type UpdateCommunityPostMutationHookResult = ReturnType<
  typeof useUpdateCommunityPostMutation
>;
export type UpdateCommunityPostMutationResult =
  Apollo.MutationResult<UpdateCommunityPostMutation>;
export type UpdateCommunityPostMutationOptions = Apollo.BaseMutationOptions<
  UpdateCommunityPostMutation,
  UpdateCommunityPostMutationVariables
>;
export const UpdateCommunityReplyDocument = gql`
  mutation UpdateCommunityReply(
    $communityId: Int!
    $replyId: String!
    $text: String!
  ) {
    updateReply(communityId: $communityId, replyId: $replyId, text: $text) {
      id
      text
      edited
    }
  }
`;
export type UpdateCommunityReplyMutationFn = Apollo.MutationFunction<
  UpdateCommunityReplyMutation,
  UpdateCommunityReplyMutationVariables
>;

/**
 * __useUpdateCommunityReplyMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityReplyMutation, { data, loading, error }] = useUpdateCommunityReplyMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      replyId: // value for 'replyId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCommunityReplyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCommunityReplyMutation,
    UpdateCommunityReplyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCommunityReplyMutation,
    UpdateCommunityReplyMutationVariables
  >(UpdateCommunityReplyDocument, options);
}
export type UpdateCommunityReplyMutationHookResult = ReturnType<
  typeof useUpdateCommunityReplyMutation
>;
export type UpdateCommunityReplyMutationResult =
  Apollo.MutationResult<UpdateCommunityReplyMutation>;
export type UpdateCommunityReplyMutationOptions = Apollo.BaseMutationOptions<
  UpdateCommunityReplyMutation,
  UpdateCommunityReplyMutationVariables
>;
export const UserChallengeParticipationDocument = gql`
  query UserChallengeParticipation($userId: Int!, $creatorId: Int!) {
    userChallengeParticipation(userId: $userId, creatorId: $creatorId) {
      active {
        id
        name
      }
      inactive {
        id
        name
      }
    }
  }
`;

/**
 * __useUserChallengeParticipationQuery__
 *
 * To run a query within a React component, call `useUserChallengeParticipationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserChallengeParticipationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserChallengeParticipationQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useUserChallengeParticipationQuery(
  baseOptions: Apollo.QueryHookOptions<
    UserChallengeParticipationQuery,
    UserChallengeParticipationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UserChallengeParticipationQuery,
    UserChallengeParticipationQueryVariables
  >(UserChallengeParticipationDocument, options);
}
export function useUserChallengeParticipationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserChallengeParticipationQuery,
    UserChallengeParticipationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserChallengeParticipationQuery,
    UserChallengeParticipationQueryVariables
  >(UserChallengeParticipationDocument, options);
}
export type UserChallengeParticipationQueryHookResult = ReturnType<
  typeof useUserChallengeParticipationQuery
>;
export type UserChallengeParticipationLazyQueryHookResult = ReturnType<
  typeof useUserChallengeParticipationLazyQuery
>;
export type UserChallengeParticipationQueryResult = Apollo.QueryResult<
  UserChallengeParticipationQuery,
  UserChallengeParticipationQueryVariables
>;
export const CollectionSwapConfigDocument = gql`
  query CollectionSwapConfig($collectionId: Int!) {
    collection(collectionId: $collectionId) {
      id
      swapConfig {
        swapsEnabled
      }
    }
  }
`;

/**
 * __useCollectionSwapConfigQuery__
 *
 * To run a query within a React component, call `useCollectionSwapConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionSwapConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionSwapConfigQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useCollectionSwapConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    CollectionSwapConfigQuery,
    CollectionSwapConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CollectionSwapConfigQuery,
    CollectionSwapConfigQueryVariables
  >(CollectionSwapConfigDocument, options);
}
export function useCollectionSwapConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CollectionSwapConfigQuery,
    CollectionSwapConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CollectionSwapConfigQuery,
    CollectionSwapConfigQueryVariables
  >(CollectionSwapConfigDocument, options);
}
export type CollectionSwapConfigQueryHookResult = ReturnType<
  typeof useCollectionSwapConfigQuery
>;
export type CollectionSwapConfigLazyQueryHookResult = ReturnType<
  typeof useCollectionSwapConfigLazyQuery
>;
export type CollectionSwapConfigQueryResult = Apollo.QueryResult<
  CollectionSwapConfigQuery,
  CollectionSwapConfigQueryVariables
>;
export const SwapCatalogExercisesDocument = gql`
  query swapCatalogExercises($q: String, $influencerId: Int) {
    swapCatalogExercises(q: $q, influencerId: $influencerId) {
      name
      exercise {
        name
        description
        media {
          ...media
        }
      }
    }
  }
  ${MediaFragmentDoc}
`;

/**
 * __useSwapCatalogExercisesQuery__
 *
 * To run a query within a React component, call `useSwapCatalogExercisesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwapCatalogExercisesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwapCatalogExercisesQuery({
 *   variables: {
 *      q: // value for 'q'
 *      influencerId: // value for 'influencerId'
 *   },
 * });
 */
export function useSwapCatalogExercisesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    SwapCatalogExercisesQuery,
    SwapCatalogExercisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SwapCatalogExercisesQuery,
    SwapCatalogExercisesQueryVariables
  >(SwapCatalogExercisesDocument, options);
}
export function useSwapCatalogExercisesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SwapCatalogExercisesQuery,
    SwapCatalogExercisesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SwapCatalogExercisesQuery,
    SwapCatalogExercisesQueryVariables
  >(SwapCatalogExercisesDocument, options);
}
export type SwapCatalogExercisesQueryHookResult = ReturnType<
  typeof useSwapCatalogExercisesQuery
>;
export type SwapCatalogExercisesLazyQueryHookResult = ReturnType<
  typeof useSwapCatalogExercisesLazyQuery
>;
export type SwapCatalogExercisesQueryResult = Apollo.QueryResult<
  SwapCatalogExercisesQuery,
  SwapCatalogExercisesQueryVariables
>;
export const LandingPageConfigDocument = gql`
  query LandingPageConfig(
    $influencerId: Int!
    $creatorId: ID!
    $forActiveBundle: Boolean
  ) {
    landingPageConfig(influencerId: $influencerId) {
      id
      influencerId
      config
    }
    creator(id: $influencerId) {
      id
      firstName
      lastName
      customURL
      businessModel
      bio
      messageProfile
      mediaAvatar {
        cdn01
        image
      }
      mediaWelcome {
        cdn01
        video
      }
      mediaCover {
        cdn01
        image
      }
      customDomains {
        id
        domain
        status
      }
      customColorSchema {
        id
        primaryColor
        secondaryColor
      }
      publishedPrograms(forActiveBundle: $forActiveBundle) {
        id
        name
        accessType
        mediaCover {
          cdn01
          image
        }
      }
    }
    bundle(creatorId: $influencerId) {
      id
      title
      influencerId
      status
      landingPageUrl
      items {
        contentId
        itemId
        itemType
      }
      oneTimeProduct {
        price
      }
      checkoutPage {
        url
      }
      subscriptionTier {
        id
        prices {
          billingCycleInterval
          billingCycleIntervalUnit
          price
        }
      }
      pricing
      isPlatformBundle
      coverImage {
        cdn01
        image
      }
    }
    feature {
      id
      name
      code
    }
    content(creatorId: $creatorId) {
      contentItems {
        type
        value {
          ... on ContentLinkValue {
            id
            title
          }
          ... on ContentPDFValue {
            id
            title
          }
          ... on ContentSlidesValue {
            id
            title
          }
          ... on ContentLegacyGuideValue {
            id
            title
          }
          ... on ContentVideoValue {
            id
            title
          }
        }
      }
    }
  }
`;

/**
 * __useLandingPageConfigQuery__
 *
 * To run a query within a React component, call `useLandingPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingPageConfigQuery({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *      creatorId: // value for 'creatorId'
 *      forActiveBundle: // value for 'forActiveBundle'
 *   },
 * });
 */
export function useLandingPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    LandingPageConfigQuery,
    LandingPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    LandingPageConfigQuery,
    LandingPageConfigQueryVariables
  >(LandingPageConfigDocument, options);
}
export function useLandingPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    LandingPageConfigQuery,
    LandingPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    LandingPageConfigQuery,
    LandingPageConfigQueryVariables
  >(LandingPageConfigDocument, options);
}
export type LandingPageConfigQueryHookResult = ReturnType<
  typeof useLandingPageConfigQuery
>;
export type LandingPageConfigLazyQueryHookResult = ReturnType<
  typeof useLandingPageConfigLazyQuery
>;
export type LandingPageConfigQueryResult = Apollo.QueryResult<
  LandingPageConfigQuery,
  LandingPageConfigQueryVariables
>;
export const GetOtpProductsDocument = gql`
  query GetOtpProducts($creatorId: Int!) {
    creator(id: $creatorId) {
      customURL
    }
    collections(
      input: {
        filters: {
          influencerId: $creatorId
          accessTypes: [Exclusive, PremiumExclusive]
        }
      }
    ) {
      id
      name
      type
      accessType
    }
    bundle(creatorId: $creatorId, bundlePricing: [OTP]) {
      id
      title
      status
      description
      landingPageUrl
    }
  }
`;

/**
 * __useGetOtpProductsQuery__
 *
 * To run a query within a React component, call `useGetOtpProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtpProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtpProductsQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetOtpProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOtpProductsQuery,
    GetOtpProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOtpProductsQuery, GetOtpProductsQueryVariables>(
    GetOtpProductsDocument,
    options,
  );
}
export function useGetOtpProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOtpProductsQuery,
    GetOtpProductsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOtpProductsQuery, GetOtpProductsQueryVariables>(
    GetOtpProductsDocument,
    options,
  );
}
export type GetOtpProductsQueryHookResult = ReturnType<
  typeof useGetOtpProductsQuery
>;
export type GetOtpProductsLazyQueryHookResult = ReturnType<
  typeof useGetOtpProductsLazyQuery
>;
export type GetOtpProductsQueryResult = Apollo.QueryResult<
  GetOtpProductsQuery,
  GetOtpProductsQueryVariables
>;
export const GrantFreeExclusiveSubscriptionToCreatorDocument = gql`
  mutation GrantFreeExclusiveSubscriptionToCreator($creatorId: Int!) {
    grantFreeExclusiveSubscriptionToCreator(creatorId: $creatorId)
  }
`;
export type GrantFreeExclusiveSubscriptionToCreatorMutationFn =
  Apollo.MutationFunction<
    GrantFreeExclusiveSubscriptionToCreatorMutation,
    GrantFreeExclusiveSubscriptionToCreatorMutationVariables
  >;

/**
 * __useGrantFreeExclusiveSubscriptionToCreatorMutation__
 *
 * To run a mutation, you first call `useGrantFreeExclusiveSubscriptionToCreatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantFreeExclusiveSubscriptionToCreatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantFreeExclusiveSubscriptionToCreatorMutation, { data, loading, error }] = useGrantFreeExclusiveSubscriptionToCreatorMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGrantFreeExclusiveSubscriptionToCreatorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GrantFreeExclusiveSubscriptionToCreatorMutation,
    GrantFreeExclusiveSubscriptionToCreatorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GrantFreeExclusiveSubscriptionToCreatorMutation,
    GrantFreeExclusiveSubscriptionToCreatorMutationVariables
  >(GrantFreeExclusiveSubscriptionToCreatorDocument, options);
}
export type GrantFreeExclusiveSubscriptionToCreatorMutationHookResult =
  ReturnType<typeof useGrantFreeExclusiveSubscriptionToCreatorMutation>;
export type GrantFreeExclusiveSubscriptionToCreatorMutationResult =
  Apollo.MutationResult<GrantFreeExclusiveSubscriptionToCreatorMutation>;
export type GrantFreeExclusiveSubscriptionToCreatorMutationOptions =
  Apollo.BaseMutationOptions<
    GrantFreeExclusiveSubscriptionToCreatorMutation,
    GrantFreeExclusiveSubscriptionToCreatorMutationVariables
  >;
export const AdminResetStripeDataDocument = gql`
  mutation AdminResetStripeData($influencerId: Int!) {
    resetStripeData(influencerId: $influencerId)
  }
`;
export type AdminResetStripeDataMutationFn = Apollo.MutationFunction<
  AdminResetStripeDataMutation,
  AdminResetStripeDataMutationVariables
>;

/**
 * __useAdminResetStripeDataMutation__
 *
 * To run a mutation, you first call `useAdminResetStripeDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminResetStripeDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminResetStripeDataMutation, { data, loading, error }] = useAdminResetStripeDataMutation({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *   },
 * });
 */
export function useAdminResetStripeDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminResetStripeDataMutation,
    AdminResetStripeDataMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminResetStripeDataMutation,
    AdminResetStripeDataMutationVariables
  >(AdminResetStripeDataDocument, options);
}
export type AdminResetStripeDataMutationHookResult = ReturnType<
  typeof useAdminResetStripeDataMutation
>;
export type AdminResetStripeDataMutationResult =
  Apollo.MutationResult<AdminResetStripeDataMutation>;
export type AdminResetStripeDataMutationOptions = Apollo.BaseMutationOptions<
  AdminResetStripeDataMutation,
  AdminResetStripeDataMutationVariables
>;
export const AdminUpdateInfluencerDocument = gql`
  mutation AdminUpdateInfluencer($data: AdminInfluencerUpdateInput!) {
    adminUpdateInfluencer(data: $data)
  }
`;
export type AdminUpdateInfluencerMutationFn = Apollo.MutationFunction<
  AdminUpdateInfluencerMutation,
  AdminUpdateInfluencerMutationVariables
>;

/**
 * __useAdminUpdateInfluencerMutation__
 *
 * To run a mutation, you first call `useAdminUpdateInfluencerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateInfluencerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateInfluencerMutation, { data, loading, error }] = useAdminUpdateInfluencerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAdminUpdateInfluencerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdminUpdateInfluencerMutation,
    AdminUpdateInfluencerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AdminUpdateInfluencerMutation,
    AdminUpdateInfluencerMutationVariables
  >(AdminUpdateInfluencerDocument, options);
}
export type AdminUpdateInfluencerMutationHookResult = ReturnType<
  typeof useAdminUpdateInfluencerMutation
>;
export type AdminUpdateInfluencerMutationResult =
  Apollo.MutationResult<AdminUpdateInfluencerMutation>;
export type AdminUpdateInfluencerMutationOptions = Apollo.BaseMutationOptions<
  AdminUpdateInfluencerMutation,
  AdminUpdateInfluencerMutationVariables
>;
export const GetAdministrationDataDocument = gql`
  query GetAdministrationData($id: Int!) {
    creator(id: $id) {
      id
      type
      tier
      isVisible
      publishedAt
      mode
      source
      isTCAccepted
      salesModel
      isPaymentEnabled
      stripeUserId
      paymentMethod
      profileDeepLink
      customURL
      insights
      tags
      customizations {
        promo
        isNewVideo
        isNewRunning
        isCrmEnabled
        hideDiscovery
        hideAbout
        hideSuggestion
        workoutsTitle
        insightsTitle
        linkInBio
        feedFirst
        hideLibrary
        lastLibrary
        freeInfluencer
        feedLimit
        backgroundVideoUpload
        canUsePromotionDetails
        canUsePromotions
        productCatalogTitle
        productCatalog {
          price
          productDescription
          productName
          purchaseLink
          thumbnailUrl
          tags
        }
        premiumFeaturesOTPIds
        isPPCOnly
        exclusivesTitle
        visibleForUnknownUsers
        isTransactionLedgerEnabled
        isUnifiedProgramsEnabled
        isOtpMigratedToBundle
        isCouponWithFreeTrialEnabled
        isExerciseSwapsEnabled
        isCreatorApprovedSwapsEnabled
        isU2UReferralsEnabled
      }
      collectionType
      productType
      publisheCollectionsCount
      publishedWorkoutsCount
      hasAccessToOwnExclusiveSubscription
    }
    onboardingListData(creatorId: $id) {
      profileReady
      paymentMethodReady
      collectionPublishedReady
    }
  }
`;

/**
 * __useGetAdministrationDataQuery__
 *
 * To run a query within a React component, call `useGetAdministrationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdministrationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdministrationDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAdministrationDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdministrationDataQuery,
    GetAdministrationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAdministrationDataQuery,
    GetAdministrationDataQueryVariables
  >(GetAdministrationDataDocument, options);
}
export function useGetAdministrationDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdministrationDataQuery,
    GetAdministrationDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAdministrationDataQuery,
    GetAdministrationDataQueryVariables
  >(GetAdministrationDataDocument, options);
}
export type GetAdministrationDataQueryHookResult = ReturnType<
  typeof useGetAdministrationDataQuery
>;
export type GetAdministrationDataLazyQueryHookResult = ReturnType<
  typeof useGetAdministrationDataLazyQuery
>;
export type GetAdministrationDataQueryResult = Apollo.QueryResult<
  GetAdministrationDataQuery,
  GetAdministrationDataQueryVariables
>;
export const GetSellableContentItemsDocument = gql`
  query GetSellableContentItems($creatorId: ID!) {
    content(creatorId: $creatorId) {
      contentItems {
        type
        value {
          ... on ContentLinkValue {
            id
            title
            isArchived
            isPublished
            url
          }
          ... on ContentPDFValue {
            id
            title
            isArchived
            isPublished
            url
          }
          ... on ContentSlidesValue {
            id
            title
            isArchived
            isPublished
          }
          ... on ContentLegacyGuideValue {
            id
            title
            isArchived
            isPublished
          }
          ... on ContentVideoValue {
            id
            title
            isArchived
            isPublished
          }
        }
      }
    }
  }
`;

/**
 * __useGetSellableContentItemsQuery__
 *
 * To run a query within a React component, call `useGetSellableContentItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellableContentItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellableContentItemsQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetSellableContentItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSellableContentItemsQuery,
    GetSellableContentItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSellableContentItemsQuery,
    GetSellableContentItemsQueryVariables
  >(GetSellableContentItemsDocument, options);
}
export function useGetSellableContentItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSellableContentItemsQuery,
    GetSellableContentItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSellableContentItemsQuery,
    GetSellableContentItemsQueryVariables
  >(GetSellableContentItemsDocument, options);
}
export type GetSellableContentItemsQueryHookResult = ReturnType<
  typeof useGetSellableContentItemsQuery
>;
export type GetSellableContentItemsLazyQueryHookResult = ReturnType<
  typeof useGetSellableContentItemsLazyQuery
>;
export type GetSellableContentItemsQueryResult = Apollo.QueryResult<
  GetSellableContentItemsQuery,
  GetSellableContentItemsQueryVariables
>;
export const CreateOtpBundleDocument = gql`
  mutation CreateOtpBundle($input: CreateOtpBundleInput!) {
    createOtpBundle(input: $input) {
      bundle {
        createdAt
        deeplinkUrl
        description
        id
        influencerId
        isPlatformBundle
        pricing
        status
        title
        updatedAt
        oneTimeProduct {
          id
          playbookFee
          price
          providerPriceId
          providerProductId
        }
        items {
          bundleId
          createdAt
          id
          itemId
          itemType
        }
        coverImage {
          cdn01
          image
        }
      }
      warnings {
        message
        details {
          itemType
          itemId
          contentId
          title
          error
        }
      }
    }
  }
`;
export type CreateOtpBundleMutationFn = Apollo.MutationFunction<
  CreateOtpBundleMutation,
  CreateOtpBundleMutationVariables
>;

/**
 * __useCreateOtpBundleMutation__
 *
 * To run a mutation, you first call `useCreateOtpBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOtpBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOtpBundleMutation, { data, loading, error }] = useCreateOtpBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOtpBundleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOtpBundleMutation,
    CreateOtpBundleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOtpBundleMutation,
    CreateOtpBundleMutationVariables
  >(CreateOtpBundleDocument, options);
}
export type CreateOtpBundleMutationHookResult = ReturnType<
  typeof useCreateOtpBundleMutation
>;
export type CreateOtpBundleMutationResult =
  Apollo.MutationResult<CreateOtpBundleMutation>;
export type CreateOtpBundleMutationOptions = Apollo.BaseMutationOptions<
  CreateOtpBundleMutation,
  CreateOtpBundleMutationVariables
>;
export const DeleteOtpBundleDocument = gql`
  mutation DeleteOtpBundle($bundleId: Int!) {
    deleteOtpBundle(bundleId: $bundleId)
  }
`;
export type DeleteOtpBundleMutationFn = Apollo.MutationFunction<
  DeleteOtpBundleMutation,
  DeleteOtpBundleMutationVariables
>;

/**
 * __useDeleteOtpBundleMutation__
 *
 * To run a mutation, you first call `useDeleteOtpBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOtpBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOtpBundleMutation, { data, loading, error }] = useDeleteOtpBundleMutation({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useDeleteOtpBundleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteOtpBundleMutation,
    DeleteOtpBundleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteOtpBundleMutation,
    DeleteOtpBundleMutationVariables
  >(DeleteOtpBundleDocument, options);
}
export type DeleteOtpBundleMutationHookResult = ReturnType<
  typeof useDeleteOtpBundleMutation
>;
export type DeleteOtpBundleMutationResult =
  Apollo.MutationResult<DeleteOtpBundleMutation>;
export type DeleteOtpBundleMutationOptions = Apollo.BaseMutationOptions<
  DeleteOtpBundleMutation,
  DeleteOtpBundleMutationVariables
>;
export const GetOtpBundlesDocument = gql`
  query GetOtpBundles($creatorId: Int!, $bundlePricing: [BundlePricing!]) {
    creator(id: $creatorId) {
      id
      businessModel
    }
    collections(
      input: {
        filters: {
          influencerId: $creatorId
          accessTypes: [Exclusive]
          withDeleted: false
        }
      }
    ) {
      id
      isVisible
      name
      type
      accessType
      publishedAt
      archivedAt
      readiness {
        title
        cover
        workouts
        goal
      }
    }
    bundle(creatorId: $creatorId, bundlePricing: $bundlePricing) {
      id
      title
      influencerId
      status
      description
      items {
        contentId
        itemId
        itemType
      }
      pricing
      oneTimeProduct {
        id
        price
        playbookFee
        providerPriceId
        providerProductId
      }
      wasPurchased
      checkoutPage {
        url
        type
      }
      landingPageUrl
      deeplinkUrl
      isFree
      inAppPurchase
      migrationProgramId
      coverImage {
        cdn01
        image
      }
    }
    feature {
      id
      name
      code
    }
    getCouponsByInfluencer(influencerId: $creatorId) {
      code
      id
      isActive
      name
      paidProductIds
    }
  }
`;

/**
 * __useGetOtpBundlesQuery__
 *
 * To run a query within a React component, call `useGetOtpBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtpBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtpBundlesQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      bundlePricing: // value for 'bundlePricing'
 *   },
 * });
 */
export function useGetOtpBundlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOtpBundlesQuery,
    GetOtpBundlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOtpBundlesQuery, GetOtpBundlesQueryVariables>(
    GetOtpBundlesDocument,
    options,
  );
}
export function useGetOtpBundlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOtpBundlesQuery,
    GetOtpBundlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOtpBundlesQuery, GetOtpBundlesQueryVariables>(
    GetOtpBundlesDocument,
    options,
  );
}
export type GetOtpBundlesQueryHookResult = ReturnType<
  typeof useGetOtpBundlesQuery
>;
export type GetOtpBundlesLazyQueryHookResult = ReturnType<
  typeof useGetOtpBundlesLazyQuery
>;
export type GetOtpBundlesQueryResult = Apollo.QueryResult<
  GetOtpBundlesQuery,
  GetOtpBundlesQueryVariables
>;
export const UpdateOtpBundleDocument = gql`
  mutation UpdateOtpBundle($input: UpdateOtpBundleInput!) {
    updateOtpBundle(input: $input) {
      bundle {
        createdAt
        deeplinkUrl
        description
        id
        influencerId
        isPlatformBundle
        pricing
        status
        title
        updatedAt
        oneTimeProduct {
          id
          playbookFee
          price
          providerPriceId
          providerProductId
        }
        items {
          bundleId
          createdAt
          id
          itemId
          itemType
        }
        coverImage {
          cdn01
          image
        }
      }
      warnings {
        message
        details {
          itemType
          itemId
          contentId
          title
          error
        }
      }
    }
  }
`;
export type UpdateOtpBundleMutationFn = Apollo.MutationFunction<
  UpdateOtpBundleMutation,
  UpdateOtpBundleMutationVariables
>;

/**
 * __useUpdateOtpBundleMutation__
 *
 * To run a mutation, you first call `useUpdateOtpBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOtpBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOtpBundleMutation, { data, loading, error }] = useUpdateOtpBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOtpBundleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOtpBundleMutation,
    UpdateOtpBundleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOtpBundleMutation,
    UpdateOtpBundleMutationVariables
  >(UpdateOtpBundleDocument, options);
}
export type UpdateOtpBundleMutationHookResult = ReturnType<
  typeof useUpdateOtpBundleMutation
>;
export type UpdateOtpBundleMutationResult =
  Apollo.MutationResult<UpdateOtpBundleMutation>;
export type UpdateOtpBundleMutationOptions = Apollo.BaseMutationOptions<
  UpdateOtpBundleMutation,
  UpdateOtpBundleMutationVariables
>;
export const CreateSubscriptionBundleDocument = gql`
  mutation CreateSubscriptionBundle($input: CreateSubscriptionBundleInput!) {
    createSubscriptionBundle(input: $input) {
      id
      title
      influencerId
      isPlatformBundle
      status
      description
      items {
        contentId
        itemId
        itemType
      }
      subscriptionTier {
        id
        name
        description
        prices {
          billingCycleInterval
          billingCycleIntervalUnit
          price
          isFreeTrialEnabled
          providerPriceId
        }
      }
      pricing
      pushNotificationMessage
      pushNotificationSentAt
      pushNotificationUsageCount
      upgradeDeeplinkUrl
    }
  }
`;
export type CreateSubscriptionBundleMutationFn = Apollo.MutationFunction<
  CreateSubscriptionBundleMutation,
  CreateSubscriptionBundleMutationVariables
>;

/**
 * __useCreateSubscriptionBundleMutation__
 *
 * To run a mutation, you first call `useCreateSubscriptionBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSubscriptionBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSubscriptionBundleMutation, { data, loading, error }] = useCreateSubscriptionBundleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSubscriptionBundleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSubscriptionBundleMutation,
    CreateSubscriptionBundleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSubscriptionBundleMutation,
    CreateSubscriptionBundleMutationVariables
  >(CreateSubscriptionBundleDocument, options);
}
export type CreateSubscriptionBundleMutationHookResult = ReturnType<
  typeof useCreateSubscriptionBundleMutation
>;
export type CreateSubscriptionBundleMutationResult =
  Apollo.MutationResult<CreateSubscriptionBundleMutation>;
export type CreateSubscriptionBundleMutationOptions =
  Apollo.BaseMutationOptions<
    CreateSubscriptionBundleMutation,
    CreateSubscriptionBundleMutationVariables
  >;
export const GetSubscriptionBundlesDocument = gql`
  query GetSubscriptionBundles(
    $creatorId: Int!
    $bundlePricing: [BundlePricing!]
  ) {
    creator(id: $creatorId) {
      id
      programs {
        id
        isVisible
        name
        type
        accessType
        programBusinessModel
        publishedAt
        archivedAt
        readiness {
          title
          cover
          workouts
          goal
        }
      }
      name
      customURL
      profileDeepLink
      businessModel
      visibility
      customURL
      customizations {
        isExclusiveMigratedToBundle
      }
      enableCheckoutFreeTrial
    }
    bundle(creatorId: $creatorId, bundlePricing: $bundlePricing) {
      id
      title
      influencerId
      isPlatformBundle
      status
      description
      items {
        contentId
        itemId
        itemType
      }
      subscriptionTier {
        id
        name
        description
        prices {
          billingCycleInterval
          billingCycleIntervalUnit
          price
          isFreeTrialEnabled
          providerPriceId
        }
      }
      pricing
      pushNotificationMessage
      pushNotificationSentAt
      pushNotificationUsageCount
      upgradeDeeplinkUrl
    }
    feature {
      id
      name
      code
    }
    getCouponsByInfluencer(influencerId: $creatorId) {
      id
      isActive
      productType
      subscriptionProviderPriceId
      code
      name
    }
  }
`;

/**
 * __useGetSubscriptionBundlesQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionBundlesQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      bundlePricing: // value for 'bundlePricing'
 *   },
 * });
 */
export function useGetSubscriptionBundlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubscriptionBundlesQuery,
    GetSubscriptionBundlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubscriptionBundlesQuery,
    GetSubscriptionBundlesQueryVariables
  >(GetSubscriptionBundlesDocument, options);
}
export function useGetSubscriptionBundlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionBundlesQuery,
    GetSubscriptionBundlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionBundlesQuery,
    GetSubscriptionBundlesQueryVariables
  >(GetSubscriptionBundlesDocument, options);
}
export type GetSubscriptionBundlesQueryHookResult = ReturnType<
  typeof useGetSubscriptionBundlesQuery
>;
export type GetSubscriptionBundlesLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionBundlesLazyQuery
>;
export type GetSubscriptionBundlesQueryResult = Apollo.QueryResult<
  GetSubscriptionBundlesQuery,
  GetSubscriptionBundlesQueryVariables
>;
export const PublishSubscriptionBundleDocument = gql`
  mutation PublishSubscriptionBundle($bundleId: Int!) {
    publishSubscriptionBundle(bundleId: $bundleId) {
      id
      title
      influencerId
      isPlatformBundle
      status
      description
      items {
        contentId
        itemId
        itemType
      }
      subscriptionTier {
        id
        name
        description
        prices {
          billingCycleInterval
          billingCycleIntervalUnit
          price
          isFreeTrialEnabled
          providerPriceId
        }
      }
      pricing
      pushNotificationMessage
      pushNotificationSentAt
      pushNotificationUsageCount
      upgradeDeeplinkUrl
    }
  }
`;
export type PublishSubscriptionBundleMutationFn = Apollo.MutationFunction<
  PublishSubscriptionBundleMutation,
  PublishSubscriptionBundleMutationVariables
>;

/**
 * __usePublishSubscriptionBundleMutation__
 *
 * To run a mutation, you first call `usePublishSubscriptionBundleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishSubscriptionBundleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishSubscriptionBundleMutation, { data, loading, error }] = usePublishSubscriptionBundleMutation({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function usePublishSubscriptionBundleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishSubscriptionBundleMutation,
    PublishSubscriptionBundleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishSubscriptionBundleMutation,
    PublishSubscriptionBundleMutationVariables
  >(PublishSubscriptionBundleDocument, options);
}
export type PublishSubscriptionBundleMutationHookResult = ReturnType<
  typeof usePublishSubscriptionBundleMutation
>;
export type PublishSubscriptionBundleMutationResult =
  Apollo.MutationResult<PublishSubscriptionBundleMutation>;
export type PublishSubscriptionBundleMutationOptions =
  Apollo.BaseMutationOptions<
    PublishSubscriptionBundleMutation,
    PublishSubscriptionBundleMutationVariables
  >;
export const SendSubscriptionBundlePushNotificationDocument = gql`
  mutation SendSubscriptionBundlePushNotification(
    $bundleId: Int!
    $message: String!
  ) {
    sendSubscriptionBundlePushNotification(
      bundleId: $bundleId
      message: $message
    )
  }
`;
export type SendSubscriptionBundlePushNotificationMutationFn =
  Apollo.MutationFunction<
    SendSubscriptionBundlePushNotificationMutation,
    SendSubscriptionBundlePushNotificationMutationVariables
  >;

/**
 * __useSendSubscriptionBundlePushNotificationMutation__
 *
 * To run a mutation, you first call `useSendSubscriptionBundlePushNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSubscriptionBundlePushNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSubscriptionBundlePushNotificationMutation, { data, loading, error }] = useSendSubscriptionBundlePushNotificationMutation({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendSubscriptionBundlePushNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendSubscriptionBundlePushNotificationMutation,
    SendSubscriptionBundlePushNotificationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendSubscriptionBundlePushNotificationMutation,
    SendSubscriptionBundlePushNotificationMutationVariables
  >(SendSubscriptionBundlePushNotificationDocument, options);
}
export type SendSubscriptionBundlePushNotificationMutationHookResult =
  ReturnType<typeof useSendSubscriptionBundlePushNotificationMutation>;
export type SendSubscriptionBundlePushNotificationMutationResult =
  Apollo.MutationResult<SendSubscriptionBundlePushNotificationMutation>;
export type SendSubscriptionBundlePushNotificationMutationOptions =
  Apollo.BaseMutationOptions<
    SendSubscriptionBundlePushNotificationMutation,
    SendSubscriptionBundlePushNotificationMutationVariables
  >;
export const SetBundleBusinessModelDocument = gql`
  mutation SetBundleBusinessModel($data: SetBundleBusinessModelInput!) {
    setBundleBusinessModel(data: $data)
  }
`;
export type SetBundleBusinessModelMutationFn = Apollo.MutationFunction<
  SetBundleBusinessModelMutation,
  SetBundleBusinessModelMutationVariables
>;

/**
 * __useSetBundleBusinessModelMutation__
 *
 * To run a mutation, you first call `useSetBundleBusinessModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetBundleBusinessModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setBundleBusinessModelMutation, { data, loading, error }] = useSetBundleBusinessModelMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetBundleBusinessModelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetBundleBusinessModelMutation,
    SetBundleBusinessModelMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetBundleBusinessModelMutation,
    SetBundleBusinessModelMutationVariables
  >(SetBundleBusinessModelDocument, options);
}
export type SetBundleBusinessModelMutationHookResult = ReturnType<
  typeof useSetBundleBusinessModelMutation
>;
export type SetBundleBusinessModelMutationResult =
  Apollo.MutationResult<SetBundleBusinessModelMutation>;
export type SetBundleBusinessModelMutationOptions = Apollo.BaseMutationOptions<
  SetBundleBusinessModelMutation,
  SetBundleBusinessModelMutationVariables
>;
export const UpdateSubscriptionBundlesDocument = gql`
  mutation UpdateSubscriptionBundles($input: [UpdateBundleInput!]!) {
    updateBundles(input: $input) {
      id
    }
  }
`;
export type UpdateSubscriptionBundlesMutationFn = Apollo.MutationFunction<
  UpdateSubscriptionBundlesMutation,
  UpdateSubscriptionBundlesMutationVariables
>;

/**
 * __useUpdateSubscriptionBundlesMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionBundlesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionBundlesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionBundlesMutation, { data, loading, error }] = useUpdateSubscriptionBundlesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionBundlesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSubscriptionBundlesMutation,
    UpdateSubscriptionBundlesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSubscriptionBundlesMutation,
    UpdateSubscriptionBundlesMutationVariables
  >(UpdateSubscriptionBundlesDocument, options);
}
export type UpdateSubscriptionBundlesMutationHookResult = ReturnType<
  typeof useUpdateSubscriptionBundlesMutation
>;
export type UpdateSubscriptionBundlesMutationResult =
  Apollo.MutationResult<UpdateSubscriptionBundlesMutation>;
export type UpdateSubscriptionBundlesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateSubscriptionBundlesMutation,
    UpdateSubscriptionBundlesMutationVariables
  >;
export const UpsertOrArchiveSubscriptionBundlePricesDocument = gql`
  mutation UpsertOrArchiveSubscriptionBundlePrices(
    $input: UpsertOrArchiveSubscriptionBundlePricesInput!
  ) {
    upsertOrArchiveSubscriptionBundlePrices(input: $input)
  }
`;
export type UpsertOrArchiveSubscriptionBundlePricesMutationFn =
  Apollo.MutationFunction<
    UpsertOrArchiveSubscriptionBundlePricesMutation,
    UpsertOrArchiveSubscriptionBundlePricesMutationVariables
  >;

/**
 * __useUpsertOrArchiveSubscriptionBundlePricesMutation__
 *
 * To run a mutation, you first call `useUpsertOrArchiveSubscriptionBundlePricesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOrArchiveSubscriptionBundlePricesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOrArchiveSubscriptionBundlePricesMutation, { data, loading, error }] = useUpsertOrArchiveSubscriptionBundlePricesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertOrArchiveSubscriptionBundlePricesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertOrArchiveSubscriptionBundlePricesMutation,
    UpsertOrArchiveSubscriptionBundlePricesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertOrArchiveSubscriptionBundlePricesMutation,
    UpsertOrArchiveSubscriptionBundlePricesMutationVariables
  >(UpsertOrArchiveSubscriptionBundlePricesDocument, options);
}
export type UpsertOrArchiveSubscriptionBundlePricesMutationHookResult =
  ReturnType<typeof useUpsertOrArchiveSubscriptionBundlePricesMutation>;
export type UpsertOrArchiveSubscriptionBundlePricesMutationResult =
  Apollo.MutationResult<UpsertOrArchiveSubscriptionBundlePricesMutation>;
export type UpsertOrArchiveSubscriptionBundlePricesMutationOptions =
  Apollo.BaseMutationOptions<
    UpsertOrArchiveSubscriptionBundlePricesMutation,
    UpsertOrArchiveSubscriptionBundlePricesMutationVariables
  >;
export const GetProgramWithLiteChallengesDocument = gql`
  query GetProgramWithLiteChallenges($collectionId: Int!) {
    collection(collectionId: $collectionId) {
      ...CollectionBaseFragment
      challenges {
        ...ChallengeBaseFragment
        submissions {
          submissionId
        }
      }
    }
  }
  ${CollectionBaseFragmentFragmentDoc}
  ${ChallengeBaseFragmentFragmentDoc}
`;

/**
 * __useGetProgramWithLiteChallengesQuery__
 *
 * To run a query within a React component, call `useGetProgramWithLiteChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramWithLiteChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramWithLiteChallengesQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetProgramWithLiteChallengesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramWithLiteChallengesQuery,
    GetProgramWithLiteChallengesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramWithLiteChallengesQuery,
    GetProgramWithLiteChallengesQueryVariables
  >(GetProgramWithLiteChallengesDocument, options);
}
export function useGetProgramWithLiteChallengesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramWithLiteChallengesQuery,
    GetProgramWithLiteChallengesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramWithLiteChallengesQuery,
    GetProgramWithLiteChallengesQueryVariables
  >(GetProgramWithLiteChallengesDocument, options);
}
export type GetProgramWithLiteChallengesQueryHookResult = ReturnType<
  typeof useGetProgramWithLiteChallengesQuery
>;
export type GetProgramWithLiteChallengesLazyQueryHookResult = ReturnType<
  typeof useGetProgramWithLiteChallengesLazyQuery
>;
export type GetProgramWithLiteChallengesQueryResult = Apollo.QueryResult<
  GetProgramWithLiteChallengesQuery,
  GetProgramWithLiteChallengesQueryVariables
>;
export const GetProgramWithChallengesDocument = gql`
  query GetProgramWithChallenges($collectionId: Int!) {
    collection(collectionId: $collectionId) {
      ...CollectionBaseFragment
      challenges {
        ...ChallengeBaseFragment
        submissions {
          ...SubmissionFragment
        }
      }
    }
  }
  ${CollectionBaseFragmentFragmentDoc}
  ${ChallengeBaseFragmentFragmentDoc}
  ${SubmissionFragmentFragmentDoc}
`;

/**
 * __useGetProgramWithChallengesQuery__
 *
 * To run a query within a React component, call `useGetProgramWithChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramWithChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramWithChallengesQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetProgramWithChallengesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramWithChallengesQuery,
    GetProgramWithChallengesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramWithChallengesQuery,
    GetProgramWithChallengesQueryVariables
  >(GetProgramWithChallengesDocument, options);
}
export function useGetProgramWithChallengesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramWithChallengesQuery,
    GetProgramWithChallengesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramWithChallengesQuery,
    GetProgramWithChallengesQueryVariables
  >(GetProgramWithChallengesDocument, options);
}
export type GetProgramWithChallengesQueryHookResult = ReturnType<
  typeof useGetProgramWithChallengesQuery
>;
export type GetProgramWithChallengesLazyQueryHookResult = ReturnType<
  typeof useGetProgramWithChallengesLazyQuery
>;
export type GetProgramWithChallengesQueryResult = Apollo.QueryResult<
  GetProgramWithChallengesQuery,
  GetProgramWithChallengesQueryVariables
>;
export const GetProgramChallengesCountDocument = gql`
  query GetProgramChallengesCount($collectionId: Int!) {
    collection(collectionId: $collectionId) {
      challenges {
        id
      }
    }
  }
`;

/**
 * __useGetProgramChallengesCountQuery__
 *
 * To run a query within a React component, call `useGetProgramChallengesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgramChallengesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgramChallengesCountQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetProgramChallengesCountQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProgramChallengesCountQuery,
    GetProgramChallengesCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetProgramChallengesCountQuery,
    GetProgramChallengesCountQueryVariables
  >(GetProgramChallengesCountDocument, options);
}
export function useGetProgramChallengesCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProgramChallengesCountQuery,
    GetProgramChallengesCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetProgramChallengesCountQuery,
    GetProgramChallengesCountQueryVariables
  >(GetProgramChallengesCountDocument, options);
}
export type GetProgramChallengesCountQueryHookResult = ReturnType<
  typeof useGetProgramChallengesCountQuery
>;
export type GetProgramChallengesCountLazyQueryHookResult = ReturnType<
  typeof useGetProgramChallengesCountLazyQuery
>;
export type GetProgramChallengesCountQueryResult = Apollo.QueryResult<
  GetProgramChallengesCountQuery,
  GetProgramChallengesCountQueryVariables
>;
export const CreateChallengeDocument = gql`
  mutation createChallenge($input: CreateChallengeInput!) {
    createChallenge(input: $input) {
      id
    }
  }
`;
export type CreateChallengeMutationFn = Apollo.MutationFunction<
  CreateChallengeMutation,
  CreateChallengeMutationVariables
>;

/**
 * __useCreateChallengeMutation__
 *
 * To run a mutation, you first call `useCreateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChallengeMutation, { data, loading, error }] = useCreateChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateChallengeMutation,
    CreateChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateChallengeMutation,
    CreateChallengeMutationVariables
  >(CreateChallengeDocument, options);
}
export type CreateChallengeMutationHookResult = ReturnType<
  typeof useCreateChallengeMutation
>;
export type CreateChallengeMutationResult =
  Apollo.MutationResult<CreateChallengeMutation>;
export type CreateChallengeMutationOptions = Apollo.BaseMutationOptions<
  CreateChallengeMutation,
  CreateChallengeMutationVariables
>;
export const UpdateChallengeDocument = gql`
  mutation updateChallenge($input: UpdateChallengeInput!) {
    updateChallenge(input: $input) {
      id
    }
  }
`;
export type UpdateChallengeMutationFn = Apollo.MutationFunction<
  UpdateChallengeMutation,
  UpdateChallengeMutationVariables
>;

/**
 * __useUpdateChallengeMutation__
 *
 * To run a mutation, you first call `useUpdateChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChallengeMutation, { data, loading, error }] = useUpdateChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChallengeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateChallengeMutation,
    UpdateChallengeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateChallengeMutation,
    UpdateChallengeMutationVariables
  >(UpdateChallengeDocument, options);
}
export type UpdateChallengeMutationHookResult = ReturnType<
  typeof useUpdateChallengeMutation
>;
export type UpdateChallengeMutationResult =
  Apollo.MutationResult<UpdateChallengeMutation>;
export type UpdateChallengeMutationOptions = Apollo.BaseMutationOptions<
  UpdateChallengeMutation,
  UpdateChallengeMutationVariables
>;
export const UpdateSubmissionDocument = gql`
  mutation updateSubmission($submissionId: Int!, $isShortlisted: Boolean!) {
    setSubmissionShortlistStatus(
      submissionId: $submissionId
      isShortlisted: $isShortlisted
    )
  }
`;
export type UpdateSubmissionMutationFn = Apollo.MutationFunction<
  UpdateSubmissionMutation,
  UpdateSubmissionMutationVariables
>;

/**
 * __useUpdateSubmissionMutation__
 *
 * To run a mutation, you first call `useUpdateSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubmissionMutation, { data, loading, error }] = useUpdateSubmissionMutation({
 *   variables: {
 *      submissionId: // value for 'submissionId'
 *      isShortlisted: // value for 'isShortlisted'
 *   },
 * });
 */
export function useUpdateSubmissionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSubmissionMutation,
    UpdateSubmissionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSubmissionMutation,
    UpdateSubmissionMutationVariables
  >(UpdateSubmissionDocument, options);
}
export type UpdateSubmissionMutationHookResult = ReturnType<
  typeof useUpdateSubmissionMutation
>;
export type UpdateSubmissionMutationResult =
  Apollo.MutationResult<UpdateSubmissionMutation>;
export type UpdateSubmissionMutationOptions = Apollo.BaseMutationOptions<
  UpdateSubmissionMutation,
  UpdateSubmissionMutationVariables
>;
export const GetCollectionPageDataDocument = gql`
  query GetCollectionPageData($collectionId: Int!, $creatorId: Int!) {
    collection(collectionId: $collectionId) {
      id
      influencerId
      isVisible
      name
      swapConfig {
        swapsEnabled
      }
      mediaCover {
        ...collectionMedia
      }
      mediaIntro {
        ...collectionMedia
      }
      description
      color
      type
      publishingBehaviour
      workoutLimit
      contentStructure
      duration
      faq {
        answer
        question
      }
      tags
      expiresAt
      publishedAt
      archivedAt
      workouts {
        id
        isClass
        name
        mediaCover {
          ...collectionMedia
        }
        mediaExercise {
          ...collectionMedia
        }
      }
      accessType
      inAppPurchase
      isLocked
      migrationBundleId
      goal
      daysPerWeek
      sessionDuration
      requiredEquipment
      difficulty
      location
      testimonials {
        media {
          ...collectionMedia
        }
        text
        name
      }
      hiddenSections {
        faq
        testimonials
      }
      index
      exclusiveProgramMetadata {
        deeplinkUrl
        checkoutPageUrl
        price
        playbookFee
        originalPrice
        discountPercent
      }
      deeplinkUrl
      readiness {
        title
        cover
        workouts
        goal
      }
    }
    creator(id: $creatorId) {
      id
      customURL
      mode
      email
      publisheCollectionsCount
      profileDeepLink
      mode
      businessModel
    }
    bundle(creatorId: $creatorId) {
      id
      isPlatformBundle
      status
      pricing
      items {
        itemType
        itemId
      }
      isFree
    }
    purchasePageConfig(programId: $collectionId) {
      id
      programId
      config
    }
  }
  ${CollectionMediaFragmentDoc}
`;

/**
 * __useGetCollectionPageDataQuery__
 *
 * To run a query within a React component, call `useGetCollectionPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionPageDataQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetCollectionPageDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionPageDataQuery,
    GetCollectionPageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionPageDataQuery,
    GetCollectionPageDataQueryVariables
  >(GetCollectionPageDataDocument, options);
}
export function useGetCollectionPageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionPageDataQuery,
    GetCollectionPageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionPageDataQuery,
    GetCollectionPageDataQueryVariables
  >(GetCollectionPageDataDocument, options);
}
export type GetCollectionPageDataQueryHookResult = ReturnType<
  typeof useGetCollectionPageDataQuery
>;
export type GetCollectionPageDataLazyQueryHookResult = ReturnType<
  typeof useGetCollectionPageDataLazyQuery
>;
export type GetCollectionPageDataQueryResult = Apollo.QueryResult<
  GetCollectionPageDataQuery,
  GetCollectionPageDataQueryVariables
>;
export const GetCollectionParentOffersDocument = gql`
  query GetCollectionParentOffers($input: BundleItemInput!) {
    parentBundlesByItem(input: $input) {
      id
      status
      title
      description
    }
  }
`;

/**
 * __useGetCollectionParentOffersQuery__
 *
 * To run a query within a React component, call `useGetCollectionParentOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionParentOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionParentOffersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCollectionParentOffersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionParentOffersQuery,
    GetCollectionParentOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionParentOffersQuery,
    GetCollectionParentOffersQueryVariables
  >(GetCollectionParentOffersDocument, options);
}
export function useGetCollectionParentOffersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionParentOffersQuery,
    GetCollectionParentOffersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionParentOffersQuery,
    GetCollectionParentOffersQueryVariables
  >(GetCollectionParentOffersDocument, options);
}
export type GetCollectionParentOffersQueryHookResult = ReturnType<
  typeof useGetCollectionParentOffersQuery
>;
export type GetCollectionParentOffersLazyQueryHookResult = ReturnType<
  typeof useGetCollectionParentOffersLazyQuery
>;
export type GetCollectionParentOffersQueryResult = Apollo.QueryResult<
  GetCollectionParentOffersQuery,
  GetCollectionParentOffersQueryVariables
>;
export const GetCollectionParentOffersDetailedDocument = gql`
  query GetCollectionParentOffersDetailed(
    $input: BundleItemInput!
    $creatorId: Int!
  ) {
    parentBundlesByItem(input: $input) {
      id
      status
      title
      isFree
      oneTimeProduct {
        price
      }
      items {
        itemType
        itemId
      }
    }
    creator(id: $creatorId) {
      features {
        id
        code
      }
    }
  }
`;

/**
 * __useGetCollectionParentOffersDetailedQuery__
 *
 * To run a query within a React component, call `useGetCollectionParentOffersDetailedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionParentOffersDetailedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionParentOffersDetailedQuery({
 *   variables: {
 *      input: // value for 'input'
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetCollectionParentOffersDetailedQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionParentOffersDetailedQuery,
    GetCollectionParentOffersDetailedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionParentOffersDetailedQuery,
    GetCollectionParentOffersDetailedQueryVariables
  >(GetCollectionParentOffersDetailedDocument, options);
}
export function useGetCollectionParentOffersDetailedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionParentOffersDetailedQuery,
    GetCollectionParentOffersDetailedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionParentOffersDetailedQuery,
    GetCollectionParentOffersDetailedQueryVariables
  >(GetCollectionParentOffersDetailedDocument, options);
}
export type GetCollectionParentOffersDetailedQueryHookResult = ReturnType<
  typeof useGetCollectionParentOffersDetailedQuery
>;
export type GetCollectionParentOffersDetailedLazyQueryHookResult = ReturnType<
  typeof useGetCollectionParentOffersDetailedLazyQuery
>;
export type GetCollectionParentOffersDetailedQueryResult = Apollo.QueryResult<
  GetCollectionParentOffersDetailedQuery,
  GetCollectionParentOffersDetailedQueryVariables
>;
export const PublishCollectionDocument = gql`
  mutation PublishCollection(
    $programId: Int!
    $onlyPublish: Boolean
    $bundleIds: [Int!]
  ) {
    publishCollection(
      collectionId: $programId
      onlyPublish: $onlyPublish
      bundleIds: $bundleIds
    ) {
      id
      publishedAt
    }
  }
`;
export type PublishCollectionMutationFn = Apollo.MutationFunction<
  PublishCollectionMutation,
  PublishCollectionMutationVariables
>;

/**
 * __usePublishCollectionMutation__
 *
 * To run a mutation, you first call `usePublishCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCollectionMutation, { data, loading, error }] = usePublishCollectionMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      onlyPublish: // value for 'onlyPublish'
 *      bundleIds: // value for 'bundleIds'
 *   },
 * });
 */
export function usePublishCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PublishCollectionMutation,
    PublishCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PublishCollectionMutation,
    PublishCollectionMutationVariables
  >(PublishCollectionDocument, options);
}
export type PublishCollectionMutationHookResult = ReturnType<
  typeof usePublishCollectionMutation
>;
export type PublishCollectionMutationResult =
  Apollo.MutationResult<PublishCollectionMutation>;
export type PublishCollectionMutationOptions = Apollo.BaseMutationOptions<
  PublishCollectionMutation,
  PublishCollectionMutationVariables
>;
export const GetCollectionWorkoutsDocument = gql`
  query GetCollectionWorkouts($id: Int!) {
    collection(collectionId: $id) {
      name
      isLocked
      accessType
      migrationBundleId
      influencer {
        mode
        customURL
      }
      workouts {
        id
        isClass
        name
      }
    }
  }
`;

/**
 * __useGetCollectionWorkoutsQuery__
 *
 * To run a query within a React component, call `useGetCollectionWorkoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionWorkoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionWorkoutsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCollectionWorkoutsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionWorkoutsQuery,
    GetCollectionWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCollectionWorkoutsQuery,
    GetCollectionWorkoutsQueryVariables
  >(GetCollectionWorkoutsDocument, options);
}
export function useGetCollectionWorkoutsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionWorkoutsQuery,
    GetCollectionWorkoutsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCollectionWorkoutsQuery,
    GetCollectionWorkoutsQueryVariables
  >(GetCollectionWorkoutsDocument, options);
}
export type GetCollectionWorkoutsQueryHookResult = ReturnType<
  typeof useGetCollectionWorkoutsQuery
>;
export type GetCollectionWorkoutsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionWorkoutsLazyQuery
>;
export type GetCollectionWorkoutsQueryResult = Apollo.QueryResult<
  GetCollectionWorkoutsQuery,
  GetCollectionWorkoutsQueryVariables
>;
export const GetCollectionsDocument = gql`
  query GetCollections(
    $influencerId: Int!
    $accessType: [AccessType!]
    $withDeleted: Boolean
  ) {
    creator(id: $influencerId) {
      customURL
      profileDeepLink
      businessModel
      customizations {
        isOtpMigratedToBundle
      }
      features {
        id
        code
      }
    }
    bundle(creatorId: $influencerId) {
      id
      isPlatformBundle
      isFree
      status
      pricing
      title
      deeplinkUrl
      landingPageUrl
      items {
        itemId
        itemType
      }
      checkoutPage {
        url
        type
      }
      oneTimeProduct {
        price
      }
    }
    collections(
      input: {
        filters: {
          influencerId: $influencerId
          accessTypes: $accessType
          withDeleted: $withDeleted
        }
      }
    ) {
      ...collectionDetails
      programStats {
        avgRating
        statsBegins
        statsComments
        statsCompletions
      }
      challenges {
        id
        completionEnd
        deepLink
      }
    }
  }
  ${CollectionDetailsFragmentDoc}
`;

/**
 * __useGetCollectionsQuery__
 *
 * To run a query within a React component, call `useGetCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCollectionsQuery({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *      accessType: // value for 'accessType'
 *      withDeleted: // value for 'withDeleted'
 *   },
 * });
 */
export function useGetCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCollectionsQuery,
    GetCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(
    GetCollectionsDocument,
    options,
  );
}
export function useGetCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCollectionsQuery,
    GetCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCollectionsQuery, GetCollectionsQueryVariables>(
    GetCollectionsDocument,
    options,
  );
}
export type GetCollectionsQueryHookResult = ReturnType<
  typeof useGetCollectionsQuery
>;
export type GetCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetCollectionsLazyQuery
>;
export type GetCollectionsQueryResult = Apollo.QueryResult<
  GetCollectionsQuery,
  GetCollectionsQueryVariables
>;
export const OrderCollectionsDocument = gql`
  mutation OrderCollections(
    $influencerId: Int!
    $salesType: SalesType!
    $ids: [Int!]!
  ) {
    orderCollections(
      influencerId: $influencerId
      salesType: $salesType
      ids: $ids
    )
  }
`;
export type OrderCollectionsMutationFn = Apollo.MutationFunction<
  OrderCollectionsMutation,
  OrderCollectionsMutationVariables
>;

/**
 * __useOrderCollectionsMutation__
 *
 * To run a mutation, you first call `useOrderCollectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCollectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCollectionsMutation, { data, loading, error }] = useOrderCollectionsMutation({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *      salesType: // value for 'salesType'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useOrderCollectionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderCollectionsMutation,
    OrderCollectionsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OrderCollectionsMutation,
    OrderCollectionsMutationVariables
  >(OrderCollectionsDocument, options);
}
export type OrderCollectionsMutationHookResult = ReturnType<
  typeof useOrderCollectionsMutation
>;
export type OrderCollectionsMutationResult =
  Apollo.MutationResult<OrderCollectionsMutation>;
export type OrderCollectionsMutationOptions = Apollo.BaseMutationOptions<
  OrderCollectionsMutation,
  OrderCollectionsMutationVariables
>;
export const GetPurchaseCollectionsDocument = gql`
  query GetPurchaseCollections($influencerId: Int!, $withDeleted: Boolean) {
    creator(id: $influencerId) {
      customURL
    }
    collections(
      input: {
        filters: {
          influencerId: $influencerId
          accessTypes: [Exclusive, PremiumExclusive]
          withDeleted: $withDeleted
        }
      }
    ) {
      ...PurchaseCollection
    }
  }
  ${PurchaseCollectionFragmentDoc}
`;

/**
 * __useGetPurchaseCollectionsQuery__
 *
 * To run a query within a React component, call `useGetPurchaseCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseCollectionsQuery({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *      withDeleted: // value for 'withDeleted'
 *   },
 * });
 */
export function useGetPurchaseCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPurchaseCollectionsQuery,
    GetPurchaseCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPurchaseCollectionsQuery,
    GetPurchaseCollectionsQueryVariables
  >(GetPurchaseCollectionsDocument, options);
}
export function useGetPurchaseCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPurchaseCollectionsQuery,
    GetPurchaseCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPurchaseCollectionsQuery,
    GetPurchaseCollectionsQueryVariables
  >(GetPurchaseCollectionsDocument, options);
}
export type GetPurchaseCollectionsQueryHookResult = ReturnType<
  typeof useGetPurchaseCollectionsQuery
>;
export type GetPurchaseCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetPurchaseCollectionsLazyQuery
>;
export type GetPurchaseCollectionsQueryResult = Apollo.QueryResult<
  GetPurchaseCollectionsQuery,
  GetPurchaseCollectionsQueryVariables
>;
export const GetSubscriptionCollectionsDocument = gql`
  query GetSubscriptionCollections($influencerId: Int!, $withDeleted: Boolean) {
    creator(id: $influencerId) {
      customURL
    }
    collections(
      input: {
        filters: {
          influencerId: $influencerId
          accessTypes: [Premium]
          withDeleted: $withDeleted
        }
      }
    ) {
      ...SubscriptionCollection
    }
  }
  ${SubscriptionCollectionFragmentDoc}
`;

/**
 * __useGetSubscriptionCollectionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionCollectionsQuery({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *      withDeleted: // value for 'withDeleted'
 *   },
 * });
 */
export function useGetSubscriptionCollectionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubscriptionCollectionsQuery,
    GetSubscriptionCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubscriptionCollectionsQuery,
    GetSubscriptionCollectionsQueryVariables
  >(GetSubscriptionCollectionsDocument, options);
}
export function useGetSubscriptionCollectionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionCollectionsQuery,
    GetSubscriptionCollectionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionCollectionsQuery,
    GetSubscriptionCollectionsQueryVariables
  >(GetSubscriptionCollectionsDocument, options);
}
export type GetSubscriptionCollectionsQueryHookResult = ReturnType<
  typeof useGetSubscriptionCollectionsQuery
>;
export type GetSubscriptionCollectionsLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionCollectionsLazyQuery
>;
export type GetSubscriptionCollectionsQueryResult = Apollo.QueryResult<
  GetSubscriptionCollectionsQuery,
  GetSubscriptionCollectionsQueryVariables
>;
export const SetCustomUrlDocument = gql`
  mutation SetCustomURL($customURL: String!) {
    setCustomUrl(data: { customUrl: $customURL })
  }
`;
export type SetCustomUrlMutationFn = Apollo.MutationFunction<
  SetCustomUrlMutation,
  SetCustomUrlMutationVariables
>;

/**
 * __useSetCustomUrlMutation__
 *
 * To run a mutation, you first call `useSetCustomUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomUrlMutation, { data, loading, error }] = useSetCustomUrlMutation({
 *   variables: {
 *      customURL: // value for 'customURL'
 *   },
 * });
 */
export function useSetCustomUrlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCustomUrlMutation,
    SetCustomUrlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCustomUrlMutation,
    SetCustomUrlMutationVariables
  >(SetCustomUrlDocument, options);
}
export type SetCustomUrlMutationHookResult = ReturnType<
  typeof useSetCustomUrlMutation
>;
export type SetCustomUrlMutationResult =
  Apollo.MutationResult<SetCustomUrlMutation>;
export type SetCustomUrlMutationOptions = Apollo.BaseMutationOptions<
  SetCustomUrlMutation,
  SetCustomUrlMutationVariables
>;
export const GetCommentsDocument = gql`
  query GetComments($contentId: String!, $usersLimit: Int) {
    getComments(contentId: $contentId, usersLimit: $usersLimit) {
      id
      contentId
      threadId
      text
      author {
        id
        username
        profilePicture
      }
      hidden
      createdAt
      updatedAt
      thread {
        id
        contentId
        threadId
        text
        author {
          id
          username
          profilePicture
        }
        hidden
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      usersLimit: // value for 'usersLimit'
 *   },
 * });
 */
export function useGetCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCommentsQuery,
    GetCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(
    GetCommentsDocument,
    options,
  );
}
export function useGetCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCommentsQuery,
    GetCommentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(
    GetCommentsDocument,
    options,
  );
}
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<
  typeof useGetCommentsLazyQuery
>;
export type GetCommentsQueryResult = Apollo.QueryResult<
  GetCommentsQuery,
  GetCommentsQueryVariables
>;
export const CreateCommentDocument = gql`
  mutation CreateComment($creatorId: ID!, $input: CreateCommentInput!) {
    createComment(creatorId: $creatorId, input: $input) {
      id
    }
  }
`;
export type CreateCommentMutationFn = Apollo.MutationFunction<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCommentMutation,
    CreateCommentMutationVariables
  >(CreateCommentDocument, options);
}
export type CreateCommentMutationHookResult = ReturnType<
  typeof useCreateCommentMutation
>;
export type CreateCommentMutationResult =
  Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<
  CreateCommentMutation,
  CreateCommentMutationVariables
>;
export const UpdateCommentDocument = gql`
  mutation UpdateComment(
    $creatorId: ID!
    $commentId: ID!
    $input: UpdateCommentInput!
  ) {
    updateComment(creatorId: $creatorId, commentId: $commentId, input: $input)
  }
`;
export type UpdateCommentMutationFn = Apollo.MutationFunction<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      commentId: // value for 'commentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCommentMutation,
    UpdateCommentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCommentMutation,
    UpdateCommentMutationVariables
  >(UpdateCommentDocument, options);
}
export type UpdateCommentMutationHookResult = ReturnType<
  typeof useUpdateCommentMutation
>;
export type UpdateCommentMutationResult =
  Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<
  UpdateCommentMutation,
  UpdateCommentMutationVariables
>;
export const UpdateCommentVisibilityDocument = gql`
  mutation UpdateCommentVisibility(
    $creatorId: ID!
    $commentId: ID!
    $isVisible: Boolean!
  ) {
    updateCommentVisibility(
      creatorId: $creatorId
      commentId: $commentId
      isVisible: $isVisible
    )
  }
`;
export type UpdateCommentVisibilityMutationFn = Apollo.MutationFunction<
  UpdateCommentVisibilityMutation,
  UpdateCommentVisibilityMutationVariables
>;

/**
 * __useUpdateCommentVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateCommentVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentVisibilityMutation, { data, loading, error }] = useUpdateCommentVisibilityMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      commentId: // value for 'commentId'
 *      isVisible: // value for 'isVisible'
 *   },
 * });
 */
export function useUpdateCommentVisibilityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCommentVisibilityMutation,
    UpdateCommentVisibilityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCommentVisibilityMutation,
    UpdateCommentVisibilityMutationVariables
  >(UpdateCommentVisibilityDocument, options);
}
export type UpdateCommentVisibilityMutationHookResult = ReturnType<
  typeof useUpdateCommentVisibilityMutation
>;
export type UpdateCommentVisibilityMutationResult =
  Apollo.MutationResult<UpdateCommentVisibilityMutation>;
export type UpdateCommentVisibilityMutationOptions = Apollo.BaseMutationOptions<
  UpdateCommentVisibilityMutation,
  UpdateCommentVisibilityMutationVariables
>;
export const DeleteEngagementDocument = gql`
  mutation DeleteEngagement($creatorId: String!, $engagementId: ID!) {
    deleteEngagement(creatorId: $creatorId, engagementId: $engagementId)
  }
`;
export type DeleteEngagementMutationFn = Apollo.MutationFunction<
  DeleteEngagementMutation,
  DeleteEngagementMutationVariables
>;

/**
 * __useDeleteEngagementMutation__
 *
 * To run a mutation, you first call `useDeleteEngagementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEngagementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEngagementMutation, { data, loading, error }] = useDeleteEngagementMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      engagementId: // value for 'engagementId'
 *   },
 * });
 */
export function useDeleteEngagementMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEngagementMutation,
    DeleteEngagementMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteEngagementMutation,
    DeleteEngagementMutationVariables
  >(DeleteEngagementDocument, options);
}
export type DeleteEngagementMutationHookResult = ReturnType<
  typeof useDeleteEngagementMutation
>;
export type DeleteEngagementMutationResult =
  Apollo.MutationResult<DeleteEngagementMutation>;
export type DeleteEngagementMutationOptions = Apollo.BaseMutationOptions<
  DeleteEngagementMutation,
  DeleteEngagementMutationVariables
>;
export const GetContentDocument = gql`
  query GetContent($creatorId: ID!) {
    content(creatorId: $creatorId) {
      contentIds {
        id
        items {
          id
          items {
            id
            items {
              id
              items {
                id
              }
            }
          }
        }
      }
      contentItems {
        type
        value {
          ... on ContentTabValue {
            id
            name
            isPublished
          }
          ... on ContentLinkValue {
            id
            title
            url
            isPublished
            isArchived
            coverImage
            accessMethod
            bundles {
              id
              title
              status
              wasPurchased
            }
          }
          ... on ContentPDFValue {
            id
            title
            coverURL
            url
            downloadable
            isPublished
            isArchived
            fileName
            fileSize
            accessMethod
            bundles {
              id
              title
              status
              wasPurchased
            }
          }
          ... on ContentSlidesValue {
            id
            title
            coverURL
            downloadable
            isPublished
            isArchived
            accessMethod
            bundles {
              id
              title
              status
              wasPurchased
            }
          }
          ... on ContentImageValue {
            id
            title
            url
            isPublished
          }
          ... on ContentLegacyGuideValue {
            id
            title
            contentId
            count
            isPublished
            isArchived
            accessMethod
            bundles {
              id
              title
              status
              wasPurchased
            }
          }
          ... on ContentVideoValue {
            id
            title
            isPublished
            isArchived
            coverURL
            description
            downloadable
            durationMs
            allowComments
            thumbnailCustomURL
            thumbnailTimestampMs
            commentsCount
            likesCount
            libraryVideoId
            watchCount
            muxAssetId
            muxPlaybackId
            isProcessed
            videoAccessMethod: accessMethod
            videoBundles: bundles {
              id
              title
              status
              wasPurchased
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetContentQuery__
 *
 * To run a query within a React component, call `useGetContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetContentQuery,
    GetContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetContentQuery, GetContentQueryVariables>(
    GetContentDocument,
    options,
  );
}
export function useGetContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetContentQuery,
    GetContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetContentQuery, GetContentQueryVariables>(
    GetContentDocument,
    options,
  );
}
export type GetContentQueryHookResult = ReturnType<typeof useGetContentQuery>;
export type GetContentLazyQueryHookResult = ReturnType<
  typeof useGetContentLazyQuery
>;
export type GetContentQueryResult = Apollo.QueryResult<
  GetContentQuery,
  GetContentQueryVariables
>;
export const ReorderContentDocument = gql`
  mutation ReorderContent($creatorId: ID!, $contentIds: ContentIdsInput!) {
    reorderContent(creatorId: $creatorId, contentIds: $contentIds) {
      id
      items {
        id
        items {
          id
        }
      }
    }
  }
`;
export type ReorderContentMutationFn = Apollo.MutationFunction<
  ReorderContentMutation,
  ReorderContentMutationVariables
>;

/**
 * __useReorderContentMutation__
 *
 * To run a mutation, you first call `useReorderContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderContentMutation, { data, loading, error }] = useReorderContentMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useReorderContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReorderContentMutation,
    ReorderContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ReorderContentMutation,
    ReorderContentMutationVariables
  >(ReorderContentDocument, options);
}
export type ReorderContentMutationHookResult = ReturnType<
  typeof useReorderContentMutation
>;
export type ReorderContentMutationResult =
  Apollo.MutationResult<ReorderContentMutation>;
export type ReorderContentMutationOptions = Apollo.BaseMutationOptions<
  ReorderContentMutation,
  ReorderContentMutationVariables
>;
export const CreateTabDocument = gql`
  mutation CreateTab($creatorId: ID!, $input: CreateTabInput!) {
    createTab(creatorId: $creatorId, input: $input) {
      id
    }
  }
`;
export type CreateTabMutationFn = Apollo.MutationFunction<
  CreateTabMutation,
  CreateTabMutationVariables
>;

/**
 * __useCreateTabMutation__
 *
 * To run a mutation, you first call `useCreateTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTabMutation, { data, loading, error }] = useCreateTabMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTabMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateTabMutation,
    CreateTabMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTabMutation, CreateTabMutationVariables>(
    CreateTabDocument,
    options,
  );
}
export type CreateTabMutationHookResult = ReturnType<
  typeof useCreateTabMutation
>;
export type CreateTabMutationResult = Apollo.MutationResult<CreateTabMutation>;
export type CreateTabMutationOptions = Apollo.BaseMutationOptions<
  CreateTabMutation,
  CreateTabMutationVariables
>;
export const UpdateTabDocument = gql`
  mutation UpdateTab($creatorId: ID!, $itemId: ID!, $input: UpdateTabInput!) {
    updateTab(creatorId: $creatorId, itemId: $itemId, input: $input)
  }
`;
export type UpdateTabMutationFn = Apollo.MutationFunction<
  UpdateTabMutation,
  UpdateTabMutationVariables
>;

/**
 * __useUpdateTabMutation__
 *
 * To run a mutation, you first call `useUpdateTabMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTabMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTabMutation, { data, loading, error }] = useUpdateTabMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTabMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateTabMutation,
    UpdateTabMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTabMutation, UpdateTabMutationVariables>(
    UpdateTabDocument,
    options,
  );
}
export type UpdateTabMutationHookResult = ReturnType<
  typeof useUpdateTabMutation
>;
export type UpdateTabMutationResult = Apollo.MutationResult<UpdateTabMutation>;
export type UpdateTabMutationOptions = Apollo.BaseMutationOptions<
  UpdateTabMutation,
  UpdateTabMutationVariables
>;
export const CreateLinkDocument = gql`
  mutation CreateLink($creatorId: ID!, $input: CreateLinkInput!) {
    createLink(creatorId: $creatorId, input: $input) {
      id
    }
  }
`;
export type CreateLinkMutationFn = Apollo.MutationFunction<
  CreateLinkMutation,
  CreateLinkMutationVariables
>;

/**
 * __useCreateLinkMutation__
 *
 * To run a mutation, you first call `useCreateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLinkMutation, { data, loading, error }] = useCreateLinkMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLinkMutation,
    CreateLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateLinkMutation, CreateLinkMutationVariables>(
    CreateLinkDocument,
    options,
  );
}
export type CreateLinkMutationHookResult = ReturnType<
  typeof useCreateLinkMutation
>;
export type CreateLinkMutationResult =
  Apollo.MutationResult<CreateLinkMutation>;
export type CreateLinkMutationOptions = Apollo.BaseMutationOptions<
  CreateLinkMutation,
  CreateLinkMutationVariables
>;
export const UpdateLinkDocument = gql`
  mutation UpdateLink($creatorId: ID!, $itemId: ID!, $input: UpdateLinkInput!) {
    updateLink(creatorId: $creatorId, itemId: $itemId, input: $input)
  }
`;
export type UpdateLinkMutationFn = Apollo.MutationFunction<
  UpdateLinkMutation,
  UpdateLinkMutationVariables
>;

/**
 * __useUpdateLinkMutation__
 *
 * To run a mutation, you first call `useUpdateLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkMutation, { data, loading, error }] = useUpdateLinkMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLinkMutation,
    UpdateLinkMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateLinkMutation, UpdateLinkMutationVariables>(
    UpdateLinkDocument,
    options,
  );
}
export type UpdateLinkMutationHookResult = ReturnType<
  typeof useUpdateLinkMutation
>;
export type UpdateLinkMutationResult =
  Apollo.MutationResult<UpdateLinkMutation>;
export type UpdateLinkMutationOptions = Apollo.BaseMutationOptions<
  UpdateLinkMutation,
  UpdateLinkMutationVariables
>;
export const CreateLegacyGuideDocument = gql`
  mutation CreateLegacyGuide($creatorId: ID!, $input: CreateLegacyGuideInput!) {
    createLegacyGuide(creatorId: $creatorId, input: $input) {
      id
    }
  }
`;
export type CreateLegacyGuideMutationFn = Apollo.MutationFunction<
  CreateLegacyGuideMutation,
  CreateLegacyGuideMutationVariables
>;

/**
 * __useCreateLegacyGuideMutation__
 *
 * To run a mutation, you first call `useCreateLegacyGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLegacyGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLegacyGuideMutation, { data, loading, error }] = useCreateLegacyGuideMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLegacyGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateLegacyGuideMutation,
    CreateLegacyGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateLegacyGuideMutation,
    CreateLegacyGuideMutationVariables
  >(CreateLegacyGuideDocument, options);
}
export type CreateLegacyGuideMutationHookResult = ReturnType<
  typeof useCreateLegacyGuideMutation
>;
export type CreateLegacyGuideMutationResult =
  Apollo.MutationResult<CreateLegacyGuideMutation>;
export type CreateLegacyGuideMutationOptions = Apollo.BaseMutationOptions<
  CreateLegacyGuideMutation,
  CreateLegacyGuideMutationVariables
>;
export const UpdateLegacyGuideDocument = gql`
  mutation UpdateLegacyGuide(
    $creatorId: ID!
    $itemId: ID!
    $input: UpdateLegacyGuideInput!
  ) {
    updateLegacyGuide(creatorId: $creatorId, itemId: $itemId, input: $input)
  }
`;
export type UpdateLegacyGuideMutationFn = Apollo.MutationFunction<
  UpdateLegacyGuideMutation,
  UpdateLegacyGuideMutationVariables
>;

/**
 * __useUpdateLegacyGuideMutation__
 *
 * To run a mutation, you first call `useUpdateLegacyGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLegacyGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLegacyGuideMutation, { data, loading, error }] = useUpdateLegacyGuideMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLegacyGuideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateLegacyGuideMutation,
    UpdateLegacyGuideMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateLegacyGuideMutation,
    UpdateLegacyGuideMutationVariables
  >(UpdateLegacyGuideDocument, options);
}
export type UpdateLegacyGuideMutationHookResult = ReturnType<
  typeof useUpdateLegacyGuideMutation
>;
export type UpdateLegacyGuideMutationResult =
  Apollo.MutationResult<UpdateLegacyGuideMutation>;
export type UpdateLegacyGuideMutationOptions = Apollo.BaseMutationOptions<
  UpdateLegacyGuideMutation,
  UpdateLegacyGuideMutationVariables
>;
export const CreateSlidesDocument = gql`
  mutation CreateSlides($creatorId: ID!, $input: CreateSlidesInput!) {
    createSlides(creatorId: $creatorId, input: $input) {
      id
    }
  }
`;
export type CreateSlidesMutationFn = Apollo.MutationFunction<
  CreateSlidesMutation,
  CreateSlidesMutationVariables
>;

/**
 * __useCreateSlidesMutation__
 *
 * To run a mutation, you first call `useCreateSlidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSlidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSlidesMutation, { data, loading, error }] = useCreateSlidesMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSlidesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateSlidesMutation,
    CreateSlidesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateSlidesMutation,
    CreateSlidesMutationVariables
  >(CreateSlidesDocument, options);
}
export type CreateSlidesMutationHookResult = ReturnType<
  typeof useCreateSlidesMutation
>;
export type CreateSlidesMutationResult =
  Apollo.MutationResult<CreateSlidesMutation>;
export type CreateSlidesMutationOptions = Apollo.BaseMutationOptions<
  CreateSlidesMutation,
  CreateSlidesMutationVariables
>;
export const UpdateSlidesDocument = gql`
  mutation UpdateSlides(
    $creatorId: ID!
    $itemId: ID!
    $input: UpdateSlidesInput!
  ) {
    updateSlides(creatorId: $creatorId, itemId: $itemId, input: $input)
  }
`;
export type UpdateSlidesMutationFn = Apollo.MutationFunction<
  UpdateSlidesMutation,
  UpdateSlidesMutationVariables
>;

/**
 * __useUpdateSlidesMutation__
 *
 * To run a mutation, you first call `useUpdateSlidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSlidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSlidesMutation, { data, loading, error }] = useUpdateSlidesMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSlidesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateSlidesMutation,
    UpdateSlidesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateSlidesMutation,
    UpdateSlidesMutationVariables
  >(UpdateSlidesDocument, options);
}
export type UpdateSlidesMutationHookResult = ReturnType<
  typeof useUpdateSlidesMutation
>;
export type UpdateSlidesMutationResult =
  Apollo.MutationResult<UpdateSlidesMutation>;
export type UpdateSlidesMutationOptions = Apollo.BaseMutationOptions<
  UpdateSlidesMutation,
  UpdateSlidesMutationVariables
>;
export const CreateImageDocument = gql`
  mutation CreateImage(
    $creatorId: ID!
    $input: CreateImageInput!
    $file: Upload!
  ) {
    createImage(creatorId: $creatorId, input: $input, file: $file) {
      id
    }
  }
`;
export type CreateImageMutationFn = Apollo.MutationFunction<
  CreateImageMutation,
  CreateImageMutationVariables
>;

/**
 * __useCreateImageMutation__
 *
 * To run a mutation, you first call `useCreateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImageMutation, { data, loading, error }] = useCreateImageMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateImageMutation,
    CreateImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateImageMutation, CreateImageMutationVariables>(
    CreateImageDocument,
    options,
  );
}
export type CreateImageMutationHookResult = ReturnType<
  typeof useCreateImageMutation
>;
export type CreateImageMutationResult =
  Apollo.MutationResult<CreateImageMutation>;
export type CreateImageMutationOptions = Apollo.BaseMutationOptions<
  CreateImageMutation,
  CreateImageMutationVariables
>;
export const UpdateImageDocument = gql`
  mutation UpdateImage(
    $creatorId: ID!
    $itemId: ID!
    $input: UpdateImageInput!
  ) {
    updateImage(creatorId: $creatorId, itemId: $itemId, input: $input)
  }
`;
export type UpdateImageMutationFn = Apollo.MutationFunction<
  UpdateImageMutation,
  UpdateImageMutationVariables
>;

/**
 * __useUpdateImageMutation__
 *
 * To run a mutation, you first call `useUpdateImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateImageMutation, { data, loading, error }] = useUpdateImageMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateImageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateImageMutation,
    UpdateImageMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateImageMutation, UpdateImageMutationVariables>(
    UpdateImageDocument,
    options,
  );
}
export type UpdateImageMutationHookResult = ReturnType<
  typeof useUpdateImageMutation
>;
export type UpdateImageMutationResult =
  Apollo.MutationResult<UpdateImageMutation>;
export type UpdateImageMutationOptions = Apollo.BaseMutationOptions<
  UpdateImageMutation,
  UpdateImageMutationVariables
>;
export const CreatePdfDocument = gql`
  mutation CreatePDF($creatorId: ID!, $input: CreatePDFInput!, $file: Upload!) {
    createPDF(creatorId: $creatorId, input: $input, file: $file) {
      id
    }
  }
`;
export type CreatePdfMutationFn = Apollo.MutationFunction<
  CreatePdfMutation,
  CreatePdfMutationVariables
>;

/**
 * __useCreatePdfMutation__
 *
 * To run a mutation, you first call `useCreatePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPdfMutation, { data, loading, error }] = useCreatePdfMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreatePdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreatePdfMutation,
    CreatePdfMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePdfMutation, CreatePdfMutationVariables>(
    CreatePdfDocument,
    options,
  );
}
export type CreatePdfMutationHookResult = ReturnType<
  typeof useCreatePdfMutation
>;
export type CreatePdfMutationResult = Apollo.MutationResult<CreatePdfMutation>;
export type CreatePdfMutationOptions = Apollo.BaseMutationOptions<
  CreatePdfMutation,
  CreatePdfMutationVariables
>;
export const UpdatePdfDocument = gql`
  mutation UpdatePDF(
    $creatorId: ID!
    $itemId: ID!
    $input: UpdatePDFInput!
    $file: Upload
  ) {
    updatePDF(
      creatorId: $creatorId
      itemId: $itemId
      input: $input
      file: $file
    )
  }
`;
export type UpdatePdfMutationFn = Apollo.MutationFunction<
  UpdatePdfMutation,
  UpdatePdfMutationVariables
>;

/**
 * __useUpdatePdfMutation__
 *
 * To run a mutation, you first call `useUpdatePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePdfMutation, { data, loading, error }] = useUpdatePdfMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      input: // value for 'input'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdatePdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdatePdfMutation,
    UpdatePdfMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePdfMutation, UpdatePdfMutationVariables>(
    UpdatePdfDocument,
    options,
  );
}
export type UpdatePdfMutationHookResult = ReturnType<
  typeof useUpdatePdfMutation
>;
export type UpdatePdfMutationResult = Apollo.MutationResult<UpdatePdfMutation>;
export type UpdatePdfMutationOptions = Apollo.BaseMutationOptions<
  UpdatePdfMutation,
  UpdatePdfMutationVariables
>;
export const CreateVideoDocument = gql`
  mutation CreateVideo($creatorId: ID!, $input: CreateVideoInput!) {
    createVideo(creatorId: $creatorId, input: $input) {
      id
    }
  }
`;
export type CreateVideoMutationFn = Apollo.MutationFunction<
  CreateVideoMutation,
  CreateVideoMutationVariables
>;

/**
 * __useCreateVideoMutation__
 *
 * To run a mutation, you first call `useCreateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVideoMutation, { data, loading, error }] = useCreateVideoMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateVideoMutation,
    CreateVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateVideoMutation, CreateVideoMutationVariables>(
    CreateVideoDocument,
    options,
  );
}
export type CreateVideoMutationHookResult = ReturnType<
  typeof useCreateVideoMutation
>;
export type CreateVideoMutationResult =
  Apollo.MutationResult<CreateVideoMutation>;
export type CreateVideoMutationOptions = Apollo.BaseMutationOptions<
  CreateVideoMutation,
  CreateVideoMutationVariables
>;
export const UpdateVideoDocument = gql`
  mutation UpdateVideo(
    $creatorId: ID!
    $itemId: ID!
    $input: UpdateVideoInput!
  ) {
    updateVideo(creatorId: $creatorId, itemId: $itemId, input: $input)
  }
`;
export type UpdateVideoMutationFn = Apollo.MutationFunction<
  UpdateVideoMutation,
  UpdateVideoMutationVariables
>;

/**
 * __useUpdateVideoMutation__
 *
 * To run a mutation, you first call `useUpdateVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoMutation, { data, loading, error }] = useUpdateVideoMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateVideoMutation,
    UpdateVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateVideoMutation, UpdateVideoMutationVariables>(
    UpdateVideoDocument,
    options,
  );
}
export type UpdateVideoMutationHookResult = ReturnType<
  typeof useUpdateVideoMutation
>;
export type UpdateVideoMutationResult =
  Apollo.MutationResult<UpdateVideoMutation>;
export type UpdateVideoMutationOptions = Apollo.BaseMutationOptions<
  UpdateVideoMutation,
  UpdateVideoMutationVariables
>;
export const DeleteContentDocument = gql`
  mutation DeleteContent($creatorId: ID!, $itemId: ID!) {
    deleteContent(creatorId: $creatorId, itemId: $itemId)
  }
`;
export type DeleteContentMutationFn = Apollo.MutationFunction<
  DeleteContentMutation,
  DeleteContentMutationVariables
>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useDeleteContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteContentMutation,
    DeleteContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteContentMutation,
    DeleteContentMutationVariables
  >(DeleteContentDocument, options);
}
export type DeleteContentMutationHookResult = ReturnType<
  typeof useDeleteContentMutation
>;
export type DeleteContentMutationResult =
  Apollo.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = Apollo.BaseMutationOptions<
  DeleteContentMutation,
  DeleteContentMutationVariables
>;
export const SellAsSubscriptionDocument = gql`
  mutation SellAsSubscription(
    $creatorId: ID!
    $itemId: ID!
    $type: String!
    $accessMethod: ContentAccessMethod!
  ) {
    updateContent(
      creatorId: $creatorId
      itemId: $itemId
      input: {
        type: $type
        value: {
          accessMethod: $accessMethod
          isPublished: true
          isArchived: false
        }
      }
    )
  }
`;
export type SellAsSubscriptionMutationFn = Apollo.MutationFunction<
  SellAsSubscriptionMutation,
  SellAsSubscriptionMutationVariables
>;

/**
 * __useSellAsSubscriptionMutation__
 *
 * To run a mutation, you first call `useSellAsSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellAsSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellAsSubscriptionMutation, { data, loading, error }] = useSellAsSubscriptionMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      type: // value for 'type'
 *      accessMethod: // value for 'accessMethod'
 *   },
 * });
 */
export function useSellAsSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SellAsSubscriptionMutation,
    SellAsSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SellAsSubscriptionMutation,
    SellAsSubscriptionMutationVariables
  >(SellAsSubscriptionDocument, options);
}
export type SellAsSubscriptionMutationHookResult = ReturnType<
  typeof useSellAsSubscriptionMutation
>;
export type SellAsSubscriptionMutationResult =
  Apollo.MutationResult<SellAsSubscriptionMutation>;
export type SellAsSubscriptionMutationOptions = Apollo.BaseMutationOptions<
  SellAsSubscriptionMutation,
  SellAsSubscriptionMutationVariables
>;
export const SellAsAnyPurchaseDocument = gql`
  mutation SellAsAnyPurchase(
    $creatorId: ID!
    $itemId: ID!
    $type: String!
    $accessMethod: ContentAccessMethod!
  ) {
    updateContent(
      creatorId: $creatorId
      itemId: $itemId
      input: {
        type: $type
        value: { accessMethod: $accessMethod, isArchived: false }
      }
    )
  }
`;
export type SellAsAnyPurchaseMutationFn = Apollo.MutationFunction<
  SellAsAnyPurchaseMutation,
  SellAsAnyPurchaseMutationVariables
>;

/**
 * __useSellAsAnyPurchaseMutation__
 *
 * To run a mutation, you first call `useSellAsAnyPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSellAsAnyPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sellAsAnyPurchaseMutation, { data, loading, error }] = useSellAsAnyPurchaseMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      type: // value for 'type'
 *      accessMethod: // value for 'accessMethod'
 *   },
 * });
 */
export function useSellAsAnyPurchaseMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SellAsAnyPurchaseMutation,
    SellAsAnyPurchaseMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SellAsAnyPurchaseMutation,
    SellAsAnyPurchaseMutationVariables
  >(SellAsAnyPurchaseDocument, options);
}
export type SellAsAnyPurchaseMutationHookResult = ReturnType<
  typeof useSellAsAnyPurchaseMutation
>;
export type SellAsAnyPurchaseMutationResult =
  Apollo.MutationResult<SellAsAnyPurchaseMutation>;
export type SellAsAnyPurchaseMutationOptions = Apollo.BaseMutationOptions<
  SellAsAnyPurchaseMutation,
  SellAsAnyPurchaseMutationVariables
>;
export const ArchiveContentDocument = gql`
  mutation ArchiveContent($creatorId: ID!, $itemId: ID!, $type: String!) {
    updateContent(
      creatorId: $creatorId
      itemId: $itemId
      input: { type: $type, value: { isArchived: true } }
    )
  }
`;
export type ArchiveContentMutationFn = Apollo.MutationFunction<
  ArchiveContentMutation,
  ArchiveContentMutationVariables
>;

/**
 * __useArchiveContentMutation__
 *
 * To run a mutation, you first call `useArchiveContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveContentMutation, { data, loading, error }] = useArchiveContentMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useArchiveContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ArchiveContentMutation,
    ArchiveContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ArchiveContentMutation,
    ArchiveContentMutationVariables
  >(ArchiveContentDocument, options);
}
export type ArchiveContentMutationHookResult = ReturnType<
  typeof useArchiveContentMutation
>;
export type ArchiveContentMutationResult =
  Apollo.MutationResult<ArchiveContentMutation>;
export type ArchiveContentMutationOptions = Apollo.BaseMutationOptions<
  ArchiveContentMutation,
  ArchiveContentMutationVariables
>;
export const UnarchiveContentDocument = gql`
  mutation UnarchiveContent($creatorId: ID!, $itemId: ID!, $type: String!) {
    updateContent(
      creatorId: $creatorId
      itemId: $itemId
      input: { type: $type, value: { isArchived: false } }
    )
  }
`;
export type UnarchiveContentMutationFn = Apollo.MutationFunction<
  UnarchiveContentMutation,
  UnarchiveContentMutationVariables
>;

/**
 * __useUnarchiveContentMutation__
 *
 * To run a mutation, you first call `useUnarchiveContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveContentMutation, { data, loading, error }] = useUnarchiveContentMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      itemId: // value for 'itemId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUnarchiveContentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnarchiveContentMutation,
    UnarchiveContentMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnarchiveContentMutation,
    UnarchiveContentMutationVariables
  >(UnarchiveContentDocument, options);
}
export type UnarchiveContentMutationHookResult = ReturnType<
  typeof useUnarchiveContentMutation
>;
export type UnarchiveContentMutationResult =
  Apollo.MutationResult<UnarchiveContentMutation>;
export type UnarchiveContentMutationOptions = Apollo.BaseMutationOptions<
  UnarchiveContentMutation,
  UnarchiveContentMutationVariables
>;
export const GetOnboardingGuideDataDocument = gql`
  query GetOnboardingGuideData($creatorId: ID!) {
    GetChecklists(creatorId: $creatorId) {
      id
      title
      description
      estimatedDurationLabel
      scope
      strategyIds
      isActive
      tasks {
        id
        title
        subtitle
        actionUrl
        actionModal
        actionPage
        estimatedTimeLabel
        completionMode
        isChecked
        completedAt
        completedBy
      }
    }
    GetStrategies(creatorId: $creatorId) {
      id
      name
      isActive
      isSelected
      launchTimeLabel
    }
    GetOnboardingDismissal(creatorId: $creatorId) {
      webDismissedAt
    }
  }
`;

/**
 * __useGetOnboardingGuideDataQuery__
 *
 * To run a query within a React component, call `useGetOnboardingGuideDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingGuideDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingGuideDataQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetOnboardingGuideDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOnboardingGuideDataQuery,
    GetOnboardingGuideDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOnboardingGuideDataQuery,
    GetOnboardingGuideDataQueryVariables
  >(GetOnboardingGuideDataDocument, options);
}
export function useGetOnboardingGuideDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOnboardingGuideDataQuery,
    GetOnboardingGuideDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOnboardingGuideDataQuery,
    GetOnboardingGuideDataQueryVariables
  >(GetOnboardingGuideDataDocument, options);
}
export type GetOnboardingGuideDataQueryHookResult = ReturnType<
  typeof useGetOnboardingGuideDataQuery
>;
export type GetOnboardingGuideDataLazyQueryHookResult = ReturnType<
  typeof useGetOnboardingGuideDataLazyQuery
>;
export type GetOnboardingGuideDataQueryResult = Apollo.QueryResult<
  GetOnboardingGuideDataQuery,
  GetOnboardingGuideDataQueryVariables
>;
export const DismissOnboardingGuideWebDocument = gql`
  mutation DismissOnboardingGuideWeb($creatorId: ID!) {
    SaveOnboardingDismissal(creatorId: $creatorId, platform: WEB) {
      webDismissedAt
    }
  }
`;
export type DismissOnboardingGuideWebMutationFn = Apollo.MutationFunction<
  DismissOnboardingGuideWebMutation,
  DismissOnboardingGuideWebMutationVariables
>;

/**
 * __useDismissOnboardingGuideWebMutation__
 *
 * To run a mutation, you first call `useDismissOnboardingGuideWebMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissOnboardingGuideWebMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissOnboardingGuideWebMutation, { data, loading, error }] = useDismissOnboardingGuideWebMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useDismissOnboardingGuideWebMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DismissOnboardingGuideWebMutation,
    DismissOnboardingGuideWebMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DismissOnboardingGuideWebMutation,
    DismissOnboardingGuideWebMutationVariables
  >(DismissOnboardingGuideWebDocument, options);
}
export type DismissOnboardingGuideWebMutationHookResult = ReturnType<
  typeof useDismissOnboardingGuideWebMutation
>;
export type DismissOnboardingGuideWebMutationResult =
  Apollo.MutationResult<DismissOnboardingGuideWebMutation>;
export type DismissOnboardingGuideWebMutationOptions =
  Apollo.BaseMutationOptions<
    DismissOnboardingGuideWebMutation,
    DismissOnboardingGuideWebMutationVariables
  >;
export const SaveOnboardingTaskProgressDocument = gql`
  mutation SaveOnboardingTaskProgress(
    $creatorId: ID!
    $input: UpdateTaskProgressInputModel!
  ) {
    SaveTaskProgress(creatorId: $creatorId, input: $input)
  }
`;
export type SaveOnboardingTaskProgressMutationFn = Apollo.MutationFunction<
  SaveOnboardingTaskProgressMutation,
  SaveOnboardingTaskProgressMutationVariables
>;

/**
 * __useSaveOnboardingTaskProgressMutation__
 *
 * To run a mutation, you first call `useSaveOnboardingTaskProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOnboardingTaskProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOnboardingTaskProgressMutation, { data, loading, error }] = useSaveOnboardingTaskProgressMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveOnboardingTaskProgressMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveOnboardingTaskProgressMutation,
    SaveOnboardingTaskProgressMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveOnboardingTaskProgressMutation,
    SaveOnboardingTaskProgressMutationVariables
  >(SaveOnboardingTaskProgressDocument, options);
}
export type SaveOnboardingTaskProgressMutationHookResult = ReturnType<
  typeof useSaveOnboardingTaskProgressMutation
>;
export type SaveOnboardingTaskProgressMutationResult =
  Apollo.MutationResult<SaveOnboardingTaskProgressMutation>;
export type SaveOnboardingTaskProgressMutationOptions =
  Apollo.BaseMutationOptions<
    SaveOnboardingTaskProgressMutation,
    SaveOnboardingTaskProgressMutationVariables
  >;
export const SetActiveOnboardingChecklistDocument = gql`
  mutation SetActiveOnboardingChecklist(
    $creatorId: ID!
    $input: SetActiveChecklistInputModel!
  ) {
    SetActiveChecklist(creatorId: $creatorId, input: $input)
  }
`;
export type SetActiveOnboardingChecklistMutationFn = Apollo.MutationFunction<
  SetActiveOnboardingChecklistMutation,
  SetActiveOnboardingChecklistMutationVariables
>;

/**
 * __useSetActiveOnboardingChecklistMutation__
 *
 * To run a mutation, you first call `useSetActiveOnboardingChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveOnboardingChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveOnboardingChecklistMutation, { data, loading, error }] = useSetActiveOnboardingChecklistMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetActiveOnboardingChecklistMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetActiveOnboardingChecklistMutation,
    SetActiveOnboardingChecklistMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetActiveOnboardingChecklistMutation,
    SetActiveOnboardingChecklistMutationVariables
  >(SetActiveOnboardingChecklistDocument, options);
}
export type SetActiveOnboardingChecklistMutationHookResult = ReturnType<
  typeof useSetActiveOnboardingChecklistMutation
>;
export type SetActiveOnboardingChecklistMutationResult =
  Apollo.MutationResult<SetActiveOnboardingChecklistMutation>;
export type SetActiveOnboardingChecklistMutationOptions =
  Apollo.BaseMutationOptions<
    SetActiveOnboardingChecklistMutation,
    SetActiveOnboardingChecklistMutationVariables
  >;
export const MarkChecklistAsCompletedDocument = gql`
  mutation MarkChecklistAsCompleted($creatorId: ID!, $checklistId: ID!) {
    MarkChecklistAsCompleted(creatorId: $creatorId, checklistId: $checklistId)
  }
`;
export type MarkChecklistAsCompletedMutationFn = Apollo.MutationFunction<
  MarkChecklistAsCompletedMutation,
  MarkChecklistAsCompletedMutationVariables
>;

/**
 * __useMarkChecklistAsCompletedMutation__
 *
 * To run a mutation, you first call `useMarkChecklistAsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChecklistAsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChecklistAsCompletedMutation, { data, loading, error }] = useMarkChecklistAsCompletedMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      checklistId: // value for 'checklistId'
 *   },
 * });
 */
export function useMarkChecklistAsCompletedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkChecklistAsCompletedMutation,
    MarkChecklistAsCompletedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkChecklistAsCompletedMutation,
    MarkChecklistAsCompletedMutationVariables
  >(MarkChecklistAsCompletedDocument, options);
}
export type MarkChecklistAsCompletedMutationHookResult = ReturnType<
  typeof useMarkChecklistAsCompletedMutation
>;
export type MarkChecklistAsCompletedMutationResult =
  Apollo.MutationResult<MarkChecklistAsCompletedMutation>;
export type MarkChecklistAsCompletedMutationOptions =
  Apollo.BaseMutationOptions<
    MarkChecklistAsCompletedMutation,
    MarkChecklistAsCompletedMutationVariables
  >;
export const CreateDraftCollectionDocument = gql`
  mutation CreateDraftCollection($data: CreateCollectionInput!) {
    createDraftCollection(data: $data) {
      id
    }
  }
`;
export type CreateDraftCollectionMutationFn = Apollo.MutationFunction<
  CreateDraftCollectionMutation,
  CreateDraftCollectionMutationVariables
>;

/**
 * __useCreateDraftCollectionMutation__
 *
 * To run a mutation, you first call `useCreateDraftCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDraftCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDraftCollectionMutation, { data, loading, error }] = useCreateDraftCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDraftCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDraftCollectionMutation,
    CreateDraftCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDraftCollectionMutation,
    CreateDraftCollectionMutationVariables
  >(CreateDraftCollectionDocument, options);
}
export type CreateDraftCollectionMutationHookResult = ReturnType<
  typeof useCreateDraftCollectionMutation
>;
export type CreateDraftCollectionMutationResult =
  Apollo.MutationResult<CreateDraftCollectionMutation>;
export type CreateDraftCollectionMutationOptions = Apollo.BaseMutationOptions<
  CreateDraftCollectionMutation,
  CreateDraftCollectionMutationVariables
>;
export const GetHomePageDataDocument = gql`
  query GetHomePageData($creatorId: Int!, $creatorIdStr: ID!) {
    onboardingListData(creatorId: $creatorId) {
      profileReady
      paymentMethodReady
      collectionPublishedReady
    }
    GetOnboardingDismissal(creatorId: $creatorIdStr) {
      webDismissedAt
    }
    GetStrategies(creatorId: $creatorIdStr) {
      id
      isActive
      isSelected
    }
    creator(id: $creatorId) {
      id
      tier
      email
      mode
      salesModel
      offering
      mediaAvatar {
        cdn01
        image
      }
      mediaCover {
        cdn01
        image
      }
      title
      firstName
      lastName
      profileInstagram
      profileDeepLink
      isVisible
      customURL
      visibility
      tikTokConfiguration {
        pixelId
        apiSecret
      }
      createdAt
      features {
        id
        code
        name
      }
      businessModel
      customizations {
        isExclusiveMigratedToBundle
        isOtpMigratedToBundle
      }
    }
    collections(
      input: { filters: { influencerId: $creatorId, withDeleted: false } }
    ) {
      id
      name
      accessType
      publishedAt
      archivedAt
      exclusiveProgramMetadata {
        deeplinkUrl
        checkoutPageUrl
        price
      }
    }
    bundle(creatorId: $creatorId) {
      id
      status
      pricing
    }
    searchComments(
      creatorId: $creatorId
      limit: 20
      offset: 0
      status: 1
      type: 4
    ) {
      id
      textValue
      status
      type
      user {
        id
        name
        mediaThumbnail {
          cdn01
          image
        }
      }
      createdAt
      workout {
        id
        name
      }
      userActivity {
        id
        type
        floatValue
      }
    }
  }
`;

/**
 * __useGetHomePageDataQuery__
 *
 * To run a query within a React component, call `useGetHomePageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomePageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomePageDataQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      creatorIdStr: // value for 'creatorIdStr'
 *   },
 * });
 */
export function useGetHomePageDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetHomePageDataQuery,
    GetHomePageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHomePageDataQuery, GetHomePageDataQueryVariables>(
    GetHomePageDataDocument,
    options,
  );
}
export function useGetHomePageDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHomePageDataQuery,
    GetHomePageDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHomePageDataQuery,
    GetHomePageDataQueryVariables
  >(GetHomePageDataDocument, options);
}
export type GetHomePageDataQueryHookResult = ReturnType<
  typeof useGetHomePageDataQuery
>;
export type GetHomePageDataLazyQueryHookResult = ReturnType<
  typeof useGetHomePageDataLazyQuery
>;
export type GetHomePageDataQueryResult = Apollo.QueryResult<
  GetHomePageDataQuery,
  GetHomePageDataQueryVariables
>;
export const SetCreatorAsLiveDocument = gql`
  mutation SetCreatorAsLive($creatorId: Int!) {
    setCreatorAsLive(creatorId: $creatorId)
  }
`;
export type SetCreatorAsLiveMutationFn = Apollo.MutationFunction<
  SetCreatorAsLiveMutation,
  SetCreatorAsLiveMutationVariables
>;

/**
 * __useSetCreatorAsLiveMutation__
 *
 * To run a mutation, you first call `useSetCreatorAsLiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCreatorAsLiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCreatorAsLiveMutation, { data, loading, error }] = useSetCreatorAsLiveMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useSetCreatorAsLiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetCreatorAsLiveMutation,
    SetCreatorAsLiveMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetCreatorAsLiveMutation,
    SetCreatorAsLiveMutationVariables
  >(SetCreatorAsLiveDocument, options);
}
export type SetCreatorAsLiveMutationHookResult = ReturnType<
  typeof useSetCreatorAsLiveMutation
>;
export type SetCreatorAsLiveMutationResult =
  Apollo.MutationResult<SetCreatorAsLiveMutation>;
export type SetCreatorAsLiveMutationOptions = Apollo.BaseMutationOptions<
  SetCreatorAsLiveMutation,
  SetCreatorAsLiveMutationVariables
>;
export const AddFolderDocument = gql`
  mutation AddFolder($creatorId: Int!, $name: String!, $parentId: Int) {
    addFolder(creatorId: $creatorId, name: $name, parentId: $parentId) {
      id
      parentId
      name
    }
  }
`;
export type AddFolderMutationFn = Apollo.MutationFunction<
  AddFolderMutation,
  AddFolderMutationVariables
>;

/**
 * __useAddFolderMutation__
 *
 * To run a mutation, you first call `useAddFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFolderMutation, { data, loading, error }] = useAddFolderMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      name: // value for 'name'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useAddFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddFolderMutation,
    AddFolderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddFolderMutation, AddFolderMutationVariables>(
    AddFolderDocument,
    options,
  );
}
export type AddFolderMutationHookResult = ReturnType<
  typeof useAddFolderMutation
>;
export type AddFolderMutationResult = Apollo.MutationResult<AddFolderMutation>;
export type AddFolderMutationOptions = Apollo.BaseMutationOptions<
  AddFolderMutation,
  AddFolderMutationVariables
>;
export const AddToFolderDocument = gql`
  mutation AddToFolder(
    $creatorId: Int!
    $id: Int
    $folderIds: [Int!]
    $videoIds: [String!]
  ) {
    addToFolder(
      creatorId: $creatorId
      id: $id
      folderIds: $folderIds
      videoIds: $videoIds
    )
  }
`;
export type AddToFolderMutationFn = Apollo.MutationFunction<
  AddToFolderMutation,
  AddToFolderMutationVariables
>;

/**
 * __useAddToFolderMutation__
 *
 * To run a mutation, you first call `useAddToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToFolderMutation, { data, loading, error }] = useAddToFolderMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      id: // value for 'id'
 *      folderIds: // value for 'folderIds'
 *      videoIds: // value for 'videoIds'
 *   },
 * });
 */
export function useAddToFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddToFolderMutation,
    AddToFolderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddToFolderMutation, AddToFolderMutationVariables>(
    AddToFolderDocument,
    options,
  );
}
export type AddToFolderMutationHookResult = ReturnType<
  typeof useAddToFolderMutation
>;
export type AddToFolderMutationResult =
  Apollo.MutationResult<AddToFolderMutation>;
export type AddToFolderMutationOptions = Apollo.BaseMutationOptions<
  AddToFolderMutation,
  AddToFolderMutationVariables
>;
export const BulkDeleteDocument = gql`
  mutation BulkDelete(
    $creatorId: Int!
    $videoIds: [String!]
    $folderIds: [Int!]
  ) {
    bulkDelete(
      creatorId: $creatorId
      videoIds: $videoIds
      folderIds: $folderIds
    )
  }
`;
export type BulkDeleteMutationFn = Apollo.MutationFunction<
  BulkDeleteMutation,
  BulkDeleteMutationVariables
>;

/**
 * __useBulkDeleteMutation__
 *
 * To run a mutation, you first call `useBulkDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteMutation, { data, loading, error }] = useBulkDeleteMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      videoIds: // value for 'videoIds'
 *      folderIds: // value for 'folderIds'
 *   },
 * });
 */
export function useBulkDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkDeleteMutation,
    BulkDeleteMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BulkDeleteMutation, BulkDeleteMutationVariables>(
    BulkDeleteDocument,
    options,
  );
}
export type BulkDeleteMutationHookResult = ReturnType<
  typeof useBulkDeleteMutation
>;
export type BulkDeleteMutationResult =
  Apollo.MutationResult<BulkDeleteMutation>;
export type BulkDeleteMutationOptions = Apollo.BaseMutationOptions<
  BulkDeleteMutation,
  BulkDeleteMutationVariables
>;
export const BulkDeleteVideosDocument = gql`
  mutation BulkDeleteVideos($creatorId: Int!, $videoIds: [String!]!) {
    bulkDeleteVideos(creatorId: $creatorId, videoIds: $videoIds)
  }
`;
export type BulkDeleteVideosMutationFn = Apollo.MutationFunction<
  BulkDeleteVideosMutation,
  BulkDeleteVideosMutationVariables
>;

/**
 * __useBulkDeleteVideosMutation__
 *
 * To run a mutation, you first call `useBulkDeleteVideosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkDeleteVideosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkDeleteVideosMutation, { data, loading, error }] = useBulkDeleteVideosMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      videoIds: // value for 'videoIds'
 *   },
 * });
 */
export function useBulkDeleteVideosMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BulkDeleteVideosMutation,
    BulkDeleteVideosMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BulkDeleteVideosMutation,
    BulkDeleteVideosMutationVariables
  >(BulkDeleteVideosDocument, options);
}
export type BulkDeleteVideosMutationHookResult = ReturnType<
  typeof useBulkDeleteVideosMutation
>;
export type BulkDeleteVideosMutationResult =
  Apollo.MutationResult<BulkDeleteVideosMutation>;
export type BulkDeleteVideosMutationOptions = Apollo.BaseMutationOptions<
  BulkDeleteVideosMutation,
  BulkDeleteVideosMutationVariables
>;
export const DeleteFolderDocument = gql`
  mutation DeleteFolder($id: Int!) {
    deleteFolder(id: $id)
  }
`;
export type DeleteFolderMutationFn = Apollo.MutationFunction<
  DeleteFolderMutation,
  DeleteFolderMutationVariables
>;

/**
 * __useDeleteFolderMutation__
 *
 * To run a mutation, you first call `useDeleteFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFolderMutation, { data, loading, error }] = useDeleteFolderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteFolderMutation,
    DeleteFolderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteFolderMutation,
    DeleteFolderMutationVariables
  >(DeleteFolderDocument, options);
}
export type DeleteFolderMutationHookResult = ReturnType<
  typeof useDeleteFolderMutation
>;
export type DeleteFolderMutationResult =
  Apollo.MutationResult<DeleteFolderMutation>;
export type DeleteFolderMutationOptions = Apollo.BaseMutationOptions<
  DeleteFolderMutation,
  DeleteFolderMutationVariables
>;
export const DeleteVideoDocument = gql`
  mutation DeleteVideo(
    $creatorId: Int!
    $id: String!
    $videoSourceType: String!
  ) {
    deleteVideo(
      creatorId: $creatorId
      id: $id
      videoSourceType: $videoSourceType
    )
  }
`;
export type DeleteVideoMutationFn = Apollo.MutationFunction<
  DeleteVideoMutation,
  DeleteVideoMutationVariables
>;

/**
 * __useDeleteVideoMutation__
 *
 * To run a mutation, you first call `useDeleteVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVideoMutation, { data, loading, error }] = useDeleteVideoMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      id: // value for 'id'
 *      videoSourceType: // value for 'videoSourceType'
 *   },
 * });
 */
export function useDeleteVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteVideoMutation,
    DeleteVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteVideoMutation, DeleteVideoMutationVariables>(
    DeleteVideoDocument,
    options,
  );
}
export type DeleteVideoMutationHookResult = ReturnType<
  typeof useDeleteVideoMutation
>;
export type DeleteVideoMutationResult =
  Apollo.MutationResult<DeleteVideoMutation>;
export type DeleteVideoMutationOptions = Apollo.BaseMutationOptions<
  DeleteVideoMutation,
  DeleteVideoMutationVariables
>;
export const GetCreatorsFoldersDocument = gql`
  query GetCreatorsFolders($creatorId: Int!, $parentId: Int) {
    getCreatorsFolders(creatorId: $creatorId, parentId: $parentId) {
      id
      name
      parentId
      updatedAt
      creatorId
      createdAt
    }
  }
`;

/**
 * __useGetCreatorsFoldersQuery__
 *
 * To run a query within a React component, call `useGetCreatorsFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreatorsFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreatorsFoldersQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useGetCreatorsFoldersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCreatorsFoldersQuery,
    GetCreatorsFoldersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetCreatorsFoldersQuery,
    GetCreatorsFoldersQueryVariables
  >(GetCreatorsFoldersDocument, options);
}
export function useGetCreatorsFoldersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCreatorsFoldersQuery,
    GetCreatorsFoldersQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCreatorsFoldersQuery,
    GetCreatorsFoldersQueryVariables
  >(GetCreatorsFoldersDocument, options);
}
export type GetCreatorsFoldersQueryHookResult = ReturnType<
  typeof useGetCreatorsFoldersQuery
>;
export type GetCreatorsFoldersLazyQueryHookResult = ReturnType<
  typeof useGetCreatorsFoldersLazyQuery
>;
export type GetCreatorsFoldersQueryResult = Apollo.QueryResult<
  GetCreatorsFoldersQuery,
  GetCreatorsFoldersQueryVariables
>;
export const GetLibraryDocument = gql`
  query GetLibrary($creatorId: Int!, $folderId: Int) {
    getLibrary(creatorId: $creatorId, folderId: $folderId) {
      folders {
        id
        name
        parentId
        updatedAt
        creatorId
        createdAt
      }
      videos {
        uuid
        creatorId
        title
        type
        video
        image
        cdn01
        videoSourceType
        videoThumbnailUrl
        videoUrl
        duration
        aspectRatio
        status
        width
        height
        mimeType
        createdAt
        deletedAt
        description
        downloadLink {
          low {
            link
            width
            height
            filesize
          }
          medium {
            link
            width
            height
            filesize
          }
          high {
            link
            width
            height
            filesize
          }
        }
        fileSize
        updatedAt
      }
    }
  }
`;

/**
 * __useGetLibraryQuery__
 *
 * To run a query within a React component, call `useGetLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useGetLibraryQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLibraryQuery,
    GetLibraryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLibraryQuery, GetLibraryQueryVariables>(
    GetLibraryDocument,
    options,
  );
}
export function useGetLibraryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLibraryQuery,
    GetLibraryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLibraryQuery, GetLibraryQueryVariables>(
    GetLibraryDocument,
    options,
  );
}
export type GetLibraryQueryHookResult = ReturnType<typeof useGetLibraryQuery>;
export type GetLibraryLazyQueryHookResult = ReturnType<
  typeof useGetLibraryLazyQuery
>;
export type GetLibraryQueryResult = Apollo.QueryResult<
  GetLibraryQuery,
  GetLibraryQueryVariables
>;
export const GetLibraryContentDocument = gql`
  query GetLibraryContent($creatorId: Int!, $parentId: Int, $type: String) {
    getCreatorsFolders(creatorId: $creatorId, parentId: $parentId) {
      id
      name
      parentId
      updatedAt
      creatorId
      createdAt
    }
    getCreatorsMedia(
      creatorId: $creatorId
      type: $type
      includeProcessing: true
    ) {
      uuid
      creatorId
      title
      type
      video
      image
      cdn01
      videoSourceType
      videoThumbnailUrl
      videoUrl
      duration
      aspectRatio
      status
      width
      height
      mimeType
      createdAt
      deletedAt
      updatedAt
      description
      downloadLink {
        low {
          link
          width
          height
          filesize
        }
        medium {
          link
          width
          height
          filesize
        }
        high {
          link
          width
          height
          filesize
        }
      }
      fileSize
      folderId
    }
  }
`;

/**
 * __useGetLibraryContentQuery__
 *
 * To run a query within a React component, call `useGetLibraryContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryContentQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      parentId: // value for 'parentId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLibraryContentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLibraryContentQuery,
    GetLibraryContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLibraryContentQuery,
    GetLibraryContentQueryVariables
  >(GetLibraryContentDocument, options);
}
export function useGetLibraryContentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLibraryContentQuery,
    GetLibraryContentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLibraryContentQuery,
    GetLibraryContentQueryVariables
  >(GetLibraryContentDocument, options);
}
export type GetLibraryContentQueryHookResult = ReturnType<
  typeof useGetLibraryContentQuery
>;
export type GetLibraryContentLazyQueryHookResult = ReturnType<
  typeof useGetLibraryContentLazyQuery
>;
export type GetLibraryContentQueryResult = Apollo.QueryResult<
  GetLibraryContentQuery,
  GetLibraryContentQueryVariables
>;
export const GetLibraryTagsDocument = gql`
  query GetLibraryTags(
    $creatorId: ID!
    $tagId: ID
    $tagInternalName: String
    $limit: Int = 100
  ) {
    getContentIdsWithTag(
      creatorId: $creatorId
      tagId: $tagId
      tagInternalName: $tagInternalName
      limit: $limit
    )
  }
`;

/**
 * __useGetLibraryTagsQuery__
 *
 * To run a query within a React component, call `useGetLibraryTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryTagsQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      tagId: // value for 'tagId'
 *      tagInternalName: // value for 'tagInternalName'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLibraryTagsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLibraryTagsQuery,
    GetLibraryTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLibraryTagsQuery, GetLibraryTagsQueryVariables>(
    GetLibraryTagsDocument,
    options,
  );
}
export function useGetLibraryTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLibraryTagsQuery,
    GetLibraryTagsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLibraryTagsQuery, GetLibraryTagsQueryVariables>(
    GetLibraryTagsDocument,
    options,
  );
}
export type GetLibraryTagsQueryHookResult = ReturnType<
  typeof useGetLibraryTagsQuery
>;
export type GetLibraryTagsLazyQueryHookResult = ReturnType<
  typeof useGetLibraryTagsLazyQuery
>;
export type GetLibraryTagsQueryResult = Apollo.QueryResult<
  GetLibraryTagsQuery,
  GetLibraryTagsQueryVariables
>;
export const RenameFolderDocument = gql`
  mutation RenameFolder($creatorId: Int!, $name: String!, $id: Int!) {
    renameFolder(creatorId: $creatorId, name: $name, id: $id) {
      id
      parentId
      name
    }
  }
`;
export type RenameFolderMutationFn = Apollo.MutationFunction<
  RenameFolderMutation,
  RenameFolderMutationVariables
>;

/**
 * __useRenameFolderMutation__
 *
 * To run a mutation, you first call `useRenameFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameFolderMutation, { data, loading, error }] = useRenameFolderMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      name: // value for 'name'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRenameFolderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RenameFolderMutation,
    RenameFolderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RenameFolderMutation,
    RenameFolderMutationVariables
  >(RenameFolderDocument, options);
}
export type RenameFolderMutationHookResult = ReturnType<
  typeof useRenameFolderMutation
>;
export type RenameFolderMutationResult =
  Apollo.MutationResult<RenameFolderMutation>;
export type RenameFolderMutationOptions = Apollo.BaseMutationOptions<
  RenameFolderMutation,
  RenameFolderMutationVariables
>;
export const GetInfluencerNameDocument = gql`
  query GetInfluencerName($id: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
    }
  }
`;

/**
 * __useGetInfluencerNameQuery__
 *
 * To run a query within a React component, call `useGetInfluencerNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfluencerNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfluencerNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInfluencerNameQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetInfluencerNameQuery,
    GetInfluencerNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInfluencerNameQuery,
    GetInfluencerNameQueryVariables
  >(GetInfluencerNameDocument, options);
}
export function useGetInfluencerNameLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInfluencerNameQuery,
    GetInfluencerNameQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInfluencerNameQuery,
    GetInfluencerNameQueryVariables
  >(GetInfluencerNameDocument, options);
}
export type GetInfluencerNameQueryHookResult = ReturnType<
  typeof useGetInfluencerNameQuery
>;
export type GetInfluencerNameLazyQueryHookResult = ReturnType<
  typeof useGetInfluencerNameLazyQuery
>;
export type GetInfluencerNameQueryResult = Apollo.QueryResult<
  GetInfluencerNameQuery,
  GetInfluencerNameQueryVariables
>;
export const GetProfileDocument = gql`
  query GetProfile($id: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
      customURL
      mode
      title
      gender
      messageProfile
      keywords
      accomplishments
      profileInstagram
      profileTiktok
      profileYoutubeChannel
      businessModel
      offering
      mediaAvatar {
        ...fullMedia
      }
      mediaCover {
        ...fullMedia
      }
      mediaWelcome {
        ...fullMedia
      }
      mediaBanner {
        ...fullMedia
      }
      customColorSchema {
        primaryColor
      }
    }
  }
  ${FullMediaFragmentDoc}
`;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export function useGetProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetProfileQuery,
    GetProfileQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(
    GetProfileDocument,
    options,
  );
}
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<
  typeof useGetProfileLazyQuery
>;
export type GetProfileQueryResult = Apollo.QueryResult<
  GetProfileQuery,
  GetProfileQueryVariables
>;
export const IsCustomUrlAvailableDocument = gql`
  query IsCustomUrlAvailable($customUrl: String!) {
    isCustomUrlAvailable(data: $customUrl)
  }
`;

/**
 * __useIsCustomUrlAvailableQuery__
 *
 * To run a query within a React component, call `useIsCustomUrlAvailableQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsCustomUrlAvailableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsCustomUrlAvailableQuery({
 *   variables: {
 *      customUrl: // value for 'customUrl'
 *   },
 * });
 */
export function useIsCustomUrlAvailableQuery(
  baseOptions: Apollo.QueryHookOptions<
    IsCustomUrlAvailableQuery,
    IsCustomUrlAvailableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    IsCustomUrlAvailableQuery,
    IsCustomUrlAvailableQueryVariables
  >(IsCustomUrlAvailableDocument, options);
}
export function useIsCustomUrlAvailableLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IsCustomUrlAvailableQuery,
    IsCustomUrlAvailableQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    IsCustomUrlAvailableQuery,
    IsCustomUrlAvailableQueryVariables
  >(IsCustomUrlAvailableDocument, options);
}
export type IsCustomUrlAvailableQueryHookResult = ReturnType<
  typeof useIsCustomUrlAvailableQuery
>;
export type IsCustomUrlAvailableLazyQueryHookResult = ReturnType<
  typeof useIsCustomUrlAvailableLazyQuery
>;
export type IsCustomUrlAvailableQueryResult = Apollo.QueryResult<
  IsCustomUrlAvailableQuery,
  IsCustomUrlAvailableQueryVariables
>;
export const AddCustomDomainDocument = gql`
  mutation addCustomDomain($domain: String!, $influencerId: Int!) {
    addCustomDomain(domain: $domain, influencerId: $influencerId) {
      id
      status
      domain
      additionalInfo
    }
  }
`;
export type AddCustomDomainMutationFn = Apollo.MutationFunction<
  AddCustomDomainMutation,
  AddCustomDomainMutationVariables
>;

/**
 * __useAddCustomDomainMutation__
 *
 * To run a mutation, you first call `useAddCustomDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCustomDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCustomDomainMutation, { data, loading, error }] = useAddCustomDomainMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *      influencerId: // value for 'influencerId'
 *   },
 * });
 */
export function useAddCustomDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddCustomDomainMutation,
    AddCustomDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddCustomDomainMutation,
    AddCustomDomainMutationVariables
  >(AddCustomDomainDocument, options);
}
export type AddCustomDomainMutationHookResult = ReturnType<
  typeof useAddCustomDomainMutation
>;
export type AddCustomDomainMutationResult =
  Apollo.MutationResult<AddCustomDomainMutation>;
export type AddCustomDomainMutationOptions = Apollo.BaseMutationOptions<
  AddCustomDomainMutation,
  AddCustomDomainMutationVariables
>;
export const ConfirmDomainDocument = gql`
  mutation ConfirmDomain($domainId: Int!, $influencerId: Int!) {
    confirmDomain(domainId: $domainId, influencerId: $influencerId) {
      id
      status
      domain
      additionalInfo
    }
  }
`;
export type ConfirmDomainMutationFn = Apollo.MutationFunction<
  ConfirmDomainMutation,
  ConfirmDomainMutationVariables
>;

/**
 * __useConfirmDomainMutation__
 *
 * To run a mutation, you first call `useConfirmDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDomainMutation, { data, loading, error }] = useConfirmDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      influencerId: // value for 'influencerId'
 *   },
 * });
 */
export function useConfirmDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ConfirmDomainMutation,
    ConfirmDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ConfirmDomainMutation,
    ConfirmDomainMutationVariables
  >(ConfirmDomainDocument, options);
}
export type ConfirmDomainMutationHookResult = ReturnType<
  typeof useConfirmDomainMutation
>;
export type ConfirmDomainMutationResult =
  Apollo.MutationResult<ConfirmDomainMutation>;
export type ConfirmDomainMutationOptions = Apollo.BaseMutationOptions<
  ConfirmDomainMutation,
  ConfirmDomainMutationVariables
>;
export const CustomDomainsDocument = gql`
  query CustomDomains($id: Int!) {
    creator(id: $id) {
      id
      firstName
      lastName
      customURL
      customDomains {
        id
        domain
        status
        additionalInfo
      }
    }
  }
`;

/**
 * __useCustomDomainsQuery__
 *
 * To run a query within a React component, call `useCustomDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomDomainsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomDomainsQuery(
  baseOptions: Apollo.QueryHookOptions<
    CustomDomainsQuery,
    CustomDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomDomainsQuery, CustomDomainsQueryVariables>(
    CustomDomainsDocument,
    options,
  );
}
export function useCustomDomainsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomDomainsQuery,
    CustomDomainsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomDomainsQuery, CustomDomainsQueryVariables>(
    CustomDomainsDocument,
    options,
  );
}
export type CustomDomainsQueryHookResult = ReturnType<
  typeof useCustomDomainsQuery
>;
export type CustomDomainsLazyQueryHookResult = ReturnType<
  typeof useCustomDomainsLazyQuery
>;
export type CustomDomainsQueryResult = Apollo.QueryResult<
  CustomDomainsQuery,
  CustomDomainsQueryVariables
>;
export const RemoveCustomDomainDocument = gql`
  mutation removeCustomDomain($domainId: Int!, $influencerId: Int!) {
    removeDomain(domainId: $domainId, influencerId: $influencerId)
  }
`;
export type RemoveCustomDomainMutationFn = Apollo.MutationFunction<
  RemoveCustomDomainMutation,
  RemoveCustomDomainMutationVariables
>;

/**
 * __useRemoveCustomDomainMutation__
 *
 * To run a mutation, you first call `useRemoveCustomDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCustomDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCustomDomainMutation, { data, loading, error }] = useRemoveCustomDomainMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      influencerId: // value for 'influencerId'
 *   },
 * });
 */
export function useRemoveCustomDomainMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCustomDomainMutation,
    RemoveCustomDomainMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveCustomDomainMutation,
    RemoveCustomDomainMutationVariables
  >(RemoveCustomDomainDocument, options);
}
export type RemoveCustomDomainMutationHookResult = ReturnType<
  typeof useRemoveCustomDomainMutation
>;
export type RemoveCustomDomainMutationResult =
  Apollo.MutationResult<RemoveCustomDomainMutation>;
export type RemoveCustomDomainMutationOptions = Apollo.BaseMutationOptions<
  RemoveCustomDomainMutation,
  RemoveCustomDomainMutationVariables
>;
export const GetOtpDefaultFeeDocument = gql`
  query GetOtpDefaultFee($id: Int!) {
    creator(id: $id) {
      otpDefaultFee
      otpBundleDefaultFee
    }
  }
`;

/**
 * __useGetOtpDefaultFeeQuery__
 *
 * To run a query within a React component, call `useGetOtpDefaultFeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtpDefaultFeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtpDefaultFeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOtpDefaultFeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOtpDefaultFeeQuery,
    GetOtpDefaultFeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOtpDefaultFeeQuery, GetOtpDefaultFeeQueryVariables>(
    GetOtpDefaultFeeDocument,
    options,
  );
}
export function useGetOtpDefaultFeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOtpDefaultFeeQuery,
    GetOtpDefaultFeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOtpDefaultFeeQuery,
    GetOtpDefaultFeeQueryVariables
  >(GetOtpDefaultFeeDocument, options);
}
export type GetOtpDefaultFeeQueryHookResult = ReturnType<
  typeof useGetOtpDefaultFeeQuery
>;
export type GetOtpDefaultFeeLazyQueryHookResult = ReturnType<
  typeof useGetOtpDefaultFeeLazyQuery
>;
export type GetOtpDefaultFeeQueryResult = Apollo.QueryResult<
  GetOtpDefaultFeeQuery,
  GetOtpDefaultFeeQueryVariables
>;
export const GetSubscriptionRevenueDocument = gql`
  query GetSubscriptionRevenue($influencerId: Int!) {
    subscriptionRevenue(influencerId: $influencerId) {
      revenueSplit {
        creatorId
        productType
        attributionType
        splitCriteria
        referralPercent
        engagementPercent
        playbookPercent
        deletedAt
      }
      distribution {
        creatorId
        productType
        attributionType
        distributionType
        deletedAt
      }
      payout {
        creatorId
        ruleType
        amount
        startDate
        endDate
        deletedAt
      }
    }
  }
`;

/**
 * __useGetSubscriptionRevenueQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionRevenueQuery({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *   },
 * });
 */
export function useGetSubscriptionRevenueQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSubscriptionRevenueQuery,
    GetSubscriptionRevenueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetSubscriptionRevenueQuery,
    GetSubscriptionRevenueQueryVariables
  >(GetSubscriptionRevenueDocument, options);
}
export function useGetSubscriptionRevenueLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSubscriptionRevenueQuery,
    GetSubscriptionRevenueQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSubscriptionRevenueQuery,
    GetSubscriptionRevenueQueryVariables
  >(GetSubscriptionRevenueDocument, options);
}
export type GetSubscriptionRevenueQueryHookResult = ReturnType<
  typeof useGetSubscriptionRevenueQuery
>;
export type GetSubscriptionRevenueLazyQueryHookResult = ReturnType<
  typeof useGetSubscriptionRevenueLazyQuery
>;
export type GetSubscriptionRevenueQueryResult = Apollo.QueryResult<
  GetSubscriptionRevenueQuery,
  GetSubscriptionRevenueQueryVariables
>;
export const SetOtpDefaultFeeDocument = gql`
  mutation SetOtpDefaultFee($data: SetOtpDefaultFeeInput!) {
    setOtpDefaultFee(data: $data)
  }
`;
export type SetOtpDefaultFeeMutationFn = Apollo.MutationFunction<
  SetOtpDefaultFeeMutation,
  SetOtpDefaultFeeMutationVariables
>;

/**
 * __useSetOtpDefaultFeeMutation__
 *
 * To run a mutation, you first call `useSetOtpDefaultFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOtpDefaultFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOtpDefaultFeeMutation, { data, loading, error }] = useSetOtpDefaultFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetOtpDefaultFeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetOtpDefaultFeeMutation,
    SetOtpDefaultFeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetOtpDefaultFeeMutation,
    SetOtpDefaultFeeMutationVariables
  >(SetOtpDefaultFeeDocument, options);
}
export type SetOtpDefaultFeeMutationHookResult = ReturnType<
  typeof useSetOtpDefaultFeeMutation
>;
export type SetOtpDefaultFeeMutationResult =
  Apollo.MutationResult<SetOtpDefaultFeeMutation>;
export type SetOtpDefaultFeeMutationOptions = Apollo.BaseMutationOptions<
  SetOtpDefaultFeeMutation,
  SetOtpDefaultFeeMutationVariables
>;
export const SetOtpOfferDefaultFeeDocument = gql`
  mutation SetOtpOfferDefaultFee($data: SetOtpDefaultFeeInput!) {
    setOtpOfferDefaultFee(data: $data)
  }
`;
export type SetOtpOfferDefaultFeeMutationFn = Apollo.MutationFunction<
  SetOtpOfferDefaultFeeMutation,
  SetOtpOfferDefaultFeeMutationVariables
>;

/**
 * __useSetOtpOfferDefaultFeeMutation__
 *
 * To run a mutation, you first call `useSetOtpOfferDefaultFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetOtpOfferDefaultFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setOtpOfferDefaultFeeMutation, { data, loading, error }] = useSetOtpOfferDefaultFeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetOtpOfferDefaultFeeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetOtpOfferDefaultFeeMutation,
    SetOtpOfferDefaultFeeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetOtpOfferDefaultFeeMutation,
    SetOtpOfferDefaultFeeMutationVariables
  >(SetOtpOfferDefaultFeeDocument, options);
}
export type SetOtpOfferDefaultFeeMutationHookResult = ReturnType<
  typeof useSetOtpOfferDefaultFeeMutation
>;
export type SetOtpOfferDefaultFeeMutationResult =
  Apollo.MutationResult<SetOtpOfferDefaultFeeMutation>;
export type SetOtpOfferDefaultFeeMutationOptions = Apollo.BaseMutationOptions<
  SetOtpOfferDefaultFeeMutation,
  SetOtpOfferDefaultFeeMutationVariables
>;
export const SetRevenueSplitRulesDocument = gql`
  mutation SetRevenueSplitRules($data: SetRevenueSplitRulesInput!) {
    setRevenueSplitRules(data: $data)
  }
`;
export type SetRevenueSplitRulesMutationFn = Apollo.MutationFunction<
  SetRevenueSplitRulesMutation,
  SetRevenueSplitRulesMutationVariables
>;

/**
 * __useSetRevenueSplitRulesMutation__
 *
 * To run a mutation, you first call `useSetRevenueSplitRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRevenueSplitRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRevenueSplitRulesMutation, { data, loading, error }] = useSetRevenueSplitRulesMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetRevenueSplitRulesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetRevenueSplitRulesMutation,
    SetRevenueSplitRulesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetRevenueSplitRulesMutation,
    SetRevenueSplitRulesMutationVariables
  >(SetRevenueSplitRulesDocument, options);
}
export type SetRevenueSplitRulesMutationHookResult = ReturnType<
  typeof useSetRevenueSplitRulesMutation
>;
export type SetRevenueSplitRulesMutationResult =
  Apollo.MutationResult<SetRevenueSplitRulesMutation>;
export type SetRevenueSplitRulesMutationOptions = Apollo.BaseMutationOptions<
  SetRevenueSplitRulesMutation,
  SetRevenueSplitRulesMutationVariables
>;
export const GetCrmDataDocument = gql`
  query GetCrmData($creatorId: Int!) {
    creator(id: $creatorId) {
      id
      visibility
      businessModel
      offering
      bundle {
        id
        title
        pricing
        status
        isFree
      }
      purchasedOtpProducts {
        id
        productType
        name
      }
      freeOfferProducts {
        id
        productType
        name
      }
      convertedToProducts {
        productType
        name
      }
      subscribedProducts
    }
  }
`;

/**
 * __useGetCrmDataQuery__
 *
 * To run a query within a React component, call `useGetCrmDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCrmDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCrmDataQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetCrmDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCrmDataQuery,
    GetCrmDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCrmDataQuery, GetCrmDataQueryVariables>(
    GetCrmDataDocument,
    options,
  );
}
export function useGetCrmDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCrmDataQuery,
    GetCrmDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCrmDataQuery, GetCrmDataQueryVariables>(
    GetCrmDataDocument,
    options,
  );
}
export type GetCrmDataQueryHookResult = ReturnType<typeof useGetCrmDataQuery>;
export type GetCrmDataLazyQueryHookResult = ReturnType<
  typeof useGetCrmDataLazyQuery
>;
export type GetCrmDataQueryResult = Apollo.QueryResult<
  GetCrmDataQuery,
  GetCrmDataQueryVariables
>;
export const GetDirectMessageStatusDocument = gql`
  query GetDirectMessageStatus($id: Int!) {
    creator(id: $id) {
      offering
      businessModel
      features {
        id
        code
        name
      }
      customizations {
        premiumFeaturesOTPIds
      }
    }
  }
`;

/**
 * __useGetDirectMessageStatusQuery__
 *
 * To run a query within a React component, call `useGetDirectMessageStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectMessageStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectMessageStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDirectMessageStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetDirectMessageStatusQuery,
    GetDirectMessageStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetDirectMessageStatusQuery,
    GetDirectMessageStatusQueryVariables
  >(GetDirectMessageStatusDocument, options);
}
export function useGetDirectMessageStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDirectMessageStatusQuery,
    GetDirectMessageStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDirectMessageStatusQuery,
    GetDirectMessageStatusQueryVariables
  >(GetDirectMessageStatusDocument, options);
}
export type GetDirectMessageStatusQueryHookResult = ReturnType<
  typeof useGetDirectMessageStatusQuery
>;
export type GetDirectMessageStatusLazyQueryHookResult = ReturnType<
  typeof useGetDirectMessageStatusLazyQuery
>;
export type GetDirectMessageStatusQueryResult = Apollo.QueryResult<
  GetDirectMessageStatusQuery,
  GetDirectMessageStatusQueryVariables
>;
export const GetUserInfoDocument = gql`
  query GetUserInfo($userIds: [Int!]!) {
    getUsersInfoByIds(userIds: $userIds) {
      id
      username
      badges
      profilePicture
      email
      marketing
      hasDirectMessagesAccess
    }
  }
`;

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useGetUserInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options,
  );
}
export function useGetUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserInfoQuery,
    GetUserInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(
    GetUserInfoDocument,
    options,
  );
}
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<
  typeof useGetUserInfoLazyQuery
>;
export type GetUserInfoQueryResult = Apollo.QueryResult<
  GetUserInfoQuery,
  GetUserInfoQueryVariables
>;
export const UpsertConsumerByIdDocument = gql`
  mutation upsertConsumerById($id: Int!) {
    upsertConsumerById(id: $id)
  }
`;
export type UpsertConsumerByIdMutationFn = Apollo.MutationFunction<
  UpsertConsumerByIdMutation,
  UpsertConsumerByIdMutationVariables
>;

/**
 * __useUpsertConsumerByIdMutation__
 *
 * To run a mutation, you first call `useUpsertConsumerByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertConsumerByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertConsumerByIdMutation, { data, loading, error }] = useUpsertConsumerByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpsertConsumerByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpsertConsumerByIdMutation,
    UpsertConsumerByIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpsertConsumerByIdMutation,
    UpsertConsumerByIdMutationVariables
  >(UpsertConsumerByIdDocument, options);
}
export type UpsertConsumerByIdMutationHookResult = ReturnType<
  typeof useUpsertConsumerByIdMutation
>;
export type UpsertConsumerByIdMutationResult =
  Apollo.MutationResult<UpsertConsumerByIdMutation>;
export type UpsertConsumerByIdMutationOptions = Apollo.BaseMutationOptions<
  UpsertConsumerByIdMutation,
  UpsertConsumerByIdMutationVariables
>;
export const EditVideoDocument = gql`
  mutation EditVideo(
    $name: String
    $description: String
    $id: String!
    $creatorId: Int!
    $thumbnailTimestamp: Float
    $videoSourceType: String!
  ) {
    editVideo(
      name: $name
      description: $description
      id: $id
      creatorId: $creatorId
      thumbnailTimestamp: $thumbnailTimestamp
      videoSourceType: $videoSourceType
    ) {
      uuid
      creatorId
      title
      type
      video
      image
      cdn01
      videoSourceType
      videoThumbnailUrl
      videoUrl
      duration
      aspectRatio
      status
      width
      height
      mimeType
      createdAt
      deletedAt
      downloadLink {
        low {
          link
          width
          height
          filesize
        }
        medium {
          link
          width
          height
          filesize
        }
        high {
          link
          width
          height
          filesize
        }
      }
      fileSize
    }
  }
`;
export type EditVideoMutationFn = Apollo.MutationFunction<
  EditVideoMutation,
  EditVideoMutationVariables
>;

/**
 * __useEditVideoMutation__
 *
 * To run a mutation, you first call `useEditVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editVideoMutation, { data, loading, error }] = useEditVideoMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      creatorId: // value for 'creatorId'
 *      thumbnailTimestamp: // value for 'thumbnailTimestamp'
 *      videoSourceType: // value for 'videoSourceType'
 *   },
 * });
 */
export function useEditVideoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EditVideoMutation,
    EditVideoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditVideoMutation, EditVideoMutationVariables>(
    EditVideoDocument,
    options,
  );
}
export type EditVideoMutationHookResult = ReturnType<
  typeof useEditVideoMutation
>;
export type EditVideoMutationResult = Apollo.MutationResult<EditVideoMutation>;
export type EditVideoMutationOptions = Apollo.BaseMutationOptions<
  EditVideoMutation,
  EditVideoMutationVariables
>;
export const GetLivestreamStatusDocument = gql`
  query GetLivestreamStatus($id: Int!) {
    creator(id: $id) {
      features {
        id
        code
        name
      }
    }
  }
`;

/**
 * __useGetLivestreamStatusQuery__
 *
 * To run a query within a React component, call `useGetLivestreamStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLivestreamStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLivestreamStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLivestreamStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLivestreamStatusQuery,
    GetLivestreamStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLivestreamStatusQuery,
    GetLivestreamStatusQueryVariables
  >(GetLivestreamStatusDocument, options);
}
export function useGetLivestreamStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLivestreamStatusQuery,
    GetLivestreamStatusQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLivestreamStatusQuery,
    GetLivestreamStatusQueryVariables
  >(GetLivestreamStatusDocument, options);
}
export type GetLivestreamStatusQueryHookResult = ReturnType<
  typeof useGetLivestreamStatusQuery
>;
export type GetLivestreamStatusLazyQueryHookResult = ReturnType<
  typeof useGetLivestreamStatusLazyQuery
>;
export type GetLivestreamStatusQueryResult = Apollo.QueryResult<
  GetLivestreamStatusQuery,
  GetLivestreamStatusQueryVariables
>;
export const CreateInfluencerDocument = gql`
  mutation createInfluencer($data: CreateInfluencerInput!) {
    createInfluencer(data: $data) {
      id
    }
  }
`;
export type CreateInfluencerMutationFn = Apollo.MutationFunction<
  CreateInfluencerMutation,
  CreateInfluencerMutationVariables
>;

/**
 * __useCreateInfluencerMutation__
 *
 * To run a mutation, you first call `useCreateInfluencerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInfluencerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInfluencerMutation, { data, loading, error }] = useCreateInfluencerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInfluencerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateInfluencerMutation,
    CreateInfluencerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateInfluencerMutation,
    CreateInfluencerMutationVariables
  >(CreateInfluencerDocument, options);
}
export type CreateInfluencerMutationHookResult = ReturnType<
  typeof useCreateInfluencerMutation
>;
export type CreateInfluencerMutationResult =
  Apollo.MutationResult<CreateInfluencerMutation>;
export type CreateInfluencerMutationOptions = Apollo.BaseMutationOptions<
  CreateInfluencerMutation,
  CreateInfluencerMutationVariables
>;
export const SaveModalityKeywordsDocument = gql`
  mutation SaveModalityKeywords($data: CreatorProfileUpdateInput!) {
    updateCreatorProfile(data: $data)
  }
`;
export type SaveModalityKeywordsMutationFn = Apollo.MutationFunction<
  SaveModalityKeywordsMutation,
  SaveModalityKeywordsMutationVariables
>;

/**
 * __useSaveModalityKeywordsMutation__
 *
 * To run a mutation, you first call `useSaveModalityKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveModalityKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveModalityKeywordsMutation, { data, loading, error }] = useSaveModalityKeywordsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSaveModalityKeywordsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveModalityKeywordsMutation,
    SaveModalityKeywordsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveModalityKeywordsMutation,
    SaveModalityKeywordsMutationVariables
  >(SaveModalityKeywordsDocument, options);
}
export type SaveModalityKeywordsMutationHookResult = ReturnType<
  typeof useSaveModalityKeywordsMutation
>;
export type SaveModalityKeywordsMutationResult =
  Apollo.MutationResult<SaveModalityKeywordsMutation>;
export type SaveModalityKeywordsMutationOptions = Apollo.BaseMutationOptions<
  SaveModalityKeywordsMutation,
  SaveModalityKeywordsMutationVariables
>;
export const GetOnboardingQuestionsDocument = gql`
  query GetOnboardingQuestions($platform: Platform!) {
    GetOnboardingQuestions(platform: $platform) {
      id
      title
      subtitle
      type
      targetCategory
      isRequired
      platforms
      answers {
        id
        title
        subtitle
        weight
      }
    }
  }
`;

/**
 * __useGetOnboardingQuestionsQuery__
 *
 * To run a query within a React component, call `useGetOnboardingQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingQuestionsQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetOnboardingQuestionsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOnboardingQuestionsQuery,
    GetOnboardingQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOnboardingQuestionsQuery,
    GetOnboardingQuestionsQueryVariables
  >(GetOnboardingQuestionsDocument, options);
}
export function useGetOnboardingQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOnboardingQuestionsQuery,
    GetOnboardingQuestionsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOnboardingQuestionsQuery,
    GetOnboardingQuestionsQueryVariables
  >(GetOnboardingQuestionsDocument, options);
}
export type GetOnboardingQuestionsQueryHookResult = ReturnType<
  typeof useGetOnboardingQuestionsQuery
>;
export type GetOnboardingQuestionsLazyQueryHookResult = ReturnType<
  typeof useGetOnboardingQuestionsLazyQuery
>;
export type GetOnboardingQuestionsQueryResult = Apollo.QueryResult<
  GetOnboardingQuestionsQuery,
  GetOnboardingQuestionsQueryVariables
>;
export const GetOnboardingResponsesDocument = gql`
  query GetOnboardingResponses($creatorId: ID!) {
    GetOnboardingResponses(creatorId: $creatorId) {
      questionId
      answerIds
      textValue
    }
  }
`;

/**
 * __useGetOnboardingResponsesQuery__
 *
 * To run a query within a React component, call `useGetOnboardingResponsesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingResponsesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingResponsesQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetOnboardingResponsesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOnboardingResponsesQuery,
    GetOnboardingResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOnboardingResponsesQuery,
    GetOnboardingResponsesQueryVariables
  >(GetOnboardingResponsesDocument, options);
}
export function useGetOnboardingResponsesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOnboardingResponsesQuery,
    GetOnboardingResponsesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOnboardingResponsesQuery,
    GetOnboardingResponsesQueryVariables
  >(GetOnboardingResponsesDocument, options);
}
export type GetOnboardingResponsesQueryHookResult = ReturnType<
  typeof useGetOnboardingResponsesQuery
>;
export type GetOnboardingResponsesLazyQueryHookResult = ReturnType<
  typeof useGetOnboardingResponsesLazyQuery
>;
export type GetOnboardingResponsesQueryResult = Apollo.QueryResult<
  GetOnboardingResponsesQuery,
  GetOnboardingResponsesQueryVariables
>;
export const GetOnboardingDismissalDocument = gql`
  query GetOnboardingDismissal($creatorId: ID!) {
    GetOnboardingDismissal(creatorId: $creatorId) {
      webDismissedAt
      mobileDismissedAt
    }
  }
`;

/**
 * __useGetOnboardingDismissalQuery__
 *
 * To run a query within a React component, call `useGetOnboardingDismissalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingDismissalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingDismissalQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetOnboardingDismissalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOnboardingDismissalQuery,
    GetOnboardingDismissalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetOnboardingDismissalQuery,
    GetOnboardingDismissalQueryVariables
  >(GetOnboardingDismissalDocument, options);
}
export function useGetOnboardingDismissalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOnboardingDismissalQuery,
    GetOnboardingDismissalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetOnboardingDismissalQuery,
    GetOnboardingDismissalQueryVariables
  >(GetOnboardingDismissalDocument, options);
}
export type GetOnboardingDismissalQueryHookResult = ReturnType<
  typeof useGetOnboardingDismissalQuery
>;
export type GetOnboardingDismissalLazyQueryHookResult = ReturnType<
  typeof useGetOnboardingDismissalLazyQuery
>;
export type GetOnboardingDismissalQueryResult = Apollo.QueryResult<
  GetOnboardingDismissalQuery,
  GetOnboardingDismissalQueryVariables
>;
export const GetStrategiesDocument = gql`
  query GetStrategies($creatorId: ID!) {
    GetStrategies(creatorId: $creatorId) {
      id
      name
      tagline
      description
      superTitle
      pills
      features
      priceLabel
      programLengthLabel
      launchTimeLabel
      coverImageUrl
      isRecommended
      isActive
      isSelected
      caseStudies {
        id
        strategyId
        title
        subtitle
        description
        coverImageHorizontalUrl
        coverImageVerticalUrl
        creatorName
        creatorInstagramName
        documentUrl
      }
    }
  }
`;

/**
 * __useGetStrategiesQuery__
 *
 * To run a query within a React component, call `useGetStrategiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrategiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrategiesQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetStrategiesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetStrategiesQuery,
    GetStrategiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetStrategiesQuery, GetStrategiesQueryVariables>(
    GetStrategiesDocument,
    options,
  );
}
export function useGetStrategiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStrategiesQuery,
    GetStrategiesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetStrategiesQuery, GetStrategiesQueryVariables>(
    GetStrategiesDocument,
    options,
  );
}
export type GetStrategiesQueryHookResult = ReturnType<
  typeof useGetStrategiesQuery
>;
export type GetStrategiesLazyQueryHookResult = ReturnType<
  typeof useGetStrategiesLazyQuery
>;
export type GetStrategiesQueryResult = Apollo.QueryResult<
  GetStrategiesQuery,
  GetStrategiesQueryVariables
>;
export const GetBookingStepDocument = gql`
  query GetBookingStep($creatorId: ID!) {
    GetBookingStep(creatorId: $creatorId) {
      status
      qualified
      amKey
      amDisplayName
      meetingUrl
      prefillEmail
      prefillFirstName
    }
  }
`;

/**
 * __useGetBookingStepQuery__
 *
 * To run a query within a React component, call `useGetBookingStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingStepQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useGetBookingStepQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBookingStepQuery,
    GetBookingStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBookingStepQuery, GetBookingStepQueryVariables>(
    GetBookingStepDocument,
    options,
  );
}
export function useGetBookingStepLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingStepQuery,
    GetBookingStepQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBookingStepQuery, GetBookingStepQueryVariables>(
    GetBookingStepDocument,
    options,
  );
}
export type GetBookingStepQueryHookResult = ReturnType<
  typeof useGetBookingStepQuery
>;
export type GetBookingStepLazyQueryHookResult = ReturnType<
  typeof useGetBookingStepLazyQuery
>;
export type GetBookingStepQueryResult = Apollo.QueryResult<
  GetBookingStepQuery,
  GetBookingStepQueryVariables
>;
export const GetStrategyScoringCategoriesDocument = gql`
  query GetStrategyScoringCategories {
    GetStrategyScoringCategory {
      id
      name
    }
  }
`;

/**
 * __useGetStrategyScoringCategoriesQuery__
 *
 * To run a query within a React component, call `useGetStrategyScoringCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrategyScoringCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrategyScoringCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStrategyScoringCategoriesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStrategyScoringCategoriesQuery,
    GetStrategyScoringCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStrategyScoringCategoriesQuery,
    GetStrategyScoringCategoriesQueryVariables
  >(GetStrategyScoringCategoriesDocument, options);
}
export function useGetStrategyScoringCategoriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStrategyScoringCategoriesQuery,
    GetStrategyScoringCategoriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStrategyScoringCategoriesQuery,
    GetStrategyScoringCategoriesQueryVariables
  >(GetStrategyScoringCategoriesDocument, options);
}
export type GetStrategyScoringCategoriesQueryHookResult = ReturnType<
  typeof useGetStrategyScoringCategoriesQuery
>;
export type GetStrategyScoringCategoriesLazyQueryHookResult = ReturnType<
  typeof useGetStrategyScoringCategoriesLazyQuery
>;
export type GetStrategyScoringCategoriesQueryResult = Apollo.QueryResult<
  GetStrategyScoringCategoriesQuery,
  GetStrategyScoringCategoriesQueryVariables
>;
export const GetStrategyScoringRulesDocument = gql`
  query GetStrategyScoringRules {
    GetStrategyScoringRules {
      id
      strategyId
      categoryId
      minScore
      maxScore
    }
  }
`;

/**
 * __useGetStrategyScoringRulesQuery__
 *
 * To run a query within a React component, call `useGetStrategyScoringRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStrategyScoringRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStrategyScoringRulesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStrategyScoringRulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetStrategyScoringRulesQuery,
    GetStrategyScoringRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetStrategyScoringRulesQuery,
    GetStrategyScoringRulesQueryVariables
  >(GetStrategyScoringRulesDocument, options);
}
export function useGetStrategyScoringRulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetStrategyScoringRulesQuery,
    GetStrategyScoringRulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetStrategyScoringRulesQuery,
    GetStrategyScoringRulesQueryVariables
  >(GetStrategyScoringRulesDocument, options);
}
export type GetStrategyScoringRulesQueryHookResult = ReturnType<
  typeof useGetStrategyScoringRulesQuery
>;
export type GetStrategyScoringRulesLazyQueryHookResult = ReturnType<
  typeof useGetStrategyScoringRulesLazyQuery
>;
export type GetStrategyScoringRulesQueryResult = Apollo.QueryResult<
  GetStrategyScoringRulesQuery,
  GetStrategyScoringRulesQueryVariables
>;
export const SaveOnboardingResponsesDocument = gql`
  mutation SaveOnboardingResponses(
    $creatorId: ID!
    $responses: [OnboardingResponseInput!]!
  ) {
    SaveOnboardingResponses(
      creatorId: $creatorId
      responses: $responses
      platform: WEB
    )
  }
`;
export type SaveOnboardingResponsesMutationFn = Apollo.MutationFunction<
  SaveOnboardingResponsesMutation,
  SaveOnboardingResponsesMutationVariables
>;

/**
 * __useSaveOnboardingResponsesMutation__
 *
 * To run a mutation, you first call `useSaveOnboardingResponsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOnboardingResponsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOnboardingResponsesMutation, { data, loading, error }] = useSaveOnboardingResponsesMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useSaveOnboardingResponsesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveOnboardingResponsesMutation,
    SaveOnboardingResponsesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveOnboardingResponsesMutation,
    SaveOnboardingResponsesMutationVariables
  >(SaveOnboardingResponsesDocument, options);
}
export type SaveOnboardingResponsesMutationHookResult = ReturnType<
  typeof useSaveOnboardingResponsesMutation
>;
export type SaveOnboardingResponsesMutationResult =
  Apollo.MutationResult<SaveOnboardingResponsesMutation>;
export type SaveOnboardingResponsesMutationOptions = Apollo.BaseMutationOptions<
  SaveOnboardingResponsesMutation,
  SaveOnboardingResponsesMutationVariables
>;
export const SaveSelectedStrategyDocument = gql`
  mutation SaveSelectedStrategy($creatorId: ID!, $strategyId: ID!) {
    SaveSelectedStrategy(creatorId: $creatorId, strategyId: $strategyId)
  }
`;
export type SaveSelectedStrategyMutationFn = Apollo.MutationFunction<
  SaveSelectedStrategyMutation,
  SaveSelectedStrategyMutationVariables
>;

/**
 * __useSaveSelectedStrategyMutation__
 *
 * To run a mutation, you first call `useSaveSelectedStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSelectedStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSelectedStrategyMutation, { data, loading, error }] = useSaveSelectedStrategyMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      strategyId: // value for 'strategyId'
 *   },
 * });
 */
export function useSaveSelectedStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveSelectedStrategyMutation,
    SaveSelectedStrategyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveSelectedStrategyMutation,
    SaveSelectedStrategyMutationVariables
  >(SaveSelectedStrategyDocument, options);
}
export type SaveSelectedStrategyMutationHookResult = ReturnType<
  typeof useSaveSelectedStrategyMutation
>;
export type SaveSelectedStrategyMutationResult =
  Apollo.MutationResult<SaveSelectedStrategyMutation>;
export type SaveSelectedStrategyMutationOptions = Apollo.BaseMutationOptions<
  SaveSelectedStrategyMutation,
  SaveSelectedStrategyMutationVariables
>;
export const SaveOnboardingDismissalDocument = gql`
  mutation SaveOnboardingDismissal($creatorId: ID!, $platform: Platform!) {
    SaveOnboardingDismissal(creatorId: $creatorId, platform: $platform) {
      webDismissedAt
      mobileDismissedAt
    }
  }
`;
export type SaveOnboardingDismissalMutationFn = Apollo.MutationFunction<
  SaveOnboardingDismissalMutation,
  SaveOnboardingDismissalMutationVariables
>;

/**
 * __useSaveOnboardingDismissalMutation__
 *
 * To run a mutation, you first call `useSaveOnboardingDismissalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveOnboardingDismissalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveOnboardingDismissalMutation, { data, loading, error }] = useSaveOnboardingDismissalMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useSaveOnboardingDismissalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveOnboardingDismissalMutation,
    SaveOnboardingDismissalMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SaveOnboardingDismissalMutation,
    SaveOnboardingDismissalMutationVariables
  >(SaveOnboardingDismissalDocument, options);
}
export type SaveOnboardingDismissalMutationHookResult = ReturnType<
  typeof useSaveOnboardingDismissalMutation
>;
export type SaveOnboardingDismissalMutationResult =
  Apollo.MutationResult<SaveOnboardingDismissalMutation>;
export type SaveOnboardingDismissalMutationOptions = Apollo.BaseMutationOptions<
  SaveOnboardingDismissalMutation,
  SaveOnboardingDismissalMutationVariables
>;
export const ResetOnboardingDocument = gql`
  mutation ResetOnboarding($creatorId: ID!) {
    ResetOnboarding(creatorId: $creatorId)
  }
`;
export type ResetOnboardingMutationFn = Apollo.MutationFunction<
  ResetOnboardingMutation,
  ResetOnboardingMutationVariables
>;

/**
 * __useResetOnboardingMutation__
 *
 * To run a mutation, you first call `useResetOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetOnboardingMutation, { data, loading, error }] = useResetOnboardingMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useResetOnboardingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetOnboardingMutation,
    ResetOnboardingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetOnboardingMutation,
    ResetOnboardingMutationVariables
  >(ResetOnboardingDocument, options);
}
export type ResetOnboardingMutationHookResult = ReturnType<
  typeof useResetOnboardingMutation
>;
export type ResetOnboardingMutationResult =
  Apollo.MutationResult<ResetOnboardingMutation>;
export type ResetOnboardingMutationOptions = Apollo.BaseMutationOptions<
  ResetOnboardingMutation,
  ResetOnboardingMutationVariables
>;
export const ClearSelectedStrategyDocument = gql`
  mutation ClearSelectedStrategy($creatorId: ID!) {
    ClearSelectedStrategy(creatorId: $creatorId)
  }
`;
export type ClearSelectedStrategyMutationFn = Apollo.MutationFunction<
  ClearSelectedStrategyMutation,
  ClearSelectedStrategyMutationVariables
>;

/**
 * __useClearSelectedStrategyMutation__
 *
 * To run a mutation, you first call `useClearSelectedStrategyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearSelectedStrategyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearSelectedStrategyMutation, { data, loading, error }] = useClearSelectedStrategyMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useClearSelectedStrategyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearSelectedStrategyMutation,
    ClearSelectedStrategyMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClearSelectedStrategyMutation,
    ClearSelectedStrategyMutationVariables
  >(ClearSelectedStrategyDocument, options);
}
export type ClearSelectedStrategyMutationHookResult = ReturnType<
  typeof useClearSelectedStrategyMutation
>;
export type ClearSelectedStrategyMutationResult =
  Apollo.MutationResult<ClearSelectedStrategyMutation>;
export type ClearSelectedStrategyMutationOptions = Apollo.BaseMutationOptions<
  ClearSelectedStrategyMutation,
  ClearSelectedStrategyMutationVariables
>;
export const ProgramsGetListDocument = gql`
  query ProgramsGetList($influencerId: Int!) {
    creator(id: $influencerId) {
      id
      customURL
      profileDeepLink
      businessModel
      features {
        id
        code
      }
    }
    bundle(creatorId: $influencerId) {
      id
      title
      isPlatformBundle
      isFree
      status
      pricing
      deeplinkUrl
      landingPageUrl
      checkoutPage {
        url
      }
      oneTimeProduct {
        price
      }
      items {
        itemType
        itemId
      }
    }
    collections(
      input: { filters: { influencerId: $influencerId, withDeleted: false } }
    ) {
      ...programsListItem
    }
  }
  ${ProgramsListItemFragmentDoc}
`;

/**
 * __useProgramsGetListQuery__
 *
 * To run a query within a React component, call `useProgramsGetListQuery` and pass it any options that fit your needs.
 * When your component renders, `useProgramsGetListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProgramsGetListQuery({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *   },
 * });
 */
export function useProgramsGetListQuery(
  baseOptions: Apollo.QueryHookOptions<
    ProgramsGetListQuery,
    ProgramsGetListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ProgramsGetListQuery, ProgramsGetListQueryVariables>(
    ProgramsGetListDocument,
    options,
  );
}
export function useProgramsGetListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProgramsGetListQuery,
    ProgramsGetListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ProgramsGetListQuery,
    ProgramsGetListQueryVariables
  >(ProgramsGetListDocument, options);
}
export type ProgramsGetListQueryHookResult = ReturnType<
  typeof useProgramsGetListQuery
>;
export type ProgramsGetListLazyQueryHookResult = ReturnType<
  typeof useProgramsGetListLazyQuery
>;
export type ProgramsGetListQueryResult = Apollo.QueryResult<
  ProgramsGetListQuery,
  ProgramsGetListQueryVariables
>;
export const ProgramsConvertToSubscriptionDocument = gql`
  mutation ProgramsConvertToSubscription($programId: Int!) {
    convertToSubscriptionProgram(programId: $programId) {
      ...programsListItem
    }
  }
  ${ProgramsListItemFragmentDoc}
`;
export type ProgramsConvertToSubscriptionMutationFn = Apollo.MutationFunction<
  ProgramsConvertToSubscriptionMutation,
  ProgramsConvertToSubscriptionMutationVariables
>;

/**
 * __useProgramsConvertToSubscriptionMutation__
 *
 * To run a mutation, you first call `useProgramsConvertToSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramsConvertToSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programsConvertToSubscriptionMutation, { data, loading, error }] = useProgramsConvertToSubscriptionMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramsConvertToSubscriptionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProgramsConvertToSubscriptionMutation,
    ProgramsConvertToSubscriptionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProgramsConvertToSubscriptionMutation,
    ProgramsConvertToSubscriptionMutationVariables
  >(ProgramsConvertToSubscriptionDocument, options);
}
export type ProgramsConvertToSubscriptionMutationHookResult = ReturnType<
  typeof useProgramsConvertToSubscriptionMutation
>;
export type ProgramsConvertToSubscriptionMutationResult =
  Apollo.MutationResult<ProgramsConvertToSubscriptionMutation>;
export type ProgramsConvertToSubscriptionMutationOptions =
  Apollo.BaseMutationOptions<
    ProgramsConvertToSubscriptionMutation,
    ProgramsConvertToSubscriptionMutationVariables
  >;
export const ProgramsConvertToUnassignedDocument = gql`
  mutation ProgramsConvertToUnassigned($programId: Int!) {
    convertToUnassignedProgram(programId: $programId) {
      ...programsListItem
    }
  }
  ${ProgramsListItemFragmentDoc}
`;
export type ProgramsConvertToUnassignedMutationFn = Apollo.MutationFunction<
  ProgramsConvertToUnassignedMutation,
  ProgramsConvertToUnassignedMutationVariables
>;

/**
 * __useProgramsConvertToUnassignedMutation__
 *
 * To run a mutation, you first call `useProgramsConvertToUnassignedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProgramsConvertToUnassignedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [programsConvertToUnassignedMutation, { data, loading, error }] = useProgramsConvertToUnassignedMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useProgramsConvertToUnassignedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProgramsConvertToUnassignedMutation,
    ProgramsConvertToUnassignedMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ProgramsConvertToUnassignedMutation,
    ProgramsConvertToUnassignedMutationVariables
  >(ProgramsConvertToUnassignedDocument, options);
}
export type ProgramsConvertToUnassignedMutationHookResult = ReturnType<
  typeof useProgramsConvertToUnassignedMutation
>;
export type ProgramsConvertToUnassignedMutationResult =
  Apollo.MutationResult<ProgramsConvertToUnassignedMutation>;
export type ProgramsConvertToUnassignedMutationOptions =
  Apollo.BaseMutationOptions<
    ProgramsConvertToUnassignedMutation,
    ProgramsConvertToUnassignedMutationVariables
  >;
export const CreateCouponDocument = gql`
  mutation CreateCoupon(
    $code: String!
    $influencerId: Int!
    $subscriptionProviderPriceId: String
    $name: String!
    $productType: CouponProductType!
    $discountType: CouponDiscountType!
    $discountAmount: Int
    $percentOff: Float
    $maxRedemptions: Int
    $paidProductIds: [Int!]
    $expiresAt: DateTime
    $compatibleWithFreeTrial: Boolean
  ) {
    createCoupon(
      input: {
        code: $code
        influencerId: $influencerId
        subscriptionProviderPriceId: $subscriptionProviderPriceId
        name: $name
        productType: $productType
        discountType: $discountType
        discountAmount: $discountAmount
        percentOff: $percentOff
        maxRedemptions: $maxRedemptions
        expiresAt: $expiresAt
        paidProductIds: $paidProductIds
        compatibleWithFreeTrial: $compatibleWithFreeTrial
      }
    ) {
      code
      createdAt
      discountAmount
      expiresAt
      id
      influencerId
      isActive
      maxRedemptions
      name
      percentOff
      providerCouponId
      redemptions
      paidProductIds
      productType
      discountType
      subscriptionProviderPriceId
      compatibleWithFreeTrial
    }
  }
`;
export type CreateCouponMutationFn = Apollo.MutationFunction<
  CreateCouponMutation,
  CreateCouponMutationVariables
>;

/**
 * __useCreateCouponMutation__
 *
 * To run a mutation, you first call `useCreateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponMutation, { data, loading, error }] = useCreateCouponMutation({
 *   variables: {
 *      code: // value for 'code'
 *      influencerId: // value for 'influencerId'
 *      subscriptionProviderPriceId: // value for 'subscriptionProviderPriceId'
 *      name: // value for 'name'
 *      productType: // value for 'productType'
 *      discountType: // value for 'discountType'
 *      discountAmount: // value for 'discountAmount'
 *      percentOff: // value for 'percentOff'
 *      maxRedemptions: // value for 'maxRedemptions'
 *      paidProductIds: // value for 'paidProductIds'
 *      expiresAt: // value for 'expiresAt'
 *      compatibleWithFreeTrial: // value for 'compatibleWithFreeTrial'
 *   },
 * });
 */
export function useCreateCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCouponMutation,
    CreateCouponMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCouponMutation,
    CreateCouponMutationVariables
  >(CreateCouponDocument, options);
}
export type CreateCouponMutationHookResult = ReturnType<
  typeof useCreateCouponMutation
>;
export type CreateCouponMutationResult =
  Apollo.MutationResult<CreateCouponMutation>;
export type CreateCouponMutationOptions = Apollo.BaseMutationOptions<
  CreateCouponMutation,
  CreateCouponMutationVariables
>;
export const DeactivateCouponDocument = gql`
  mutation DeactivateCoupon($id: Int!) {
    deactivateCoupon(id: $id) {
      code
      createdAt
      discountAmount
      expiresAt
      id
      influencerId
      isActive
      maxRedemptions
      name
      paidProductIds
      percentOff
      providerCouponId
      redemptions
    }
  }
`;
export type DeactivateCouponMutationFn = Apollo.MutationFunction<
  DeactivateCouponMutation,
  DeactivateCouponMutationVariables
>;

/**
 * __useDeactivateCouponMutation__
 *
 * To run a mutation, you first call `useDeactivateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCouponMutation, { data, loading, error }] = useDeactivateCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeactivateCouponMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeactivateCouponMutation,
    DeactivateCouponMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeactivateCouponMutation,
    DeactivateCouponMutationVariables
  >(DeactivateCouponDocument, options);
}
export type DeactivateCouponMutationHookResult = ReturnType<
  typeof useDeactivateCouponMutation
>;
export type DeactivateCouponMutationResult =
  Apollo.MutationResult<DeactivateCouponMutation>;
export type DeactivateCouponMutationOptions = Apollo.BaseMutationOptions<
  DeactivateCouponMutation,
  DeactivateCouponMutationVariables
>;
export const GetBundlesByPricingDocument = gql`
  query GetBundlesByPricing(
    $creatorId: Int!
    $bundlePricing: [BundlePricing!]
  ) {
    bundle(creatorId: $creatorId, bundlePricing: $bundlePricing) {
      id
      title
      influencerId
      status
      description
      items {
        contentId
        itemId
        itemType
      }
      pricing
      oneTimeProduct {
        id
        price
        playbookFee
        providerPriceId
        providerProductId
      }
      wasPurchased
      checkoutPage {
        url
        type
      }
      landingPageUrl
      deeplinkUrl
    }
  }
`;

/**
 * __useGetBundlesByPricingQuery__
 *
 * To run a query within a React component, call `useGetBundlesByPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundlesByPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundlesByPricingQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      bundlePricing: // value for 'bundlePricing'
 *   },
 * });
 */
export function useGetBundlesByPricingQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBundlesByPricingQuery,
    GetBundlesByPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetBundlesByPricingQuery,
    GetBundlesByPricingQueryVariables
  >(GetBundlesByPricingDocument, options);
}
export function useGetBundlesByPricingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBundlesByPricingQuery,
    GetBundlesByPricingQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetBundlesByPricingQuery,
    GetBundlesByPricingQueryVariables
  >(GetBundlesByPricingDocument, options);
}
export type GetBundlesByPricingQueryHookResult = ReturnType<
  typeof useGetBundlesByPricingQuery
>;
export type GetBundlesByPricingLazyQueryHookResult = ReturnType<
  typeof useGetBundlesByPricingLazyQuery
>;
export type GetBundlesByPricingQueryResult = Apollo.QueryResult<
  GetBundlesByPricingQuery,
  GetBundlesByPricingQueryVariables
>;
export const GetCouponDetailsDocument = gql`
  query GetCouponDetails($discountId: Int!) {
    getCouponDetails(id: $discountId) {
      coupon {
        name
        id
        code
        discountAmount
        discountType
        percentOff
        productType
        code
        createdAt
        maxRedemptions
        redemptions
        expiresAt
        paidProductIds
        influencerId
        isActive
        subscriptionProviderPriceIds
        referralCampaignId
        compatibleWithFreeTrial
      }
      metrics {
        activeSubscriber
        new
        returning
        totalRedemptions
        upgrading
      }
      paidPrograms {
        id
        name
        exclusiveProgramMetadata {
          discountPercent
          price
          playbookFee
        }
      }
      paidOtpBundles {
        createdAt
        description
        id
        influencerId
        isPlatformBundle
        pricing
        status
        title
        updatedAt
        oneTimeProduct {
          id
          playbookFee
          price
          providerPriceId
          providerProductId
        }
        checkoutPage {
          url
        }
      }
      redemptionsList {
        email
        name
        redeemedAt
        userId
        userStatusAtRedemption
      }
      subscriptionTierPrices {
        id
        price
        providerPriceId
        billingCycleInterval
      }
    }
  }
`;

/**
 * __useGetCouponDetailsQuery__
 *
 * To run a query within a React component, call `useGetCouponDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponDetailsQuery({
 *   variables: {
 *      discountId: // value for 'discountId'
 *   },
 * });
 */
export function useGetCouponDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCouponDetailsQuery,
    GetCouponDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCouponDetailsQuery, GetCouponDetailsQueryVariables>(
    GetCouponDetailsDocument,
    options,
  );
}
export function useGetCouponDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCouponDetailsQuery,
    GetCouponDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCouponDetailsQuery,
    GetCouponDetailsQueryVariables
  >(GetCouponDetailsDocument, options);
}
export type GetCouponDetailsQueryHookResult = ReturnType<
  typeof useGetCouponDetailsQuery
>;
export type GetCouponDetailsLazyQueryHookResult = ReturnType<
  typeof useGetCouponDetailsLazyQuery
>;
export type GetCouponDetailsQueryResult = Apollo.QueryResult<
  GetCouponDetailsQuery,
  GetCouponDetailsQueryVariables
>;
export const GetOtpPriceDocument = gql`
  query GetOTPPrice($collectionId: Int!) {
    collection(collectionId: $collectionId) {
      exclusiveProgramMetadata {
        checkoutPageUrl
        price
        playbookFee
        originalPrice
        discountPercent
      }
    }
  }
`;

/**
 * __useGetOtpPriceQuery__
 *
 * To run a query within a React component, call `useGetOtpPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtpPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtpPriceQuery({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *   },
 * });
 */
export function useGetOtpPriceQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetOtpPriceQuery,
    GetOtpPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOtpPriceQuery, GetOtpPriceQueryVariables>(
    GetOtpPriceDocument,
    options,
  );
}
export function useGetOtpPriceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOtpPriceQuery,
    GetOtpPriceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOtpPriceQuery, GetOtpPriceQueryVariables>(
    GetOtpPriceDocument,
    options,
  );
}
export type GetOtpPriceQueryHookResult = ReturnType<typeof useGetOtpPriceQuery>;
export type GetOtpPriceLazyQueryHookResult = ReturnType<
  typeof useGetOtpPriceLazyQuery
>;
export type GetOtpPriceQueryResult = Apollo.QueryResult<
  GetOtpPriceQuery,
  GetOtpPriceQueryVariables
>;
export const EnableCheckoutFreeTrialDocument = gql`
  mutation EnableCheckoutFreeTrial($data: EnableCreatorSettingsInput!) {
    enableCheckoutFreeTrial(data: $data)
  }
`;
export type EnableCheckoutFreeTrialMutationFn = Apollo.MutationFunction<
  EnableCheckoutFreeTrialMutation,
  EnableCheckoutFreeTrialMutationVariables
>;

/**
 * __useEnableCheckoutFreeTrialMutation__
 *
 * To run a mutation, you first call `useEnableCheckoutFreeTrialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCheckoutFreeTrialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCheckoutFreeTrialMutation, { data, loading, error }] = useEnableCheckoutFreeTrialMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEnableCheckoutFreeTrialMutation(
  baseOptions?: Apollo.MutationHookOptions<
    EnableCheckoutFreeTrialMutation,
    EnableCheckoutFreeTrialMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    EnableCheckoutFreeTrialMutation,
    EnableCheckoutFreeTrialMutationVariables
  >(EnableCheckoutFreeTrialDocument, options);
}
export type EnableCheckoutFreeTrialMutationHookResult = ReturnType<
  typeof useEnableCheckoutFreeTrialMutation
>;
export type EnableCheckoutFreeTrialMutationResult =
  Apollo.MutationResult<EnableCheckoutFreeTrialMutation>;
export type EnableCheckoutFreeTrialMutationOptions = Apollo.BaseMutationOptions<
  EnableCheckoutFreeTrialMutation,
  EnableCheckoutFreeTrialMutationVariables
>;
export const SetDirectMessagingDocument = gql`
  mutation SetDirectMessaging($data: EnableCreatorSettingsInput!) {
    setDirectMessaging(data: $data)
  }
`;
export type SetDirectMessagingMutationFn = Apollo.MutationFunction<
  SetDirectMessagingMutation,
  SetDirectMessagingMutationVariables
>;

/**
 * __useSetDirectMessagingMutation__
 *
 * To run a mutation, you first call `useSetDirectMessagingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDirectMessagingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDirectMessagingMutation, { data, loading, error }] = useSetDirectMessagingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetDirectMessagingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetDirectMessagingMutation,
    SetDirectMessagingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetDirectMessagingMutation,
    SetDirectMessagingMutationVariables
  >(SetDirectMessagingDocument, options);
}
export type SetDirectMessagingMutationHookResult = ReturnType<
  typeof useSetDirectMessagingMutation
>;
export type SetDirectMessagingMutationResult =
  Apollo.MutationResult<SetDirectMessagingMutation>;
export type SetDirectMessagingMutationOptions = Apollo.BaseMutationOptions<
  SetDirectMessagingMutation,
  SetDirectMessagingMutationVariables
>;
export const SetLivestreamingDocument = gql`
  mutation SetLivestreaming($data: EnableCreatorSettingsInput!) {
    setLivestreaming(data: $data)
  }
`;
export type SetLivestreamingMutationFn = Apollo.MutationFunction<
  SetLivestreamingMutation,
  SetLivestreamingMutationVariables
>;

/**
 * __useSetLivestreamingMutation__
 *
 * To run a mutation, you first call `useSetLivestreamingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLivestreamingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLivestreamingMutation, { data, loading, error }] = useSetLivestreamingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useSetLivestreamingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetLivestreamingMutation,
    SetLivestreamingMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetLivestreamingMutation,
    SetLivestreamingMutationVariables
  >(SetLivestreamingDocument, options);
}
export type SetLivestreamingMutationHookResult = ReturnType<
  typeof useSetLivestreamingMutation
>;
export type SetLivestreamingMutationResult =
  Apollo.MutationResult<SetLivestreamingMutation>;
export type SetLivestreamingMutationOptions = Apollo.BaseMutationOptions<
  SetLivestreamingMutation,
  SetLivestreamingMutationVariables
>;
export const UpdateContactInfoDocument = gql`
  mutation UpdateContactInfo($data: CreatorProfileUpdateInput!) {
    updateCreatorProfile(data: $data)
  }
`;
export type UpdateContactInfoMutationFn = Apollo.MutationFunction<
  UpdateContactInfoMutation,
  UpdateContactInfoMutationVariables
>;

/**
 * __useUpdateContactInfoMutation__
 *
 * To run a mutation, you first call `useUpdateContactInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactInfoMutation, { data, loading, error }] = useUpdateContactInfoMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContactInfoMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateContactInfoMutation,
    UpdateContactInfoMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateContactInfoMutation,
    UpdateContactInfoMutationVariables
  >(UpdateContactInfoDocument, options);
}
export type UpdateContactInfoMutationHookResult = ReturnType<
  typeof useUpdateContactInfoMutation
>;
export type UpdateContactInfoMutationResult =
  Apollo.MutationResult<UpdateContactInfoMutation>;
export type UpdateContactInfoMutationOptions = Apollo.BaseMutationOptions<
  UpdateContactInfoMutation,
  UpdateContactInfoMutationVariables
>;
export const GetWorkoutCustomizationsDocument = gql`
  query GetWorkoutCustomizations($id: Int!) {
    creator(id: $id) {
      id
      customizations {
        isNewRunning
      }
    }
  }
`;

/**
 * __useGetWorkoutCustomizationsQuery__
 *
 * To run a query within a React component, call `useGetWorkoutCustomizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkoutCustomizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkoutCustomizationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkoutCustomizationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkoutCustomizationsQuery,
    GetWorkoutCustomizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetWorkoutCustomizationsQuery,
    GetWorkoutCustomizationsQueryVariables
  >(GetWorkoutCustomizationsDocument, options);
}
export function useGetWorkoutCustomizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkoutCustomizationsQuery,
    GetWorkoutCustomizationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWorkoutCustomizationsQuery,
    GetWorkoutCustomizationsQueryVariables
  >(GetWorkoutCustomizationsDocument, options);
}
export type GetWorkoutCustomizationsQueryHookResult = ReturnType<
  typeof useGetWorkoutCustomizationsQuery
>;
export type GetWorkoutCustomizationsLazyQueryHookResult = ReturnType<
  typeof useGetWorkoutCustomizationsLazyQuery
>;
export type GetWorkoutCustomizationsQueryResult = Apollo.QueryResult<
  GetWorkoutCustomizationsQuery,
  GetWorkoutCustomizationsQueryVariables
>;
export const GetLibraryTextsDocument = gql`
  query getLibraryTexts($creatorId: Int!, $type: String) {
    getCreatorsMedia(creatorId: $creatorId, type: $type) {
      uuid
      title
      description
    }
  }
`;

/**
 * __useGetLibraryTextsQuery__
 *
 * To run a query within a React component, call `useGetLibraryTextsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLibraryTextsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLibraryTextsQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLibraryTextsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetLibraryTextsQuery,
    GetLibraryTextsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLibraryTextsQuery, GetLibraryTextsQueryVariables>(
    GetLibraryTextsDocument,
    options,
  );
}
export function useGetLibraryTextsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLibraryTextsQuery,
    GetLibraryTextsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLibraryTextsQuery,
    GetLibraryTextsQueryVariables
  >(GetLibraryTextsDocument, options);
}
export type GetLibraryTextsQueryHookResult = ReturnType<
  typeof useGetLibraryTextsQuery
>;
export type GetLibraryTextsLazyQueryHookResult = ReturnType<
  typeof useGetLibraryTextsLazyQuery
>;
export type GetLibraryTextsQueryResult = Apollo.QueryResult<
  GetLibraryTextsQuery,
  GetLibraryTextsQueryVariables
>;
export const GetVideoByIdDocument = gql`
  query getVideoById(
    $creatorId: Int!
    $videoId: String!
    $videoSourceType: String!
  ) {
    getVideoById(
      creatorId: $creatorId
      videoId: $videoId
      videoSourceType: $videoSourceType
    ) {
      uuid
      creatorId
      title
      description
      type
      video
      image
      cdn01
      videoSourceType
      videoThumbnailUrl
      videoUrl
      duration
      aspectRatio
      status
      width
      height
      mimeType
      createdAt
      updatedAt
      deletedAt
      fileSize
      downloadLink {
        ...download
      }
      folderId
    }
  }
  ${DownloadFragmentDoc}
`;

/**
 * __useGetVideoByIdQuery__
 *
 * To run a query within a React component, call `useGetVideoByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVideoByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVideoByIdQuery({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *      videoId: // value for 'videoId'
 *      videoSourceType: // value for 'videoSourceType'
 *   },
 * });
 */
export function useGetVideoByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetVideoByIdQuery,
    GetVideoByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetVideoByIdQuery, GetVideoByIdQueryVariables>(
    GetVideoByIdDocument,
    options,
  );
}
export function useGetVideoByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetVideoByIdQuery,
    GetVideoByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetVideoByIdQuery, GetVideoByIdQueryVariables>(
    GetVideoByIdDocument,
    options,
  );
}
export type GetVideoByIdQueryHookResult = ReturnType<
  typeof useGetVideoByIdQuery
>;
export type GetVideoByIdLazyQueryHookResult = ReturnType<
  typeof useGetVideoByIdLazyQuery
>;
export type GetVideoByIdQueryResult = Apollo.QueryResult<
  GetVideoByIdQuery,
  GetVideoByIdQueryVariables
>;
export const GetWorkoutByIdDocument = gql`
  query getWorkoutById($id: Int!) {
    workout(id: $id) {
      id
      name
      description
      duration
      media {
        ...media
      }
      mediaCover {
        ...media
      }
      mediaExercise {
        ...media
      }
      tags {
        id
        category
        title
      }
      requiredEquipment
      difficulty
      publishedAt
      timeZone
      updatedAt
      archivedAt
      programId
      programIndex
      isProtected
      isVisible
      isClass
      messagePush
      exercises {
        ...exerciseSingle
        ...exerciseMultiple
        ...exerciseCustom
        ...exerciseMux
        ...exerciseYoutube
        ...exerciseAutoplayed
      }
      swapConfig {
        swapsEnabled
      }
    }
  }
  ${MediaFragmentDoc}
  ${ExerciseSingleFragmentDoc}
  ${ExerciseMultipleFragmentDoc}
  ${ExerciseCustomFragmentDoc}
  ${ExerciseMuxFragmentDoc}
  ${ExerciseYoutubeFragmentDoc}
  ${ExerciseAutoplayedFragmentDoc}
`;

/**
 * __useGetWorkoutByIdQuery__
 *
 * To run a query within a React component, call `useGetWorkoutByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkoutByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkoutByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWorkoutByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWorkoutByIdQuery,
    GetWorkoutByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>(
    GetWorkoutByIdDocument,
    options,
  );
}
export function useGetWorkoutByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWorkoutByIdQuery,
    GetWorkoutByIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWorkoutByIdQuery, GetWorkoutByIdQueryVariables>(
    GetWorkoutByIdDocument,
    options,
  );
}
export type GetWorkoutByIdQueryHookResult = ReturnType<
  typeof useGetWorkoutByIdQuery
>;
export type GetWorkoutByIdLazyQueryHookResult = ReturnType<
  typeof useGetWorkoutByIdLazyQuery
>;
export type GetWorkoutByIdQueryResult = Apollo.QueryResult<
  GetWorkoutByIdQuery,
  GetWorkoutByIdQueryVariables
>;
export const UnpublishWorkoutByIdDocument = gql`
  mutation UnpublishWorkoutById($id: Int!) {
    unpublishWorkoutById(id: $id)
  }
`;
export type UnpublishWorkoutByIdMutationFn = Apollo.MutationFunction<
  UnpublishWorkoutByIdMutation,
  UnpublishWorkoutByIdMutationVariables
>;

/**
 * __useUnpublishWorkoutByIdMutation__
 *
 * To run a mutation, you first call `useUnpublishWorkoutByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpublishWorkoutByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpublishWorkoutByIdMutation, { data, loading, error }] = useUnpublishWorkoutByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnpublishWorkoutByIdMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UnpublishWorkoutByIdMutation,
    UnpublishWorkoutByIdMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UnpublishWorkoutByIdMutation,
    UnpublishWorkoutByIdMutationVariables
  >(UnpublishWorkoutByIdDocument, options);
}
export type UnpublishWorkoutByIdMutationHookResult = ReturnType<
  typeof useUnpublishWorkoutByIdMutation
>;
export type UnpublishWorkoutByIdMutationResult =
  Apollo.MutationResult<UnpublishWorkoutByIdMutation>;
export type UnpublishWorkoutByIdMutationOptions = Apollo.BaseMutationOptions<
  UnpublishWorkoutByIdMutation,
  UnpublishWorkoutByIdMutationVariables
>;
export const AddOfferLandingPageConfigDocument = gql`
  mutation AddOfferLandingPageConfig($data: AddLandingPageConfigInput!) {
    addLandingPageConfig(data: $data) {
      id
      parentId
      type
      influencerId
      config
    }
  }
`;
export type AddOfferLandingPageConfigMutationFn = Apollo.MutationFunction<
  AddOfferLandingPageConfigMutation,
  AddOfferLandingPageConfigMutationVariables
>;

/**
 * __useAddOfferLandingPageConfigMutation__
 *
 * To run a mutation, you first call `useAddOfferLandingPageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfferLandingPageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfferLandingPageConfigMutation, { data, loading, error }] = useAddOfferLandingPageConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddOfferLandingPageConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddOfferLandingPageConfigMutation,
    AddOfferLandingPageConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddOfferLandingPageConfigMutation,
    AddOfferLandingPageConfigMutationVariables
  >(AddOfferLandingPageConfigDocument, options);
}
export type AddOfferLandingPageConfigMutationHookResult = ReturnType<
  typeof useAddOfferLandingPageConfigMutation
>;
export type AddOfferLandingPageConfigMutationResult =
  Apollo.MutationResult<AddOfferLandingPageConfigMutation>;
export type AddOfferLandingPageConfigMutationOptions =
  Apollo.BaseMutationOptions<
    AddOfferLandingPageConfigMutation,
    AddOfferLandingPageConfigMutationVariables
  >;
export const OfferLandingPageConfigDocument = gql`
  query OfferLandingPageConfig($influencerId: Int!, $parentId: Int!) {
    landingPageConfig(
      influencerId: $influencerId
      parentId: $parentId
      type: OFFER
    ) {
      id
      parentId
      type
      influencerId
      config
    }
  }
`;

/**
 * __useOfferLandingPageConfigQuery__
 *
 * To run a query within a React component, call `useOfferLandingPageConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferLandingPageConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferLandingPageConfigQuery({
 *   variables: {
 *      influencerId: // value for 'influencerId'
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useOfferLandingPageConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferLandingPageConfigQuery,
    OfferLandingPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferLandingPageConfigQuery,
    OfferLandingPageConfigQueryVariables
  >(OfferLandingPageConfigDocument, options);
}
export function useOfferLandingPageConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferLandingPageConfigQuery,
    OfferLandingPageConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferLandingPageConfigQuery,
    OfferLandingPageConfigQueryVariables
  >(OfferLandingPageConfigDocument, options);
}
export type OfferLandingPageConfigQueryHookResult = ReturnType<
  typeof useOfferLandingPageConfigQuery
>;
export type OfferLandingPageConfigLazyQueryHookResult = ReturnType<
  typeof useOfferLandingPageConfigLazyQuery
>;
export type OfferLandingPageConfigQueryResult = Apollo.QueryResult<
  OfferLandingPageConfigQuery,
  OfferLandingPageConfigQueryVariables
>;
export const UpdateOfferLandingPageConfigDocument = gql`
  mutation UpdateOfferLandingPageConfig($data: UpdateLandingPageConfigInput!) {
    updateLandingPageConfig(data: $data) {
      id
      parentId
      type
      influencerId
      config
    }
  }
`;
export type UpdateOfferLandingPageConfigMutationFn = Apollo.MutationFunction<
  UpdateOfferLandingPageConfigMutation,
  UpdateOfferLandingPageConfigMutationVariables
>;

/**
 * __useUpdateOfferLandingPageConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOfferLandingPageConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferLandingPageConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfferLandingPageConfigMutation, { data, loading, error }] = useUpdateOfferLandingPageConfigMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateOfferLandingPageConfigMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateOfferLandingPageConfigMutation,
    UpdateOfferLandingPageConfigMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateOfferLandingPageConfigMutation,
    UpdateOfferLandingPageConfigMutationVariables
  >(UpdateOfferLandingPageConfigDocument, options);
}
export type UpdateOfferLandingPageConfigMutationHookResult = ReturnType<
  typeof useUpdateOfferLandingPageConfigMutation
>;
export type UpdateOfferLandingPageConfigMutationResult =
  Apollo.MutationResult<UpdateOfferLandingPageConfigMutation>;
export type UpdateOfferLandingPageConfigMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateOfferLandingPageConfigMutation,
    UpdateOfferLandingPageConfigMutationVariables
  >;
export const GetOfferDocument = gql`
  query GetOffer($creatorIdID: ID!, $creatorIdInt: Int!, $bundleId: Int!) {
    content(creatorId: $creatorIdID) {
      contentItems {
        type
        value {
          ... on ContentTabValue {
            id
            name
          }
          ... on ContentLinkValue {
            id
            title
          }
          ... on ContentPDFValue {
            id
            title
          }
          ... on ContentSlidesValue {
            id
            title
          }
          ... on ContentImageValue {
            id
            title
          }
          ... on ContentLegacyGuideValue {
            id
            title
          }
          ... on ContentVideoValue {
            id
            title
          }
        }
      }
    }
    bundleById(bundleId: $bundleId) {
      id
      title
      description
      influencerId
      status
      items {
        contentId
        itemId
        itemType
      }
      oneTimeProduct {
        price
      }
      checkoutPage {
        url
      }
    }
    feature {
      id
      name
      code
    }
    creator(id: $creatorIdInt) {
      mediaAvatar {
        cdn01
        image
      }
      programs {
        id
        isVisible
        name
        workouts {
          id
          name
          programId
          programName
          mediaCover {
            videoThumbnailUrl
            cdn01
            image
          }
          mediaExercise {
            image
            cdn01
            videoThumbnailUrl
          }
        }
      }
    }
  }
`;

/**
 * __useGetOfferQuery__
 *
 * To run a query within a React component, call `useGetOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfferQuery({
 *   variables: {
 *      creatorIdID: // value for 'creatorIdID'
 *      creatorIdInt: // value for 'creatorIdInt'
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useGetOfferQuery(
  baseOptions: Apollo.QueryHookOptions<GetOfferQuery, GetOfferQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOfferQuery, GetOfferQueryVariables>(
    GetOfferDocument,
    options,
  );
}
export function useGetOfferLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetOfferQuery,
    GetOfferQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOfferQuery, GetOfferQueryVariables>(
    GetOfferDocument,
    options,
  );
}
export type GetOfferQueryHookResult = ReturnType<typeof useGetOfferQuery>;
export type GetOfferLazyQueryHookResult = ReturnType<
  typeof useGetOfferLazyQuery
>;
export type GetOfferQueryResult = Apollo.QueryResult<
  GetOfferQuery,
  GetOfferQueryVariables
>;
export const GetInfluencersListDocument = gql`
  query GetInfluencersList {
    creators(input: { filters: {} }) {
      id
      tier
      mode
      mediaCover {
        cdn01
        image
      }
      firstName
      lastName
      isVisible
      publishedAt
      visibility
      createdAt
      instagramFollowersCount
      profileTiktok
      profileYoutubeChannel
      profileInstagram
      customURL
      businessModel
      email
    }
  }
`;

/**
 * __useGetInfluencersListQuery__
 *
 * To run a query within a React component, call `useGetInfluencersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfluencersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfluencersListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInfluencersListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetInfluencersListQuery,
    GetInfluencersListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetInfluencersListQuery,
    GetInfluencersListQueryVariables
  >(GetInfluencersListDocument, options);
}
export function useGetInfluencersListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInfluencersListQuery,
    GetInfluencersListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetInfluencersListQuery,
    GetInfluencersListQueryVariables
  >(GetInfluencersListDocument, options);
}
export type GetInfluencersListQueryHookResult = ReturnType<
  typeof useGetInfluencersListQuery
>;
export type GetInfluencersListLazyQueryHookResult = ReturnType<
  typeof useGetInfluencersListLazyQuery
>;
export type GetInfluencersListQueryResult = Apollo.QueryResult<
  GetInfluencersListQuery,
  GetInfluencersListQueryVariables
>;
